(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["GlobalNavigation"] = factory(require("react"), require("styled-components"), require("react-dom"));
	else
		root["GlobalNavigation"] = factory(root["React"], root["styled-components"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_63__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1028);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(136);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = __webpack_require__(72);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(128)(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(131)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$getOwnPropertyDescriptor = __webpack_require__(17);

var _Object$defineProperty = __webpack_require__(0);

var _typeof = __webpack_require__(138);

var _WeakMap = __webpack_require__(269);

function _getRequireWildcardCache() {
  if (typeof _WeakMap !== "function") return null;
  var cache = new _WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        _Object$defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$assign = __webpack_require__(170);

function _extends() {
  module.exports = _extends = _Object$assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$getOwnPropertySymbols = __webpack_require__(15);

var objectWithoutPropertiesLoose = __webpack_require__(173);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (_Object$getOwnPropertySymbols) {
    var sourceSymbolKeys = _Object$getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$defineProperty = __webpack_require__(0);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(168);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(25);
var core = __webpack_require__(8);
var ctx = __webpack_require__(50);
var hide = __webpack_require__(39);
var has = __webpack_require__(36);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(164);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var helpers = _interopRequireWildcard(__webpack_require__(109));

var includes = _interopRequireWildcard(__webpack_require__(288));

var formIncludes = _interopRequireWildcard(__webpack_require__(498));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var _default = _objectSpread(_objectSpread(_objectSpread({}, helpers), includes), formIncludes);

exports["default"] = _default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(162);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(114);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(48);

var assertThisInitialized = __webpack_require__(24);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(294);

var iterableToArrayLimit = __webpack_require__(297);

var unsupportedIterableToArray = __webpack_require__(205);

var nonIterableRest = __webpack_require__(305);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(155);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(159);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(34)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _tokens["default"];
  }
});

var _tokens = _interopRequireDefault(__webpack_require__(332));
//# sourceMappingURL=index.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(32);
var IE8_DOM_DEFINE = __webpack_require__(92);
var toPrimitive = __webpack_require__(65);
var dP = Object.defineProperty;

exports.f = __webpack_require__(26) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(66)('wks');
var uid = __webpack_require__(53);
var Symbol = __webpack_require__(25).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(74);
var defined = __webpack_require__(64);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(29);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(30);
var createDesc = __webpack_require__(49);
module.exports = __webpack_require__(26) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.gridTypes = exports.limitedSize = exports.defaultSize = exports.autoSize = exports.size = exports.kind = exports.color = exports.align = void 0;
var align = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left",
  CENTER: "center"
};
exports.align = align;
var color = {
  BLACK: "black",
  BLUE: "blue",
  GREEN: "green",
  GREY: "grey",
  ORANGE: "orange",
  LIGHT_BLUE: "lightBlue",
  LIGHT_ORANGE: "lightOrange",
  RED: "red"
};
exports.color = color;
var kind = {
  DEFAULT: "default",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  DESTRUCTIVE: "destructive",
  FLAT: "flat",
  MINOR: "minor",
  LINK: "link"
};
exports.kind = kind;
var size = {
  AUTO: "auto",
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge"
};
exports.size = size;
var autoSize = {
  AUTO: "auto",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
exports.autoSize = autoSize;
var defaultSize = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
exports.defaultSize = defaultSize;
var limitedSize = {
  SMALL: "small",
  MEDIUM: "medium"
};
exports.limitedSize = limitedSize;
var gridTypes = {
  GRID: "grid",
  NONE: "none",
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
};
exports.gridTypes = gridTypes;
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray__);




var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray___default()(args));
  }
};

var Logger =
/*#__PURE__*/
function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Logger);

    this.init(concreteLogger, options);
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(104);
var enumBugKeys = __webpack_require__(67);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(278);

/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(64);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = defer;
/* harmony export (immutable) */ __webpack_exports__["f"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["i"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["g"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["h"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["d"] = escape;
// http://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */

  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }

  return target;
}
function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/* eslint-disable */

var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(73);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);



var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, EventEmitter);

    this.observers = {};
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      var _this2 = this;

      if (!this.observers[event]) {
        return;
      }

      this.observers[event].forEach(function () {
        if (!listener) {
          delete _this2.observers[event];
        } else {
          var index = _this2.observers[event].indexOf(listener);

          if (index > -1) {
            _this2.observers[event].splice(index, 1);
          }
        }
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 53 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(51);
var createDesc = __webpack_require__(49);
var toIObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(65);
var has = __webpack_require__(36);
var IE8_DOM_DEFINE = __webpack_require__(92);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(26) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(53)('meta');
var isObject = __webpack_require__(28);
var has = __webpack_require__(36);
var setDesc = __webpack_require__(30).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(34)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.2.10
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("whatInput", [], factory);
	else if(typeof exports === 'object')
		exports["whatInput"] = factory();
	else
		root["whatInput"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	  /*
	   * bail out if there is no document or window
	   * (i.e. in a node/non-DOM environment)
	   *
	   * Return a stubbed API instead
	   */
	  if (typeof document === 'undefined' || typeof window === 'undefined') {
	    return {
	      // always return "initial" because no interaction will ever be detected
	      ask: function ask() {
	        return 'initial';
	      },

	      // always return null
	      element: function element() {
	        return null;
	      },

	      // no-op
	      ignoreKeys: function ignoreKeys() {},

	      // no-op
	      specificKeys: function specificKeys() {},

	      // no-op
	      registerOnChange: function registerOnChange() {},

	      // no-op
	      unRegisterOnChange: function unRegisterOnChange() {}
	    };
	  }

	  /*
	   * variables
	   */

	  // cache document.documentElement
	  var docElem = document.documentElement;

	  // currently focused dom element
	  var currentElement = null;

	  // last used input type
	  var currentInput = 'initial';

	  // last used input intent
	  var currentIntent = currentInput;

	  // UNIX timestamp of current event
	  var currentTimestamp = Date.now();

	  // check for a `data-whatpersist` attribute on either the `html` or `body` elements, defaults to `true`
	  var shouldPersist = 'false';

	  // form input types
	  var formInputs = ['button', 'input', 'select', 'textarea'];

	  // empty array for holding callback functions
	  var functionList = [];

	  // list of modifier keys commonly used with the mouse and
	  // can be safely ignored to prevent false keyboard detection
	  var ignoreMap = [16, // shift
	  17, // control
	  18, // alt
	  91, // Windows key / left Apple cmd
	  93 // Windows menu / right Apple cmd
	  ];

	  var specificMap = [];

	  // mapping of events to input types
	  var inputMap = {
	    keydown: 'keyboard',
	    keyup: 'keyboard',
	    mousedown: 'mouse',
	    mousemove: 'mouse',
	    MSPointerDown: 'pointer',
	    MSPointerMove: 'pointer',
	    pointerdown: 'pointer',
	    pointermove: 'pointer',
	    touchstart: 'touch',
	    touchend: 'touch'

	    // boolean: true if the page is being scrolled
	  };var isScrolling = false;

	  // store current mouse position
	  var mousePos = {
	    x: null,
	    y: null

	    // map of IE 10 pointer events
	  };var pointerMap = {
	    2: 'touch',
	    3: 'touch', // treat pen like touch
	    4: 'mouse'

	    // check support for passive event listeners
	  };var supportsPassive = false;

	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        supportsPassive = true;
	      }
	    });

	    window.addEventListener('test', null, opts);
	  } catch (e) {}
	  // fail silently


	  /*
	   * set up
	   */

	  var setUp = function setUp() {
	    // add correct mouse wheel event mapping to `inputMap`
	    inputMap[detectWheel()] = 'mouse';

	    addListeners();
	  };

	  /*
	   * events
	   */

	  var addListeners = function addListeners() {
	    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
	    // can only demonstrate potential, but not actual, interaction
	    // and are treated separately
	    var options = supportsPassive ? { passive: true } : false;

	    document.addEventListener('DOMContentLoaded', setPersist);

	    // pointer events (mouse, pen, touch)
	    if (window.PointerEvent) {
	      window.addEventListener('pointerdown', setInput);
	      window.addEventListener('pointermove', setIntent);
	    } else if (window.MSPointerEvent) {
	      window.addEventListener('MSPointerDown', setInput);
	      window.addEventListener('MSPointerMove', setIntent);
	    } else {
	      // mouse events
	      window.addEventListener('mousedown', setInput);
	      window.addEventListener('mousemove', setIntent);

	      // touch events
	      if ('ontouchstart' in window) {
	        window.addEventListener('touchstart', setInput, options);
	        window.addEventListener('touchend', setInput);
	      }
	    }

	    // mouse wheel
	    window.addEventListener(detectWheel(), setIntent, options);

	    // keyboard events
	    window.addEventListener('keydown', setInput);
	    window.addEventListener('keyup', setInput);

	    // focus events
	    window.addEventListener('focusin', setElement);
	    window.addEventListener('focusout', clearElement);
	  };

	  // checks if input persistence should happen and
	  // get saved state from session storage if true (defaults to `false`)
	  var setPersist = function setPersist() {
	    shouldPersist = !(docElem.getAttribute('data-whatpersist') || document.body.getAttribute('data-whatpersist') === 'false');

	    if (shouldPersist) {
	      // check for session variables and use if available
	      try {
	        if (window.sessionStorage.getItem('what-input')) {
	          currentInput = window.sessionStorage.getItem('what-input');
	        }

	        if (window.sessionStorage.getItem('what-intent')) {
	          currentIntent = window.sessionStorage.getItem('what-intent');
	        }
	      } catch (e) {
	        // fail silently
	      }
	    }

	    // always run these so at least `initial` state is set
	    doUpdate('input');
	    doUpdate('intent');
	  };

	  // checks conditions before updating new input
	  var setInput = function setInput(event) {
	    var eventKey = event.which;
	    var value = inputMap[event.type];

	    if (value === 'pointer') {
	      value = pointerType(event);
	    }

	    var ignoreMatch = !specificMap.length && ignoreMap.indexOf(eventKey) === -1;

	    var specificMatch = specificMap.length && specificMap.indexOf(eventKey) !== -1;

	    var shouldUpdate = value === 'keyboard' && eventKey && (ignoreMatch || specificMatch) || value === 'mouse' || value === 'touch';

	    // prevent touch detection from being overridden by event execution order
	    if (validateTouch(value)) {
	      shouldUpdate = false;
	    }

	    if (shouldUpdate && currentInput !== value) {
	      currentInput = value;

	      persistInput('input', currentInput);
	      doUpdate('input');
	    }

	    if (shouldUpdate && currentIntent !== value) {
	      // preserve intent for keyboard interaction with form fields
	      var activeElem = document.activeElement;
	      var notFormInput = activeElem && activeElem.nodeName && (formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1 || activeElem.nodeName.toLowerCase() === 'button' && !checkClosest(activeElem, 'form'));

	      if (notFormInput) {
	        currentIntent = value;

	        persistInput('intent', currentIntent);
	        doUpdate('intent');
	      }
	    }
	  };

	  // updates the doc and `inputTypes` array with new input
	  var doUpdate = function doUpdate(which) {
	    docElem.setAttribute('data-what' + which, which === 'input' ? currentInput : currentIntent);

	    fireFunctions(which);
	  };

	  // updates input intent for `mousemove` and `pointermove`
	  var setIntent = function setIntent(event) {
	    var value = inputMap[event.type];

	    if (value === 'pointer') {
	      value = pointerType(event);
	    }

	    // test to see if `mousemove` happened relative to the screen to detect scrolling versus mousemove
	    detectScrolling(event);

	    // only execute if scrolling isn't happening
	    if ((!isScrolling && !validateTouch(value) || isScrolling && event.type === 'wheel' || event.type === 'mousewheel' || event.type === 'DOMMouseScroll') && currentIntent !== value) {
	      currentIntent = value;

	      persistInput('intent', currentIntent);
	      doUpdate('intent');
	    }
	  };

	  var setElement = function setElement(event) {
	    if (!event.target.nodeName) {
	      // If nodeName is undefined, clear the element
	      // This can happen if click inside an <svg> element.
	      clearElement();
	      return;
	    }

	    currentElement = event.target.nodeName.toLowerCase();
	    docElem.setAttribute('data-whatelement', currentElement);

	    if (event.target.classList && event.target.classList.length) {
	      docElem.setAttribute('data-whatclasses', event.target.classList.toString().replace(' ', ','));
	    }
	  };

	  var clearElement = function clearElement() {
	    currentElement = null;

	    docElem.removeAttribute('data-whatelement');
	    docElem.removeAttribute('data-whatclasses');
	  };

	  var persistInput = function persistInput(which, value) {
	    if (shouldPersist) {
	      try {
	        window.sessionStorage.setItem('what-' + which, value);
	      } catch (e) {
	        // fail silently
	      }
	    }
	  };

	  /*
	   * utilities
	   */

	  var pointerType = function pointerType(event) {
	    if (typeof event.pointerType === 'number') {
	      return pointerMap[event.pointerType];
	    } else {
	      // treat pen like touch
	      return event.pointerType === 'pen' ? 'touch' : event.pointerType;
	    }
	  };

	  // prevent touch detection from being overridden by event execution order
	  var validateTouch = function validateTouch(value) {
	    var timestamp = Date.now();

	    var touchIsValid = value === 'mouse' && currentInput === 'touch' && timestamp - currentTimestamp < 200;

	    currentTimestamp = timestamp;

	    return touchIsValid;
	  };

	  // detect version of mouse wheel event to use
	  // via https://developer.mozilla.org/en-US/docs/Web/API/Element/wheel_event
	  var detectWheel = function detectWheel() {
	    var wheelType = null;

	    // Modern browsers support "wheel"
	    if ('onwheel' in document.createElement('div')) {
	      wheelType = 'wheel';
	    } else {
	      // Webkit and IE support at least "mousewheel"
	      // or assume that remaining browsers are older Firefox
	      wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
	    }

	    return wheelType;
	  };

	  // runs callback functions
	  var fireFunctions = function fireFunctions(type) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].type === type) {
	        functionList[i].fn.call(undefined, type === 'input' ? currentInput : currentIntent);
	      }
	    }
	  };

	  // finds matching element in an object
	  var objPos = function objPos(match) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].fn === match) {
	        return i;
	      }
	    }
	  };

	  var detectScrolling = function detectScrolling(event) {
	    if (mousePos.x !== event.screenX || mousePos.y !== event.screenY) {
	      isScrolling = false;

	      mousePos.x = event.screenX;
	      mousePos.y = event.screenY;
	    } else {
	      isScrolling = true;
	    }
	  };

	  // manual version of `closest()`
	  var checkClosest = function checkClosest(elem, tag) {
	    var ElementPrototype = window.Element.prototype;

	    if (!ElementPrototype.matches) {
	      ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.webkitMatchesSelector;
	    }

	    if (!ElementPrototype.closest) {
	      do {
	        if (elem.matches(tag)) {
	          return elem;
	        }

	        elem = elem.parentElement || elem.parentNode;
	      } while (elem !== null && elem.nodeType === 1);

	      return null;
	    } else {
	      return elem.closest(tag);
	    }
	  };

	  /*
	   * init
	   */

	  // don't start script unless browser cuts the mustard
	  // (also passes if polyfills are used)
	  if ('addEventListener' in window && Array.prototype.indexOf) {
	    setUp();
	  }

	  /*
	   * api
	   */

	  return {
	    // returns string: the current input type
	    // opt: 'intent'|'input'
	    // 'input' (default): returns the same value as the `data-whatinput` attribute
	    // 'intent': includes `data-whatintent` value if it's different than `data-whatinput`
	    ask: function ask(opt) {
	      return opt === 'intent' ? currentIntent : currentInput;
	    },

	    // returns string: the currently focused element or null
	    element: function element() {
	      return currentElement;
	    },

	    // overwrites ignored keys with provided array
	    ignoreKeys: function ignoreKeys(arr) {
	      ignoreMap = arr;
	    },

	    // overwrites specific char keys to update on
	    specificKeys: function specificKeys(arr) {
	      specificMap = arr;
	    },

	    // attach functions to input and intent "events"
	    // funct: function to fire on change
	    // eventType: 'input'|'intent'
	    registerOnChange: function registerOnChange(fn, eventType) {
	      functionList.push({
	        fn: fn,
	        type: eventType || 'input'
	      });
	    },

	    unRegisterOnChange: function unRegisterOnChange(fn) {
	      var position = objPos(fn);

	      if (position || position === 0) {
	        functionList.splice(position, 1);
	      }
	    },

	    clearStorage: function clearStorage() {
	      window.sessionStorage.clear();
	    }
	  };
	}();

/***/ })
/******/ ])
});
;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_63__;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var global = __webpack_require__(25);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(56) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(104);
var hiddenKeys = __webpack_require__(67).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(30).f;
var has = __webpack_require__(36);
var TAG = __webpack_require__(31)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(32);
var dPs = __webpack_require__(103);
var enumBugKeys = __webpack_require__(67);
var IE_PROTO = __webpack_require__(77)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(93)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(166).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(76);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(126);
} else {
  module.exports = __webpack_require__(127);
}


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(75);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(66)('keys');
var uid = __webpack_require__(53);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(31);


/***/ }),
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(132);

var iterableToArray = __webpack_require__(133);

var unsupportedIterableToArray = __webpack_require__(91);

var nonIterableSpread = __webpack_require__(134);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(151);

var iterableToArrayLimit = __webpack_require__(152);

var unsupportedIterableToArray = __webpack_require__(91);

var nonIterableRest = __webpack_require__(153);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(264);
var global = __webpack_require__(25);
var hide = __webpack_require__(39);
var Iterators = __webpack_require__(57);
var TO_STRING_TAG = __webpack_require__(31)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(50);
var call = __webpack_require__(179);
var isArrayIter = __webpack_require__(180);
var anObject = __webpack_require__(32);
var toLength = __webpack_require__(71);
var getIterFn = __webpack_require__(121);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(14);
var core = __webpack_require__(8);
var fails = __webpack_require__(34);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(262)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(117)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(39);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(25);
var core = __webpack_require__(8);
var LIBRARY = __webpack_require__(56);
var wksExt = __webpack_require__(78);
var defineProperty = __webpack_require__(30).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(88);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(26) && !__webpack_require__(34)(function () {
  return Object.defineProperty(__webpack_require__(93)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var document = __webpack_require__(25).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(75);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(295);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(307);

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return use; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(144);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(30);
var anObject = __webpack_require__(32);
var getKeys = __webpack_require__(43);

module.exports = __webpack_require__(26) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(36);
var toIObject = __webpack_require__(33);
var arrayIndexOf = __webpack_require__(157)(false);
var IE_PROTO = __webpack_require__(77)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(25);
var has = __webpack_require__(36);
var DESCRIPTORS = __webpack_require__(26);
var $export = __webpack_require__(14);
var redefine = __webpack_require__(89);
var META = __webpack_require__(61).KEY;
var $fails = __webpack_require__(34);
var shared = __webpack_require__(66);
var setToStringTag = __webpack_require__(69);
var uid = __webpack_require__(53);
var wks = __webpack_require__(31);
var wksExt = __webpack_require__(78);
var wksDefine = __webpack_require__(90);
var enumKeys = __webpack_require__(165);
var isArray = __webpack_require__(94);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(28);
var toObject = __webpack_require__(46);
var toIObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(65);
var createDesc = __webpack_require__(49);
var _create = __webpack_require__(70);
var gOPNExt = __webpack_require__(167);
var $GOPD = __webpack_require__(60);
var $GOPS = __webpack_require__(54);
var $DP = __webpack_require__(30);
var $keys = __webpack_require__(43);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(68).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(51).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(56)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(39)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(26);
var getKeys = __webpack_require__(43);
var gOPS = __webpack_require__(54);
var pIE = __webpack_require__(51);
var toObject = __webpack_require__(46);
var IObject = __webpack_require__(74);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(34)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(50);
var IObject = __webpack_require__(74);
var toObject = __webpack_require__(46);
var toLength = __webpack_require__(71);
var asc = __webpack_require__(272);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.rgb = rgb;
exports.alpha = alpha;
exports.zValue = exports.z = exports.spacer = exports.lineHeight = exports.lineHeightValue = exports.fontSize = exports.fontSizeValue = exports.toInt = void 0;

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _tokens = _interopRequireDefault(__webpack_require__(27));

//
// Utilities
//
var toInt = function toInt(token) {
  return (0, _parseInt["default"])(token, 10);
}; //
// Typography
//


exports.toInt = toInt;
var fontScaleRatio = 1.125; // 8:9 - Major second

var fontSizeValue = function fontSizeValue() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Math.round((0, _parseInt["default"])(_tokens["default"].fontSize["default"], 10) * Math.pow(fontScaleRatio, scale));
};

exports.fontSizeValue = fontSizeValue;

var fontSize = function fontSize() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "\n  font-size: ".concat(fontSizeValue(scale), "px;\n");
};

exports.fontSize = fontSize;
var leadingBase = 1.4;
var leadingScaleRatio = 1.125;

var lineHeightValue = function lineHeightValue() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Math.round(leadingBase * Math.pow(leadingScaleRatio, scale) * 100) / 100;
};

exports.lineHeightValue = lineHeightValue;

var lineHeight = function lineHeight() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "\n  line-height: ".concat(lineHeightValue(scale), ";\n");
}; //
// Layout
//


exports.lineHeight = lineHeight;

var spacer = function spacer(numSpaces) {
  return "".concat((0, _parseInt["default"])(_tokens["default"].space, 10) * numSpaces, "px");
};

exports.spacer = spacer;

function zIsValid(level) {
  return /^-1$|^[0-7]$|^inherit$|^initial$|^auto$/.test(level);
}

var z = function z(level) {
  return zIsValid(level) ? "z-index: ".concat(level, ";") : "z-index: 1;";
};

exports.z = z;

var zValue = function zValue(level) {
  return zIsValid(level) ? level : 1;
}; //
// Color
//


exports.zValue = zValue;

function rgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return null;
  return [(0, _parseInt["default"])(result[1], 16), (0, _parseInt["default"])(result[2], 16), (0, _parseInt["default"])(result[3], 16)];
}

function alpha(colorValue) {
  var alphaValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return "rgba(".concat(rgb(colorValue), ", ").concat(alphaValue, ")");
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(30);
var createDesc = __webpack_require__(49);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(266);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(369);

/***/ }),
/* 113 */,
/* 114 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var locales = {};
['en', 'de', 'fr', 'es', 'pt', 'ja', 'zh'].forEach(function (lng) {
  // eslint-disable-next-line
  Object.assign(locales, __webpack_require__(184)("./".concat(lng, ".yml")));
});
/* harmony default export */ __webpack_exports__["default"] = (locales);

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var $export = __webpack_require__(14);
var redefine = __webpack_require__(89);
var hide = __webpack_require__(39);
var Iterators = __webpack_require__(57);
var $iterCreate = __webpack_require__(263);
var setToStringTag = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(193);
var ITERATOR = __webpack_require__(31)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 118 */
/***/ (function(module, exports) {



/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(39);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(123);
var ITERATOR = __webpack_require__(31)('iterator');
var Iterators = __webpack_require__(57);
module.exports = __webpack_require__(8).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(75);
var TAG = __webpack_require__(31)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(500);
var bytesToUuid = __webpack_require__(501);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(72);
var assign = __webpack_require__(129);

var ReactPropTypesSecret = __webpack_require__(58);
var checkPropTypes = __webpack_require__(130);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(58);
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(58);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(88);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(137);
var $Object = __webpack_require__(8).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(26), 'Object', { defineProperty: __webpack_require__(30).f });


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol$iterator = __webpack_require__(203);

var _Symbol = __webpack_require__(111);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof _Symbol === "function" && typeof _Symbol$iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof _Symbol === "function" && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = useListBox;

var _react = _interopRequireDefault(__webpack_require__(2));

var _Provider = __webpack_require__(731);

var types = _interopRequireWildcard(__webpack_require__(1160));

function useListBox() {
  var _React$useContext = _react["default"].useContext(_Provider.StoreContext),
      state = _React$useContext.state,
      dispatch = _React$useContext.dispatch;

  return [state, dispatch];
}

useListBox.types = types;
//# sourceMappingURL=useListBox.js.map

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResourceStore_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Translator_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LanguageUtils_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PluralResolver_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Interpolator_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BackendConnector_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__defaults_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__postProcessor_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_js__ = __webpack_require__(47);




















function noop() {}

var I18n =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, I18n);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(I18n).call(this));
    __WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__["a" /* default */].call(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this))); // <=IE10 fix (unable to call parent constructor)

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_16__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */];
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(_this, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      this.options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, Object(__WEBPACK_IMPORTED_MODULE_16__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_16__defaults_js__["b" /* transformOptions */])(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      } // init services


      if (!this.options.isClone) {
        if (this.modules.logger) {
          __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */].init(null, this.options);
        }

        var lu = new __WEBPACK_IMPORTED_MODULE_12__LanguageUtils_js__["a" /* default */](this.options);
        this.store = new __WEBPACK_IMPORTED_MODULE_10__ResourceStore_js__["a" /* default */](this.options.resources, this.options);
        var s = this.services;
        s.logger = __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */];
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_13__PluralResolver_js__["a" /* default */](lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new __WEBPACK_IMPORTED_MODULE_14__Interpolator_js__["a" /* default */](this.options);
        s.backendConnector = new __WEBPACK_IMPORTED_MODULE_15__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options); // pipe events from backendConnector

        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new __WEBPACK_IMPORTED_MODULE_11__Translator_js__["a" /* default */](this.services, this.options); // pipe events from translator

        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      } // append api


      var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();

      var load = function load() {
        _this2.changeLanguage(_this2.options.lng, function (err, t) {
          _this2.isInitialized = true;

          _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t); // not rejecting on err (as err is only a loading translation failed warning)

          callback(err, t);
        });
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "loadResources",
    value: function loadResources() {
      var _this3 = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!this.language) {
          // at least load fallbacks in this case
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(this.language);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, callback);
      } else {
        callback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve(); // not rejecting on err (as err is only a loading translation failed warning)

        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        __WEBPACK_IMPORTED_MODULE_17__postProcessor_js__["a" /* default */].addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        _this4.translator.changeLanguage(l);

        if (l) {
          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, opts);

        if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this6 = this;

      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      }); // Exit early if all given languages are already preloaded

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
    /* eslint class-methods-use-this: 0 */

  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this7 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this7[m];
      });
      clone.translator = new __WEBPACK_IMPORTED_MODULE_11__Translator_js__["a" /* default */](clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options; // sync options

      return clone;
    }
  }]);

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventEmitter_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(47);










var ResourceStore =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ResourceStore);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ResourceStore).call(this));
    __WEBPACK_IMPORTED_MODULE_7__EventEmitter_js__["a" /* default */].call(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this))); // <=IE10 fix (unable to call parent constructor)

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return __WEBPACK_IMPORTED_MODULE_8__utils_js__["e" /* getPath */](this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      __WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* setPath */](this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      /* eslint no-restricted-syntax: 0 */
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = __WEBPACK_IMPORTED_MODULE_8__utils_js__["e" /* getPath */](this.data, path) || {};

      if (deep) {
        __WEBPACK_IMPORTED_MODULE_8__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
      } else {
        pack = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, pack, resources);
      }

      __WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* setPath */](this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS; // COMPATIBILITY: remove extend in v2.1.0

      if (this.options.compatibilityAPI === 'v1') return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_7__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_js__ = __webpack_require__(47);













var Translator =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Translator);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Translator).call(this));
    __WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__["a" /* default */].call(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this))); // <=IE10 fix (unable to call parent constructor)

    __WEBPACK_IMPORTED_MODULE_11__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator || this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options) {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        /* eslint prefer-rest-params: 0 */
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {}; // non valid keys handling

      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)]; // separators

      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator; // get namespace(s)

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1]; // return key on CIMode

      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      } // resolve from store


      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays; // object

      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        } // if we got a separator we loop over children - else we just return object as is
        // as having it set to false means no hierarchy so no lookup for nested values


        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {}; // apply child translation on a copy

          /* eslint no-restricted-syntax: 0 */

          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        // array special treatment
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options);
      } else {
        // string, empty or null
        var usedDefault = false;
        var usedKey = false; // fallback value

        if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
          usedDefault = true;

          if (options.count !== undefined) {
            var suffix = this.pluralResolver.getSuffix(lng, options.count);
            res = options["defaultValue".concat(suffix)];
          }

          if (!res) res = options.defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        } // save missing


        var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (l) {
                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

                plurals.forEach(function (p) {
                  return send([l], p);
                });
              });
            } else {
              send(lngs, key);
            }
          }
        } // extend


        res = this.extendTranslation(res, keys, options, resolved); // append namespace if still key

        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key); // parseMissingKeyHandler

        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      } // return


      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        // i18next.parsing
        if (options.interpolation) this.interpolator.init(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, options, {
          interpolation: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, this.options.interpolation, options.interpolation)
        })); // interpolate

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options); // nesting

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          return _this3.translate.apply(_this3, arguments);
        }, options);
        if (options.interpolation) this.interpolator.reset();
      } // post process


      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey; // plain key

      var exactUsedKey; // key with context / plural

      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys]; // forEach possible key

      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count); // fallback for plural if context not found

              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix); // get key for context if needed

              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context)); // get key for plural if needed

              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            } // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only


            var possibleKey;
            /* eslint no-cond-assign: 0 */

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }]);

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger_js__ = __webpack_require__(41);




function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil =
/*#__PURE__*/
function () {
  function LanguageUtil(options) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_2__logger_js__["a" /* default */].create('languageUtils');
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      // http://www.iana.org/assignments/language-tags/language-tags.xhtml
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase(); // if lenght 2 guess it's a country

          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks.default || []; // asume we have an object defining fallbacks

      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks.default;
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this.isWhitelisted(c)) {
          codes.push(c);
        } else {
          _this.logger.warn("rejecting non-whitelisted language code: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger_js__ = __webpack_require__(41);


 // definition http://translate.sourceforge.net/wiki/l10n/pluralforms

/* eslint-disable */

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver =
/*#__PURE__*/
function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = __WEBPACK_IMPORTED_MODULE_2__logger_js__["a" /* default */].create('pluralResolver');
    this.rules = createRules();
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var _this = this;

      var ret = [];
      var rule = this.getRule(code);
      if (!rule) return ret;
      rule.numbers.forEach(function (n) {
        var suffix = _this.getSuffix(code, n);

        ret.push("".concat(key).concat(suffix));
      });
      return ret;
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        // if (rule.numbers.length === 1) return ''; // only singular
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx]; // special treatment for lngs only having singular and plural

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        }; // COMPATIBILITY JSON
        // v1


        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (
        /* v2 */
        this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (
        /* v3 - gettext index */
        this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger_js__ = __webpack_require__(41);






var Interpolator =
/*#__PURE__*/
function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_4__logger_js__["a" /* default */].create('interpolator');
    this.init(options, true);
  }
  /* eslint no-param-reassign: 0 */


  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var reset = arguments.length > 1 ? arguments[1] : undefined;

      if (reset) {
        this.options = options;

        this.format = options.interpolation && options.interpolation.format || function (value) {
          return value;
        };
      }

      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : __WEBPACK_IMPORTED_MODULE_3__utils_js__["d" /* escape */];
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */]('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](')');
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000; // the regexp

      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      // the regexp
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_3__utils_js__["e" /* getPath */](data, key);
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(__WEBPACK_IMPORTED_MODULE_3__utils_js__["e" /* getPath */](data, k), f, lng);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      replaces = 0; // unescape if has unescapePrefix/Suffix

      /* eslint no-cond-assign: 0 */

      while (match = this.regexpUnescape.exec(str)) {
        value = handleFormat(match[1].trim());
        str = str.replace(match[0], value);
        this.regexpUnescape.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      replaces = 0; // regular escape on demand

      while (match = this.regexp.exec(str)) {
        value = handleFormat(match[1].trim());

        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            var temp = missingInterpolationHandler(str, match, options);
            value = typeof temp === 'string' ? temp : '';
          } else {
            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = __WEBPACK_IMPORTED_MODULE_3__utils_js__["f" /* makeString */](value);
        }

        value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, options);

      clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup
      // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"

      function handleHasOptions(key, inheritedOptions) {
        if (key.indexOf(',') < 0) return key;
        var p = key.split(',');
        key = p.shift();
        var optionsString = p.join(',');
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.error("failed parsing options string in nesting for key ".concat(key), e);
        }

        return key;
      } // regular escape on demand


      while (match = this.nestingRegexp.exec(str)) {
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions); // is only the nesting key (key1 = '$(key2)') return the value without stringify

        if (value && match[0] === str && typeof value !== 'string') return value; // no string to include or empty

        if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_3__utils_js__["f" /* makeString */](value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        } // Nested keys should not be escaped by default #854
        // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);


        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logger_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EventEmitter_js__ = __webpack_require__(52);












function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Connector);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Connector).call(this));
    __WEBPACK_IMPORTED_MODULE_10__EventEmitter_js__["a" /* default */].call(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this))); // <=IE10 fix (unable to call parent constructor)

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_9__logger_js__["a" /* default */].create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      // find what needs to be loaded
      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2; // loaded
          } else if (_this2.state[name] < 0) {// nothing to do for err
          } else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1; // pending

            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var _name$split = name.split('|'),
          _name$split2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_name$split, 2),
          lng = _name$split2[0],
          ns = _name$split2[1];

      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      } // set loaded


      this.state[name] = err ? -1 : 2; // consolidated loading done in this run - only emit once for a loaded namespace

      var loaded = {}; // callback if ready

      this.queue.forEach(function (q) {
        __WEBPACK_IMPORTED_MODULE_8__utils_js__["g" /* pushPath */](q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          // only do once per loaded -> this.emit('loaded', q.loaded);
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          /* eslint no-param-reassign: 0 */

          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      }); // emit consolidated loaded event

      this.emit('loaded', loaded); // remove done load requests

      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {}); // noting to load

      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data
        /* = retryFlag */
        && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now

        return null; // pendings will trigger callback
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var _name$split3 = name.split('|'),
          _name$split4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_name$split3, 2),
          lng = _name$split4[0],
          ns = _name$split4[1];

      this.read(lng, ns, 'read', null, null, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null
        /* unused callback */
        , __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, options, {
          isUpdate: isUpdate
        }));
      } // write to store to avoid resending


      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_10__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 151 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    // string or array of namespaces
    whitelist: false,
    // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all',
    // | currentOnly | languageOnly
    preload: false,
    // array with preload languages
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    // allow bundling certain languages that are not remotely fetched
    saveMissing: false,
    // enable to send missing values
    updateMissing: false,
    // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback',
    // 'current' || 'all'
    saveMissingPlurals: true,
    // will save all forms not only singular key
    missingKeyHandler: false,
    // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false,
    // function(str, match)
    postProcess: false,
    // string or array of postProcessor names
    returnNull: true,
    // allows null value as valid translation
    returnEmptyString: true,
    // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false,
    // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {},
    // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false,
    // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(args[2]) === 'object' || __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop

    }
  };
}
/* eslint no-param-reassign: 0 */

function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS]; // extend whitelist with cimode

  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(156);
var $Object = __webpack_require__(8).Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(26), 'Object', { defineProperties: __webpack_require__(103) });


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(33);
var toLength = __webpack_require__(71);
var toAbsoluteIndex = __webpack_require__(158);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(76);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(160);
module.exports = __webpack_require__(8).Object.getOwnPropertyDescriptors;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(14);
var ownKeys = __webpack_require__(161);
var toIObject = __webpack_require__(33);
var gOPD = __webpack_require__(60);
var createProperty = __webpack_require__(110);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(68);
var gOPS = __webpack_require__(54);
var anObject = __webpack_require__(32);
var Reflect = __webpack_require__(25).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(163);
var $Object = __webpack_require__(8).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(33);
var $getOwnPropertyDescriptor = __webpack_require__(60).f;

__webpack_require__(86)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
module.exports = __webpack_require__(8).Object.getOwnPropertySymbols;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(43);
var gOPS = __webpack_require__(54);
var pIE = __webpack_require__(51);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(25).document;
module.exports = document && document.documentElement;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(33);
var gOPN = __webpack_require__(68).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(169);
module.exports = __webpack_require__(8).Object.keys;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(46);
var $keys = __webpack_require__(43);

__webpack_require__(86)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(171);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(172);
module.exports = __webpack_require__(8).Object.assign;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(14);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(107) });


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$keys = __webpack_require__(13);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = _Object$keys(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = useI18n;
exports.getI18nObject = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _react = _interopRequireDefault(__webpack_require__(2));

var _L10nContext = _interopRequireDefault(__webpack_require__(705));

var _i18n2 = __webpack_require__(703);

var _locales = _interopRequireDefault(__webpack_require__(704));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function mergeTranslation(customLocales, paprikaLocales) {
  var result = {};
  (0, _keys["default"])(paprikaLocales).forEach(function (lang) {
    result[lang] = {
      translation: _objectSpread(_objectSpread({}, paprikaLocales[lang] ? paprikaLocales[lang].translation : {}), customLocales[lang] ? customLocales[lang].translation : {})
    };
  });
  return result;
}

var getI18nObject = function getI18nObject() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
  var locales = arguments.length > 1 ? arguments[1] : undefined;

  var _i18n = (0, _i18n2.i18n)(locales ? mergeTranslation(locales, _locales["default"]) : _locales["default"]);

  return {
    locale: locale,
    t: _i18n.getFixedT(locale)
  };
};

exports.getI18nObject = getI18nObject;

function useI18n() {
  var _i18n = _react["default"].useContext(_L10nContext["default"]);

  return _i18n || getI18nObject();
}
//# sourceMappingURL=useI18n.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(32);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(57);
var ITERATOR = __webpack_require__(31)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(359);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(364);

var iterableToArray = __webpack_require__(365);

var unsupportedIterableToArray = __webpack_require__(205);

var nonIterableSpread = __webpack_require__(366);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de.yml": 185,
	"./en.yml": 186,
	"./es.yml": 187,
	"./fr.yml": 188,
	"./ja.yml": 189,
	"./pt.yml": 190,
	"./zh.yml": 191
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = {"de":{"translation":{"edit_conflict":{"header":"Konflikt bearbeiten","description":"Dieser Eintrag wurde während Ihrer Bearbeitung geändert:","notice":"„{{term}}” wurde während Ihrer Bearbeitung geändert.","options":{"save_your_edit":"Um Ihre Änderungen zu speichern, kopieren Sie den Text aus dem Editor mit der rechten\nMaustaste in Ihre Zwischenablage. Wenn Sie Ihr Display aktualisieren oder auf Änderungen speichern klicken,\nwird der geänderte Eintrag angezeigt.\nSie müssen Ihren Text dann manuell in den neuen Eintrag einfügen.\n","discard_your_changes":"Um Ihre Änderungen zu verwerfen und den neuen Eintrag zu laden,\naktualisieren Sie einfach Ihr Display oder klicken Sie auf Speichern.\n","save_changes":"Um Ihre Änderungen zu speichern, kopieren Sie den Text in ein anderes Programm, aktualisieren Sie Ihren Browser,\noder klicken Sie auf „Speichern” und führen Sie eine manuelle Zusammenführung Ihrer Änderungen durch.\n","discard_changes":"Aktualisieren Sie Ihren Browser, um Ihre Änderungen zu verwerfen."}},"delete_conflict":{"header":"Konflikt löschen","notice":"„{{term}}” wurde gelöscht und ist nicht mehr verfügbar.","options":{"save_changes":"Um Ihre Änderungen zu speichern, kopieren Sie den Text in ein anderes Programm\nund geben Sie die Änderungen in ein neues %{term}-Formular ein.\n","discard_changes":"Schließen Sie das Formular und aktualisieren Sie Ihren Browser, um Ihre Änderungen zu verwerfen."}},"assessment_drivers":{"notifications":{"assessment_disabled":"Dieser Bewertungsfaktor ist momentan deaktiviert."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"Bei Speichern des Bewertungsfaktors ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.","metric_deleted":"{{name}} wurde aus der Ergebnisse-App gelöscht und ist nicht mehr verfügbar.","targetable_field_changed":"Die Skala für {{name}} wurde geändert. Überprüfen Sie den Bewertungsfaktor und aktivieren Sie ihn erneut.","metric_updated":"Die Konfiguration von {{name}} wurde in der Ergebnisse-App geändert. Prüfen und aktivieren Sie diesen Bewertungsfaktor erneut.","insufficient_data":"Die Daten reichen zur Berechnung von {{name}} in der Ergebnisse-App nicht aus.","invalid_data":"Der Wert für {{name}} ist {{value}} und kann nicht ordnungsgemäß vom Bewertungsfaktor verarbeitet werden.","saved_failed":"Es gab ein Problem mit dem Server, und wir waren nicht in der Lage, Ihre Änderungen zu speichern. Versuchen Sie es bitte erneut.","no_response":"Wir konnten keine Metriken laden."}}}},"success_saving":"Die {{targetableField}}-Bewertung für „{{target}}” wurde erfolgreich automatisiert.","bubbly_header":"{{target_term}}-Bewertungen automatisieren","bubbly_content_html":"Mit Hilfe von Bewertungsfaktoren können Sie Ihre Bewertungen in Echtzeit aktualisieren. Sie können vordefinierte Metrikbereiche verwenden, um Ihre {{target_term}} zu bewerten und bei Änderungen wichtige Interessensgruppen benachrichtigen. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">Erfahren Sie mehr.</a>","bubbly_footer":"Diesen Tipp nicht mehr anzeigen.","save":"Speichern","cancel":"Abbrechen","enable":"Bewertungsfaktor aktivieren","delete":"Löschen","delete_popover":{"title":"Bewertungsfaktor löschen?","description":"Sie können auf dieses Element nicht mehr zugreifen oder es wiederherstellen."},"tour":{"description":{"step_one":"Definieren Sie die Bedingungen, die erfüllt werden müssen, damit die {{target_term}}-Bewertung die angegebene Einstufung automatisch aktualisiert.","step_two":"Während Sie Werte in die rechte Spalte eingeben, wird die linke Spalte automatisch mit dem nächsten sequenziellen Wert ausgefüllt."},"navigation":{"back":"Zurück","close":"Schließen","done":"Abgeschlossen","next":"Nächstes"}},"title":{"new":"Neuer Bewertungsfaktor","edit":"Bewertungsfaktor bearbeiten"},"dropdowns":{"entity":"Entität","process":"Prozess","metric":"Metrik","tooltip":"Deaktivieren Sie den Bewertungsfaktor, um die automatische {{target_term}}-Bewertung zu pausieren.","help_icon_text_risk":"Nur Risiken mit verlinkten Metriken können ausgewählt werden.","automated":"%{name} (Automatisierung gesetzt)","placerholder_entity":"%{operating_segment} auswählen...","placeholder_metric":"Metrik auswählen..."},"metric_ranges":{"errors":{"format_error":"Nur Zahlen sind gültige Zeichen.","range_error":"Bereiche dürfen nicht überlappen."},"dropdown":{"less_than":"kleiner als","greater_than":"größer als","equal_to":"oder gleich"}},"more_information":"Weitere Informationen"},"metrics":{"title":"Bisher wurden noch keine Metriken verknüpft","header":"Metriken","add_or_remove":"Hinzufügen/Entfernen","description_html":"Metriken sind quantifizierbare Maßnahmen mit denen {{targetTerm}} verfolgt, überwacht und bewertet werden können. Sie können Metriken mit {{targetTerm}} verknüpfen, um die Risikobewertung mit Informationen zu unterstützen.","start_linking":"Metriken verknüpfen","done_editing":"Abgeschlossen","edit_metrics":"Metriken bearbeiten","view_data":"Daten anzeigen","learn_more":{"label":"Erfahren Sie mehr."},"link_table":{"title":"Zu verknüpfende Metriken auswählen","search_placeholder":"Metriken durchsuchen","no_metrics_available":"Keine Metriken verfügbar, die verknüpft werden können","no_metrics_available_description":"Metriken sind quantifizierbare Maßnahmen mit denen {{targetTerm}} verfolgt, überwacht und bewertet werden können. Nachdem Sie eine Metrik erstellt haben, können Sie diese mit einem {{targetTerm}} verknüpfen.","unlink_confirmation_button":"Verknüpfung aufheben und Änderungen speichern","save":"Speichern","cancel":"Abbrechen","headers":{"metric":"Metrik","table":"Tabelle","collection":"Sammlung"}},"updated_successfully":"Metriken erfolgreich aktualisiert","updated_failed":"Der Datensatz, den Sie bearbeiten, wurde durch einen anderen Benutzer verändert. Ihre vorgenommenen Änderungen wurden nicht gespeichert. Bitte versuchen Sie es erneut.","linked_metric":{"not_found":"{{name}} wurde aus der Ergebnisse-App gelöscht und ist nicht mehr verfügbar.","insufficient_data":"Die Daten reichen zur Berechnung von {{name}} in der Ergebnisse-App nicht aus.","no_response":"Wir konnten keine Metriken laden. Aktualisieren Sie die Seite und versuchen Sie es erneut.","unlink_metric_button":"Verknüpfung mit Metrik aufheben","unlink_metric_header":"Verknüpfung mit Metriken aufheben?","unlink_metric_body":"Wenn Sie die Verknüpfung mit dieser Metrik aufheben, werden alle verbundenen Bewertungsfaktoren endgültig entfernt.","archived_html":"Diese Metrik stammt aus einer <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">archivierten Sammlung <i class=\"acl-i-arrow-up-b\"></i></a> und ist schreibgeschützt. Es wurden keine Daten hinzugefügt oder geändert."},"add_description":"+ Fügen Sie der Metrik eine Beschreibung hinzu, um den Kontext zu erhöhen...","formatting":{"blank":"(leer)","date":{"default":"D. MMM YYYY"},"time":{"default":"HH:mm:ss","error":"unbekannte Zeit"},"datetime":{"default":"D. MMM YYYY HH:mm:ss"},"numeric":{"abbreviations":{"thousand":"Tsd.","million":"Mio.","billion":"Mrd.","trillion":"Bio."}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Eindeutige Werte","blanks":"Leere Felder","percent":"% der Summe","count":"Anzahl","positives":"Positive","negatives":"Negative","zeros":"Nullen","total":"Summen","average":"Durchschnitt","lowest":"Niedrigste","highest":"Höchste","standard_deviation":"Std. Abweichung"},"sparkline":{"axis_date":{"day":"D. MMM YYYY","month":"MMM YYYY","quarter":"[Q]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Vergrößern/Verkleinern zurücksetzen","reset_zoom_tooltip":"Einstellung für Vergrößern/Verkleinern zurücksetzen"},"indicator":{"empty":{"no_sparkline_data":"Zur Erstellung einer Sparkline gibt es nicht genügend Daten.","no_preview_data":"Zur Berechnung dieser Metrik sind keine ausreichenden Daten verfügbar. Versuchen Sie, Ihre Filter zu ändern oder zur Berechnung der Metrik mehr Daten hinzuzufügen."}}},"global_navigation":{"navigation_items":{"logo":"Zurück zum Launchpad","app_switcher":"Apps wechseln","announcer":"Ankündigungen","helper":"Hilfe und Support","user":"Angemeldet: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Anmelden"},"apps":{"academy":"Akademie","community":"Community","projects":"Projekte","results":"Ergebnisse","storyboards":"Storyboards","mission_control":"Kontrollzentrum","risks":"Strategie","reports":"Berichte","launchpad":"Launchpad","robots":"Robots","frameworks":"Frameworks","compliance_maps":"Compliance-Maps","assurance_plans":"Sicherungspläne","project_scheduler":"Ablaufplaner","issue_tracker":"Problemverfolgung","task_tracker":"Aufgabenverfolgung","project_timesheets":"Stundennachweise","dashboard":"{{module}}-Dashboard","master_library":"Master-Bibliothek"},"app_sections":{"setup":"Einstellungen","workspace":"Arbeitsbereich","automation":"Automatisierung"},"user":{"my_profile":"Mein Profil","log_out":"Abmelden"},"helper":{"help_docs":"Hilfedokumente","support":"Support"},"skip_button":"Bis Hauptinhalt überspringen","logo":"Logo","other":"Andere","section":"Abschnitt"},"contacts_dropdown":{"contacts":"Ansprechpartner","custom_value_a11y":"{{nameFieldLabel}} Textfeld","custom_value_enter":"{{customValue}} als {{nameFieldLabel}} hinzufügen und eine E-Mail-Adresse manuell eingeben.","select_placeholder":"Benutzer angeben...","search_a11y":"Sie können nach einem Benutzer oder einem Kontakt suchen. Wenn keine Suchergebnisse zurückgegeben werden, verwenden Sie den Suchwert als {{nameFieldLabel}}-Name","search_placeholder":"Benutzer suchen oder einen neuen Namen eingeben...","email_address":"E-Mail-Adresse","email_address_error":"Die E-Mail-Adresse muss gültig sein","users":"Benutzer","contacts_error":"Ihr Kontaktbuch wurde nicht geladen."},"resource_sharing":{"loading_collaborators":"Wird geladen...","add_collaborators_search_placeholder":"Gruppen oder Einzelpersonen suchen...","manage_collaborators":"Mitarbeiter verwalten","close":"Schließen","disabled":"Gesperrt","disabled_a11y_text":"Deaktivierte Gruppe","disabled_group_tooltip":"Diese Gruppe hat <strong>keinen Zugriff</strong>, weil die Gruppe in Launchpad deaktiviert wurde. Systemadministratoren können die Gruppe wieder aktivieren.","add_collaborators":"Mitarbeiter hinzufügen","add_collaborators_loading_tooltip":"Bitte warten Sie, bis die Liste der Personen geladen wurde.","individuals":"Einzelpersonen","individuals_section_tooltip_button":"QuickInfo zum Abschnitt \"Einzelpersonen\"","individuals_section_tooltip":"Der Zugriff einer Person muss mindestens so hoch sein, wie der Zugriff der zugewiesenen Gruppe. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">Erfahren Sie mehr</a>.","no_results_found":"Keine Ergebnisse gefunden","show_more":"Mehr anzeigen","remove":"Entfernen","collaborators_widget":{"add":"Hinzufügen","manage":"Verwalten","view":"Anzeigen","more_users_tooltip":"{{remaining_users}} andere"},"side_panel":{"cancel":"Abbrechen","groups_count":"{{count}} Gruppe","groups_count_plural":"{{count}} Gruppen","individuals_count":"{{count}} Person","individuals_count_plural":"{{count}} Personen","title":"‘{{resource_name}}’ freigeben","save":"Speichern"},"groups":"Gruppen","group_members_count":"({{count}} Mitglied)","group_members_count_plural":"({{count}} Mitglieder)","disabled_role":"(deaktiviert)","no_access":"Kein Zugriff","default":"Standard","default_a11y_text":"Standardgruppe","success_message":"{{resource_name}} wurde erfolgreich aktualisiert.","error_message":"Irgendetwas ist fehlgeschlagen. Aktualisieren Sie bitte die Seite und versuchen Sie es erneut. Wenn das Problem erneut auftritt, wenden Sie an unser Support-Team."},"attribute_types_details":{"Bool":"Boole'scher Wert","Date":"Datum","DateTime":"Datum-Uhrzeit","Number":"Nummer","Paragraph":"Absatz","Text":"Text","Select":"Auswählen","widgets":{"false":"Falsch","true":"Richtig","allow_decimals":"Dezimalzahlen zulassen","allow_rich_text":"Rich-Text zulassen","display_24_hour_time":"Zeit im 24-Stunden-Format","option":"Option","set_default_values":"Standardwert festlegen","specific_date_time":"Bestimmte Datumzeit","users_current_date_time":"Aktuelles Datum/Uhrzeit des Benutzers","weight":"Gewicht","select":{"allow_multiple":"Mehrfachauswahl zulassen","name":"Name","score":"Einstufung","color":"Farbe","add_option":"+ Option hinzufügen","default_value_placeholder":"Standardwert auswählen...","name_placeholder":"Name...","score_placeholder":"Einstufung...","color_placeholder":"Farbe...","errors":{"name_is_required":"Name ist erforderlich.","name_exceeds_limit":"Name überschreitet die maximale Zeichenanzahl.","score_range":"Einstufung sollte zwischen 0 und 9.999.999.999,999 betragen.","score_decimal":"Einstufung sollte auf 3 Nachkommastellen gerundet werden.","color_hex":"Die verwendete Farbe ist kein gültiger Hex-Code."}}}},"asset_type":{"activity_log_link":"Vollständiges Aktivitätsprotokoll anzeigen"},"attribute_type":{"created_by":"Erstellt am {{date}} von {{name}}","display_name":{"label_checkbox":"Unterschiedlicher Anzeigename im Anlagentyp","placeholder":"Anzeigename"},"edited_by":"Bearbeitet am {{date}} von {{name}}","is_global":{"label":"Global (kann in einem beliebigen Anlagentyp verwendet werden)"},"is_hidden":{"label":"Ausgeblendet (für Workflows)"},"is_required":{"label":"Pflichtfeld"},"label":"Name des Attributtyps","placeholder":"Name des Attributtyps","recent_activity":"Letzte Aktivitäten","tooltip":{"label_checkbox":"Kontextinformationen werden im QuickInfo angezeigt","placeholder":"Kontextinformationen werden im QuickInfo angezeigt"}}}}}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = {"en":{"translation":{"edit_conflict":{"header":"Edit Conflict","description":"This record changed while you were editing:","notice":"This {{term}} changed while you were editing.","options":{"save_your_edit":"To save your edit, copy the text from the editor into your clipboard\nusing right click of your mouse. When you refresh the screen or click Save Changes,\nthe new record will be loaded.\nYou will need to manually merge your text to the new record.\n","discard_your_changes":"To discard your changes and load the new record,\nsimply refresh the screen or click Save button.\n","save_changes":"To save your changes, copy the text to another program,\nrefresh your browser or click Save, and manually merge your changes.\n","discard_changes":"To discard your changes, refresh your browser."}},"delete_conflict":{"header":"Delete Conflict","notice":"This {{term}} has been deleted and is no longer available.","options":{"save_changes":"To save your changes, copy the text to another program,\nand enter the information in a new %{term} form.\n","discard_changes":"To discard your changes, close the form and refresh your browser."}},"assessment_drivers":{"notifications":{"assessment_disabled":"This Assessment Driver is currently disabled."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"A problem occured while saving the Assessment Driver, please try again.","metric_deleted":"{{name}} has been deleted from the Results app and is no longer available.","targetable_field_changed":"The scale for {{name}} has been changed. Review and enable this Assessment Driver again.","metric_updated":"{{name}}'s configuration has been changed in the Results app. Review and enable this Assessment Driver again.","insufficient_data":"There is not enough data to calculate {{name}} in the Results app.","invalid_data":"The value for {{name}} is {{value}} and cannot be properly processed by the Assessment Driver.","saved_failed":"There was a problem with the server and we were unable to save your changes, please try again.","no_response":"We are unable to load Metrics."}}}},"success_saving":"{{target}} {{targetableField}} rating was successfully automated.","bubbly_header":"Automate your {{target_term}} assessments","bubbly_content_html":"Assessment Drivers allow you to keep your assessments current, in real-time. Use pre-defined metric ranges to assess your {{target_term}} and notify key stakeholders when changes occur. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">Learn more.</a>","bubbly_footer":"Don't show this tip again.","save":"Save","cancel":"Cancel","enable":"Enable Assessment Driver","delete":"Delete","delete_popover":{"title":"Delete Assessment Driver?","description":"You will not be able to access or restore this item."},"tour":{"description":{"step_one":"Define the conditions that need to occur for the {{target_term}} assessment to automatically update to the specified score.","step_two":"As you enter values in the right column, the left column is auto-populated with the next sequential value."},"navigation":{"back":"Back","close":"Close","done":"Done","next":"Next"}},"title":{"new":"New Assessment Driver","edit":"Edit Assessment Driver"},"dropdowns":{"entity":"Entity","process":"Process","metric":"Metric","tooltip":"Disable Assessment Driver to pause automated {{target_term}} assessment.","help_icon_text_risk":"Only risks that have Metrics linked can be selected.","automated":"%{name} (automation set)","placerholder_entity":"Select a(n) %{operating_segment}...","placeholder_metric":"Select a Metric..."},"metric_ranges":{"errors":{"format_error":"Only numbers are valid.","range_error":"Ranges cannot overlap."},"dropdown":{"less_than":"less than","greater_than":"greater than","equal_to":"or equal to"}},"more_information":"More information"},"metrics":{"title":"No Metrics Linked Yet","header":"Metrics","add_or_remove":"Add/Remove","description_html":"Metrics are quantifiable measures used to track, monitor, and assess {{targetTerm}}. You can link Metrics to a {{targetTerm}} to help inform the assessment.","start_linking":"Link Metrics","done_editing":"Done","edit_metrics":"Edit Metrics","view_data":"View Data","learn_more":{"label":"Learn more."},"link_table":{"title":"Select Metrics to link","search_placeholder":"Search Metrics","no_metrics_available":"No Metrics Available to Link","no_metrics_available_description":"Metrics are quantifiable measures used to track, monitor, and assess {{targetTerm}}. Once you have created a Metric, you can link it to a {{targetTerm}}.","unlink_confirmation_button":"Unlink and save changes","save":"Save","cancel":"Cancel","headers":{"metric":"Metric","table":"Table","collection":"Collection"}},"updated_successfully":"Successfully updated Metrics","updated_failed":"The record you are working on has been modified by another user. The changes you made were not saved, please try again.","linked_metric":{"not_found":"{{name}} has been deleted from Results and is no longer available.","insufficient_data":"There is not enough data to calculate {{name}} in the Results app.","no_response":"We are unable to load Metrics. Refresh the page to try again.","unlink_metric_button":"Unlink Metric","unlink_metric_header":"Unlink Metrics?","unlink_metric_body":"Unlinking this Metric will permanently remove any associated Assessment Drivers.","archived_html":"This metric is from an <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">archived collection <i class=\"acl-i-arrow-up-b\"></i></a> and is read-only. No data can be added or changed."},"add_description":"+ Add a description to give the Metric context...","formatting":{"blank":"(blank)","date":{"default":"MMM D, YYYY"},"time":{"default":"h:mm:ss A","error":"unknown time"},"datetime":{"default":"MMM D, YYYY h:mm:ss A"},"numeric":{"abbreviations":{"thousand":"k","million":"m","billion":"b","trillion":"t"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Unique Values","blanks":"Blanks","percent":"% of Total","count":"Count","positives":"Positives","negatives":"Negatives","zeros":"Zeros","total":"Total","average":"Average","lowest":"Lowest","highest":"Highest","standard_deviation":"Std. Deviation"},"sparkline":{"axis_date":{"day":"MMM DD, YYYY","month":"MMM, YYYY","quarter":"[Q]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Reset zoom","reset_zoom_tooltip":"Reset zoom level"},"indicator":{"empty":{"no_sparkline_data":"There isn’t enough data to generate a spark line.​","no_preview_data":"There is not enough data to calculate this metric. Try changing your filters or adding more data to calculate the metric."}}},"global_navigation":{"navigation_items":{"logo":"Back to Launchpad","app_switcher":"Switch Apps","announcer":"Announcements","helper":"Help and Support","user":"Signed in: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Sign in"},"apps":{"academy":"Academy","community":"Community","projects":"Projects","results":"Results","storyboards":"Storyboards","mission_control":"Mission Control","risks":"Strategy","reports":"Reports","launchpad":"Launchpad","robots":"Robots","frameworks":"Frameworks","compliance_maps":"Compliance Maps","assurance_plans":"Assurance Plans","project_scheduler":"Scheduler","issue_tracker":"Issue Tracker","task_tracker":"Task Tracker","project_timesheets":"Timesheets","dashboard":"{{module}} Dashboard","master_library":"Master Library"},"app_sections":{"setup":"Setup","workspace":"Workspace","automation":"Automation"},"user":{"my_profile":"My Profile","log_out":"Log Out"},"helper":{"help_docs":"Help Docs","support":"Support"},"skip_button":"Skip to main content","logo":"logo","other":"Other","section":"section"},"contacts_dropdown":{"contacts":"Contacts","custom_value_a11y":"{{nameFieldLabel}} text field","custom_value_enter":"Add {{customValue}} as {{nameFieldLabel}} and manually enter an email address.","select_placeholder":"Specify a user...","search_a11y":"Search for user or contact. If there are no search results then use the search value as the {{nameFieldLabel}} name","search_placeholder":"Search users or enter a new name...","email_address":"Email address","email_address_error":"Email address should be valid","users":"Users","contacts_error":"Your contact book was not loaded."},"resource_sharing":{"loading_collaborators":"Loading...","add_collaborators_search_placeholder":"Search groups or individuals...","manage_collaborators":"Manage collaborators","close":"Close","disabled":"Disabled","disabled_a11y_text":"Disabled group","disabled_group_tooltip":"This group has <strong>no access</strong> because the group has been disabled in Launchpad. System admins can re-enable the group.","add_collaborators":"Add Collaborators","add_collaborators_loading_tooltip":"Please wait until the list of individuals is loaded.","individuals":"Individuals","individuals_section_tooltip_button":"Individuals Section Tooltip","individuals_section_tooltip":"Individual access must be equal to or higher than assigned group access. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">Learn more</a>.","no_results_found":"No results found","show_more":"Show more","remove":"Remove","collaborators_widget":{"add":"Add","manage":"Manage","view":"View","more_users_tooltip":"{{remaining_users}} others"},"side_panel":{"cancel":"Cancel","groups_count":"{{count}} group","groups_count_plural":"{{count}} groups","individuals_count":"{{count}} individual","individuals_count_plural":"{{count}} individuals","title":"Share ‘{{resource_name}}’","save":"Save"},"groups":"Groups","group_members_count":"({{count}} member)","group_members_count_plural":"({{count}} members)","disabled_role":"(disabled)","no_access":"No access","default":"Default","default_a11y_text":"Default group","success_message":"{{resource_name}} was successfully updated.","error_message":"Something went wrong. Please refresh the page to try again. If the problem persists, contact our support team."},"attribute_types_details":{"Bool":"Boolean","Date":"Date","DateTime":"Date Time","Number":"Number","Paragraph":"Paragraph","Text":"Text","Select":"Select","widgets":{"false":"False","true":"True","allow_decimals":"Allow decimals","allow_rich_text":"Allow rich text","display_24_hour_time":"Display 24-hour time","option":"Option","set_default_values":"Set default value","specific_date_time":"Specific DateTime","users_current_date_time":"User’s current date/time","weight":"Weight","select":{"allow_multiple":"Allow multiple selections","name":"Name","score":"Score","color":"Color","add_option":"+ Add option","default_value_placeholder":"Select default value...","name_placeholder":"Name...","score_placeholder":"Score...","color_placeholder":"Color...","errors":{"name_is_required":"Name is required.","name_exceeds_limit":"Name exceeds character limit.","score_range":"Score should between 0 and 9,999,999,999.999.","score_decimal":"Score should be rounded to 3 decimals.","color_hex":"Color used is not a valid hex code."}}}},"asset_type":{"activity_log_link":"See full activity log"},"attribute_type":{"created_by":"Created by {{name}} on {{date}}","display_name":{"label_checkbox":"Different display name in asset type","placeholder":"Display name"},"edited_by":"Edited by {{name}} on {{date}}","is_global":{"label":"Global (can be used in any asset type)"},"is_hidden":{"label":"Hidden (used for workflows)"},"is_required":{"label":"Required field"},"label":"Attribute type name","placeholder":"Attribute type name","recent_activity":"Recent activity","tooltip":{"label_checkbox":"Contextual info shown in tooltip","placeholder":"Contextual info shown in tooltip"}}}}}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = {"es":{"translation":{"edit_conflict":{"header":"Editar conflicto","description":"Este registro cambió mientras estaba editando:","notice":"Este(a) {{term}} cambió mientras estaba editando.","options":{"save_your_edit":"Para guardar su edición, copie el texto desde el editor en el portapapeles\nhaciendo clic en el botón derecho de su ratón. Al actualizar la pantalla o hacer clic en Guardar cambios,\nse cargará el nuevo registro.\nTendrá que fusionar manualmente el texto con el nuevo registro.\n","discard_your_changes":"Para descartar los cambios y cargar el nuevo registro,\nsimplemente actualizar la pantalla o hacer clic en el botón Guardar.\n","save_changes":"Para guardar los cambios, copie el texto a otro programa,\nactualice el navegador o haga clic en Guardar y combine manualmente los cambios.\n","discard_changes":"Para descartar los cambios, actualice su navegador."}},"delete_conflict":{"header":"Eliminar conflicto","notice":"Este(a) {{term}} se ha eliminado y ya no está disponible.","options":{"save_changes":"Para guardar los cambios, copie el texto a otro programa e\nintroduzca la información en un nuevo formulario de %{term}.\n","discard_changes":"Para descartar los cambios, cierre el formulario y actualice su navegador."}},"assessment_drivers":{"notifications":{"assessment_disabled":"Este controlador de evaluación actualmente está desactivado."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"Se ha producido un problema al guardar el controlador de evaluación. Vuelva a intentarlo.","metric_deleted":"{{name}} se ha eliminado de la aplicación Resultados y ya no está disponible.","targetable_field_changed":"Se ha cambiado la escala de {{name}}. Revise y vuelva a habilitar este controlador de evaluación.","metric_updated":"La configuración de {{name}} se ha cambiado en la aplicación Resultados. Revise y active este controlador de evaluación nuevamente.","insufficient_data":"No hay suficientes datos para calcular {{name}} en la aplicación Resultados.","invalid_data":"El valor de {{name}} es {{value}} y no puede ser procesado correctamente por el controlador de evaluación.","saved_failed":"Hubo un problema con el servidor y no pudimos guardar los cambios, intente de nuevo.","no_response":"No podemos cargar Medidas."}}}},"success_saving":"La calificación de {{targetableField}} de {{target}} se automatizó con éxito.","bubbly_header":"Automatice sus evaluaciones de {{target_term}}","bubbly_content_html":"Los controladores de evaluación le permiten mantener sus evaluaciones actualizadas, en tiempo real. Utilice rangos de medidas predefinidos para evaluar su {{target_term}} y notificar a las partes interesadas clave cuando ocurran cambios. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">Obtener más información.</a>","bubbly_footer":"No mostrar este consejo de nuevo.","save":"Guardar","cancel":"Cancelar","enable":"Habilitar controlador de evaluación","delete":"Eliminar","delete_popover":{"title":"¿Eliminar controlador de evaluación?","description":"No podrá acceder a este elemento ni restaurarlo."},"tour":{"description":{"step_one":"Defina las condiciones que deben ocurrir para que la evaluación de {{target_term}} se actualice automáticamente a la calificación especificada.","step_two":"Cuando se introducen valores en la columna de la derecha, la columna izquierda se rellena automáticamente con el siguiente valor secuencial."},"navigation":{"back":"Atrás","close":"Cerrar","done":"Terminado","next":"Siguiente"}},"title":{"new":"Nuevo controlador de evaluación","edit":"Editar controlador de evaluación"},"dropdowns":{"entity":"Entidad","process":"Proceso","metric":"Medida","tooltip":"Desactive el controlador de evaluación para pausar la evaluación automática de {{target_term}}.","help_icon_text_risk":"Solo se pueden seleccionar los riesgos que tienen medidas enlazadas.","automated":"%{name} (conjunto de automatización)","placerholder_entity":"Seleccione un(a) %{operating_segment}...","placeholder_metric":"Seleccione una medida..."},"metric_ranges":{"errors":{"format_error":"Solo son válidos los números.","range_error":"Los rangos no se pueden superponer."},"dropdown":{"less_than":"menor que","greater_than":"mayor que","equal_to":"o igual a"}},"more_information":"Más información"},"metrics":{"title":"No hay medidas enlazadas todavía","header":"Medidas","add_or_remove":"Agregar/quitar","description_html":"Las medidas son mediciones cuantificables que se usan para seguir, monitorear y evaluar {{targetTerm}}. Puede enlazar Medidas a un {{targetTerm}} para ayudar a informar la evaluación.","start_linking":"Enlazar medidas","done_editing":"Terminado","edit_metrics":"Editar medidas","view_data":"Ver datos","learn_more":{"label":"Obtener más información."},"link_table":{"title":"Seleccione las medidas a enlazar","search_placeholder":"Buscar medidas","no_metrics_available":"No hay medidas disponibles para enlazar","no_metrics_available_description":"Las medidas son mediciones cuantificables que se usan para seguir, monitorear y evaluar {{targetTerm}}. Una vez que haya creado una medida, puede enlazarla con un {{targetTerm}}.","unlink_confirmation_button":"Desenlazar y guardar cambios","save":"Guardar","cancel":"Cancelar","headers":{"metric":"Medida","table":"Tabla","collection":"Colección"}},"updated_successfully":"Las medidas se actualizaron con éxito","updated_failed":"El registro en el que está trabajando ha sido modificado por otro usuario. Los cambios realizados no se guardaron, vuelva a intentarlo.","linked_metric":{"not_found":"{{name}} se ha eliminado de Resultados y ya no está disponible.","insufficient_data":"No hay suficientes datos para calcular {{name}} en la aplicación Resultados.","no_response":"No podemos cargar Medidas. Actualice la página para volver a intentarlo.","unlink_metric_button":"Desenlazar medida","unlink_metric_header":"¿Desenlazar medidas?","unlink_metric_body":"La desvinculación de esta medida quitará permanentemente los controladores de evaluación asociados.","archived_html":"Esta medida es de una <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">colección archivada <i class=\"acl-i-arrow-up-b\"></i></a> y es de solo lectura. No se pueden agregar ni modificar datos."},"add_description":"+ Agregue una descripción para dar el contexto de la medida...","formatting":{"blank":"(en blanco)","date":{"default":"D MMM YYYY"},"time":{"default":"hh:mm:ss A","error":"hora desconocida"},"datetime":{"default":"D MMM YYYY hh:mm:ss A"},"numeric":{"abbreviations":{"thousand":"k","million":"mm","billion":"b","trillion":"t"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Valores únicos","blanks":"Blancos","percent":"% del total","count":"Recuento","positives":"Positivos","negatives":"Negativos","zeros":"Ceros","total":"Total","average":"Promedio","lowest":"Más bajo","highest":"Más alto","standard_deviation":"Desviación estándar"},"sparkline":{"axis_date":{"day":"DD MMM YYYY","month":"MMM YYYY","quarter":"[T]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Restablecer el zoom","reset_zoom_tooltip":"Restablecer el nivel de zoom"},"indicator":{"empty":{"no_sparkline_data":"No hay datos suficientes para generar un minigráfico.","no_preview_data":"No hay datos suficientes para calcular esta medida. Intente cambiar los filtros o agregar más datos para calcular la medida."}}},"global_navigation":{"navigation_items":{"logo":"Volver a Launchpad","app_switcher":"Cambiar aplicaciones","announcer":"Anuncios","helper":"Ayuda y soporte","user":"Inició sesión: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Iniciar sesión"},"apps":{"academy":"Academia","community":"Comunidad","projects":"Proyectos","results":"Resultados","storyboards":"Storyboards","mission_control":"Control de la misión","risks":"Estrategia","reports":"Reportes","launchpad":"Launchpad","robots":"Robots","frameworks":"Marcos","compliance_maps":"Mapas de cumplimiento","assurance_plans":"Planes de aseguramiento","project_scheduler":"Programador","issue_tracker":"Rastreador de asuntos","task_tracker":"Rastreador de tareas","project_timesheets":"Planillas de horas","dashboard":"Tablero de mando de {{module}}","master_library":"Biblioteca maestra"},"app_sections":{"setup":"Configuración","workspace":"Área de trabajo","automation":"Automatización"},"user":{"my_profile":"Mi perfil","log_out":"Finalizar la sesión"},"helper":{"help_docs":"Documentos de ayuda","support":"Soporte"},"skip_button":"Ir al contenido principal","logo":"logotipo","other":"Otro","section":"sección"},"contacts_dropdown":{"contacts":"Contactos","custom_value_a11y":"Campo de texto {{nameFieldLabel}}","custom_value_enter":"Agregue {{customValue}} como {{nameFieldLabel}} e ingrese manualmente una dirección de correo electrónico.","select_placeholder":"Especifique un usuario...","search_a11y":"Buscar usuario o contacto. Si no hay resultados de búsqueda, utilice el valor de búsqueda como nombre de {{nameFieldLabel}}","search_placeholder":"Busque usuarios o ingrese un nuevo nombre...","email_address":"Dirección de correo electrónico","email_address_error":"La dirección de correo electrónico debe ser válida","users":"Usuarios","contacts_error":"Su libreta de contactos no se cargó."},"resource_sharing":{"loading_collaborators":"Cargando...","add_collaborators_search_placeholder":"Buscar grupos o individuos...","manage_collaborators":"Administrar colaboradores","close":"Cerrar","disabled":"Desactivado","disabled_a11y_text":"Grupo desactivado","disabled_group_tooltip":"Este grupo <strong>no tiene acceso</strong> porque el grupo ha sido desactivado en Launchpad. Los administradores del sistema pueden reactivar el grupo.","add_collaborators":"Agregar colaboradores","add_collaborators_loading_tooltip":"Por favor, espere hasta que se cargue la lista de personas.","individuals":"Personas","individuals_section_tooltip_button":"Información sobre herramientas de la sección Personas","individuals_section_tooltip":"El acceso individual debe ser igual o superior al acceso de grupo asignado. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">Obtener más información</a>.","no_results_found":"No se han encontrado resultados","show_more":"Mostrar más","remove":"Quitar","collaborators_widget":{"add":"Agregar","manage":"Gestionar","view":"Ver","more_users_tooltip":"{{remaining_users}} otros"},"side_panel":{"cancel":"Cancelar","groups_count":"{{count}} grupo","groups_count_plural":"{{count}} grupos","individuals_count":"{{count}} individuo","individuals_count_plural":"{{count}} individuos","title":"Compartir ‘{{resource_name}}’","save":"Guardar"},"groups":"Grupos","group_members_count":"({{count}} miembro)","group_members_count_plural":"({{count}} miembros)","disabled_role":"(desactivado)","no_access":"Sin acceso","default":"Predeterminado","default_a11y_text":"Grupo predeterminado","success_message":"{{resource_name}} fue actualizado con éxito.","error_message":"Algo salió mal. Por favor, actualice la página para volver a intentarlo. Si el problema persiste, comuníquese con nuestro equipo de soporte."},"attribute_types_details":{"Bool":"Booleano","Date":"Fecha","DateTime":"Fecha hora","Number":"Número","Paragraph":"Párrafo","Text":"Texto","Select":"Seleccionar","widgets":{"false":"Falso","true":"Verdadero","allow_decimals":"Permitir decimales","allow_rich_text":"Permitir texto enriquecido","display_24_hour_time":"Mostrar el tiempo en 24 horas","option":"Opción","set_default_values":"Establecer valor predeterminado","specific_date_time":"Fechahora específica","users_current_date_time":"Fecha/hora actual del usuario","weight":"Peso","select":{"allow_multiple":"Permitir varias selecciones","name":"Nombre","score":"Calificación","color":"Color","add_option":"+ Agregar opción","default_value_placeholder":"Seleccionar valor predeterminado...","name_placeholder":"Nombre...","score_placeholder":"Calificación...","color_placeholder":"Color...","errors":{"name_is_required":"El nombre es obligatorio.","name_exceeds_limit":"El nombre excede el límite de caracteres.","score_range":"La calificación debe estar entre 0 y 9.999.999.999,999.","score_decimal":"La calificación debe redondearse a 3 decimales.","color_hex":"El color utilizado no es un código hexadecimal válido."}}}},"asset_type":{"activity_log_link":"Ver log completo de actividades"},"attribute_type":{"created_by":"Creado por {{name}} el {{date}}","display_name":{"label_checkbox":"Nombre visible diferente en el tipo de activo","placeholder":"Nombre visible"},"edited_by":"Editado por {{name}} el {{date}}","is_global":{"label":"Global (se puede usar en cualquier tipo de activo)"},"is_hidden":{"label":"Oculto (utilizado para flujos de trabajo)"},"is_required":{"label":"Campo obligatorio"},"label":"Nombre del tipo de atributo","placeholder":"Nombre del tipo de atributo","recent_activity":"Actividad reciente","tooltip":{"label_checkbox":"Información contextual que se muestra en la información sobre herramientas","placeholder":"Información contextual que se muestra en la información sobre herramientas"}}}}}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = {"fr":{"translation":{"edit_conflict":{"header":"Modifier le conflit","description":"Cet enregistrement a changé pendant que vous étiez en train de le modifier :","notice":"Ce(tte) {{term}} a changé pendant que vous étiez en train d'y apporter des modifications.","options":{"save_your_edit":"Pour sauvegarder votre modification, copiez le texte à partir de l'éditeur vers votre presse-papiers\nà l'aide du bouton droit de votre souris. Lorsque vous actualisez l'écran ou que vous cliquez sur Sauvegarder les modifications,\nle nouvel enregistrement est chargé.\nIl vous faudra fusionner manuellement votre texte avec le nouvel enregistrement.\n","discard_your_changes":"Pour abandonner vos modifications et charger le nouvel enregistrement,\nactualisez simplement l'écran ou cliquez sr le bouton Sauvegarder.\n","save_changes":"Pour enregistrer vos modifications, copiez le texte dans un autre programme,\nactualisez votre navigateur ou cliquez sur Enregistrer, puis fusionnez manuellement vos modifications.\n","discard_changes":"Pour abandonner vos modifications, actualisez votre navigateur."}},"delete_conflict":{"header":"Supprimer le conflit","notice":"Ce(tte) {{term}} a été supprimé(e) et n'est plus disponible.","options":{"save_changes":"Pour enregistrer vos modifications, copiez le texte dans un autre programme,\npuis saisissez les informations dans un nouveau formulaire %{term}.\n","discard_changes":"Pour abandonner vos modifications, fermez le formulaire et actualisez votre navigateur."}},"assessment_drivers":{"notifications":{"assessment_disabled":"Ce pilote d'évaluation est actuellement désactivé."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"Un problème s'est produit pendant l'enregistrement du pilote d'évaluation, veuillez réessayer.","metric_deleted":"{{name}} a été supprimé de l'application Résultats et n'est plus disponible.","targetable_field_changed":"Le barème pour {{name}} a été modifié. Examinez et activez à nouveau ce pilote d'évaluation.","metric_updated":"La configuration de {{name}} a été modifiée dans l'application Résultats. Examinez et activez à nouveau ce pilote d'évaluation.","insufficient_data":"Il n'y a pas assez de données pour calculer {{name}} dans l'application Résultats.","invalid_data":"La valeur pour {{name}} est {{value}} et ne peut pas être correctement traitée par le pilote d'évaluation.","saved_failed":"Un problème s'est produit avec le serveur et nous n'avons pas pu enregistré vos modifications, essayez à nouveau.","no_response":"Nous n'avons pas pu charger les mesures."}}}},"success_saving":"L'évaluation pour {{target}} {{targetableField}} a été correctement automatisée.","bubbly_header":"Automatisez vos évaluations pour {{target_term}}","bubbly_content_html":"Les pilotes d'évaluation vous permettent de tenir à jour vos évaluations, en temps réel. Utilisez des plages de mesures pré-définies pour évaluer {{target_term}} et avertir les intervenants clés en cas de modifications. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">En savoir plus.</a>","bubbly_footer":"Ne plus afficher cette astuce.","save":"Enregistrer","cancel":"Annuler","enable":"Activer le pilote d'évaluation","delete":"Supprimer","delete_popover":{"title":"Supprimer le pilote d'évaluation ?","description":"Vous ne pourrez plus accéder à cet élément ni le restaurer."},"tour":{"description":{"step_one":"Définissez les conditions qui doivent se produire pour l'évaluation de {{target_term}} afin de permettre la mise à jour automatique avec le score indiqué.","step_two":"Pendant que vous saisissez les valeurs dans la colonne de droite, la colonne de gauche est automatiquement renseignée avec la valeur séquentielle suivante."},"navigation":{"back":"Retour","close":"Fermer","done":"Terminé","next":"Suivant"}},"title":{"new":"Nouveau pilote d'évaluation","edit":"Modifier le pilote d'évaluation"},"dropdowns":{"entity":"Entité","process":"Processus","metric":"Mesure","tooltip":"Désactiver le pilote d'évaluation pour mettre en suspens l'évaluation automatisée de {{target_term}}.","help_icon_text_risk":"Seuls les risques ayant une mesure liée peuvent être sélectionnés.","automated":"%{name} (jeu d'automatisation)","placerholder_entity":"Sélectionnez un(e) %{operating_segment}...","placeholder_metric":"Sélectionner une mesure..."},"metric_ranges":{"errors":{"format_error":"Seuls les chiffres sont valides.","range_error":"Les plages ne peuvent pas se chevaucher."},"dropdown":{"less_than":"inférieur à","greater_than":"supérieur à","equal_to":"ou égal à"}},"more_information":"Plus d'informations"},"metrics":{"title":"Aucune mesure encore liée","header":"Mesures","add_or_remove":"Ajouter/Supprimer","description_html":"Les mesures sont des relevés quantifiables qui permettent de suivre, surveiller et évaluer {{targetTerm}}. Vous pouvez lier les mesures avec {{targetTerm}} pour simplifier la compréhension de l'évaluation.","start_linking":"Lier les mesures","done_editing":"Terminé","edit_metrics":"Modifier les mesures","view_data":"Voir les données","learn_more":{"label":"En savoir plus."},"link_table":{"title":"Sélectionner des mesures à lier","search_placeholder":"Rechercher des mesures","no_metrics_available":"Pas de mesures disponibles pour le lien","no_metrics_available_description":"Les mesures sont des relevés quantifiables qui permettent de suivre, surveiller et évaluer {{targetTerm}}. Une fois que vous avez créé une mesure, vous pouvez la lier à un {{targetTerm}}.","unlink_confirmation_button":"Supprimer le lien et enregistrer les modifications","save":"Enregistrer","cancel":"Annuler","headers":{"metric":"Mesure","table":"Table","collection":"Collection"}},"updated_successfully":"Mesures correctement mises à jour","updated_failed":"Un autre utilisateur a modifié l'enregistrement sur lequel vous travaillez. Les modifications que vous avez apportées n'ont pas été enregistrées, essayez à nouveau.","linked_metric":{"not_found":"{{name}} a été supprimé de Résultats et n'est plus disponible.","insufficient_data":"Il n'y a pas assez de données pour calculer {{name}} dans l'application Résultats.","no_response":"Nous n'avons pas pu charger les mesures. Rafraîchissez la page pour essayer à nouveau.","unlink_metric_button":"Annuler le lien de la mesure","unlink_metric_header":"Annuler le lien des mesures ?","unlink_metric_body":"L'annulation du lien de cette mesure supprime de manière définitive tout pilote d'évaluation associé.","archived_html":"Cette mesure provient d'une <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">collection archivée <i class=\"acl-i-arrow-up-b\"></i></a> et est en lecture seule. Impossible d'ajouter ou de modifier des données."},"add_description":"+ Ajouter une description pour spécifier le contexte de la mesure...","formatting":{"blank":"(vide)","date":{"default":"D MMM YYYY"},"time":{"default":"HH:mm:ss","error":"heure inconnue"},"datetime":{"default":"D MMM YYYY HH:mm:ss"},"numeric":{"abbreviations":{"thousand":"k","million":"M","billion":"Md(s)","trillion":"T"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Valeurs uniques","blanks":"Vides","percent":"% du total","count":"Compte","positives":"Positifs","negatives":"Négatifs","zeros":"Zéros","total":"Total","average":"Moyenne","lowest":"Plus bas","highest":"Plus élevé","standard_deviation":"Ecart-Type"},"sparkline":{"axis_date":{"day":"DD MMM YYYY","month":"MMM YYYY","quarter":"[T]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Réinitialiser le zoom","reset_zoom_tooltip":"Réinitialiser le niveau de zoom"},"indicator":{"empty":{"no_sparkline_data":"Le nombre de données est insuffisant pour générer un graphique sparkline.","no_preview_data":"Le nombre de données est insuffisant pour calculer cette mesure. Essayez de changer les filtres ou d'ajouter plus de données pour calculer la mesure."}}},"global_navigation":{"navigation_items":{"logo":"Retour vers la Barre de lancement","app_switcher":"Basculer d'une appli à l'autre","announcer":"Annonces","helper":"Aide et Assistance","user":"Connecté(e) : {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Connexion"},"apps":{"academy":"Académie","community":"Communauté","projects":"Projets","results":"Résultats","storyboards":"Storyboards","mission_control":"Suivi des contrôles","risks":"Stratégie","reports":"Rapports","launchpad":"Barre de lancement","robots":"Robots","frameworks":"Cadres","compliance_maps":"Cartes de conformité","assurance_plans":"Plans d'assurance","project_scheduler":"Planificateur","issue_tracker":"Outil de suivi des problèmes","task_tracker":"Outil de suivi des tâches","project_timesheets":"Relevés des temps","dashboard":"Tableau de bord pour {{module}}","master_library":"Bibliothèque de base"},"app_sections":{"setup":"Configuration","workspace":"Environnement de travail","automation":"Automatisation"},"user":{"my_profile":"Mon profil","log_out":"Déconnexion"},"helper":{"help_docs":"Documentation d'aide","support":"Assistance"},"skip_button":"Passer au contenu principal","logo":"logo","other":"Autres","section":"section"},"contacts_dropdown":{"contacts":"Contacts","custom_value_a11y":"Champ de texte {{nameFieldLabel}}","custom_value_enter":"Ajoutez {{customValue}} en tant que {{nameFieldLabel}} et saisissez manuellement une adresse e-mail.","select_placeholder":"Indiquez un utilisateur...","search_a11y":"Recherchez l'utilisateur ou le contact. Si vous n'obtenez aucun résultat, utilisez alors la valeur de recherche comme le nom pour {{nameFieldLabel}}","search_placeholder":"Rechercher des utilisateurs ou saisir un nouveau nom...","email_address":"Adresse e-mail","email_address_error":"L'adresse e-mail doit être valide","users":"Utilisateurs","contacts_error":"Votre carnet de contacts n'a pas été chargé."},"resource_sharing":{"loading_collaborators":"Chargement...","add_collaborators_search_placeholder":"Rechercher des groupes ou des individus...","manage_collaborators":"Gérer des collaborateurs","close":"Fermer","disabled":"Désactivé","disabled_a11y_text":"Groupe désactivé","disabled_group_tooltip":"Ce groupe <strong>n'a aucun accès</strong> car le groupe a été désactivé dans la barre de lancement. Les admins système peuvent réactiver le groupe.","add_collaborators":"Ajouter des collaborateurs","add_collaborators_loading_tooltip":"Veuillez patienter jusqu'à ce que la liste des individus soit chargée.","individuals":"Personnes","individuals_section_tooltip_button":"Info-bulle Section personnes","individuals_section_tooltip":"L'accès individuel doit être égal ou supérieur à l'accès de groupe affecté. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">En savoir plus</a>.","no_results_found":"Aucun résultat trouvé","show_more":"Afficher plus","remove":"Supprimer","collaborators_widget":{"add":"Ajouter","manage":"Gérer","view":"Voir","more_users_tooltip":"{{remaining_users}} autres"},"side_panel":{"cancel":"Annuler","groups_count":"{{count}} groupe","groups_count_plural":"{{count}} groupes","individuals_count":"{{count}} individu","individuals_count_plural":"{{count}} individus","title":"Partager ‘{{resource_name}}’","save":"Enregistrer"},"groups":"Groupes","group_members_count":"({{count}} membre)","group_members_count_plural":"({{count}} membres)","disabled_role":"(désactivé)","no_access":"Aucun accès","default":"Par défaut","default_a11y_text":"Groupe par défaut","success_message":"{{resource_name}} a été mis à jour.","error_message":"Un incident est survenu. Veuillez rafraîchir la page pour essayer à nouveau. Si le problème persiste, contactez notre équie de l'assistance."},"attribute_types_details":{"Bool":"Booléen","Date":"Date","DateTime":"Date Heure","Number":"Numéro","Paragraph":"Paragraphe","Text":"Texte","Select":"Sélectionner","widgets":{"false":"Faux","true":"Vrai","allow_decimals":"Autoriser les décimales","allow_rich_text":"Autoriser le texte enrichi","display_24_hour_time":"Afficher format 24 heures","option":"Option","set_default_values":"Définir une valeur par défaut","specific_date_time":"DateHeure spécifique","users_current_date_time":"Date/heure actuelle de l'utilisateur","weight":"Poids","select":{"allow_multiple":"Autoriser les sélections multiples","name":"Nom","score":"Score","color":"Couleur","add_option":"+ Ajouter option","default_value_placeholder":"Sélectionner une valeur par défaut...","name_placeholder":"Nom...","score_placeholder":"Score...","color_placeholder":"Couleur...","errors":{"name_is_required":"Le nom est obligatoire.","name_exceeds_limit":"Le nom dépasse la limite de caractère.","score_range":"Le score doit être compris entre 0 et 9 999 999 999,999.","score_decimal":"Le score doit être arrondi à 3 décimales.","color_hex":"La couleur utilisée n'est pas un code hexadécimale valide."}}}},"asset_type":{"activity_log_link":"Voir le journal d'activité en intégralité"},"attribute_type":{"created_by":"Créé par {{name}} le {{date}}","display_name":{"label_checkbox":"Nom d'affichage différent dans type d'actif","placeholder":"Nom d'affichage"},"edited_by":"Modifié par {{name}} le {{date}}","is_global":{"label":"Global (utilisable dans n'importe type d'actif)"},"is_hidden":{"label":"Masqué (utilisé pour les flux d'activités)"},"is_required":{"label":"Champ obligatoire"},"label":"Nom du type d'attribut","placeholder":"Nom du type d'attribut","recent_activity":"Activité récente","tooltip":{"label_checkbox":"Infos contextuelles affichées dans l'info-bulle","placeholder":"Infos contextuelles affichées dans l'info-bulle"}}}}}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = {"ja":{"translation":{"edit_conflict":{"header":"編集による競合","description":"編集中に変更されたレコード:","notice":"編集中にこの{{term}}が変更されました。","options":{"save_your_edit":"編集内容を保存するには、マウスの右ボタンをクリックしてエディター上のテキストを\nクリップボードにコピーします。画面を更新するか、または [変更の保存] をクリックすると、\n新しいレコードが読み込まれます。\n新しいレコードにテキストを手動でマージする必要があります。\n","discard_your_changes":"変更を破棄して新しいレコードを読み込む場合は、\n単に画面を更新するか、または [保存] ボタンをクリックします。\n","save_changes":"変更を保存するには、別のプログラムにテキストをコピーし、\nブラウザーを最新の情報に更新するか、［保存］をクリックし、変更を手動でマージします。\n","discard_changes":"変更を破棄するには、ご利用のブラウザーを最新の情報に更新します。"}},"delete_conflict":{"header":"重複の削除","notice":"この{{term}}が削除されているため、利用できません。","options":{"save_changes":"変更を保存するには、別のプログラムにテキストをコピーし、\nそこで新しい%{term}フォームにこの情報を入力します。\n","discard_changes":"変更を破棄するには、フォームを閉じ、ご利用のブラウザーを最新の情報に更新します。"}},"assessment_drivers":{"notifications":{"assessment_disabled":"この評価ドライバーは現在無効です。"},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"評価ドライバーを保存中に問題が発生しました、もう一度お試しください。","metric_deleted":"{{name}}はリザルトアプリから削除されているため利用できません。","targetable_field_changed":"{{name}}のスケールが変更されました。この評価ドライバーをレビューし、もう一度有効にします。","metric_updated":"{{name}}の設定はリザルトアプリで変更されています。この評価ドライバーをもう一度レビューし、有効にします。","insufficient_data":"リザルトアプリで{{name}}を計算するための十分なデータがありません。","invalid_data":"{{name}}の値は {{value}} であり、評価ドライバーで適切に処理できません。","saved_failed":"サーバーに問題が発生し、変更を保存できませんでした。もう一度お試しください。","no_response":"メトリクスを読み込めません。"}}}},"success_saving":"{{target}} {{targetableField}}評価は正常に自動化されました。","bubbly_header":"{{target_term}}評価を自動化","bubbly_content_html":"評価ドライバーにより、リアルタイムで評価を最新の状態に維持できます。事前に定義されたメトリクスの範囲を使用して{{target_term}}を評価し、変更が発生したら主な関係者に通知します。<a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">詳細を表示。</a>","bubbly_footer":"今後、このメッセージを表示しない","save":"保存","cancel":"キャンセル","enable":"評価ドライバーを有効化","delete":"削除","delete_popover":{"title":"評価ドライバーを削除しますか?","description":"この項目は、アクセスすることも復元することもできなくなります。"},"tour":{"description":{"step_one":"{{target_term}}評価で発生する必要のある状況を定義して、指定したスコアに自動的に更新されるようにしてください。","step_two":"右の列に値を入力するとおりに、左の列が連続する次の値で自動入力されます。"},"navigation":{"back":"戻る","close":"閉じる","done":"完了","next":"次へ"}},"title":{"new":"新しい評価ドライバー","edit":"評価ドライバーを編集"},"dropdowns":{"entity":"エンティティ","process":"プロセス","metric":"メトリクス","tooltip":"評価ドライバーを無効にして、自動化された{{target_term}}評価を一時停止します。","help_icon_text_risk":"メトリクスがリンクされているリスクのみを選択できます。","automated":"%{name} (オートメーションの設定)","placerholder_entity":"%{operating_segment}を選択...","placeholder_metric":"メトリクスを選択..."},"metric_ranges":{"errors":{"format_error":"数字のみ有効です。","range_error":"範囲は重複できません。"},"dropdown":{"less_than":"次の値未満:","greater_than":"次の値より大きい:","equal_to":"または次の値と等しい:"}},"more_information":"詳しい情報"},"metrics":{"title":"メトリクスがまだリンクされていません","header":"メトリクス","add_or_remove":"追加/削除","description_html":"メトリクスは、{{targetTerm}}の追跡、監視、および評価するために使用される、定量化できる評価基準です。評価を通知できるように、メトリクスを{{targetTerm}}にリンクさせることができます。","start_linking":"メトリクスをリンクする","done_editing":"完了","edit_metrics":"メトリクスを編集","view_data":"データを表示","learn_more":{"label":"詳細を表示。"},"link_table":{"title":"リンクするメトリクスを選択","search_placeholder":"メトリクスを検索","no_metrics_available":"リンクに利用できるメトリクスがありません","no_metrics_available_description":"メトリクスは、{{targetTerm}}の追跡、監視、および評価するために使用される、定量化できる評価基準です。メトリクスを作成したら、{{targetTerm}}にこのメトリクスをリンクさせることができます。","unlink_confirmation_button":"変更へのリンク解除と保存","save":"保存","cancel":"キャンセル","headers":{"metric":"メトリクス","table":"テーブル","collection":"コレクション"}},"updated_successfully":"メトリクスが正常に更新されました","updated_failed":"作業中のレコードは、別のユーザーによって修正されました。変更内容は保存されませんでした。もう一度お試しください。","linked_metric":{"not_found":"{{name}}はリザルトから削除されているため利用できません。","insufficient_data":"リザルトアプリで{{name}}を計算するための十分なデータがありません。","no_response":"メトリクスを読み込めません。このページを更新してもう一度実行してください。","unlink_metric_button":"メトリクスをリンク解除","unlink_metric_header":"メトリクスをリンク解除?","unlink_metric_body":"このメトリクスをリンク解除すると、関連する評価ドライバーはすべて完全に削除されます。","archived_html":"このメトリクスは<a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">アーカイブ済みコレクション<i class=\"acl-i-arrow-up-b\"></i></a>からのものであり、読み取り専用です。データは追加または変更できません。"},"add_description":"説明を［+ 追加］し、メトリクスの背景を説明します...","formatting":{"blank":"(空白)","date":{"default":"YYYY/MM/DD"},"time":{"default":"HH:mm:ss","error":"不明な時間"},"datetime":{"default":"YYYY/MM/DD HH:mm:ss"},"numeric":{"abbreviations":{"thousand":"千","million":"百万","billion":"十億","trillion":"兆"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"一意の値","blanks":"空白","percent":"合計の %","count":"カウント","positives":"正数","negatives":"負数","zeros":"ゼロ","total":"合計","average":"平均","lowest":"最低値","highest":"最高値","standard_deviation":"標準偏差"},"sparkline":{"axis_date":{"day":"YYYY 年 M 月 D 日","month":"YYYY 年 M 月","quarter":"YYYY 年第 [Q]Q 四半期","year":"YYYY 年"}}},"sparkline":{"reset_zoom":"ズームをリセット","reset_zoom_tooltip":"ズーム レベルをリセット"},"indicator":{"empty":{"no_sparkline_data":"スパーク ラインを生成できるだけのデータがありません。","no_preview_data":"このメトリクスを計算するための十分なデータがありません。メトリクスを計算するには、フィルターを変更するか、その他のデータを追加してください。"}}},"global_navigation":{"navigation_items":{"logo":"Launchpad に戻る","app_switcher":"アプリを切り替える","announcer":"発表","helper":"ヘルプとサポート","user":"サインイン: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"サインイン"},"apps":{"academy":"アカデミー","community":"コミュニティ","projects":"プロジェクト","results":"リザルト","storyboards":"ストーリーボード","mission_control":"ミッション コントロール","risks":"ストラテジー","reports":"レポート","launchpad":"Launchpad","robots":"ロボット","frameworks":"フレームワーク","compliance_maps":"コンプライアンス マップ","assurance_plans":"保証計画","project_scheduler":"スケジューラ","issue_tracker":"問題の追跡ツール","task_tracker":"タスクの追跡ツール","project_timesheets":"タイムシート","dashboard":"{{module}}ダッシュボード","master_library":"マスター ライブラリ"},"app_sections":{"setup":"セットアップ","workspace":"ワークスペース","automation":"自動化"},"user":{"my_profile":"マイ プロファイル","log_out":"ログアウト"},"helper":{"help_docs":"ヘルプ ドキュメント","support":"サポート"},"skip_button":"メイン コンテンツまでスキップ","logo":"ロゴ","other":"その他","section":"セクション"},"contacts_dropdown":{"contacts":"連絡先","custom_value_a11y":"{{nameFieldLabel}} テキスト フィールド","custom_value_enter":"{{nameFieldLabel}}として{{customValue}}を追加し、電子メールアドレスを手動で入力します。","select_placeholder":"ユーザーを指定します...","search_a11y":"ユーザーまたは連絡先を検索します。検索結果がない場合は、{{nameFieldLabel}} 名として検索値を使用します。","search_placeholder":"ユーザーを検索するか、新しい名前を入力します...","email_address":"電子メール アドレス","email_address_error":"電子メール アドレスは有効でなくてはなりません","users":"ユーザー","contacts_error":"ご利用のアドレス帳を読み込めませんでした。"},"resource_sharing":{"loading_collaborators":"読み込み中...","add_collaborators_search_placeholder":"グループまたは個人を検索...","manage_collaborators":"コラボレーターを管理する","close":"閉じる","disabled":"無効","disabled_a11y_text":"無効化済みグループ","disabled_group_tooltip":"Launchpad でグループが無効になっているため、このグループに<strong>アクセスできません</strong>。システム管理者は、グループを再有効化できます。","add_collaborators":"コラボレーターを追加する","add_collaborators_loading_tooltip":"個人の一覧が読み込まれるまでお待ちください。","individuals":"個人","individuals_section_tooltip_button":"個人のセクション ツール チップ","individuals_section_tooltip":"個人のアクセス権は、割り当てられたグループ アクセス権と同等以上でなければなりません。<a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">詳細を表示</a>。","no_results_found":"結果が見つかりません","show_more":"詳しく表示","remove":"削除","collaborators_widget":{"add":"追加","manage":"管理","view":"表示","more_users_tooltip":"{{remaining_users}} 他"},"side_panel":{"cancel":"キャンセル","groups_count":"{{count}} グループ","groups_count_plural":"{{count}} グループ","individuals_count":"{{count}} 個人","individuals_count_plural":"{{count}} 個人","title":"‘{{resource_name}}’ を共有する","save":"保存"},"groups":"グループ","group_members_count":"({{count}} メンバー)","group_members_count_plural":"({{count}} メンバー)","disabled_role":"(無効化済み)","no_access":"アクセス権なし","default":"既定","default_a11y_text":"既定のグループ","success_message":"{{resource_name}} は正常に更新されました。","error_message":"問題が発生しました。このページを更新してもう一度実行してください。問題が解決しない場合は、サポート チームにお問い合わせください。"},"attribute_types_details":{"Bool":"ブール","Date":"日付","DateTime":"日付時刻","Number":"番号","Paragraph":"パラグラフ","Text":"テキスト","Select":"選択","widgets":{"false":"False","true":"True","allow_decimals":"小数点を許可","allow_rich_text":"リッチテキストを許可","display_24_hour_time":"24時間表示","option":"オプション","set_default_values":"デフォルト値を設定","specific_date_time":"特定の日付時刻","users_current_date_time":"ユーザーの現在の日付/時刻","weight":"加重","select":{"allow_multiple":"複数の選択肢を許可","name":"名前","score":"スコア","color":"色","add_option":"+ オプションの追加","default_value_placeholder":"デフォルト値を選択...","name_placeholder":"名前...","score_placeholder":"スコア...","color_placeholder":"色...","errors":{"name_is_required":"名前は必須です。","name_exceeds_limit":"名前は文字数の制限を超えています。","score_range":"スコアは0～9,999,999,999.999の範囲でなくてはなりません。","score_decimal":"スコアは小数点以下第3位で丸める必要があります。","color_hex":"使用されている色は、有効な16進コードではありません。"}}}},"asset_type":{"activity_log_link":"全活動ログを表示"},"attribute_type":{"created_by":"作成者: {{name}}、{{date}}","display_name":{"label_checkbox":"資産のタイプの異なる表示名","placeholder":"表示名"},"edited_by":"編集者: {{name}}、{{date}}","is_global":{"label":"グローバル (資産のタイプで使用可能)"},"is_hidden":{"label":"非表示 (ワークフローに使用)"},"is_required":{"label":"必須フィールド"},"label":"属性のタイプの名前","placeholder":"属性のタイプの名前","recent_activity":"最近の活動","tooltip":{"label_checkbox":"ツールチップに表示される文脈情報","placeholder":"ツールチップに表示される文脈情報"}}}}}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = {"pt":{"translation":{"edit_conflict":{"header":"Editar Conflito","description":"Este registro foi alterado enquanto você editava:","notice":"Este(a) {{term}} mudou enquanto você estava editando.","options":{"save_your_edit":"Para salvar sua edição, copie o texto do editor para sua prancheta\nutilizando o botão direto do seu mouse. Quando você atualizar a tela ou clicar em Salvar Alterações,\no novo registro será carregado.\nVocê precisará fundir manualmente o seu texto ao novo registro.\n","discard_your_changes":"Para descartar suas mudanças e carregar o novo registro,\napenas atualize a tela ou clique no botão Salvar.\n","save_changes":"Para salvar suas alterações, copie o texto para outro programa,\natualize seu navegador ou clique em Salvar e mescle manualmente suas alterações.\n","discard_changes":"Para descartar suas alterações, atualize o navegador."}},"delete_conflict":{"header":"Excluir Conflito","notice":"Este(a) {{term}} foi excluído(a) e não está mais disponível.","options":{"save_changes":"Para salvar suas alterações, copie o texto para outro programa,\ne insira as informações em um novo formulário de %{term}.\n","discard_changes":"Para descartar suas alterações, feche o formulário e atualize o navegador."}},"assessment_drivers":{"notifications":{"assessment_disabled":"Este Driver de Avaliação está desativado no momento."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"Ocorreu um problema ao salvar o Driver de Avaliação, tente novamente.","metric_deleted":"{{name}} foi excluído(a) do aplicativo Resultados e não está mais disponível.","targetable_field_changed":"A escala para {{name}} foi alterada. Revise e habilite o Driver de Avaliação novamente.","metric_updated":"A configuração de {{name}} foi alterada no aplicativo Resultados. Revise e ative o Driver de Avaliação novamente.","insufficient_data":"Não há dados suficientes para calcular {{name}} no aplicativo Resultados.","invalid_data":"O valor para {{name}} é {{value}} e não pode ser adequadamente processado pelo Driver de Avaliação.","saved_failed":"Houve um problema com o servidor e não foi possível salvar suas alterações. Tente novamente.","no_response":"Não foi possível carregar as Métricas."}}}},"success_saving":"Classificação de {{targetableField}} de {{target}} automatizada com sucesso.","bubbly_header":"Automatize suas avaliações de ({target_term})","bubbly_content_html":"Os Drivers de Avaliação permitem que você mantenha suas avaliações atualizadas, em tempo real. Use intervalos de métricas para avaliar seu ({target_term}) e notificar as principais partes interessadas quando ocorrerem mudanças. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">Saiba mais.</a>","bubbly_footer":"Não exibir esta dica novamente.","save":"Salvar","cancel":"Cancelar","enable":"Ativar Driver de Avaliação","delete":"Excluir","delete_popover":{"title":"Excluir Driver de Avaliação?","description":"Você não poderá acessar nem restaurar este item."},"tour":{"description":{"step_one":"Defina as condições que precisam ocorrer para que a avaliação de risco seja automaticamente atualizada para a pontuação especificada.","step_two":"Ao inserir valores na coluna à direita, a coluna à esquerda é preenchida automaticamente com o próximo valor sequencial."},"navigation":{"back":"Voltar","close":"Fechar","done":"Concluído","next":"Próximo"}},"title":{"new":"Novo Driver de Avaliação","edit":"Editar Driver de Avaliação"},"dropdowns":{"entity":"Entidade","process":"Processo","metric":"Métrica","tooltip":"Desative o Driver de Avaliação para pausar a avaliação de {{target_term}} automatizada.","help_icon_text_risk":"Apenas riscos com Métricas vinculadas podem ser selecionados.","automated":"%{name} (ajuste automático)","placerholder_entity":"Selecione um(a) %{operating_segment}...","placeholder_metric":"Selecione uma Métrica..."},"metric_ranges":{"errors":{"format_error":"Apenas números são válidos.","range_error":"Os intervalos não pode se sobrepor."},"dropdown":{"less_than":"menor que","greater_than":"maior que","equal_to":"ou igual a"}},"more_information":"Mais informações"},"metrics":{"title":"Nenhuma Métrica Vinculada Ainda","header":"Métricas","add_or_remove":"Adicionar/Remover","description_html":"Métricas são medidas quantificáveis usadas para rastrear, monitorar e avaliar {{targetTerm}}. Você pode vincular Métricas a um {{targetTerm}} para ajudar a informar a avaliação de risco.","start_linking":"Vincular Métricas","done_editing":"Concluído","edit_metrics":"Editar Métricas","view_data":"Exibir Dados","learn_more":{"label":"Saiba mais."},"link_table":{"title":"Selecionar Métricas a vincular","search_placeholder":"Pesquisar Métricas","no_metrics_available":"Não há Métricas disponíveis para vincular","no_metrics_available_description":"Métricas são medidas quantificáveis usadas para rastrear, monitorar e avaliar ({targetTerm}). Depois de criar uma Métrica, você pode vinculá-la a um {{targetTerm}}.","unlink_confirmation_button":"Desvincular e salvar alterações","save":"Salvar","cancel":"Cancelar","headers":{"metric":"Métrica","table":"Tabela","collection":"Coleção"}},"updated_successfully":"Métricas atualizadas com sucesso","updated_failed":"O registro em que você está trabalhando foi modificado por outro usuário. As alterações feitas não foram salvas, tente novamente.","linked_metric":{"not_found":"{{name}} foi excluído(a) do Resultados e não está mais disponível.","insufficient_data":"Não há dados suficientes para calcular {{name}} no aplicativo Resultados.","no_response":"Não foi possível carregar as Métricas. Atualize a página e tente novamente.","unlink_metric_button":"Desvincular métrica","unlink_metric_header":"Desvincular Métricas?","unlink_metric_body":"Desvincular essa Métrica removerá permanentemente todos os Drivers de Avaliação associados.","archived_html":"Essa métrica é de uma <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">coleção arquivada <i class=\"acl-i-arrow-up-b\"></i></a> e é somente leitura. Nenhum dado pode ser adicionado ou alterado."},"add_description":"+ Adicionar uma descrição para dar contexto à Métrica...","formatting":{"blank":"(branco)","date":{"default":"D MMM YYYY"},"time":{"default":"HH:mm:ss","error":"hora desconhecida"},"datetime":{"default":"D MMM YYYY HH:mm:ss"},"numeric":{"abbreviations":{"thousand":"mil","million":"mi","billion":"bi","trillion":"tri"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Valores únicos","blanks":"Brancos","percent":"% do total","count":"Contagem","positives":"Positivos","negatives":"Negativos","zeros":"Zeros","total":"Total","average":"Média","lowest":"Mais baixo","highest":"Mais alto","standard_deviation":"Desvio Padrão"},"sparkline":{"axis_date":{"day":"DD MMM YYYY","month":"MMM YYYY","quarter":"[T]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Redefinir zoom","reset_zoom_tooltip":"Redefinir nível de zoom"},"indicator":{"empty":{"no_sparkline_data":"Não há dados suficientes para gerar um minigráfico.","no_preview_data":"Não há dados suficientes para calcular esta métrica. Tente alterar os filtros ou adicionar mais dados para calcular a métrica."}}},"global_navigation":{"navigation_items":{"logo":"Voltar para o Launchpad","app_switcher":"Alternar Aplicativos","announcer":"Lançamentos","helper":"Ajuda e Suporte","user":"Entrou: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Entrar"},"apps":{"academy":"Academia","community":"Comunidade","projects":"Projetos","results":"Resultados","storyboards":"Storyboards","mission_control":"Controle da Missão","risks":"Estratégia","reports":"Relatórios","launchpad":"Launchpad","robots":"Robôs","frameworks":"Estruturas","compliance_maps":"Mapas de Conformidade","assurance_plans":"Planos de Garantia","project_scheduler":"Agendador","issue_tracker":"Rastreador de Problemas","task_tracker":"Rastreador de Tarefas","project_timesheets":"Quadros de Horário","dashboard":"Painel do {{module}}","master_library":"Biblioteca Principal"},"app_sections":{"setup":"Configuração","workspace":"Área de trabalho","automation":"Automação"},"user":{"my_profile":"Meu Perfil","log_out":"Efetuar Logout"},"helper":{"help_docs":"Documentos de Ajuda","support":"Suporte"},"skip_button":"Ir para conteúdo principal","logo":"logotipo","other":"Outro","section":"seção"},"contacts_dropdown":{"contacts":"Contatos","custom_value_a11y":"Campo de texto de {{nameFieldLabel}}","custom_value_enter":"Adicionar {{customValue}} como {{nameFieldLabel}} e inserir um endereço de e-mail manualmente.","select_placeholder":"Especificar um usuário...","search_a11y":"Pesquisar usuário ou contato. Se não houver resultados de pesquisa, use o valor de pesquisa como nome de {{nameFieldLabel}}","search_placeholder":"Pesquisar usuários ou inserir novo nome...","email_address":"Endereço de e-mail","email_address_error":"O endereço de e-mail deve ser válido","users":"Usuários","contacts_error":"Sua agenda de contatos não foi carregada."},"resource_sharing":{"loading_collaborators":"Carregando...","add_collaborators_search_placeholder":"Pesquisar grupos ou indivíduos...","manage_collaborators":"Gerenciar colaboradores","close":"Fechar","disabled":"Desabilitado","disabled_a11y_text":"Desativar grupo","disabled_group_tooltip":"Este grupo <strong>não tem acesso</strong> porque foi desativado no Launchpad. Administradores do sistema podem reativar o grupo.","add_collaborators":"Adicionar Colaboradores","add_collaborators_loading_tooltip":"Aguarde até que a lista de indivíduos seja carregada.","individuals":"Indivíduos","individuals_section_tooltip_button":"Kit de Ferramentas da Seção Indivíduos","individuals_section_tooltip":"O acesso individual deve ser igual ou superior ao acesso atribuído ao grupo. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">Saiba mais</a>.","no_results_found":"Nenhum resultado encontrado","show_more":"Mostrar mais","remove":"Remover","collaborators_widget":{"add":"Adicionar","manage":"Gerenciar","view":"Exibir","more_users_tooltip":"{{remaining_users}} outros(as)"},"side_panel":{"cancel":"Cancelar","groups_count":"{{count}} grupo","groups_count_plural":"{{count}} grupos","individuals_count":"{{count}} indivíduo","individuals_count_plural":"{{count}} indivíduos","title":"Compartilhar ‘{{resource_name}}’","save":"Salvar"},"groups":"Grupos","group_members_count":"({{count}} membro)","group_members_count_plural":"({{count}} membros)","disabled_role":"(desabilitado)","no_access":"Sem acesso","default":"Padrão","default_a11y_text":"Grupo padrão","success_message":"{{resource_name}} foi atualizado com sucesso.","error_message":"Algo deu errado. Atualize a página e tente novamente. Se o problema persistir, entre em contato com nossa equipe de suporte."},"attribute_types_details":{"Bool":"Booleano","Date":"Data","DateTime":"Data e hora","Number":"Número","Paragraph":"Parágrafo","Text":"Texto","Select":"Selecione","widgets":{"false":"Falso","true":"Verdadeiro","allow_decimals":"Permitir decimais","allow_rich_text":"Permitir rich text","display_24_hour_time":"Exibir horário com 24 horas","option":"Opção","set_default_values":"Definir valor padrão","specific_date_time":"DataHora Específica","users_current_date_time":"Data/hora atual do usuário","weight":"Peso","select":{"allow_multiple":"Permitir múltiplas seleções","name":"Nome","score":"Pontuação","color":"Cor","add_option":"+ Adicionar opção","default_value_placeholder":"Selecionar valor padrão...","name_placeholder":"Nome...","score_placeholder":"Pontuação...","color_placeholder":"Cor...","errors":{"name_is_required":"O nome é obrigatório.","name_exceeds_limit":"O nome ultrapassa o limite de caracteres.","score_range":"A pontuação deve ser entre 0 e 9.999.999.999,999.","score_decimal":"A pontuação deve ser arredondada para três casas decimais.","color_hex":"A cor usada não é um código hexa válido."}}}},"asset_type":{"activity_log_link":"Ver log de atividades completo"},"attribute_type":{"created_by":"Criado por {{name}} em {{date}}","display_name":{"label_checkbox":"Nome de exibição diferente no tipo de atributo","placeholder":"Nome de exibição"},"edited_by":"Editado por {{name}} em {{date}}","is_global":{"label":"Global (pode ser usado em qualquer tipo de ativo)"},"is_hidden":{"label":"Oculto (usado para fluxos de trabalho)"},"is_required":{"label":"Campo obrigatório"},"label":"Nome do tipo de atributo","placeholder":"Nome do tipo de atributo","recent_activity":"Atividade recente","tooltip":{"label_checkbox":"Informação contextual mostrada na dica da ferramenta","placeholder":"Informação contextual mostrada na dica da ferramenta"}}}}}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = {"zh":{"translation":{"edit_conflict":{"header":"编辑冲突","description":"您在编辑时此记录有变化：","notice":"您在编辑时此{{term}}有变化。","options":{"save_your_edit":"要保存您的编辑，\n点击鼠标右键，从编辑器复制文本至您的剪贴板。当您刷新屏幕或点击保存更改时，\n新记录将被加载。\n您将需要手动合并您的文本至新记录。\n","discard_your_changes":"要放弃更改并加载新记录，\n只需刷新屏幕或点击保存按钮。\n","save_changes":"要保存更改，请将文本复制到另一个计划，\n刷新浏览器或单击保存，然后手动合并更改。\n","discard_changes":"若要放弃更改，请刷新您的浏览器。"}},"delete_conflict":{"header":"删除冲突","notice":"此{{term}}已被删除，不再可用。","options":{"save_changes":"要保存更改，请将文本复制到另一个计划，\n并在新的%{term}表单输入信息。\n","discard_changes":"若要放弃更改，请关闭表单并刷新您的浏览器。"}},"assessment_drivers":{"notifications":{"assessment_disabled":"此评估推动器当前被禁用。"},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"保存评估推动器时出现问题，请重试。","metric_deleted":"{{name}}已被从结果应用程序中删除，不再可用。","targetable_field_changed":"{{name}}的刻度尺已更改。再次查看并启用此评估推动器。","metric_updated":"{{name}}的配置已在结果应用程序中更改。再次查看并启用此评估推动器。","insufficient_data":"没有足够的数据以在结果应用程序中计算{{name}}。","invalid_data":"{{name}}的值是{{value}}，无法由评估推动器正确处理。","saved_failed":"服务器出现问题，我们无法保存您的更改，请重试。","no_response":"我们无法加载度量。"}}}},"success_saving":"{{target}} {{targetableField}}评级成功自动化。","bubbly_header":"自动化您的{{target_term}}评估","bubbly_content_html":"评估推动器允许您实时监控评估。使用预定义的度量范围评估您的{{target_term}}，并在发生变化时通知关键利益相关者。<a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">了解详细信息。</a>","bubbly_footer":"不要再显示此提示。","save":"保存","cancel":"取消","enable":"启用评估推动器","delete":"删除","delete_popover":{"title":"删除评估推动器？","description":"您将无法访问或恢复此项。"},"tour":{"description":{"step_one":"定义{{target_term}}评估需要发生的条件，以自动更新到指定的分数。","step_two":"当您在右列中输入值时，左列将自动填充下一个顺序值。"},"navigation":{"back":"返回","close":"关闭","done":"完成","next":"下一步"}},"title":{"new":"新的评估推动器","edit":"编辑评估推动器"},"dropdowns":{"entity":"实体","process":"进程","metric":"度量","tooltip":"禁用评估推动器暂停自动化{{target_term}}评估。","help_icon_text_risk":"只能选择已链接度量的风险。","automated":"%{name}（自动化集）","placerholder_entity":"选择%{operating_segment}…","placeholder_metric":"选择度量…"},"metric_ranges":{"errors":{"format_error":"仅数字有效。","range_error":"范围不能重叠。"},"dropdown":{"less_than":"小于","greater_than":"大于","equal_to":"或等于"}},"more_information":"更多信息"},"metrics":{"title":"尚未链接度量","header":"度量","add_or_remove":"添加/移除","description_html":"度量是用来跟踪、监视和评估{{targetTerm}}的量化指标。您可以链接度量到{{targetTerm}}，以帮助告知评估。","start_linking":"链接度量","done_editing":"完成","edit_metrics":"编辑度量","view_data":"查看数据","learn_more":{"label":"了解详细信息。"},"link_table":{"title":"选择度量以链接","search_placeholder":"搜索度量","no_metrics_available":"没有度量可用于链接","no_metrics_available_description":"度量是用来跟踪、监视和评估{{targetTerm}}的量化指标。一旦创建了度量，您可以把将其链接到{{targetTerm}}。","unlink_confirmation_button":"取消链接并保存更改","save":"保存","cancel":"取消","headers":{"metric":"度量","table":"表","collection":"集合"}},"updated_successfully":"已成功更新度量","updated_failed":"您正在处理的记录已被另一个用户修改。未保存您所做的修改，请重试。","linked_metric":{"not_found":"{{name}}已被从结果应用程序中删除，不再可用。","insufficient_data":"没有足够的数据以在结果应用程序中计算{{name}}。","no_response":"我们无法加载度量。请刷新页面再试一次。","unlink_metric_button":"取消链接度量","unlink_metric_header":"取消链接度量？","unlink_metric_body":"取消链接此度量将永久删除任何相关联的评估推动器。","archived_html":"此度量标准来自<a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">存档集合<i class=\"acl-i-arrow-up-b\"></i></a>，并且是只读的。无法添加或更改任何数据。"},"add_description":"+ 添加描述以提供度量背景…","formatting":{"blank":"（空）","date":{"default":"YYYY年M月D日"},"time":{"default":"ahh:mm:ss","error":"未知的时间"},"datetime":{"default":"YYYY年M月D日 ahh:mm:ss"},"numeric":{"abbreviations":{"thousand":"千","million":"百万","billion":"十亿","trillion":"兆"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"唯一值","blanks":"空白","percent":"合计百分比","count":"计数","positives":"正","negatives":"负","zeros":"零","total":"合计","average":"平均","lowest":"最低","highest":"最高","standard_deviation":"标准偏差"},"sparkline":{"axis_date":{"day":"YYYY 年 M 月 D 日","month":"YYYY 年 M 月","quarter":"YYYY 年 [Q]Q 季度","year":"YYYY 年"}}},"sparkline":{"reset_zoom":"重置缩放","reset_zoom_tooltip":"重置缩放级别"},"indicator":{"empty":{"no_sparkline_data":"没有足够的数据生成微线图。","no_preview_data":"没有足够的数据来计算此量度。请尝试更改您的过滤器或添加更多数据来计算此量度。"}}},"global_navigation":{"navigation_items":{"logo":"返回到启动面板","app_switcher":"切换应用","announcer":"公告","helper":"帮助和支持","user":"登录：{{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"登录"},"apps":{"academy":"学校","community":"社区","projects":"项目","results":"结果","storyboards":"Storyboard","mission_control":"任务控制","risks":"战略","reports":"报告","launchpad":"启动面板","robots":"机器人","frameworks":"框架","compliance_maps":"合规地图","assurance_plans":"保障计划","project_scheduler":"计划器","issue_tracker":"问题跟踪器","task_tracker":"任务跟踪器","project_timesheets":"时间表","dashboard":"{{module}}仪表盘","master_library":"主库"},"app_sections":{"setup":"设置","workspace":"工作空间","automation":"自动化"},"user":{"my_profile":"我的个人资料","log_out":"注销"},"helper":{"help_docs":"帮助文档","support":"支持"},"skip_button":"跳到主要内容","logo":"徽标","other":"其他","section":"部分"},"contacts_dropdown":{"contacts":"联系人","custom_value_a11y":"{{nameFieldLabel}} 文本字段","custom_value_enter":"添加 {{customValue}} 作为 {{nameFieldLabel}} 并手动输入电子邮件地址。","select_placeholder":"指定用户…","search_a11y":"搜索用户或联系人。如果没有搜索结果，则使用搜索值作为{{nameFieldLabel}}名称","search_placeholder":"搜索用户或输入新名称…","email_address":"电子邮件地址","email_address_error":"电子邮件地址应有效","users":"用户","contacts_error":"您的通讯录未加载。"},"resource_sharing":{"loading_collaborators":"正在加载…","add_collaborators_search_placeholder":"搜索组或个人…","manage_collaborators":"管理协作者","close":"关闭","disabled":"已禁用","disabled_a11y_text":"已禁用组","disabled_group_tooltip":"该组<strong>无访问权限</strong>，因为该组已在启动面板中被禁用。系统管理员可以重新启用该组。","add_collaborators":"添加协作者","add_collaborators_loading_tooltip":"请等待加载个人列表。","individuals":"个人","individuals_section_tooltip_button":"个人部分工具提示","individuals_section_tooltip":"个人访问权限必须等于或高于分配的组访问权限。<a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">了解详细信息</a>。","no_results_found":"未找到结果","show_more":"显示更多","remove":"移除","collaborators_widget":{"add":"添加","manage":"管理","view":"查看","more_users_tooltip":"{{remaining_users}} 其他"},"side_panel":{"cancel":"取消","groups_count":"{{count}}个组","groups_count_plural":"{{count}}个组","individuals_count":"{{count}}位个人","individuals_count_plural":"{{count}}位个人","title":"共享‘{{resource_name}}’","save":"保存"},"groups":"组","group_members_count":"（{{count}} 个成员）","group_members_count_plural":"（{{count}} 个成员）","disabled_role":"（已禁用）","no_access":"禁止访问","default":"默认","default_a11y_text":"默认组","success_message":"{{resource_name}}已成功更新。","error_message":"出了些问题。请刷新页面再试一次。如果问题仍然存在，请联系我们的支持团队。"},"attribute_types_details":{"Bool":"布尔","Date":"日期","DateTime":"日期时间","Number":"编号","Paragraph":"段落","Text":"文本","Select":"选择","widgets":{"false":"假","true":"真","allow_decimals":"允许小数","allow_rich_text":"允许富文本","display_24_hour_time":"显示 24 小时时间","option":"选项","set_default_values":"设置默认值","specific_date_time":"特定日期时间","users_current_date_time":"用户当前日期/时间","weight":"权重","select":{"allow_multiple":"允许多个选择","name":"名称","score":"分数","color":"颜色","add_option":"+ 添加选项","default_value_placeholder":"选择默认值…","name_placeholder":"名称…","score_placeholder":"分数…","color_placeholder":"颜色…","errors":{"name_is_required":"名称是必需的。","name_exceeds_limit":"名称超出字符限制。","score_range":"分数应介于 0 和 9,999,999,999.999 之间。","score_decimal":"分数应四舍五入到小数点后三位。","color_hex":"使用的颜色不是有效的十六进制代码。"}}}},"asset_type":{"activity_log_link":"查看完整活动日志"},"attribute_type":{"created_by":"由 {{name}} 于 {{date}} 创建","display_name":{"label_checkbox":"资产类型中的不同显示名称","placeholder":"显示名称"},"edited_by":"由 {{name}} 于 {{date}} 编辑","is_global":{"label":"全局（可用于任何资产类型）"},"is_hidden":{"label":"隐藏（用于工作流）"},"is_required":{"label":"该域是必需的"},"label":"属性类型名称","placeholder":"属性类型名称","recent_activity":"近期活动","tooltip":{"label_checkbox":"工具提示中显示上下文信息","placeholder":"工具提示中显示上下文信息"}}}}}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55), __webpack_require__(116)(module)))

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(36);
var toObject = __webpack_require__(46);
var IE_PROTO = __webpack_require__(77)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(25);
var $export = __webpack_require__(14);
var meta = __webpack_require__(61);
var fails = __webpack_require__(34);
var hide = __webpack_require__(39);
var redefineAll = __webpack_require__(119);
var forOf = __webpack_require__(84);
var anInstance = __webpack_require__(120);
var isObject = __webpack_require__(28);
var setToStringTag = __webpack_require__(69);
var dP = __webpack_require__(30).f;
var each = __webpack_require__(108)(0);
var DESCRIPTORS = __webpack_require__(26);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(14);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(14);
var aFunction = __webpack_require__(73);
var ctx = __webpack_require__(50);
var forOf = __webpack_require__(84);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(302);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(25).parseInt;
var $trim = __webpack_require__(280).trim;
var ws = __webpack_require__(175);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(261);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(300);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(198);

var arrayLikeToArray = __webpack_require__(206);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return _Array$from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),
/* 206 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["default"] = (memoizeOne);


/***/ }),
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(371);

/***/ }),
/* 217 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$defineProperty = __webpack_require__(0);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;

    _Object$defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$create = __webpack_require__(375);

var setPrototypeOf = __webpack_require__(378);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = _Object$create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(138);

var assertThisInitialized = __webpack_require__(382);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$getPrototypeOf = __webpack_require__(383);

var _Object$setPrototypeOf = __webpack_require__(281);

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = _Object$setPrototypeOf ? _Object$getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || _Object$getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87);
__webpack_require__(83);
module.exports = __webpack_require__(78).f('iterator');


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(76);
var defined = __webpack_require__(64);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(70);
var descriptor = __webpack_require__(49);
var setToStringTag = __webpack_require__(69);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(39)(IteratorPrototype, __webpack_require__(31)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(265);
var step = __webpack_require__(194);
var Iterators = __webpack_require__(57);
var toIObject = __webpack_require__(33);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(117)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
__webpack_require__(118);
__webpack_require__(267);
__webpack_require__(268);
module.exports = __webpack_require__(8).Symbol;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('asyncIterator');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('observable');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(270);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118);
__webpack_require__(83);
__webpack_require__(271);
__webpack_require__(275);
__webpack_require__(276);
module.exports = __webpack_require__(8).WeakMap;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(25);
var each = __webpack_require__(108)(0);
var redefine = __webpack_require__(89);
var meta = __webpack_require__(61);
var assign = __webpack_require__(107);
var weak = __webpack_require__(274);
var isObject = __webpack_require__(28);
var validate = __webpack_require__(85);
var NATIVE_WEAK_MAP = __webpack_require__(85);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(195)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(273);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var isArray = __webpack_require__(94);
var SPECIES = __webpack_require__(31)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(119);
var getWeak = __webpack_require__(61).getWeak;
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(28);
var anInstance = __webpack_require__(120);
var forOf = __webpack_require__(84);
var createArrayMethod = __webpack_require__(108);
var $has = __webpack_require__(36);
var validate = __webpack_require__(85);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(196)('WeakMap');


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(197)('WeakMap');


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(298);

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(279);
module.exports = __webpack_require__(8).Number.parseInt;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
var $parseInt = __webpack_require__(199);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
var defined = __webpack_require__(64);
var fails = __webpack_require__(34);
var spaces = __webpack_require__(175);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(379);

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.placeholders = exports.placeholder = exports.disabledPlaceholder = exports.focusRing = exports.visuallyHidden = exports.noTruncateText = exports.truncateText = exports.alignMiddle = exports.boxSizingStyles = void 0;

var _styledComponents = __webpack_require__(4);

var _tokens = _interopRequireDefault(__webpack_require__(27));

//
// Layout
//
var boxSizingStyles = (0, _styledComponents.css)(["&,*,*::before,*::after{box-sizing:border-box;}"]);
exports.boxSizingStyles = boxSizingStyles;
var alignMiddle = (0, _styledComponents.css)(["align-items:center;display:flex;justify-content:center;"]); //
// Typography
//

exports.alignMiddle = alignMiddle;
var truncateText = (0, _styledComponents.css)(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
exports.truncateText = truncateText;
var noTruncateText = (0, _styledComponents.css)(["overflow:visible;text-overflow:clip;white-space:normal;"]); //
// Accessibility
//

exports.noTruncateText = noTruncateText;
var visuallyHidden = (0, _styledComponents.css)(["border:0 !important;clip:rect(1px,1px,1px,1px);height:1px !important;overflow:hidden;padding:0 !important;position:absolute !important;white-space:nowrap;width:1px !important;"]); // Focus Indicators

exports.visuallyHidden = visuallyHidden;

var focusRing = function focusRing() {
  var inset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return inset === true ? (0, _styledComponents.css)(["box-shadow:", ";outline:none;"], _tokens["default"].highlight.active.withBorder.insetBoxShadow) : (0, _styledComponents.css)(["box-shadow:", ";outline:none;"], _tokens["default"].highlight.active.withBorder.boxShadow);
};

exports.focusRing = focusRing;

focusRing.bordered = function () {
  var inset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return inset === true ? (0, _styledComponents.css)(["border-color:", ";box-shadow:", ";outline:none;"], _tokens["default"].highlight.active.noBorder.borderColor, _tokens["default"].highlight.active.noBorder.insetBoxShadow) : (0, _styledComponents.css)(["border-color:", ";box-shadow:", ";outline:none;"], _tokens["default"].highlight.active.noBorder.borderColor, _tokens["default"].highlight.active.noBorder.boxShadow);
};

focusRing.subtle = function () {
  var inset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return inset === true ? (0, _styledComponents.css)(["outline:", ";outline-offset:-2px;"], _tokens["default"].highlight.active.nonInteractive.outline) : (0, _styledComponents.css)(["outline:", ";"], _tokens["default"].highlight.active.nonInteractive.outline);
}; //
// Forms
//


var disabledPlaceholder = (0, _styledComponents.css)(["color:", ";"], _tokens["default"].color.blackLighten60);
exports.disabledPlaceholder = disabledPlaceholder;
var placeholder = (0, _styledComponents.css)(["color:", ";font-style:", ";&[disabled]{", ";}"], _tokens["default"].placeholder.color, _tokens["default"].placeholder.fontStyle, disabledPlaceholder);
exports.placeholder = placeholder;
var placeholders = (0, _styledComponents.css)(["&::placeholder{", ";}&::-webkit-input-placeholder{", ";}&::-moz-placeholder{", ";opacity:1;}&:-ms-input-placeholder{", ";}&:-moz-placeholder{", ";opacity:1;}&[disabled]::placeholder{", ";}&[disabled]::-webkit-input-placeholder{", ";}&[disabled]::-moz-placeholder{", ";opacity:1;}&[disabled]:-ms-input-placeholder{", ";}&[disabled]:-moz-placeholder{", ";opacity:1;}"], placeholder, placeholder, placeholder, placeholder, placeholder, disabledPlaceholder, disabledPlaceholder, disabledPlaceholder, disabledPlaceholder, disabledPlaceholder);
exports.placeholders = placeholders;
//# sourceMappingURL=includes.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// This file replaces `index.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.

if (process.env.NODE_ENV !== 'production') {
  // All bundlers will remove this block in production bundle
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    throw new Error(
      'React Native does not have a built-in secure random generator. ' +
      'If you don’t need unpredictable IDs, you can use `nanoid/non-secure`. ' +
      'For secure ID install `expo-random` locally and use `nanoid/async`.'
    )
  }
  if (typeof self === 'undefined' || (!self.crypto && !self.msCrypto)) {
    throw new Error(
      'Your browser does not have secure random generator. ' +
      'If you don’t need unpredictable IDs, you can use nanoid/non-secure.'
    )
  }
}

var crypto = self.crypto || self.msCrypto

// This alphabet uses a-z A-Z 0-9 _- symbols.
// Symbols are generated for smaller size.
// -_zyxwvutsrqponmlkjihgfedcba9876543210ZYXWVUTSRQPONMLKJIHGFEDCBA
var url = '-_'
// Loop from 36 to 0 (from z to a and 9 to 0 in Base36).
var i = 36
while (i--) {
  // 36 is radix. Number.prototype.toString(36) returns number
  // in Base36 representation. Base36 is like hex, but it uses 0–9 and a-z.
  url += i.toString(36)
}
// Loop from 36 to 10 (from Z to A in Base36).
i = 36
while (i-- - 10) {
  url += i.toString(36).toUpperCase()
}

module.exports = function (size) {
  var id = ''
  var bytes = crypto.getRandomValues(new Uint8Array(size || 21))
  i = size || 21

  // Compact alternative for `for (var i = 0; i < size; i++)`
  while (i--) {
    // We can’t use bytes bigger than the alphabet. 63 is 00111111 bitmask.
    // This mask reduces random byte 0-255 to 0-63 values.
    // There is no need in `|| ''` and `* 1.6` hacks in here,
    // because bitmask trim bytes exact to alphabet size.
    id += url[bytes[i] & 63]
  }
  return id
}


/***/ }),
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(95);

function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(296);
module.exports = __webpack_require__(8).Array.isArray;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(14);

$export($export.S, 'Array', { isArray: __webpack_require__(94) });


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var _getIterator = __webpack_require__(277);

var _isIterable = __webpack_require__(204);

var _Symbol = __webpack_require__(111);

function _iterableToArrayLimit(arr, i) {
  if (typeof _Symbol === "undefined" || !_isIterable(Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(83);
__webpack_require__(87);
module.exports = __webpack_require__(299);


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(32);
var get = __webpack_require__(121);
module.exports = __webpack_require__(8).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(83);
__webpack_require__(87);
module.exports = __webpack_require__(301);


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(123);
var ITERATOR = __webpack_require__(31)('iterator');
var Iterators = __webpack_require__(57);
module.exports = __webpack_require__(8).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87);
__webpack_require__(303);
module.exports = __webpack_require__(8).Array.from;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(50);
var $export = __webpack_require__(14);
var toObject = __webpack_require__(46);
var call = __webpack_require__(179);
var isArrayIter = __webpack_require__(180);
var toLength = __webpack_require__(71);
var createProperty = __webpack_require__(110);
var getIterFn = __webpack_require__(121);

$export($export.S + $export.F * !__webpack_require__(304)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(31)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 305 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return icons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return iconSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return navigationItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return leftNavigationItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return rightNavigationItems; });
/* unused harmony export appSwitcherSections */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__acl_services_wasabicons_lib_AppSwitcher__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__acl_services_wasabicons_lib_AppSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__acl_services_wasabicons_lib_AppSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_HelpCircle__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_HelpCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_HelpCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_AclLogo__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_AclLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_AclLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_UserCircle__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_UserCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_UserCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_Academy__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_Academy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_Academy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_CommunityLogo__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_CommunityLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_CommunityLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_LaunchpadLogo__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_LaunchpadLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_LaunchpadLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_MissionControl__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_MissionControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_MissionControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_ProjectsLogo__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_ProjectsLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_ProjectsLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_ReportsLogo__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_ReportsLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_ReportsLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__acl_services_wasabicons_lib_ResultsLogo__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__acl_services_wasabicons_lib_ResultsLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__acl_services_wasabicons_lib_ResultsLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__acl_services_wasabicons_lib_Robot__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__acl_services_wasabicons_lib_Robot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__acl_services_wasabicons_lib_Robot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__acl_services_wasabicons_lib_StrategyLogo__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__acl_services_wasabicons_lib_StrategyLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__acl_services_wasabicons_lib_StrategyLogo__);













var icons = {
  appSwitcher: __WEBPACK_IMPORTED_MODULE_0__acl_services_wasabicons_lib_AppSwitcher___default.a,
  helper: __WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_HelpCircle___default.a,
  logo: __WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_AclLogo___default.a,
  user: __WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_UserCircle___default.a,
  academy: __WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_Academy___default.a,
  community: __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_CommunityLogo___default.a,
  launchpad: __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_LaunchpadLogo___default.a,
  mission_control: __WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_MissionControl___default.a,
  projects: __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_ProjectsLogo___default.a,
  reports: __WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_ReportsLogo___default.a,
  results: __WEBPACK_IMPORTED_MODULE_10__acl_services_wasabicons_lib_ResultsLogo___default.a,
  robots: __WEBPACK_IMPORTED_MODULE_11__acl_services_wasabicons_lib_Robot___default.a,
  risks: __WEBPACK_IMPORTED_MODULE_12__acl_services_wasabicons_lib_StrategyLogo___default.a
};
var iconSize = '20px';
var navigationItems = {
  currentApp: 'CURRENT_APP',
  appSwitcher: 'APP_SWITCHER',
  helper: 'HELPER',
  helperWithPendo: 'HELPER_WITH_PENDO',
  logo: 'LOGO',
  user: 'USER',
  signIn: 'SIGN_IN'
};
var leftNavigationItems = [navigationItems.logo, navigationItems.appSwitcher, navigationItems.currentApp];
var rightNavigationItems = [navigationItems.signIn, navigationItems.helper, navigationItems.helperWithPendo, navigationItems.user];
var appSwitcherSections = {
  appLink: 'APP_LINK',
  resourceLink: 'RESOURCE_LINK'
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(308);
module.exports = __webpack_require__(8).Object.values;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(14);
var $values = __webpack_require__(309)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(26);
var getKeys = __webpack_require__(43);
var toIObject = __webpack_require__(33);
var isEnum = __webpack_require__(51).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "CaretDown___StyledSvg",
  componentId: "dw438p-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgCaretDown = function SvgCaretDown(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.099 15.258a1.501 1.501 0 01-2.223 0c-1.41-1.554-3.83-4.22-5.256-5.789a.753.753 0 01.556-1.257h11.623a.751.751 0 01.556 1.257l-5.256 5.789z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgCaretDown;
exports["default"] = _default;
//# sourceMappingURL=CaretDown.js.map

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
var tokens = {
  "color": {
    "black": "#3f3d3c",
    "blackLighten10": "#575757",
    "blackLighten20": "#717171",
    "blackLighten30": "#8a8a8a",
    "blackLighten40": "#a4a4a4",
    "blackLighten50": "#bdbdbd",
    "blackLighten60": "#d7d7d7",
    "blackLighten70": "#f0f0f0",
    "blackLighten80": "#f7f7f7",
    "blackLighten90": "#fcfcfc",
    "blackDisabled": "#a4a4a4",
    "blackPure": "#000000",
    "blue": "#276cf5",
    "blueDarken20": "#004a94",
    "blueDarken10": "#0063c5",
    "blueLighten10": "#3396f9",
    "blueLighten20": "#66b0fa",
    "blueLighten30": "#99cbfc",
    "blueLighten40": "#cce5fd",
    "blueLighten50": "#e5f1fe",
    "creme": "#e6e3df",
    "cremeDarken30": "#a39889",
    "cremeDarken20": "#b9b1a6",
    "cremeDarken10": "#d0cac2",
    "cremeLighten5": "#f1f0ed",
    "cremeLighten10": "#fcfcfc",
    "green": "#42996d",
    "greenDarken10": "#337554",
    "greenDarken20": "#23523a",
    "greenLighten10": "#5db187",
    "greenLighten20": "#80c1a0",
    "greenLighten30": "#a2d2ba",
    "greenLighten40": "#c4e3d3",
    "greenLighten50": "#e7f3ed",
    "offWhite": "#f0f0f0",
    "orange": "#de4d33",
    "orangeDarken10": "#bf371f",
    "orangeDarken20": "#932b18",
    "orangeDarken30": "#671e11",
    "orangeLighten10": "#e07764",
    "orangeLighten20": "#e99c8e",
    "orangeLighten30": "#f1c1b9",
    "orangeLighten40": "#fae7e3",
    "orangeDisabled": "#e99c8e",
    "orangeHighlight": "#e1624b",
    "purple": "#785cba",
    "purpleDarken10": "#5f449f",
    "purpleDarken20": "#4a347c",
    "purpleLighten10": "#9884c5",
    "purpleLighten20": "#b5a7d5",
    "purpleLighten30": "#d2c9e6",
    "purpleLighten40": "#efecf6",
    "purpleLighten50": "#fbfafd",
    "white": "#ffffff",
    "yellow": "#eaba51",
    "yellowDarken10": "#e5a823",
    "yellowDarken20": "#be8a17",
    "yellowDarken30": "#916911",
    "yellowDarken40": "#63480c",
    "yellowLighten10": "#eccb82",
    "yellowLighten20": "#f3ddae",
    "yellowLighten30": "#f9f0db",
    "gold": "#f0a117",
    "silver": "#cfcfcf",
    "eggplant": "#2e143d",
    "eggplantLighten10": "#4b2164",
    "eggplantLighten20": "#682e8b",
    "eggplantLighten30": "#853AB1",
    "chartColor01": "#cd3c44",
    "chartColor02": "#cb8133",
    "chartColor03": "#eaba51",
    "chartColor04": "#79a551",
    "chartColor05": "#299a7a",
    "chartColor06": "#8c6d68",
    "chartColor07": "#ec848f",
    "chartColor08": "#b9668f",
    "chartColor09": "#785cba",
    "chartColor10": "#2b82bf",
    "chartColor11": "#7ec0cc",
    "chartColor12": "#d1cbc2"
  },
  "space": "8px",
  "spaceSm": "4px",
  "spaceLg": "12px",
  "placeholder": {
    "color": "#717171",
    "fontStyle": "italic"
  },
  "highlight": {
    "active": {
      "noBorder": {
        "boxShadow": "0 0 0 2px #99cbfc",
        "insetBoxShadow": "inset 0 0 0 2px #99cbfc",
        "borderColor": "#276cf5"
      },
      "withBorder": {
        "boxShadow": "0 0 0 1px #276cf5, 0 0 0 3px #99cbfc",
        "insetBoxShadow": "inset 0 0 0 1px #276cf5, inset 0 0 0 3px #99cbfc"
      },
      "nonInteractive": {
        "outline": "2px dotted #8a8a8a"
      }
    },
    "text": {
      "green": {
        "background": "#e7f3ed",
        "font": "#23523a"
      },
      "orange": {
        "background": "#fae7e3",
        "font": "#932b18"
      },
      "yellow": {
        "background": "#f7f3ba",
        "font": "#63480c"
      }
    }
  },
  "textColor": {
    "default": "#3f3d3c",
    "subtle": "#717171",
    "link": "#0063c5",
    "linkHover": "#004a94",
    "icon": "#717171"
  },
  "fontFamily": {
    "default": "\"Lato\", \"Helvetica Neue\", Helvetica, Arial, sans-serif",
    "jp": "\"Lato\", \"Helvetica Neue\", Helvetica, Arial, sans-serif, \"Hiragino Kaku Gothic Pro\", \"ヒラギノ角ゴ Pro W3\", \"ＭＳ Ｐゴシック\", \"MS PGothic\"",
    "kr": "\"Lato\", \"Helvetica Neue\", Helvetica, Arial, sans-serif, \"Malgun Gothic\"",
    "zh": "\"Helvetica Neue\", Helvetica, Arial, sans-serif, 黑體-繁, \"Heiti TC\", 儷黑Pro, \"LiHei Pro\", PMingLiu, 宋体, SimSun"
  },
  "table": {
    "header": {
      "backgroundColor": "#f0f0f0"
    },
    "row": {
      "backgroundColor": "#ffffff"
    },
    "rowEven": {
      "backgroundColor": "#f7f7f7"
    }
  },
  "border": {
    "radius": "3px",
    "color": "#d7d7d7",
    "hoverColor": "#a4a4a4",
    "colorTransition": "border-color 0.2s"
  },
  "button": {
    "borderRadius": "4px"
  },
  "card": {
    "borderRadius": "6px",
    "shadow": "0 0 0 1px rgba(63,61,60,0.05),0 1px 3px 0 rgba(63,61,60,0.15)"
  },
  "overlay": {
    "animationDuration": "700",
    "backdrop": {
      "backgroundColor": "rgba(63,61,60,0.5)"
    }
  },
  "modal": {
    "backgroundColor": "#ffffff",
    "borderRadius": "6px",
    "shadow": "0 8px 12px -4px rgba(63,61,60,0.2),0 1px 3px 0 rgba(63,61,60,0.1)",
    "sizes": {
      "sm": "450px",
      "md": "675px",
      "lg": "900px"
    },
    "margin": "24px",
    "top": "100px",
    "footer": {
      "backgroundColor": "#f7f7f7"
    }
  },
  "checkbox": {
    "sizeSm": "16px",
    "sizeMd": "20px",
    "sizeLg": "24px"
  },
  "radio": {
    "sizeSm": "16px",
    "sizeMd": "20px",
    "sizeLg": "24px"
  },
  "popover": {
    "borderRadius": "6px",
    "shadow": "0 2px 4px rgba(0,0,0,0.1)"
  },
  "counter": {
    "small": "17px",
    "medium": "19px"
  },
  "pill": {
    "smallRadius": "8px / 50%",
    "mediumRadius": "12px / 50%"
  },
  "backgroundColor": {
    "level0": "#f7f7f7"
  },
  "fontSize": {
    "default": "16px"
  },
  "shadow": "0px 1px 5px rgba(0,0,0,0.07),0px 7px 17px rgba(0,0,0,0.1)"
};
var _default = tokens;
exports["default"] = _default;
//# sourceMappingURL=tokens.js.map

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FOCUS_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FOCUS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FOCUS_ALLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FOCUS_AUTO; });
var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = 'data-autofocus-inside';

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(386);

/***/ }),
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ArrowRightB___StyledSvg",
  componentId: "m3iyn7-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var ArrowRightB = function ArrowRightB(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M346.47 271.373H30v-63h316.47L265 127.747 309.546 83.2s85.231 84.055 128.153 126.975c16.401 16.403 16.401 42.995 0 59.398-42.922 42.92-128.153 126.975-128.153 126.975L265 352.001l81.472-80.628z"
  }));
};

var _default = ArrowRightB;
exports["default"] = _default;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(360);
module.exports = __webpack_require__(8).Number.isNaN;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(14);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "Refresh___StyledSvg",
  componentId: "sc-1sctrs9-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgRefresh = function SvgRefresh(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.931 6.069L15.15 8.85h6.3v-6.3l-2.035 2.035A10.425 10.425 0 0012 1.5C6.21 1.5 1.5 6.21 1.5 12h2.1c0-4.632 3.768-8.4 8.4-8.4 2.28 0 4.385.915 5.931 2.469zM6.07 17.93L8.85 15.15h-6.3v6.3l2.034-2.035A10.427 10.427 0 0012 22.5c5.79 0 10.5-4.71 10.5-10.5h-2.1c0 4.632-3.768 8.4-8.4 8.4a8.334 8.334 0 01-5.931-2.469z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgRefresh;
exports["default"] = _default;
//# sourceMappingURL=Refresh.js.map

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "Times___StyledSvg",
  componentId: "sc-1hngl9r-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgTimes = function SvgTimes(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.743 9.029L20.27 1.5 22.5 3.728l-7.529 7.53a1.05 1.05 0 000 1.485l7.529 7.529-2.229 2.228-7.528-7.529a1.05 1.05 0 00-1.486 0L3.728 22.5 1.5 20.272l7.529-7.53a1.05 1.05 0 000-1.485L1.5 3.728 3.728 1.5l7.53 7.529c.41.41 1.074.41 1.485 0z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgTimes;
exports["default"] = _default;
//# sourceMappingURL=Times.js.map

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "NewTab___StyledSvg",
  componentId: "sc-1cri4kc-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgNewTab = function SvgNewTab(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.213 2.394v3.08H3.071v15.392h15.355V14.71h3.071v6.157c0 1.7-1.376 3.079-3.07 3.079H3.07A3.076 3.076 0 010 20.866V5.473c0-1.7 1.376-3.079 3.071-3.079h6.142zM24 0v9.497h-2.707V4.632l-8.516 8.538-1.914-1.919 8.517-8.538h-4.854V0H24z",
    fill: "currentColor"
  }));
};

var _default = SvgNewTab;
exports["default"] = _default;
//# sourceMappingURL=NewTab.js.map

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(95);

var arrayLikeToArray = __webpack_require__(206);

function _arrayWithoutHoles(arr) {
  if (_Array$isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(198);

var _isIterable = __webpack_require__(204);

var _Symbol = __webpack_require__(111);

function _iterableToArray(iter) {
  if (typeof _Symbol !== "undefined" && _isIterable(Object(iter))) return _Array$from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 366 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arrayFind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return asArray; });
var toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};

var arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};

var asArray = function asArray(a) {
  return Array.isArray(a) ? a : [a];
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(370);
module.exports = __webpack_require__(8).parseInt;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
var $parseInt = __webpack_require__(199);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(372);
module.exports = __webpack_require__(8).Reflect.construct;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(14);
var create = __webpack_require__(70);
var aFunction = __webpack_require__(73);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(28);
var fails = __webpack_require__(34);
var bind = __webpack_require__(373);
var rConstruct = (__webpack_require__(25).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(73);
var isObject = __webpack_require__(28);
var invoke = __webpack_require__(374);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(376);

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(377);
var $Object = __webpack_require__(8).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(70) });


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$setPrototypeOf = __webpack_require__(281);

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = _Object$setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(380);
module.exports = __webpack_require__(8).Object.setPrototypeOf;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(14);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(381).set });


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(28);
var anObject = __webpack_require__(32);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(50)(Function.call, __webpack_require__(60).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 382 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(384);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(385);
module.exports = __webpack_require__(8).Object.getPrototypeOf;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(46);
var $getPrototypeOf = __webpack_require__(193);

__webpack_require__(86)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118);
__webpack_require__(87);
__webpack_require__(83);
__webpack_require__(387);
__webpack_require__(390);
__webpack_require__(393);
__webpack_require__(394);
module.exports = __webpack_require__(8).Set;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(388);
var validate = __webpack_require__(85);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(195)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(30).f;
var create = __webpack_require__(70);
var redefineAll = __webpack_require__(119);
var ctx = __webpack_require__(50);
var anInstance = __webpack_require__(120);
var forOf = __webpack_require__(84);
var $iterDefine = __webpack_require__(117);
var step = __webpack_require__(194);
var setSpecies = __webpack_require__(389);
var DESCRIPTORS = __webpack_require__(26);
var fastKey = __webpack_require__(61).fastKey;
var validate = __webpack_require__(85);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(25);
var core = __webpack_require__(8);
var dP = __webpack_require__(30);
var DESCRIPTORS = __webpack_require__(26);
var SPECIES = __webpack_require__(31)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(14);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(391)('Set') });


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(123);
var from = __webpack_require__(392);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(84);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(196)('Set');


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(197)('Set');


/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.selectSingleOption = selectSingleOption;
exports.toggleMultipleOption = toggleMultipleOption;
exports.selectMultipleOption = selectMultipleOption;
exports.isOptionSelected = isOptionSelected;
exports.isOptionVisible = isOptionVisible;
exports.getNextOptionActiveIndex = getNextOptionActiveIndex;
exports.getNextOptionActiveIndexLooping = getNextOptionActiveIndexLooping;
exports.handleArrowKeys = handleArrowKeys;
exports.handleEnterOrSpace = handleEnterOrSpace;
exports.isWhiteListed = isWhiteListed;
exports.handleClickOption = void 0;

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _useListBox = _interopRequireDefault(__webpack_require__(140));

var _invokeOnChange = _interopRequireDefault(__webpack_require__(562));

function selectSingleOption(_ref) {
  var activeOptionIndex = _ref.activeOptionIndex,
      isOpen = _ref.isOpen,
      dispatch = _ref.dispatch,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? null : _ref$onChange,
      onChangeContext = _ref.onChangeContext;
  var onChangeFn = onChange || (0, _invokeOnChange["default"])(onChangeContext, "list-box:option-selected");
  dispatch({
    type: _useListBox["default"].types.selectSingleOption,
    payload: {
      activeOptionIndex: activeOptionIndex,
      isOpen: isOpen,
      onChangeFn: onChangeFn
    }
  });
}

function toggleMultipleOption(_ref2) {
  var activeOptionIndex = _ref2.activeOptionIndex,
      dispatch = _ref2.dispatch,
      onChangeContext = _ref2.onChangeContext;
  dispatch({
    type: _useListBox["default"].types.toggleMultipleOption,
    payload: {
      activeOptionIndex: activeOptionIndex,
      onChangeFn: (0, _invokeOnChange["default"])(onChangeContext, "list-box:option-selected")
    }
  });
}

function selectMultipleOption(_ref3) {
  var activeOptionIndex = _ref3.activeOptionIndex,
      dispatch = _ref3.dispatch,
      isSelected = _ref3.isSelected,
      _ref3$onChange = _ref3.onChange,
      onChange = _ref3$onChange === void 0 ? null : _ref3$onChange,
      onChangeContext = _ref3.onChangeContext;
  var onChangeFn = onChange || (0, _invokeOnChange["default"])(onChangeContext, "list-box:option-selected");
  dispatch({
    type: _useListBox["default"].types.selectMultipleOption,
    payload: {
      activeOptionIndex: activeOptionIndex,
      onChangeFn: onChangeFn,
      isSelected: isSelected
    }
  });
}

function isOptionSelected(state, index) {
  return state.selectedOptions.includes(index);
}

function isOptionVisible(state, key) {
  if (!(0, _keys["default"])(state.options).length) return;
  var keyInt = (0, _parseInt["default"])(key, 10);

  if (typeof state.options[keyInt] === "undefined") {
    return true;
  }

  if (state.noResultsFound) {
    return false;
  }

  if (state.options[keyInt].isHidden) {
    return false;
  }

  return !state.filteredOptions.length || state.filteredOptions.includes(keyInt);
}

function isDisabled(state, key) {
  return state.options[key].isDisabled;
}

function getNextOptionActiveIndex(state) {
  var isAscending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var activeOption = state.activeOption,
      filteredOptions = state.filteredOptions,
      options = state.options;
  var optionsKeys = (0, _keys["default"])(state.options);
  if (state.noResultsFound) return null;

  if (optionsKeys.length === 1) {
    if (state.options[0].isDisabled) {
      return null;
    }

    return 0;
  }

  if (optionsKeys.length - 1 < activeOption) return 0;
  var key = state.activeOption === null ? -1 : state.options[activeOption].index;
  var keepIterating = true;

  while (keepIterating) {
    if (isAscending) {
      if (filteredOptions.length === 1) {
        keepIterating = false;
        return filteredOptions[0];
      }

      if (key > -1 && (filteredOptions.length && key + 1 > options.length || key + 1 > optionsKeys.length - 1)) {
        keepIterating = false;
        return null;
      }

      key++;
    } else {
      if (filteredOptions.length && key - 1 < 0 || key - 1 < 0) {
        keepIterating = false;
        return null;
      }

      key--;
    }

    if (isOptionVisible(state, key) && !isDisabled(state, key)) {
      return key;
    }
  }
}

function getNextOptionActiveIndexLooping(state) {
  return getNextOptionActiveIndex(state) || getNextOptionActiveIndex(state, false);
}

function handleArrowKeys(_ref4) {
  var event = _ref4.event,
      state = _ref4.state,
      dispatch = _ref4.dispatch,
      _ref4$isArrowDown = _ref4.isArrowDown,
      isArrowDown = _ref4$isArrowDown === void 0 ? null : _ref4$isArrowDown,
      onChangeContext = _ref4.onChangeContext;

  if (!state.isInline && !state.isOpen) {
    dispatch({
      type: _useListBox["default"].types.openPopover
    });
    return;
  }

  event.preventDefault();
  var next = getNextOptionActiveIndex(state, isArrowDown);

  if (next !== null) {
    if (state.isMulti) {
      dispatch({
        type: _useListBox["default"].types.setActiveOption,
        payload: {
          activeOptionIndex: next,
          isOpen: true
        }
      });
    } else {
      selectSingleOption({
        activeOptionIndex: next,
        isOpen: true,
        dispatch: dispatch,
        onChangeContext: onChangeContext
      });
    }
  }
}

var handleClickOption = function handleClickOption(_ref5) {
  var props = _ref5.props,
      state = _ref5.state,
      dispatch = _ref5.dispatch,
      onChangeContext = _ref5.onChangeContext;
  return function (event) {
    var index = props.index;
    var options = state.options,
        hasFilter = state.hasFilter,
        isMulti = state.isMulti,
        refFilterInput = state.refFilterInput;
    var hasPreventDefaultOnSelect = options[index].preventDefaultOnSelect;

    if (state.isDisabled || props.isDisabled) {
      return;
    }

    var focusListBoxContentIfHasNotFilter = state.refListBox.current.contains(event.target) && document.activeElement === document.body && !hasFilter;

    if (focusListBoxContentIfHasNotFilter) {
      state.refListBoxContainer.current.focus();
    }

    if (hasFilter && isMulti) {
      refFilterInput.current.focus();
    }

    if (props.onClick || hasPreventDefaultOnSelect) {
      var onClick = props.onClick ? props.onClick : function () {};

      if (hasPreventDefaultOnSelect) {
        // this will not selected the option, but will report that was clicked it.
        // since this action will not affect the state we can report it right back.
        onClick();
        return;
      }

      onClick();
    }

    if (isMulti) {
      toggleMultipleOption({
        activeOptionIndex: index,
        dispatch: dispatch,
        onChangeContext: onChangeContext
      });
      return;
    }

    selectSingleOption({
      activeOptionIndex: index,
      isOpen: false,
      dispatch: dispatch,
      onChangeContext: onChangeContext
    });
  };
};

exports.handleClickOption = handleClickOption;

function handleEnterOrSpace(_ref6) {
  var event = _ref6.event,
      state = _ref6.state,
      dispatch = _ref6.dispatch,
      onChangeContext = _ref6.onChangeContext;
  var pressedSpaceKeyWhileHavingFilter = state.hasFilter && event.key === " " && event.target.value !== "";
  var isEventOnFooter = state.refFooterContainer.current ? state.refFooterContainer.current.contains(event.target) : false;

  if (pressedSpaceKeyWhileHavingFilter || isEventOnFooter) {
    return;
  }

  event.preventDefault();
  var option = state.options[state.activeOption];

  if (option && (option.isDisabled || option.preventDefaultOnSelect)) {
    if (typeof state.options[state.activeOption] !== "undefined" && state.options[state.activeOption].onClick) {
      // no sure if this is the state they want
      // since haven't run the entire cycle befor executing it
      state.options[state.activeOption].onClick(event, state.activeOption, state.options, state, dispatch);
    }

    return;
  }

  if (state.activeOption === null) {
    if (state.isInline) {
      return;
    }

    if (state.noResultsFound) {
      return;
    }

    if (state.isMulti) {
      dispatch({
        type: _useListBox["default"].types.togglePopover
      });
      return;
    }
  }

  if (state.isOpen || state.isInline) {
    if (typeof state.options[state.activeOption] !== "undefined" && state.options[state.activeOption].onClick) {
      state.options[state.activeOption].onClick();
    }

    if (state.isMulti) {
      toggleMultipleOption({
        activeOptionIndex: state.activeOption,
        dispatch: dispatch,
        onChangeContext: onChangeContext
      });
      return;
    } // for single select the option is set when the user interact with up and down arrows
    // no need to notify which option is selected just close the popover


    dispatch({
      type: _useListBox["default"].types.closePopover
    });

    if (state.refTrigger.current) {
      state.refTrigger.current.focus();
    }
  } else {
    dispatch({
      type: _useListBox["default"].types.openPopover
    });
  }
}

function isWhiteListed(displayName) {
  return displayName === "ListBox.Option" || displayName === "ListBox.RawItem" || displayName === "ListBox.Divider";
}
//# sourceMappingURL=options.js.map

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.errorFormStyles = exports.readOnlyFormStyles = exports.disabledFormStyles = void 0;

var _tokens = _interopRequireDefault(__webpack_require__(27));

var disabledFormStyles = "\n  background-color: ".concat(_tokens["default"].color.white, ";\n  border-color: ").concat(_tokens["default"].color.blackLighten70, ";\n  color: ").concat(_tokens["default"].color.blackLighten60, ";\n  cursor: not-allowed;\n");
exports.disabledFormStyles = disabledFormStyles;
var readOnlyFormStyles = "\n  background-color: ".concat(_tokens["default"].color.blackLighten70, ";\n  box-shadow: none;\n  color: ").concat(_tokens["default"].color.black, ";\n  cursor: text;\n\n  &,\n  &:focus {\n    border-color: ").concat(_tokens["default"].color.blackLighten60, ";\n  }\n");
exports.readOnlyFormStyles = readOnlyFormStyles;
var errorFormStyles = "\n  border-color: ".concat(_tokens["default"].color.orange, ";\n");
exports.errorFormStyles = errorFormStyles;
//# sourceMappingURL=formIncludes.js.map

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRef;
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}


/***/ }),
/* 500 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 501 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ThemeContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var PopoverContext = _react["default"].createContext();

var ThemeContext = _react["default"].createContext();

exports.ThemeContext = ThemeContext;
var _default = PopoverContext;
exports["default"] = _default;
//# sourceMappingURL=PopoverContext.js.map

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Trigger = exports.Popover = exports.consts = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _rawButton = _interopRequireDefault(__webpack_require__(727));

var consts = {
  transition: "150ms"
};
exports.consts = consts;

var Popover = _styledComponents["default"].div.withConfig({
  displayName: "Popoverstyles__Popover",
  componentId: "sc-1lyt872-0"
})(["display:inline-block;"]);

exports.Popover = Popover;
var Trigger = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "Popoverstyles__Trigger",
  componentId: "sc-1lyt872-1"
})(["&:focus{box-shadow:none;", ";}"], _stylers["default"].focusRing.subtle());
exports.Trigger = Trigger;
//# sourceMappingURL=Popover.styles.js.map

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(505);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 505 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ThemeContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var PopoverContext = _react["default"].createContext();

var ThemeContext = _react["default"].createContext();

exports.ThemeContext = ThemeContext;
var _default = PopoverContext;
exports["default"] = _default;
//# sourceMappingURL=PopoverContext.js.map

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Trigger = exports.Popover = exports.consts = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _rawButton = _interopRequireDefault(__webpack_require__(563));

var consts = {
  transition: "150ms"
};
exports.consts = consts;

var Popover = _styledComponents["default"].div.withConfig({
  displayName: "Popoverstyles__Popover",
  componentId: "sc-1lyt872-0"
})(["display:inline-block;"]);

exports.Popover = Popover;
var Trigger = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "Popoverstyles__Trigger",
  componentId: "sc-1lyt872-1"
})(["&:focus{box-shadow:none;", ";}"], _stylers["default"].focusRing.subtle());
exports.Trigger = Trigger;
//# sourceMappingURL=Popover.styles.js.map

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = OnChangeProvider;
exports.OnChangeContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var OnChangeContext = _react["default"].createContext(null);

exports.OnChangeContext = OnChangeContext;
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  onChange: _propTypes["default"].func.isRequired
};

function OnChangeProvider(props) {
  var children = props.children,
      onChange = props.onChange;
  return /*#__PURE__*/_react["default"].createElement(OnChangeContext.Provider, {
    value: onChange
  }, children);
}

OnChangeProvider.propTypes = propTypes;
//# sourceMappingURL=OnChangeProvider.js.map

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "TimesCircle___StyledSvg",
  componentId: "ufq9lp-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgTimesCircle = function SvgTimesCircle(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 1.5C6.218 1.5 1.5 6.235 1.5 12S6.218 22.5 12 22.5 22.5 17.782 22.5 12 17.765 1.5 12 1.5zm-.755 7.532a1.05 1.05 0 001.481.004l2.624-2.598 2.228 2.228-2.617 2.591a1.05 1.05 0 00-.003 1.489l2.604 2.604-2.228 2.227-2.604-2.604a1.05 1.05 0 00-1.489.004l-2.575 2.6-2.228-2.227 2.582-2.608a1.05 1.05 0 00-.003-1.482L6.423 8.666 8.65 6.438l2.595 2.594z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgTimesCircle;
exports["default"] = _default;
//# sourceMappingURL=TimesCircle.js.map

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ThemeContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var PopoverContext = _react["default"].createContext();

var ThemeContext = _react["default"].createContext();

exports.ThemeContext = ThemeContext;
var _default = PopoverContext;
exports["default"] = _default;
//# sourceMappingURL=PopoverContext.js.map

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Trigger = exports.Popover = exports.consts = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _rawButton = _interopRequireDefault(__webpack_require__(512));

var consts = {
  transition: "150ms"
};
exports.consts = consts;

var Popover = _styledComponents["default"].div.withConfig({
  displayName: "Popoverstyles__Popover",
  componentId: "sc-1lyt872-0"
})(["display:inline-block;"]);

exports.Popover = Popover;
var Trigger = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "Popoverstyles__Trigger",
  componentId: "sc-1lyt872-1"
})(["&:focus{box-shadow:none;", ";}"], _stylers["default"].focusRing.subtle());
exports.Trigger = Trigger;
//# sourceMappingURL=Popover.styles.js.map

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RawButton["default"];
  }
});

var _RawButton = _interopRequireDefault(__webpack_require__(1286));
//# sourceMappingURL=index.js.map

/***/ }),
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RawButton["default"];
  }
});

var _RawButton = _interopRequireDefault(__webpack_require__(1040));
//# sourceMappingURL=index.js.map

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.sidePanelKinds = exports.MEDIUM = exports.SMALL = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var SMALL = constants.size.SMALL;
exports.SMALL = SMALL;
var MEDIUM = constants.size.MEDIUM;
exports.MEDIUM = MEDIUM;
var sidePanelKinds = {
  DEFAULT: "default",
  CHILD: "child",
  PRIMARY: "primary"
};
exports.sidePanelKinds = sidePanelKinds;
//# sourceMappingURL=types.js.map

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ButtonIcon = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var _rawButton = _interopRequireDefault(__webpack_require__(715));

var _Refresh = _interopRequireDefault(__webpack_require__(361));

var _CaretDown = _interopRequireDefault(__webpack_require__(310));

__webpack_require__(636);

var constants = _interopRequireWildcard(__webpack_require__(40));

var sc = _interopRequireWildcard(__webpack_require__(716));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var ButtonIcon = function ButtonIcon(props) {
  return props.children ? /*#__PURE__*/_react["default"].createElement(sc.ButtonIcon, (0, _extends2["default"])({
    "data-pka-anchor": "button.icon"
  }, props)) : null;
};

exports.ButtonIcon = ButtonIcon;

var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      icon = props.icon,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      isDropdown = props.isDropdown,
      isPending = props.isPending,
      isSemantic = props.isSemantic,
      isSubmit = props.isSubmit,
      kind = props.kind,
      onClick = props.onClick,
      role = props.role,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "icon", "isActive", "isDisabled", "isDropdown", "isPending", "isSemantic", "isSubmit", "kind", "onClick", "role", "tabIndex"]);
  if (a11yText) moreProps["aria-label"] = a11yText;

  var buttonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        buttonRef.current.focus();
      }
    };
  });

  var isButtonDisabled = isDisabled || isPending;

  function handleSubmit(event) {
    var $form = event.target.closest("form");
    var button = $form.ownerDocument.createElement("input");
    button.style.display = "none";
    button.type = "submit";
    $form.appendChild(button).click();
    $form.removeChild(button);
  }

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);

    if (isSubmit && !isSemantic) {
      handleSubmit(event);
    }

    if (!canPropagate) event.stopPropagation();
    if (!isButtonDisabled) onClick(event);
  };

  var bestTabIndex = isButtonDisabled && tabIndex === null ? -1 : tabIndex || 0;

  function handleBlur(event) {
    if ("onBlur" in moreProps) {
      moreProps.onBlur(event);
    }

    setHasForcedFocus(false);
  }

  var buttonProps = _objectSpread(_objectSpread({
    "aria-pressed": isActive,
    "data-pka-anchor": "button",
    tabIndex: tabIndex
  }, moreProps), {}, {
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isButtonDisabled,
    kind: kind,
    onBlur: handleBlur,
    onClick: handleClick,
    ref: buttonRef
  });

  if (isSemantic) {
    buttonProps.disabled = isButtonDisabled;
    buttonProps.type = isSubmit ? "submit" : "button";
    if (role !== "button") buttonProps.role = role;
  } else {
    buttonProps.tabIndex = bestTabIndex;
    buttonProps.role = role;
  }

  var iconProps = {
    isDisabled: isButtonDisabled,
    kind: kind
  };
  return /*#__PURE__*/_react["default"].createElement(sc.Button, (0, _extends2["default"])({
    as: isSemantic ? "button" : _rawButton["default"]
  }, buttonProps), /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isPending: isPending
  }), isPending ? /*#__PURE__*/_react["default"].createElement(_Refresh["default"], null) : icon), children, /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isSuffixIcon: true
  }), isDropdown && /*#__PURE__*/_react["default"].createElement(_CaretDown["default"], null)));
});

Button.types = {
  size: constants.defaultSize,
  kind: constants.kind
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** If the button includes a down arrow to the right of children content. */
  isDropdown: _propTypes["default"].bool,

  /** If the width of the button should span it's parent container (100%). */
  isFullWidth: _propTypes["default"].bool,

  /** If the button should render in a pending state (with a spinner icon). */
  isPending: _propTypes["default"].bool,

  /** If it will be rendered as a <button> element. If false, a <span> will be rendered via an accessible <RawButton>. */
  isSemantic: _propTypes["default"].bool,

  /** If the type attribute should "submit", instead of the default "button". */
  isSubmit: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Button.types.kind.DEFAULT, Button.types.kind.PRIMARY, Button.types.kind.SECONDARY, Button.types.kind.DESTRUCTIVE, Button.types.kind.FLAT, Button.types.kind.MINOR, Button.types.kind.LINK]),

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Button.types.size.SMALL, Button.types.size.MEDIUM, Button.types.size.LARGE]),

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  children: null,
  icon: null,
  isActive: null,
  isDisabled: false,
  isDropdown: false,
  isFullWidth: false,
  isPending: false,
  isSemantic: true,
  isSubmit: false,
  kind: Button.types.kind.DEFAULT,
  onClick: function onClick() {},
  role: "button",
  size: Button.types.size.MEDIUM,
  tabIndex: null
};
var buttonPropTypes = {
  children: _propTypes["default"].node
};
var buttonDefaultProps = {
  children: null
};
Button.displayName = "Button";
ButtonIcon.propTypes = buttonPropTypes;
ButtonIcon.defaultProps = buttonDefaultProps;
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
var _default = Button;
exports["default"] = _default;
//# sourceMappingURL=Button.js.map

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LINK = exports.MINOR = exports.FLAT = exports.DESTRUCTIVE = exports.SECONDARY = exports.PRIMARY = exports.DEFAULT = exports.LARGE = exports.MEDIUM = exports.SMALL = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var SMALL = constants.size.SMALL;
exports.SMALL = SMALL;
var MEDIUM = constants.size.MEDIUM;
exports.MEDIUM = MEDIUM;
var LARGE = constants.size.LARGE;
exports.LARGE = LARGE;
var DEFAULT = constants.kind.DEFAULT;
exports.DEFAULT = DEFAULT;
var PRIMARY = constants.kind.PRIMARY;
exports.PRIMARY = PRIMARY;
var SECONDARY = constants.kind.SECONDARY;
exports.SECONDARY = SECONDARY;
var DESTRUCTIVE = constants.kind.DESTRUCTIVE;
exports.DESTRUCTIVE = DESTRUCTIVE;
var FLAT = constants.kind.FLAT;
exports.FLAT = FLAT;
var MINOR = constants.kind.MINOR;
exports.MINOR = MINOR;
var LINK = constants.kind.LINK;
exports.LINK = LINK;
//# sourceMappingURL=types.js.map

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["b"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deferAction;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inlineProp; });
function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var _window = window,
      setImmediate = _window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover["default"];
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(1123));
//# sourceMappingURL=index.js.map

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var organizationShape = {
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  customerName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  logo: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  launchpad: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (organizationShape);

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.sanitizeActionTypes = sanitizeActionTypes;
exports.getSelectedOptionSingle = getSelectedOptionSingle;
exports.getSelectedOptionsMulti = getSelectedOptionsMulti;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _useListBox = _interopRequireDefault(__webpack_require__(140));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function sanitizeActionTypes() {
  var actionTypes = _useListBox["default"].types;
  return {
    clear: actionTypes.clear,
    closePopover: actionTypes.closePopover,
    openPopover: actionTypes.openPopover,
    reset: actionTypes.reset,
    togglePopover: actionTypes.togglePopover,
    unhideOptions: actionTypes.unhideOptions,
    unselectOptions: actionTypes.unselectOptions
  };
}

function getSelectedOptionSingle(state) {
  var activeOptionIndex = state.selectedOptions && state.selectedOptions.length === 0 ? null : state.selectedOptions[0];
  return [activeOptionIndex, state.options];
}

function getSelectedOptionsMulti(state) {
  return [state.selectedOptions, state.options, state.activeOption];
}

var invokeOnChange = function invokeOnChange() {
  var onChangeCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var event = arguments.length > 2 ? arguments[2] : undefined;
  return function (state, dispatch) {
    if (!onChangeCallback) {
      // This could mean that the consumer might decide to use onClickAccept in the footer without a onChange or
      // added a footer without onClickAccept.
      return;
    }

    if (state.isMulti) {
      var _getSelectedOptionsMu = getSelectedOptionsMulti(state),
          _getSelectedOptionsMu2 = (0, _slicedToArray2["default"])(_getSelectedOptionsMu, 3),
          _selected = _getSelectedOptionsMu2[0],
          _options = _getSelectedOptionsMu2[1],
          current = _getSelectedOptionsMu2[2];

      onChangeCallback(_selected, _options, current, _objectSpread({
        dispatch: dispatch,
        actionTypes: sanitizeActionTypes(),
        eventType: eventType
      }, event));
      dispatch({
        type: _useListBox["default"].types.cleanOnChangeFn
      });
      return;
    }

    var _getSelectedOptionSin = getSelectedOptionSingle(state),
        _getSelectedOptionSin2 = (0, _slicedToArray2["default"])(_getSelectedOptionSin, 2),
        selected = _getSelectedOptionSin2[0],
        options = _getSelectedOptionSin2[1];

    onChangeCallback(selected, options, _objectSpread({
      dispatch: dispatch,
      actionTypes: sanitizeActionTypes(),
      eventType: eventType
    }, event));
    dispatch({
      type: _useListBox["default"].types.cleanOnChangeFn
    });
  };
};

var _default = invokeOnChange;
exports["default"] = _default;
//# sourceMappingURL=invokeOnChange.js.map

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RawButton["default"];
  }
});

var _RawButton = _interopRequireDefault(__webpack_require__(1170));
//# sourceMappingURL=index.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.getDOMAttributesForListBoxContainer = getDOMAttributesForListBoxContainer;
exports.getDOMAttributesForListBox = getDOMAttributesForListBox;
exports.getDOMAttributesForListBoxButton = getDOMAttributesForListBoxButton;
exports.getA11yAttributesForOption = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _keys = _interopRequireDefault(__webpack_require__(13));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function getDOMAttributesForListBoxContainer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$isInline = _ref.isInline,
      isInline = _ref$isInline === void 0 ? false : _ref$isInline;

  var tabIndex = isInline ? "0" : "-1";
  return {
    tabIndex: tabIndex
  };
}

function getDOMAttributesForListBox(state) {
  var activedescendant = "";
  var activeOption = state.activeOption;

  if (activeOption && activeOption < (0, _keys["default"])(state.options).length) {
    var id = state.options[activeOption].id;

    if (id) {
      activedescendant = id;
    }
  }

  var idListBox = state.idListBox;
  return {
    "aria-activedescendant": activedescendant,
    "aria-labelledby": "".concat(idListBox, "__button"),
    id: idListBox,
    role: "listbox"
  };
}

var getA11yAttributesForOption = function getA11yAttributesForOption(isSelected) {
  var a11yIsSelected = {
    "aria-selected": "".concat(isSelected ? "true" : "false")
  };
  return _objectSpread({
    role: "option"
  }, a11yIsSelected);
};

exports.getA11yAttributesForOption = getA11yAttributesForOption;

function getDOMAttributesForListBoxButton(idListBox) {
  return function innerFunction() {
    return {
      id: "".concat(idListBox, "__button"),
      type: "button"
    };
  };
}
//# sourceMappingURL=DOMAttributes.js.map

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ButtonIcon = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var _rawButton = _interopRequireDefault(__webpack_require__(563));

var _Refresh = _interopRequireDefault(__webpack_require__(361));

var _CaretDown = _interopRequireDefault(__webpack_require__(310));

__webpack_require__(636);

var constants = _interopRequireWildcard(__webpack_require__(40));

var sc = _interopRequireWildcard(__webpack_require__(737));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var ButtonIcon = function ButtonIcon(props) {
  return props.children ? /*#__PURE__*/_react["default"].createElement(sc.ButtonIcon, (0, _extends2["default"])({
    "data-pka-anchor": "button.icon"
  }, props)) : null;
};

exports.ButtonIcon = ButtonIcon;

var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      icon = props.icon,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      isDropdown = props.isDropdown,
      isPending = props.isPending,
      isSemantic = props.isSemantic,
      isSubmit = props.isSubmit,
      kind = props.kind,
      onClick = props.onClick,
      role = props.role,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "icon", "isActive", "isDisabled", "isDropdown", "isPending", "isSemantic", "isSubmit", "kind", "onClick", "role", "tabIndex"]);
  if (a11yText) moreProps["aria-label"] = a11yText;

  var buttonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        buttonRef.current.focus();
      }
    };
  });

  var isButtonDisabled = isDisabled || isPending;

  function handleSubmit(event) {
    var $form = event.target.closest("form");
    var button = $form.ownerDocument.createElement("input");
    button.style.display = "none";
    button.type = "submit";
    $form.appendChild(button).click();
    $form.removeChild(button);
  }

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);

    if (isSubmit && !isSemantic) {
      handleSubmit(event);
    }

    if (!canPropagate) event.stopPropagation();
    if (!isButtonDisabled) onClick(event);
  };

  var bestTabIndex = isButtonDisabled && tabIndex === null ? -1 : tabIndex || 0;

  function handleBlur(event) {
    if ("onBlur" in moreProps) {
      moreProps.onBlur(event);
    }

    setHasForcedFocus(false);
  }

  var buttonProps = _objectSpread(_objectSpread({
    "aria-pressed": isActive,
    "data-pka-anchor": "button",
    tabIndex: tabIndex
  }, moreProps), {}, {
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isButtonDisabled,
    kind: kind,
    onBlur: handleBlur,
    onClick: handleClick,
    ref: buttonRef
  });

  if (isSemantic) {
    buttonProps.disabled = isButtonDisabled;
    buttonProps.type = isSubmit ? "submit" : "button";
    if (role !== "button") buttonProps.role = role;
  } else {
    buttonProps.tabIndex = bestTabIndex;
    buttonProps.role = role;
  }

  var iconProps = {
    isDisabled: isButtonDisabled,
    kind: kind
  };
  return /*#__PURE__*/_react["default"].createElement(sc.Button, (0, _extends2["default"])({
    as: isSemantic ? "button" : _rawButton["default"]
  }, buttonProps), /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isPending: isPending
  }), isPending ? /*#__PURE__*/_react["default"].createElement(_Refresh["default"], null) : icon), children, /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isSuffixIcon: true
  }), isDropdown && /*#__PURE__*/_react["default"].createElement(_CaretDown["default"], null)));
});

Button.types = {
  size: constants.defaultSize,
  kind: constants.kind
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** If the button includes a down arrow to the right of children content. */
  isDropdown: _propTypes["default"].bool,

  /** If the width of the button should span it's parent container (100%). */
  isFullWidth: _propTypes["default"].bool,

  /** If the button should render in a pending state (with a spinner icon). */
  isPending: _propTypes["default"].bool,

  /** If it will be rendered as a <button> element. If false, a <span> will be rendered via an accessible <RawButton>. */
  isSemantic: _propTypes["default"].bool,

  /** If the type attribute should "submit", instead of the default "button". */
  isSubmit: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Button.types.kind.DEFAULT, Button.types.kind.PRIMARY, Button.types.kind.SECONDARY, Button.types.kind.DESTRUCTIVE, Button.types.kind.FLAT, Button.types.kind.MINOR, Button.types.kind.LINK]),

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Button.types.size.SMALL, Button.types.size.MEDIUM, Button.types.size.LARGE]),

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  children: null,
  icon: null,
  isActive: null,
  isDisabled: false,
  isDropdown: false,
  isFullWidth: false,
  isPending: false,
  isSemantic: true,
  isSubmit: false,
  kind: Button.types.kind.DEFAULT,
  onClick: function onClick() {},
  role: "button",
  size: Button.types.size.MEDIUM,
  tabIndex: null
};
var buttonPropTypes = {
  children: _propTypes["default"].node
};
var buttonDefaultProps = {
  children: null
};
Button.displayName = "Button";
ButtonIcon.propTypes = buttonPropTypes;
ButtonIcon.defaultProps = buttonDefaultProps;
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
var _default = Button;
exports["default"] = _default;
//# sourceMappingURL=Button.js.map

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LINK = exports.MINOR = exports.FLAT = exports.DESTRUCTIVE = exports.SECONDARY = exports.PRIMARY = exports.DEFAULT = exports.LARGE = exports.MEDIUM = exports.SMALL = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var SMALL = constants.size.SMALL;
exports.SMALL = SMALL;
var MEDIUM = constants.size.MEDIUM;
exports.MEDIUM = MEDIUM;
var LARGE = constants.size.LARGE;
exports.LARGE = LARGE;
var DEFAULT = constants.kind.DEFAULT;
exports.DEFAULT = DEFAULT;
var PRIMARY = constants.kind.PRIMARY;
exports.PRIMARY = PRIMARY;
var SECONDARY = constants.kind.SECONDARY;
exports.SECONDARY = SECONDARY;
var DESTRUCTIVE = constants.kind.DESTRUCTIVE;
exports.DESTRUCTIVE = DESTRUCTIVE;
var FLAT = constants.kind.FLAT;
exports.FLAT = FLAT;
var MINOR = constants.kind.MINOR;
exports.MINOR = MINOR;
var LINK = constants.kind.LINK;
exports.LINK = LINK;
//# sourceMappingURL=types.js.map

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ButtonIcon = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var _rawButton = _interopRequireDefault(__webpack_require__(1221));

var _Refresh = _interopRequireDefault(__webpack_require__(361));

var _CaretDown = _interopRequireDefault(__webpack_require__(310));

__webpack_require__(636);

var constants = _interopRequireWildcard(__webpack_require__(40));

var sc = _interopRequireWildcard(__webpack_require__(741));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var ButtonIcon = function ButtonIcon(props) {
  return props.children ? /*#__PURE__*/_react["default"].createElement(sc.ButtonIcon, (0, _extends2["default"])({
    "data-pka-anchor": "button.icon"
  }, props)) : null;
};

exports.ButtonIcon = ButtonIcon;

var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      icon = props.icon,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      isDropdown = props.isDropdown,
      isPending = props.isPending,
      isSemantic = props.isSemantic,
      isSubmit = props.isSubmit,
      kind = props.kind,
      onClick = props.onClick,
      role = props.role,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "icon", "isActive", "isDisabled", "isDropdown", "isPending", "isSemantic", "isSubmit", "kind", "onClick", "role", "tabIndex"]);
  if (a11yText) moreProps["aria-label"] = a11yText;

  var buttonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        buttonRef.current.focus();
      }
    };
  });

  var isButtonDisabled = isDisabled || isPending;

  function handleSubmit(event) {
    var $form = event.target.closest("form");
    var button = $form.ownerDocument.createElement("input");
    button.style.display = "none";
    button.type = "submit";
    $form.appendChild(button).click();
    $form.removeChild(button);
  }

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);

    if (isSubmit && !isSemantic) {
      handleSubmit(event);
    }

    if (!canPropagate) event.stopPropagation();
    if (!isButtonDisabled) onClick(event);
  };

  var bestTabIndex = isButtonDisabled && tabIndex === null ? -1 : tabIndex || 0;

  function handleBlur(event) {
    if ("onBlur" in moreProps) {
      moreProps.onBlur(event);
    }

    setHasForcedFocus(false);
  }

  var buttonProps = _objectSpread(_objectSpread({
    "aria-pressed": isActive,
    "data-pka-anchor": "button",
    tabIndex: tabIndex
  }, moreProps), {}, {
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isButtonDisabled,
    kind: kind,
    onBlur: handleBlur,
    onClick: handleClick,
    ref: buttonRef
  });

  if (isSemantic) {
    buttonProps.disabled = isButtonDisabled;
    buttonProps.type = isSubmit ? "submit" : "button";
    if (role !== "button") buttonProps.role = role;
  } else {
    buttonProps.tabIndex = bestTabIndex;
    buttonProps.role = role;
  }

  var iconProps = {
    isDisabled: isButtonDisabled,
    kind: kind
  };
  return /*#__PURE__*/_react["default"].createElement(sc.Button, (0, _extends2["default"])({
    as: isSemantic ? "button" : _rawButton["default"]
  }, buttonProps), /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isPending: isPending
  }), isPending ? /*#__PURE__*/_react["default"].createElement(_Refresh["default"], null) : icon), children, /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isSuffixIcon: true
  }), isDropdown && /*#__PURE__*/_react["default"].createElement(_CaretDown["default"], null)));
});

Button.types = {
  size: constants.defaultSize,
  kind: constants.kind
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** If the button includes a down arrow to the right of children content. */
  isDropdown: _propTypes["default"].bool,

  /** If the width of the button should span it's parent container (100%). */
  isFullWidth: _propTypes["default"].bool,

  /** If the button should render in a pending state (with a spinner icon). */
  isPending: _propTypes["default"].bool,

  /** If it will be rendered as a <button> element. If false, a <span> will be rendered via an accessible <RawButton>. */
  isSemantic: _propTypes["default"].bool,

  /** If the type attribute should "submit", instead of the default "button". */
  isSubmit: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Button.types.kind.DEFAULT, Button.types.kind.PRIMARY, Button.types.kind.SECONDARY, Button.types.kind.DESTRUCTIVE, Button.types.kind.FLAT, Button.types.kind.MINOR, Button.types.kind.LINK]),

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Button.types.size.SMALL, Button.types.size.MEDIUM, Button.types.size.LARGE]),

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  children: null,
  icon: null,
  isActive: null,
  isDisabled: false,
  isDropdown: false,
  isFullWidth: false,
  isPending: false,
  isSemantic: true,
  isSubmit: false,
  kind: Button.types.kind.DEFAULT,
  onClick: function onClick() {},
  role: "button",
  size: Button.types.size.MEDIUM,
  tabIndex: null
};
var buttonPropTypes = {
  children: _propTypes["default"].node
};
var buttonDefaultProps = {
  children: null
};
Button.displayName = "Button";
ButtonIcon.propTypes = buttonPropTypes;
ButtonIcon.defaultProps = buttonDefaultProps;
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
var _default = Button;
exports["default"] = _default;
//# sourceMappingURL=Button.js.map

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LINK = exports.MINOR = exports.FLAT = exports.DESTRUCTIVE = exports.SECONDARY = exports.PRIMARY = exports.DEFAULT = exports.LARGE = exports.MEDIUM = exports.SMALL = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var SMALL = constants.size.SMALL;
exports.SMALL = SMALL;
var MEDIUM = constants.size.MEDIUM;
exports.MEDIUM = MEDIUM;
var LARGE = constants.size.LARGE;
exports.LARGE = LARGE;
var DEFAULT = constants.kind.DEFAULT;
exports.DEFAULT = DEFAULT;
var PRIMARY = constants.kind.PRIMARY;
exports.PRIMARY = PRIMARY;
var SECONDARY = constants.kind.SECONDARY;
exports.SECONDARY = SECONDARY;
var DESTRUCTIVE = constants.kind.DESTRUCTIVE;
exports.DESTRUCTIVE = DESTRUCTIVE;
var FLAT = constants.kind.FLAT;
exports.FLAT = FLAT;
var MINOR = constants.kind.MINOR;
exports.MINOR = MINOR;
var LINK = constants.kind.LINK;
exports.LINK = LINK;
//# sourceMappingURL=types.js.map

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "ArrowRight___StyledSvg",
  componentId: "sc-1d87buu-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgArrowRight = function SvgArrowRight(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.293 13.486c.82-.82.82-2.151 0-2.972L8.279 1.5 6.05 3.729l8.272 8.27-8.272 8.272L8.279 22.5l9.014-9.014z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var _default = SvgArrowRight;
exports["default"] = _default;
//# sourceMappingURL=ArrowRight.js.map

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ButtonIcon = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var _rawButton = _interopRequireDefault(__webpack_require__(512));

var _Refresh = _interopRequireDefault(__webpack_require__(1304));

var _CaretDown = _interopRequireDefault(__webpack_require__(1305));

__webpack_require__(1306);

var constants = _interopRequireWildcard(__webpack_require__(40));

var sc = _interopRequireWildcard(__webpack_require__(749));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var ButtonIcon = function ButtonIcon(props) {
  return props.children ? /*#__PURE__*/_react["default"].createElement(sc.ButtonIcon, (0, _extends2["default"])({
    "data-pka-anchor": "button.icon"
  }, props)) : null;
};

exports.ButtonIcon = ButtonIcon;

var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      icon = props.icon,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      isDropdown = props.isDropdown,
      isPending = props.isPending,
      isSemantic = props.isSemantic,
      isSubmit = props.isSubmit,
      kind = props.kind,
      onClick = props.onClick,
      role = props.role,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "icon", "isActive", "isDisabled", "isDropdown", "isPending", "isSemantic", "isSubmit", "kind", "onClick", "role", "tabIndex"]);
  if (a11yText) moreProps["aria-label"] = a11yText;

  var buttonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        buttonRef.current.focus();
      }
    };
  });

  var isButtonDisabled = isDisabled || isPending;

  function handleSubmit(event) {
    var $form = event.target.closest("form");
    var button = $form.ownerDocument.createElement("input");
    button.style.display = "none";
    button.type = "submit";
    $form.appendChild(button).click();
    $form.removeChild(button);
  }

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);

    if (isSubmit && !isSemantic) {
      handleSubmit(event);
    }

    if (!canPropagate) event.stopPropagation();
    if (!isButtonDisabled) onClick(event);
  };

  var bestTabIndex = isButtonDisabled && tabIndex === null ? -1 : tabIndex || 0;

  function handleBlur(event) {
    if ("onBlur" in moreProps) {
      moreProps.onBlur(event);
    }

    setHasForcedFocus(false);
  }

  var buttonProps = _objectSpread(_objectSpread({
    "aria-pressed": isActive,
    "data-pka-anchor": "button",
    tabIndex: tabIndex
  }, moreProps), {}, {
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isButtonDisabled,
    kind: kind,
    onBlur: handleBlur,
    onClick: handleClick,
    ref: buttonRef
  });

  if (isSemantic) {
    buttonProps.disabled = isButtonDisabled;
    buttonProps.type = isSubmit ? "submit" : "button";
    if (role !== "button") buttonProps.role = role;
  } else {
    buttonProps.tabIndex = bestTabIndex;
    buttonProps.role = role;
  }

  var iconProps = {
    isDisabled: isButtonDisabled,
    kind: kind
  };
  return /*#__PURE__*/_react["default"].createElement(sc.Button, (0, _extends2["default"])({
    as: isSemantic ? "button" : _rawButton["default"]
  }, buttonProps), /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isPending: isPending
  }), isPending ? /*#__PURE__*/_react["default"].createElement(_Refresh["default"], null) : icon), children, /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isSuffixIcon: true
  }), isDropdown && /*#__PURE__*/_react["default"].createElement(_CaretDown["default"], null)));
});

Button.types = {
  size: constants.defaultSize,
  kind: constants.kind
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** If the button includes a down arrow to the right of children content. */
  isDropdown: _propTypes["default"].bool,

  /** If the width of the button should span it's parent container (100%). */
  isFullWidth: _propTypes["default"].bool,

  /** If the button should render in a pending state (with a spinner icon). */
  isPending: _propTypes["default"].bool,

  /** If it will be rendered as a <button> element. If false, a <span> will be rendered via an accessible <RawButton>. */
  isSemantic: _propTypes["default"].bool,

  /** If the type attribute should "submit", instead of the default "button". */
  isSubmit: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Button.types.kind.DEFAULT, Button.types.kind.PRIMARY, Button.types.kind.SECONDARY, Button.types.kind.DESTRUCTIVE, Button.types.kind.FLAT, Button.types.kind.MINOR, Button.types.kind.LINK]),

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Button.types.size.SMALL, Button.types.size.MEDIUM, Button.types.size.LARGE]),

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  children: null,
  icon: null,
  isActive: null,
  isDisabled: false,
  isDropdown: false,
  isFullWidth: false,
  isPending: false,
  isSemantic: true,
  isSubmit: false,
  kind: Button.types.kind.DEFAULT,
  onClick: function onClick() {},
  role: "button",
  size: Button.types.size.MEDIUM,
  tabIndex: null
};
var buttonPropTypes = {
  children: _propTypes["default"].node
};
var buttonDefaultProps = {
  children: null
};
Button.displayName = "Button";
ButtonIcon.propTypes = buttonPropTypes;
ButtonIcon.defaultProps = buttonDefaultProps;
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
var _default = Button;
exports["default"] = _default;
//# sourceMappingURL=Button.js.map

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LINK = exports.MINOR = exports.FLAT = exports.DESTRUCTIVE = exports.SECONDARY = exports.PRIMARY = exports.DEFAULT = exports.LARGE = exports.MEDIUM = exports.SMALL = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var SMALL = constants.size.SMALL;
exports.SMALL = SMALL;
var MEDIUM = constants.size.MEDIUM;
exports.MEDIUM = MEDIUM;
var LARGE = constants.size.LARGE;
exports.LARGE = LARGE;
var DEFAULT = constants.kind.DEFAULT;
exports.DEFAULT = DEFAULT;
var PRIMARY = constants.kind.PRIMARY;
exports.PRIMARY = PRIMARY;
var SECONDARY = constants.kind.SECONDARY;
exports.SECONDARY = SECONDARY;
var DESTRUCTIVE = constants.kind.DESTRUCTIVE;
exports.DESTRUCTIVE = DESTRUCTIVE;
var FLAT = constants.kind.FLAT;
exports.FLAT = FLAT;
var MINOR = constants.kind.MINOR;
exports.MINOR = MINOR;
var LINK = constants.kind.LINK;
exports.LINK = LINK;
//# sourceMappingURL=types.js.map

/***/ }),
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RefOf = exports.FocusPropTypes = exports.InputValidTypes = exports.deprecated = exports.AlignTypes = exports.ShirtSizes = void 0;

var _values = _interopRequireDefault(__webpack_require__(96));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

// NOTE: Maybe this should be provided as a consumable package?
var ShirtSizes = {
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge"
};
exports.ShirtSizes = ShirtSizes;
ShirtSizes.DEFAULT = [ShirtSizes.SMALL, ShirtSizes.MEDIUM, ShirtSizes.LARGE];
ShirtSizes.LIMITED = [ShirtSizes.SMALL, ShirtSizes.MEDIUM];
ShirtSizes.ALL = (0, _values["default"])(ShirtSizes);
var AlignTypes = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left"
};
exports.AlignTypes = AlignTypes;
AlignTypes.ALL = (0, _values["default"])(AlignTypes);

var deprecated = function deprecated(name) {
  return function (props, propName, component) {
    if (props[propName] !== undefined) {
      return new Error("Deprecated prop '".concat(propName, "' supplied to ").concat(component, ". Use '").concat(name, "' instead."));
    }

    return null;
  };
};

exports.deprecated = deprecated;
var InputValidTypes = {
  EMAIL: "email",
  NUMBER: "number",
  PASSWORD: "password",
  SEARCH: "search",
  TELEPHONE: "tel",
  TEXT: "text",
  URL: "url"
};
exports.InputValidTypes = InputValidTypes;
var FocusPropTypes = {
  // properties copy from https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/src/Lock.js#L160
  // see description for props here: https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/interfaces.d.ts#L4
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  returnFocus: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
  noFocusGuards: _propTypes["default"].bool,
  allowTextSelection: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  persistentFocus: _propTypes["default"].bool,
  group: _propTypes["default"].string,
  className: _propTypes["default"].string,
  whiteList: _propTypes["default"].func,
  shards: _propTypes["default"].arrayOf(_propTypes["default"].any),
  as: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  lockProps: _propTypes["default"].object,
  onActivation: _propTypes["default"].func,
  onDeactivation: _propTypes["default"].func,
  sideCar: _propTypes["default"].any
};
exports.FocusPropTypes = FocusPropTypes;
InputValidTypes.ALL = (0, _values["default"])(InputValidTypes);

var RefOf = function RefOf() {
  var propType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _propTypes["default"].object;
  return _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: propType
  })]);
};

exports.RefOf = RefOf;
//# sourceMappingURL=customPropTypes.js.map

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button["default"];
  }
});

var _Button = _interopRequireDefault(__webpack_require__(556));

var _Close = _interopRequireDefault(__webpack_require__(1067));

var _Icon = _interopRequireDefault(__webpack_require__(717));

var _Link = _interopRequireDefault(__webpack_require__(1072));

_Button["default"].Close = _Close["default"];
_Button["default"].Icon = _Icon["default"];
_Button["default"].Link = _Link["default"];
//# sourceMappingURL=index.js.map

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest

/* eslint-disable func-names */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  };
}
/* eslint-enable func-names */
//# sourceMappingURL=closest.js.map

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCallbackRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            }
        }
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackRef;
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */
function createCallbackRef(callback) {
    var current = null;
    return {
        get current() {
            return current;
        },
        set current(value) {
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mediumFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediumBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mediumEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mediumSidecar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_use_sidecar__ = __webpack_require__(1097);

var mediumFocus = Object(__WEBPACK_IMPORTED_MODULE_0_use_sidecar__["a" /* createMedium */])({}, function (_ref) {
  var target = _ref.target,
      currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = Object(__WEBPACK_IMPORTED_MODULE_0_use_sidecar__["a" /* createMedium */])();
var mediumEffect = Object(__WEBPACK_IMPORTED_MODULE_0_use_sidecar__["a" /* createMedium */])();
var mediumSidecar = Object(__WEBPACK_IMPORTED_MODULE_0_use_sidecar__["b" /* createSidecarMedium */])({
  async: true
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(368);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var filterNested = function filterNested(nodes) {
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    var _loop = function _loop(j) {
      if (i !== j) {
        if (nodes[i].contains(nodes[j])) {
          return {
            v: filterNested(nodes.filter(function (x) {
              return x !== nodes[j];
            }))
          };
        }
      }
    };

    for (var j = 0; j < l; j += 1) {
      var _ret = _loop(j);

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  }
  return nodes;
};

var getTopParent = function getTopParent(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};

var getAllAffectedNodes = function getAllAffectedNodes(node) {
  var nodes = Object(__WEBPACK_IMPORTED_MODULE_1__array__["b" /* asArray */])(node);
  return nodes.filter(Boolean).reduce(function (acc, currentNode) {
    var group = currentNode.getAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FOCUS_GROUP */]);
    acc.push.apply(acc, group ? filterNested(Object(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* toArray */])(getTopParent(currentNode).querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FOCUS_GROUP */] + '="' + group + '"]:not([' + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* FOCUS_DISABLED */] + '="disabled"])'))) : [currentNode]);
    return acc;
  }, []);
};

/* harmony default export */ __webpack_exports__["a"] = (getAllAffectedNodes);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__paprika_tokens__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__paprika_tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__paprika_tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(306);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var NavigationIcon = /*#__PURE__*/function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default()(NavigationIcon, _React$Component);

  var _super = _createSuper(NavigationIcon);

  function NavigationIcon() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NavigationIcon);

    return _super.apply(this, arguments);
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NavigationIcon, [{
    key: "render",
    value: function render() {
      var Icon = this.props.icon;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Icon, {
        className: "navigation-item__icon",
        color: __WEBPACK_IMPORTED_MODULE_8__paprika_tokens___default.a.color.white,
        size: __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* iconSize */]
      });
    }
  }]);

  return NavigationIcon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(NavigationIcon, "propTypes", {
  icon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
});



/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button["default"];
  }
});

var _Button = _interopRequireDefault(__webpack_require__(565));

var _Close = _interopRequireDefault(__webpack_require__(1191));

var _Icon = _interopRequireDefault(__webpack_require__(738));

var _Link = _interopRequireDefault(__webpack_require__(1196));

_Button["default"].Close = _Close["default"];
_Button["default"].Icon = _Icon["default"];
_Button["default"].Link = _Link["default"];
//# sourceMappingURL=index.js.map

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "CaretUp___StyledSvg",
  componentId: "rwdaeu-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgCaretUp = function SvgCaretUp(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.099 8.742a1.501 1.501 0 00-2.223 0c-1.41 1.554-3.83 4.22-5.256 5.789a.753.753 0 00.556 1.257h11.623a.751.751 0 00.556-1.257l-5.256-5.789z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgCaretUp;
exports["default"] = _default;
//# sourceMappingURL=CaretUp.js.map

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "Search___StyledSvg",
  componentId: "sc-1ilttoo-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgSearch = function SvgSearch(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.942 19.24l-3.779-3.779a9.052 9.052 0 00-7.607-13.96A9.05 9.05 0 001.5 10.553a9.051 9.051 0 009.056 9.054 8.986 8.986 0 004.906-1.448l3.779 3.778c.748.75 1.956.748 2.7 0a1.91 1.91 0 00.001-2.698zM10.425 3.6c3.77 0 6.825 3.051 6.825 6.823 0 1.822-.71 3.536-2 4.824a6.776 6.776 0 01-4.826 1.999A6.821 6.821 0 013.6 10.423 6.82 6.82 0 0110.425 3.6z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgSearch;
exports["default"] = _default;
//# sourceMappingURL=Search.js.map

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var availableAppShape = {
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (availableAppShape);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _OverflowMenu["default"];
  }
});

var _OverflowMenu = _interopRequireDefault(__webpack_require__(1276));
//# sourceMappingURL=index.js.map

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.i18n = exports.defaultLocale = void 0;

var _i18next = _interopRequireDefault(__webpack_require__(100));

var _locales = _interopRequireDefault(__webpack_require__(704));

var defaultLocale = "en";
exports.defaultLocale = defaultLocale;

var i18n = function i18n(locales) {
  var i18nConfig = {
    lng: defaultLocale,
    fallbackLng: defaultLocale,
    lowerCaseLng: true,
    resources: locales || _locales["default"]
  };

  var newInstance = _i18next["default"].createInstance(i18nConfig, function (err) {
    if (err) return console.log("something went wrong loading i18next", err);
    return null;
  });

  return newInstance;
};

exports.i18n = i18n;
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _en = _interopRequireDefault(__webpack_require__(1031));

var _de = _interopRequireDefault(__webpack_require__(1032));

var _fr = _interopRequireDefault(__webpack_require__(1033));

var _es = _interopRequireDefault(__webpack_require__(1034));

var _pt = _interopRequireDefault(__webpack_require__(1035));

var _ja = _interopRequireDefault(__webpack_require__(1036));

var _zh = _interopRequireDefault(__webpack_require__(1037));

var locales = {
  en: _en["default"].en,
  de: _de["default"].de,
  fr: _fr["default"].fr,
  es: _es["default"].es,
  pt: _pt["default"].pt,
  ja: _ja["default"].ja,
  zh: _zh["default"].zh
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var L10nContext = _react["default"].createContext();

var _default = L10nContext;
exports["default"] = _default;
//# sourceMappingURL=L10nContext.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Academy___StyledSvg",
  componentId: "sc-1dk0ble-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Academy = function Academy(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.523 233.674H62.37v25.882H38.522v-25.882zm399.656-107.192l-183.29-94.04c-6.34-3.256-16.722-3.256-23.061 0L37 132.401v79.392h25.79V146.63l51.595 28.507v89.592h.053c0 9.476.052 17.915.052 24.766-.052.21-.052.42-.105.63.053 0 .053-.026.105-.026v14.32c0 66.99 77.385 145.569 128.966 145.569 51.582 0 128.967-78.58 128.967-145.57 0-18.584.59-94.355.315-129.504l65.65-36.264c6.248-3.465 6.143-8.951-.21-12.206v.039zm-299.683 54.587c26.971-6.865 62.448-11.065 101.495-11.065 39.047 0 74.55 4.214 101.496 11.065v28.927c-26.893-6.917-62.344-11.182-101.496-11.182-39.152 0-74.524 4.265-101.495 11.182V181.07zM341.5 273.666c-.105 12.692-.158 23.047-.158 28.323 0 49.692-67.068 108.02-101.43 108.02-34.387 0-101.43-58.328-101.43-108.02v-18.296c22.234-8.899 40.32-28.468 49.77-53.694 22.09 23.257 68.684 39.322 122.772 39.322 10.552 0 20.645-.813 30.45-2.02v6.365h.026zm-139.558 11.773c-6.983 0-12.692 5.775-12.692 12.941 0 7.14 5.71 12.941 12.692 12.941 7.035 0 12.692-5.801 12.692-12.941 0-7.166-5.657-12.941-12.692-12.941zm76.125 0c-6.983 0-12.692 5.775-12.692 12.941 0 7.14 5.71 12.941 12.692 12.941 7.035 0 12.692-5.801 12.692-12.941 0-7.166-5.657-12.941-12.692-12.941z"
  }));
};

var _default = Academy;
exports["default"] = _default;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "CommunityLogo___StyledSvg",
  componentId: "sc-11b17nu-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var CommunityLogo = function CommunityLogo(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M386.943 239.86H450v38.171h-51.507l-67.01 44.68-73.977-92.452-74.779 74.779-57.272-57.258-30.279 30.251H30V239.86h49.37l46.085-46.073 57.272 57.258 77.948-77.928 78.75 98.407 47.518-31.664zm-297.69-57.258H50.67c-.86-6.375-1.585-12.75-1.585-19.086C49.085 96.085 96.182 49 163.631 49c30.43 0 58.628 15.975 76.363 39.699C257.73 64.975 285.927 49 316.358 49c67.448 0 114.545 47.085 114.545 114.516 0 12.654-2.195 25.422-5.498 38.172H386.04c4.142-12.903 6.682-25.71 6.682-38.172 0-46.38-29.973-76.344-76.364-76.344-24.608 0-44.902 17.922-53.206 38.172h-46.334c-8.286-20.25-28.58-38.172-53.187-38.172-46.391 0-76.364 29.965-76.364 76.344 0 6.24.802 12.635 1.985 19.086zM239.898 387.02c12.332-10.421 33.103-28.782 55.382-51.723h51.813c-44.844 51.608-91.636 88.482-95.378 91.402a19.09 19.09 0 01-11.722 4.028 19.09 19.09 0 01-11.722-4.028c-4.18-3.263-62.312-49.031-111.261-110.488h50.056c25.906 29.125 53.015 54.261 72.832 70.809z"
  }));
};

var _default = CommunityLogo;
exports["default"] = _default;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "LaunchpadLogo___StyledSvg",
  componentId: "sc-1wukuf3-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var LaunchpadLogo = function LaunchpadLogo(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M440.566 39.205c-6.61-6.589-16.625-9.669-31.516-9.669-29.823 0-88.305 14.075-127.144 52.934l-80.574 80.554H65.56A20.514 20.514 0 0051.118 169l-14.422 14.442c-7.955 7.975-7.955 20.888 0 28.864l230.788 230.768a20.343 20.343 0 0014.422 5.976c5.222 0 10.444-1.999 14.422-5.976l14.442-14.422c3.835-3.835 5.956-9.016 5.956-14.442V278.418l80.574-80.574c29.333-29.313 42.266-67.172 47.345-87.081 4.12-16.176 11.974-55.504-4.08-71.558zm-280.01 164.616l-37.31 37.309-37.328-37.31h74.638zm-8.466 66.172l144.238-144.237 57.687 57.666L209.798 327.68l-57.708-57.687zm123.86 123.84l-37.309-37.289 37.309-37.33v74.619zM381.43 153.15L326.6 98.32c28.557-20.052 63.908-27.987 82.45-27.987h.571c.245 16.441-7.405 53.2-28.19 82.818zM152.07 385.388c5.303-5.304 8.649-11.689 10.423-18.481l30.802 30.822c-3.427 5.854-7.343 11.464-12.361 16.482-27.987 27.986-112.11 33.902-128.694 34.8l-22.704 1.223 1.224-22.683c.898-16.584 6.772-100.707 34.78-128.735 4.997-4.997 10.627-8.934 16.461-12.361l30.802 30.802c-6.732 1.795-13.157 5.14-18.42 10.423-8.955 8.935-17.033 44.081-20.929 78.616 34.412-3.814 69.437-11.75 78.616-20.908z"
  }));
};

var _default = LaunchpadLogo;
exports["default"] = _default;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "MissionControl___StyledSvg",
  componentId: "sc-1sbw4li-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var MissionControl = function MissionControl(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M404.102 403.989c-2.942 2.962-8.782 3.575-13.162 3.575-24.145 0-67.377-19.146-117.339-55.492 28.97-25.09 54.067-50.245 78.698-78.784 15.173 20.754 27.997 41.106 37.561 60.23 22.346 44.66 19.088 65.626 14.242 70.47M88.06 407.565c-4.38 0-10.2-.613-13.162-3.575-4.846-4.845-8.083-25.81 14.242-70.47 9.564-19.125 22.388-39.477 37.582-60.231 24.61 28.518 49.686 53.672 78.677 78.784-49.94 36.346-93.194 55.492-117.339 55.492M74.898 74.866c2.963-2.92 8.782-3.554 13.162-3.554 24.145 0 67.399 19.146 117.339 55.492-28.462 24.668-53.982 50.118-78.804 78.848C76.358 136.98 63.662 86.142 74.898 74.866m250.76 164.636a744.51 744.51 0 01-41.265 44.829c-15.151 15.148-30.133 28.455-44.882 40.873-14.77-12.418-29.753-25.725-44.883-40.873-15.427-15.423-29.012-30.38-41.264-44.83 12.739-15.084 26.472-30.168 41.264-44.935 15.13-15.147 30.112-28.497 44.883-40.915 14.749 12.418 29.731 25.768 44.882 40.915 14.77 14.767 28.504 29.851 41.265 44.936m65.282-168.19c4.38 0 10.22.635 13.162 3.554 11.236 11.276-1.44 62.114-51.676 130.786-24.843-28.73-50.342-54.18-78.825-78.848 49.962-36.346 93.194-55.492 117.339-55.492zM239.5 197.35c23.24 0 42.1 18.856 42.1 42.088s-18.86 42.088-42.1 42.088c-23.24 0-42.1-18.856-42.1-42.088s18.86-42.088 42.1-42.088zm188.218 117.234c-11.978-23.927-28.272-49.42-47.846-75.21 59.273-78.17 91.162-157.42 54.152-194.422C426.744 37.695 413.349 29 390.94 29c-38.514 0-93.596 26.17-151.43 70.068C181.657 55.17 126.575 29 88.06 29c-22.41 0-35.783 8.695-43.084 15.952-36.99 37.001-5.12 116.251 54.173 194.423-19.574 25.789-35.89 51.282-47.867 75.209-34.62 69.243-22.536 103.093-6.306 119.32 7.301 7.298 20.675 15.972 43.084 15.972 38.514 0 93.596-26.149 151.45-70.09 57.834 43.941 112.916 70.09 151.43 70.09 22.41 0 35.804-8.674 43.084-15.973 16.23-16.226 28.313-50.076-6.306-119.32"
  }));
};

var _default = MissionControl;
exports["default"] = _default;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ProjectsLogo___StyledSvg",
  componentId: "e2afxb-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var ProjectsLogo = function ProjectsLogo(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.366 8.37v14.697h18.398v3.066H15.366a3.07 3.07 0 01-3.066-3.066V8.369l-3.516 3.516-2.168-2.168L13.833 2.5l7.216 7.217-2.168 2.168-3.515-3.516zm-4.6 8.564h-4.6v-3.067h4.6v3.067zm6.133 0h7.666v4.6h3.067v-4.6a3.07 3.07 0 00-3.067-3.067H16.9v3.067zm10.733 10.732v3.965l3.515-3.516 2.168 2.168-7.217 7.217-7.216-7.217 2.167-2.168 3.516 3.516v-3.965h3.067z",
    fill: "currentColor"
  }));
};

var _default = ProjectsLogo;
exports["default"] = _default;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ReportsLogo___StyledSvg",
  componentId: "sc-16oqc9t-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var ReportsLogo = function ReportsLogo(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M450 125c0 11.592-9.387 21-21 21v210h21v42H261v42h-42v-42H30v-42h21V146c-11.592 0-21-9.408-21-21V62c0-11.592 9.408-21 21-21h378c11.613 0 21 9.408 21 21v63zm-63 231V146H93v210h294zM72 83v21h336V83H72zm105 231c-34.776 0-63-28.203-63-63 0-34.776 28.224-63 63-63v63h63c0 34.797-28.203 63-63 63zm21-147c34.797 0 63 28.224 63 63h-63v-63zm168 0v42h-63v-42h63zm0 63v42h-84v-42h84zM240 335v-42h126v42H240z"
  }));
};

var _default = ReportsLogo;
exports["default"] = _default;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ResultsLogo___StyledSvg",
  componentId: "sc-15dr7yo-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var ResultsLogo = function ResultsLogo(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.222 18.054h3.89v15.555h-3.89V18.054zM23.89 33.609H20v-7.778h3.889v7.778zm3.889-23.331h3.889v23.331h-3.89V10.278zm7.778 23.333V8.333A1.945 1.945 0 0033.61 6.39h-7.778a1.945 1.945 0 00-1.944 1.944v13.61H20v-5.834a1.945 1.945 0 00-1.944-1.944h-7.778a1.945 1.945 0 00-1.945 1.944v17.502H6.39V2.5H2.5v33.056c0 1.073.871 1.944 1.944 1.944H37.5v-3.889h-1.944z",
    fill: "currentColor"
  }));
};

var _default = ResultsLogo;
exports["default"] = _default;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Robot___StyledSvg",
  componentId: "sc-1oni3xr-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Robot = function Robot(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M219.041 190.468v-44.973c-11.931-6.902-19.959-19.802-19.959-34.577C199.082 88.872 216.954 71 239 71s39.918 17.872 39.918 39.918c0 14.775-8.028 27.675-19.96 34.577v44.91l99.542-.158c66.845 5.48 119.5 61.501 119.5 129.859 0 68.357-52.655 124.379-119.5 129.48l-239 .378C52.655 444.484 0 388.464 0 320.106s52.655-124.38 119.5-129.48l99.541-.158zm0 40.202H129c-49.477 0-89.587 40.268-89.587 89.941s40.11 89.94 89.587 89.94H347.99c49.478 0 89.587-40.267 89.587-89.94 0-49.673-40.11-89.94-89.587-89.94H219.041zM129.353 370.13c-27.348 0-49.518-22.396-49.518-50.023 0-27.627 22.17-50.024 49.518-50.024s49.518 22.397 49.518 50.024c0 27.627-22.17 50.023-49.518 50.023zm.505-30.317c10.884 0 19.706-8.823 19.706-19.706 0-10.884-8.822-19.706-19.706-19.706-10.883 0-19.706 8.822-19.706 19.706 0 10.883 8.823 19.706 19.706 19.706zm217.778 30.317c-27.348 0-49.518-22.396-49.518-50.023 0-27.627 22.17-50.024 49.518-50.024s49.518 22.397 49.518 50.024c0 27.627-22.17 50.023-49.518 50.023zm.506-30.317c10.883 0 19.706-8.823 19.706-19.706 0-10.884-8.823-19.706-19.706-19.706-10.884 0-19.706 8.822-19.706 19.706 0 10.883 8.822 19.706 19.706 19.706z"
  }));
};

var _default = Robot;
exports["default"] = _default;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "StrategyLogo___StyledSvg",
  componentId: "cik599-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var StrategyLogo = function StrategyLogo(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.528 23.484c0 .956-.541 2.027-1.405 3.125L13.938 11.426c2.674-1.318 4.792-3.2 6.078-4.547 1.934 2.026 5.726 5.297 10.512 5.971v10.635zM20.016 33.752C15.641 31.298 9.504 26.73 9.504 23.484V12.849c.256-.037.496-.107.746-.158l16.427 16.427c-2.043 1.779-4.553 3.454-6.661 4.634zM32.28 9.468c-6.027 0-10.817-6.246-10.864-6.311-.662-.876-2.137-.876-2.8 0-.047.065-4.837 6.31-10.864 6.31-.967 0-1.752.786-1.752 1.753v12.264c0 6.673 11.849 13.103 13.2 13.814a1.748 1.748 0 001.633 0c1.35-.71 13.2-7.14 13.2-13.814V11.22c0-.967-.786-1.752-1.753-1.752z",
    fill: "currentColor"
  }));
};

var _default = StrategyLogo;
exports["default"] = _default;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RawButton["default"];
  }
});

var _RawButton = _interopRequireDefault(__webpack_require__(1065));
//# sourceMappingURL=index.js.map

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ButtonIcon = exports.Button = exports.fullWidthStyles = exports.kindStyles = exports.sizeStyles = exports.commonStyles = exports.inactiveStyles = exports.activeStyles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var types = _interopRequireWildcard(__webpack_require__(557));

var _borderColors, _borderHoverColors, _sizeStyles, _iconColors;

var dropShadow = "0 1px 2px 0 rgba(0, 0, 0, 0.1)";

var enabled = function enabled(content) {
  return (0, _styledComponents.css)(["&:not([disabled]):not([aria-disabled=\"true\"]){", ";}"], content);
}; // Borders


var borderColors = (_borderColors = {}, (0, _defineProperty2["default"])(_borderColors, types.DEFAULT, _tokens["default"].border.color), (0, _defineProperty2["default"])(_borderColors, types.PRIMARY, _tokens["default"].color.green), (0, _defineProperty2["default"])(_borderColors, types.SECONDARY, _tokens["default"].color.purple), (0, _defineProperty2["default"])(_borderColors, types.DESTRUCTIVE, _tokens["default"].color.orange), (0, _defineProperty2["default"])(_borderColors, types.FLAT, _tokens["default"].border.color), (0, _defineProperty2["default"])(_borderColors, types.MINOR, "transparent"), (0, _defineProperty2["default"])(_borderColors, types.LINK, "transparent"), _borderColors);
var borderHoverColors = (_borderHoverColors = {}, (0, _defineProperty2["default"])(_borderHoverColors, types.DEFAULT, _tokens["default"].border.hoverColor), (0, _defineProperty2["default"])(_borderHoverColors, types.PRIMARY, _tokens["default"].color.greenDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.SECONDARY, _tokens["default"].color.purpleDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.DESTRUCTIVE, _tokens["default"].color.orangeDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.FLAT, _tokens["default"].border.hoverColor), (0, _defineProperty2["default"])(_borderHoverColors, types.MINOR, "transparent"), (0, _defineProperty2["default"])(_borderHoverColors, types.LINK, "transparent"), _borderHoverColors);

var borderStyles = function borderStyles(_ref) {
  var kind = _ref.kind;
  return (0, _styledComponents.css)(["border-color:", ";&:hover{", "}"], borderColors[kind], enabled((0, _styledComponents.css)(["border-color:", ";"], borderHoverColors[kind])));
}; // States


var disabledStyles = (0, _styledComponents.css)(["box-shadow:none;color:", ";cursor:not-allowed;text-decoration:none;text-shadow:none;&:focus{box-shadow:none;text-shadow:none;transform:none;}&,&:hover,&:focus{background:", ";border-color:", ";color:", ";text-decoration:none;}&,&:hover,&:active{box-shadow:none;transform:none;}"], _tokens["default"].color.blackDisabled, _tokens["default"].color.blackLighten70, _tokens["default"].color.blackLighten60, _tokens["default"].color.blackLighten40);
var disabledTextStyles = (0, _styledComponents.css)(["", " &,&:hover{background:none;border-color:transparent;}"], disabledStyles);
var activeStyles = (0, _styledComponents.css)(["", ""], _stylers["default"].focusRing.bordered());
exports.activeStyles = activeStyles;

var inactiveStyles = function inactiveStyles(_ref2) {
  var kind = _ref2.kind;
  return (0, _styledComponents.css)(["", " [data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{", "}"], borderStyles, enabled((0, _styledComponents.css)(["", " ", ""], borderStyles, [types.FLAT, types.MINOR, types.LINK].includes(kind) ? (0, _styledComponents.css)(["box-shadow:none;"]) : (0, _styledComponents.css)(["box-shadow:", ";"], dropShadow))));
}; // Common


exports.inactiveStyles = inactiveStyles;
var commonStyles = (0, _styledComponents.css)(["", " ", " appearance:none;border-radius:", ";border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;font-weight:bold;text-align:center;text-decoration:none;vertical-align:middle;&:focus{", "}&:active{box-shadow:", ",inset 0 1px 1px 0 rgba(0,0,0,0.1),inset 0 1px 4px 0 rgba(0,0,0,0.3);transform:scale(0.98);}"], _stylers["default"].alignMiddle, _stylers["default"].lineHeight(-1), _tokens["default"].button.borderRadius, _stylers["default"].focusRing.bordered(), _tokens["default"].highlight.active.noBorder.boxShadow);
exports.commonStyles = commonStyles;
var skeuomorphicStyles = (0, _styledComponents.css)(["box-shadow:", ";cursor:pointer;transition-duration:0.2s;transition-property:border;"], dropShadow);
var coloredButtonStyles = (0, _styledComponents.css)(["color:", ";text-shadow:0 1px 1px ", ";&:hover,&:visited{color:", ";text-decoration:none;}"], _tokens["default"].color.white, _stylers["default"].alpha(_tokens["default"].color.blackPure, 0.2), _tokens["default"].color.white);
var textButtonStyles = (0, _styledComponents.css)(["background:none;border-color:transparent;"]); // Sizes

var sizeStyles = (_sizeStyles = {}, (0, _defineProperty2["default"])(_sizeStyles, types.SMALL, (0, _styledComponents.css)(["", ";min-height:", ";padding:3px ", ";"], _stylers["default"].fontSize(-2), _stylers["default"].spacer(3), _tokens["default"].space)), (0, _defineProperty2["default"])(_sizeStyles, types.MEDIUM, (0, _styledComponents.css)(["", ";min-height:", ";padding:6.5px ", ";"], _stylers["default"].fontSize(-1), _stylers["default"].spacer(4), _tokens["default"].spaceLg)), (0, _defineProperty2["default"])(_sizeStyles, types.LARGE, (0, _styledComponents.css)(["", ";min-height:", ";padding:9px ", ";"], _stylers["default"].fontSize(), _stylers["default"].spacer(5), _stylers["default"].spacer(2))), _sizeStyles); // types

exports.sizeStyles = sizeStyles;

var kindStyles = function kindStyles(_ref3) {
  var _ref4;

  var isDisabled = _ref3.isDisabled;
  return _ref4 = {}, (0, _defineProperty2["default"])(_ref4, types.DEFAULT, (0, _styledComponents.css)(["", " &,&:hover,&:active,&:visited{background-color:", ";background-image:linear-gradient(", ",", ");color:", ";text-decoration:none;}&:hover,&:active{background:", ";}", ""], skeuomorphicStyles, _tokens["default"].color.white, _tokens["default"].color.blackLighten90, _tokens["default"].color.blackLighten70, _tokens["default"].color.black, _tokens["default"].color.blackLighten70, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.PRIMARY, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.greenLighten10, _tokens["default"].color.greenLighten10, _tokens["default"].color.green, _tokens["default"].color.green, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.SECONDARY, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.purpleLighten10, _tokens["default"].color.purpleLighten10, _tokens["default"].color.purple, _tokens["default"].color.purple, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.DESTRUCTIVE, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.orangeHighlight, _tokens["default"].color.orangeHighlight, _tokens["default"].color.orange, _tokens["default"].color.orange, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.FLAT, (0, _styledComponents.css)(["", " background-color:", ";color:", ";&:hover,&:visited{background:", ";color:", ";text-decoration:none;}", ""], skeuomorphicStyles, _tokens["default"].color.white, _tokens["default"].color.black, _tokens["default"].color.blackLighten70, _tokens["default"].color.black, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.MINOR, (0, _styledComponents.css)(["", " &:hover{text-decoration:underline;}", ""], textButtonStyles, isDisabled && disabledTextStyles)), (0, _defineProperty2["default"])(_ref4, types.LINK, (0, _styledComponents.css)(["", " color:", ";font-weight:inherit;text-decoration:underline;&:hover{color:", ";}&:active{color:", ";}", ""], textButtonStyles, _tokens["default"].textColor.link, _tokens["default"].textColor.linkHover, _tokens["default"].color.blue, isDisabled && disabledTextStyles)), _ref4;
}; // Modifiers


exports.kindStyles = kindStyles;
var fullWidthStyles = (0, _styledComponents.css)(["display:flex;width:100%;"]); //
// Composition
//

exports.fullWidthStyles = fullWidthStyles;

var Button = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyles__Button",
  componentId: "ru6wp6-0"
})(function (_ref5) {
  var size = _ref5.size,
      kind = _ref5.kind,
      isFullWidth = _ref5.isFullWidth,
      isActive = _ref5.isActive,
      props = (0, _objectWithoutProperties2["default"])(_ref5, ["size", "kind", "isFullWidth", "isActive"]);
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], commonStyles, sizeStyles[size], kindStyles(props)[kind], isFullWidth && fullWidthStyles, isActive ? activeStyles : inactiveStyles);
}); //
// Icons
//


exports.Button = Button;
var spinKeyframes = (0, _styledComponents.keyframes)(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var iconColors = (_iconColors = {}, (0, _defineProperty2["default"])(_iconColors, types.DEFAULT, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.PRIMARY, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.SECONDARY, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.DESTRUCTIVE, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.FLAT, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.MINOR, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.LINK, _tokens["default"].textColor.icon), _iconColors);

var getIconColor = function getIconColor(_ref6) {
  var isDisabled = _ref6.isDisabled,
      kind = _ref6.kind;
  return isDisabled ? _tokens["default"].color.blackDisabled : iconColors[kind];
};

var ButtonIcon = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyles__ButtonIcon",
  componentId: "ru6wp6-1"
})(function (_ref7) {
  var isPending = _ref7.isPending,
      isSuffixIcon = _ref7.isSuffixIcon,
      props = (0, _objectWithoutProperties2["default"])(_ref7, ["isPending", "isSuffixIcon"]);
  return (0, _styledComponents.css)(["align-items:center;color:", ";display:inline-flex;justify-content:center;margin:0 ", " 0 0;svg{vertical-align:-", "em;}", " ", ""], getIconColor(props), _tokens["default"].spaceSm, (_stylers["default"].lineHeightValue(-1) - 1) / 2, isPending && (0, _styledComponents.css)(["animation:", " 2s infinite linear;"], spinKeyframes), isSuffixIcon && (0, _styledComponents.css)(["margin:0 0 0 ", ";"], _tokens["default"].spaceSm));
});

exports.ButtonIcon = ButtonIcon;
//# sourceMappingURL=Button.styles.js.map

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon["default"];
  }
});

var _Icon = _interopRequireDefault(__webpack_require__(1070));
//# sourceMappingURL=index.js.map

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Overlay["default"];
  }
});

var _Overlay = _interopRequireDefault(__webpack_require__(1079));
//# sourceMappingURL=index.js.map

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.extractChildren = extractChildren;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(182));

var _isArray = _interopRequireDefault(__webpack_require__(95));

var _react = _interopRequireDefault(__webpack_require__(2));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function extractChildren(children, types) {
  var _children = [];
  var components = {};

  if ((0, _isArray["default"])(types)) {
    _react["default"].Children.toArray(children).forEach(function (child) {
      if (child.type && types.includes(child.type.displayName)) {
        if (Object.prototype.hasOwnProperty.call(components, child.type.displayName)) {
          var childs = (0, _isArray["default"])(components[child.type.displayName]) ? [child].concat((0, _toConsumableArray2["default"])(components[child.type.displayName])) : [child, components[child.type.displayName]];
          components[child.type.displayName] = childs;
        } else {
          components[child.type.displayName] = child;
        }
      } else {
        _children.push(child);
      }
    });

    return _objectSpread(_objectSpread({}, components), {}, {
      children: _children
    });
  }

  throw new Error("extractChildren types parameter must be an Array");
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var useOffsetScroll = function useOffsetScroll(offsetY) {
  var _React$useState = _react["default"].useState(offsetY),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      offsetScroll = _React$useState2[0],
      setOffsetScroll = _React$useState2[1];

  _react["default"].useLayoutEffect(function () {
    function handleScroll() {
      var top = window.pageYOffset || document.documentElement.scrollTop;

      if (top <= offsetY) {
        setOffsetScroll(offsetY - top);
      } else {
        setOffsetScroll(0);
      }
    }

    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [offsetY]);

  return offsetScroll;
};

var _default = useOffsetScroll;
exports["default"] = _default;
//# sourceMappingURL=useOffsetScroll.js.map

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock_constants__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_use_callback_ref__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FocusGuard__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__medium__ = __webpack_require__(639);







var emptyArray = [];
var FocusLock = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](function (props, parentRef) {
  var _extends2;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](),
      realObserved = _React$useState[0],
      setObserved = _React$useState[1];

  var observed = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"]();
  var isActive = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](false);
  var originalFocusedElement = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](null);
  var children = props.children,
      disabled = props.disabled,
      noFocusGuards = props.noFocusGuards,
      persistentFocus = props.persistentFocus,
      crossFrame = props.crossFrame,
      autoFocus = props.autoFocus,
      allowTextSelection = props.allowTextSelection,
      group = props.group,
      className = props.className,
      whiteList = props.whiteList,
      _props$shards = props.shards,
      shards = _props$shards === void 0 ? emptyArray : _props$shards,
      _props$as = props.as,
      Container = _props$as === void 0 ? 'div' : _props$as,
      _props$lockProps = props.lockProps,
      containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
      SideCar = props.sideCar,
      shouldReturnFocus = props.returnFocus,
      onActivationCallback = props.onActivation,
      onDeactivationCallback = props.onDeactivation;

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_1_react__["useState"]({}),
      id = _React$useState2[0]; // SIDE EFFECT CALLBACKS


  var onActivation = __WEBPACK_IMPORTED_MODULE_1_react__["useCallback"](function () {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;

    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }

    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = __WEBPACK_IMPORTED_MODULE_1_react__["useCallback"](function () {
    isActive.current = false;

    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  var returnFocus = __WEBPACK_IMPORTED_MODULE_1_react__["useCallback"](function (allowDefer) {
    var current = originalFocusedElement.current;

    if (Boolean(shouldReturnFocus) && current && current.focus) {
      var focusOptions = typeof shouldReturnFocus === 'object' ? shouldReturnFocus : undefined;
      originalFocusedElement.current = null;

      if (allowDefer) {
        // React might return focus after update
        // it's safer to defer the action
        Promise.resolve().then(function () {
          return current.focus(focusOptions);
        });
      } else {
        current.focus(focusOptions);
      }
    }
  }, [shouldReturnFocus]); // MEDIUM CALLBACKS

  var onFocus = __WEBPACK_IMPORTED_MODULE_1_react__["useCallback"](function (event) {
    if (isActive.current) {
      __WEBPACK_IMPORTED_MODULE_6__medium__["c" /* mediumFocus */].useMedium(event);
    }
  }, []);
  var onBlur = __WEBPACK_IMPORTED_MODULE_6__medium__["a" /* mediumBlur */].useMedium; // REF PROPAGATION
  // not using real refs due to race conditions

  var setObserveNode = __WEBPACK_IMPORTED_MODULE_1_react__["useCallback"](function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof allowTextSelection !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
    }

    __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
      if (!observed.current) {
        // eslint-disable-next-line no-console
        console.error('FocusLock: could not obtain ref to internal node');
      }
    }, []);
  }

  var lockProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends2 = {}, _extends2[__WEBPACK_IMPORTED_MODULE_3_focus_lock_constants__["c" /* FOCUS_DISABLED */]] = disabled && 'disabled', _extends2[__WEBPACK_IMPORTED_MODULE_3_focus_lock_constants__["d" /* FOCUS_GROUP */]] = group, _extends2), containerProps);

  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = Object(__WEBPACK_IMPORTED_MODULE_4_use_callback_ref__["a" /* useMergeRefs */])([parentRef, setObserveNode]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, hasLeadingGuards && [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: __WEBPACK_IMPORTED_MODULE_5__FocusGuard__["b" /* hiddenGuard */]
  }),
  /*#__PURE__*/
  // nearest focus guard
  __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: __WEBPACK_IMPORTED_MODULE_5__FocusGuard__["b" /* hiddenGuard */]
  }) // first tabbed element guard
  ], !disabled && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SideCar, {
    id: id,
    sideCar: __WEBPACK_IMPORTED_MODULE_6__medium__["d" /* mediumSidecar */],
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), children), hasTailingGuards && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: __WEBPACK_IMPORTED_MODULE_5__FocusGuard__["b" /* hiddenGuard */]
  }));
});
FocusLock.propTypes = process.env.NODE_ENV !== "production" ? {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types__["node"],
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"],
  returnFocus: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"]]),
  noFocusGuards: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"],
  allowTextSelection: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"],
  autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"],
  persistentFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"],
  crossFrame: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"],
  group: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  whiteList: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
  shards: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_2_prop_types__["any"]),
  as: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"]]),
  lockProps: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
  onActivation: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
  onDeactivation: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
  sideCar: __WEBPACK_IMPORTED_MODULE_2_prop_types__["any"].isRequired
} : {};
FocusLock.defaultProps = {
  children: undefined,
  disabled: false,
  returnFocus: false,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  crossFrame: true,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (FocusLock);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hiddenGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};

InFocusGuard.propTypes = process.env.NODE_ENV !== "production" ? {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
} : {};
InFocusGuard.defaultProps = {
  children: null
};
/* harmony default export */ __webpack_exports__["a"] = (InFocusGuard);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSidecar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__(1099);


var cache = new WeakMap();
function useSidecar(importer, effect) {
    var options = effect && effect.options || {};
    if (__WEBPACK_IMPORTED_MODULE_1__env__["a" /* env */].isNode && !options.ssr) {
        return [null, null];
    }
    var couldUseCache = __WEBPACK_IMPORTED_MODULE_1__env__["a" /* env */].forceCache || (__WEBPACK_IMPORTED_MODULE_1__env__["a" /* env */].isNode && !!options.ssr) || (!options.async);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(couldUseCache ? function () { return cache.get(importer); } : undefined), Car = _a[0], setCar = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null), error = _b[0], setError = _b[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!Car) {
            importer()
                .then(function (car) {
                var resolved = effect ? effect.read() : (car.default || car);
                if (!resolved) {
                    console.error('Sidecar error: with importer', importer);
                    var error_1;
                    if (effect) {
                        console.error('Sidecar error: with medium', effect);
                        error_1 = new Error('Sidecar medium was not found');
                    }
                    else {
                        error_1 = new Error('Sidecar was not found in exports');
                    }
                    setError(function () { return error_1; });
                    throw error_1;
                }
                cache.set(importer, resolved);
                setCar(function () { return resolved; });
            }, function (e) { return setError(function () { return e; }); });
        }
    }, []);
    return [Car, error];
}
;


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NEW_FOCUS */
/* unused harmony export newFocus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFocusabledIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_all_affected__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_correctFocus__ = __webpack_require__(725);






var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
  };
};

var isGuard = function isGuard(node) {
  return node && node.dataset && node.dataset.focusGuard;
};
var notAGuard = function notAGuard(node) {
  return !isGuard(node);
};

var NEW_FOCUS = 'NEW_FOCUS';

var newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);

  // focus is inside
  if (innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }

  var activeIndex = outerNodes.indexOf(activeElement);
  var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
  var lastNodeInside = innerNodes.indexOf(lastNode);
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);

  var correctedNodes = Object(__WEBPACK_IMPORTED_MODULE_4__utils_correctFocus__["b" /* correctNodes */])(outerNodes);
  var correctedIndexDiff = correctedNodes.indexOf(activeElement) - correctedNodes.indexOf(lastNode || activeIndex);

  var returnFirstNode = Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["b" /* pickFocusable */])(innerNodes, 0);
  var returnLastNode = Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["b" /* pickFocusable */])(innerNodes, cnt - 1);

  // new focus
  if (activeIndex === -1 || lastNodeInside === -1) {
    return NEW_FOCUS;
  }
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // first element
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  // last element
  if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  // jump out, but not on the guard
  if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};

var getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* asArray */])(baseActiveElement);
  var leftEntries = Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* asArray */])(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = null;
  leftEntries.filter(Boolean).forEach(function (entry) {
    topCommon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b" /* getCommonParent */])(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function (subEntry) {
      var common = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b" /* getCommonParent */])(activeElement, subEntry);
      if (common) {
        if (!topCommon || common.contains(topCommon)) {
          topCommon = common;
        } else {
          topCommon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b" /* getCommonParent */])(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};

var allParentAutofocusables = function allParentAutofocusables(entries) {
  return entries.reduce(function (acc, node) {
    return acc.concat(Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["d" /* parentAutofocusables */])(node));
  }, []);
};

var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
  var remap = new Map();
  // no Set(dstNodes) for IE11 :(
  dstNodes.forEach(function (entity) {
    return remap.set(entity.node, entity);
  });
  // remap to dstNodes
  return srcNodes.map(function (node) {
    return remap.get(node);
  }).filter(Boolean);
};

var getFocusabledIn = function getFocusabledIn(topNode) {
  var entries = Object(__WEBPACK_IMPORTED_MODULE_2__utils_all_affected__["a" /* default */])(topNode).filter(notAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var outerNodes = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])([commonParent], true);
  var innerElements = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])(entries).filter(function (_ref) {
    var node = _ref.node;
    return notAGuard(node);
  }).map(function (_ref2) {
    var node = _ref2.node;
    return node;
  });

  return outerNodes.map(function (_ref3) {
    var node = _ref3.node,
        index = _ref3.index;
    return {
      node: node,
      index: index,
      lockItem: innerElements.indexOf(node) >= 0,
      guard: isGuard(node)
    };
  });
};

var getFocusMerge = function getFocusMerge(topNode, lastNode) {
  var activeElement = document && document.activeElement;
  var entries = Object(__WEBPACK_IMPORTED_MODULE_2__utils_all_affected__["a" /* default */])(topNode).filter(notAGuard);

  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);

  var anyFocusable = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["a" /* getAllTabbableNodes */])(entries);
  var innerElements = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])(entries).filter(function (_ref4) {
    var node = _ref4.node;
    return notAGuard(node);
  });

  if (!innerElements[0]) {
    innerElements = anyFocusable;
    if (!innerElements[0]) {
      return undefined;
    }
  }

  var outerNodes = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["a" /* getAllTabbableNodes */])([commonParent]).map(function (_ref5) {
    var node = _ref5.node;
    return node;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerNodes = orderedInnerElements.map(function (_ref6) {
    var node = _ref6.node;
    return node;
  });

  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode);

  if (newId === "NEW_FOCUS") {
    var autoFocusable = anyFocusable.map(function (_ref7) {
      var node = _ref7.node;
      return node;
    }).filter(findAutoFocused(allParentAutofocusables(entries)));

    return {
      node: autoFocusable && autoFocusable.length ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a" /* default */])(autoFocusable) : Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a" /* default */])(innerNodes)
    };
  }

  if (newId === undefined) {
    return newId;
  }
  return orderedInnerElements[newId];
};

/* harmony default export */ __webpack_exports__["a"] = (getFocusMerge);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return correctNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return correctNodes; });
var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var correctNode = function correctNode(node, nodes) {
  if (isRadio(node) && node.name) {
    return findSelectedRadio(node, nodes);
  }
  return node;
};

var correctNodes = function correctNodes(nodes) {
  // IE11 has no Set constructor
  var resultSet = new Set();
  nodes.forEach(function (node) {
    return resultSet.add(correctNode(node, nodes));
  });
  // using filter to support IE11
  return nodes.filter(function (node) {
    return resultSet.has(node);
  });
};

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__paprika_popover__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__paprika_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__paprika_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__paprika_raw_button__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__paprika_raw_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__paprika_raw_button__);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable jsx-a11y/mouse-events-have-key-events */






var NavigationButton = /*#__PURE__*/function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default()(NavigationButton, _React$Component);

  var _super = _createSuper(NavigationButton);

  function NavigationButton() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NavigationButton);

    return _super.apply(this, arguments);
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NavigationButton, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__paprika_popover___default.a, {
        isEager: true,
        isDark: true,
        zIndex: this.props.zIndex
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__paprika_popover___default.a.Trigger, null, function (handler) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__paprika_raw_button___default.a, {
          "aria-label": _this.props.ariaLabel,
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(_this.props.className, 'navigation-item__trigger', {
            'navigation-item__trigger--is-active': _this.props.isActive
          }),
          onMouseOver: handler,
          onMouseOut: handler,
          onBlur: handler,
          onClick: _this.props.onClick
        }, _this.props.children);
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__paprika_popover___default.a.Content, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__paprika_popover___default.a.Card, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: this.props.ariaLabel
        }
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__paprika_popover___default.a.Tip, null));
    }
  }]);

  return NavigationButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(NavigationButton, "propTypes", {
  ariaLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  isActive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  zIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(NavigationButton, "defaultProps", {
  className: null,
  isActive: false,
  zIndex: 9999
});



/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RawButton["default"];
  }
});

var _RawButton = _interopRequireDefault(__webpack_require__(1131));
//# sourceMappingURL=index.js.map

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_list_box__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_list_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__paprika_list_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__organizationShape__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrganizationItem__ = __webpack_require__(1241);








function OrgSwitcher(_ref) {
  var className = _ref.className,
      organizations = _ref.organizations,
      otherText = _ref.otherText,
      renderTrigger = _ref.renderTrigger,
      selectedOrg = _ref.selectedOrg;
  var i18n = __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default()();
  var activeOrganization = organizations.find(function (organization) {
    return organization.id === selectedOrg.id;
  });
  var otherL10nText = i18n.t('global_navigation.other');
  var triggerA11yText = i18n.t('global_navigation.app_switcher_a11y', {
    orgName: activeOrganization.name
  });
  var sortedOrganizations = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useMemo(function () {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(organizations).sort(function (a, b) {
      return a.customerName && b.customerName && a.customerName.localeCompare(b.customerName) || a.name.localeCompare(b.name);
    });
  }, [organizations]);
  var formattedOrganizationData = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useMemo(function () {
    var orgs = [];
    var others = {
      heading: otherText || otherL10nText,
      options: []
    };
    sortedOrganizations.forEach(function (organization) {
      var existingCustomerPointer;

      if (organization.customerName) {
        existingCustomerPointer = orgs.find(function (org) {
          return org.heading === organization.customerName;
        });

        if (!existingCustomerPointer) {
          orgs.push({
            heading: organization.customerName,
            options: []
          });
          existingCustomerPointer = orgs[orgs.length - 1];
        }
      } else {
        existingCustomerPointer = others;
      }

      existingCustomerPointer.options.push({
        id: organization.id,
        isSelected: organization.id === selectedOrg.id,
        orgUrl: organization.launchpad,
        orgName: organization.name
      });
    });
    return others.options.length ? orgs.concat(others) : orgs;
  }, [sortedOrganizations, selectedOrg.id]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: className
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_list_box___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_list_box___default.a.Trigger, null, function (selected, options, _ref2) {
    var dispatch = _ref2.dispatch,
        types = _ref2.types,
        refTrigger = _ref2.refTrigger,
        isOpen = _ref2.isOpen;
    return renderTrigger(triggerA11yText, function () {
      return dispatch({
        type: types.togglePopover
      });
    }, isOpen, refTrigger);
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_list_box___default.a.Box, {
    className: "sriracha"
  }), formattedOrganizationData.map(function (org) {
    var html = [];
    html.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_list_box___default.a.Divider, null, org.heading));
    org.options.forEach(function (option) {
      html.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_list_box___default.a.Option, {
        key: option.id,
        isSelected: option.isSelected,
        onClick: function onClick() {
          window.location = option.orgUrl;
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__OrganizationItem__["a" /* default */], {
        href: option.orgUrl,
        title: option.orgName
      })));
    });
    return html;
  })));
}

OrgSwitcher.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  organizations: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_5__organizationShape__["a" /* default */])).isRequired,
  otherText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  renderTrigger: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  selectedOrg: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  }).isRequired
};
OrgSwitcher.defaultProps = {
  className: null,
  otherText: null,
  renderTrigger: null
};
/* harmony default export */ __webpack_exports__["a"] = (OrgSwitcher);

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = useI18n;
exports.getI18nObject = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _react = _interopRequireDefault(__webpack_require__(2));

var _L10nContext = _interopRequireDefault(__webpack_require__(1147));

var _i18n2 = __webpack_require__(1148);

var _locales = _interopRequireDefault(__webpack_require__(730));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function mergeTranslation(customLocales, paprikaLocales) {
  var result = {};
  (0, _keys["default"])(paprikaLocales).forEach(function (lang) {
    result[lang] = {
      translation: _objectSpread(_objectSpread({}, paprikaLocales[lang] ? paprikaLocales[lang].translation : {}), customLocales[lang] ? customLocales[lang].translation : {})
    };
  });
  return result;
}

var getI18nObject = function getI18nObject() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
  var locales = arguments.length > 1 ? arguments[1] : undefined;

  var _i18n = (0, _i18n2.i18n)(locales ? mergeTranslation(locales, _locales["default"]) : _locales["default"]);

  return {
    locale: locale,
    t: _i18n.getFixedT(locale)
  };
};

exports.getI18nObject = getI18nObject;

function useI18n() {
  var _i18n = _react["default"].useContext(_L10nContext["default"]);

  return _i18n || getI18nObject();
}
//# sourceMappingURL=useI18n.js.map

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _en = _interopRequireDefault(__webpack_require__(1149));

var _de = _interopRequireDefault(__webpack_require__(1150));

var _fr = _interopRequireDefault(__webpack_require__(1151));

var _es = _interopRequireDefault(__webpack_require__(1152));

var _pt = _interopRequireDefault(__webpack_require__(1153));

var _ja = _interopRequireDefault(__webpack_require__(1154));

var _zh = _interopRequireDefault(__webpack_require__(1155));

var locales = {
  en: _en["default"].en,
  de: _de["default"].de,
  fr: _fr["default"].fr,
  es: _es["default"].es,
  pt: _pt["default"].pt,
  ja: _ja["default"].ja,
  zh: _zh["default"].zh
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = Provider;
exports.StoreContext = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _v = _interopRequireDefault(__webpack_require__(124));

var _reducer = _interopRequireDefault(__webpack_require__(1159));

var _optionState = __webpack_require__(732);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var StoreContext = _react["default"].createContext();

exports.StoreContext = StoreContext;

function initializeState(props) {
  var childrenOptions = props.childrenOptions,
      height = props.height,
      isDisabled = props.isDisabled,
      isInline = props.isInline,
      isMulti = props.isMulti,
      isOpen = props.isOpen,
      placeholder = props.placeholder,
      refFilterInput = props.refFilterInput,
      refFooterContainer = props.refFooterContainer,
      refListBox = props.refListBox,
      refListBoxContainer = props.refListBoxContainer,
      refTrigger = props.refTrigger,
      refTriggerContainer = props.refTriggerContainer,
      refLabel = props.refLabel,
      size = props.size;
  var formElementId = props.id;
  var formElementLabelDescribedBy = props["aria-describedby"]; // initialize state for options and groups

  var options = (0, _optionState.getDataOptions)(childrenOptions); // const Footer = getFooter(childrenOptions);

  var selectedOptions = (0, _keys["default"])(options).filter(function (key) {
    return options[key].isSelected;
  }).map(function (key) {
    return (0, _parseInt["default"])(key, 10);
  });
  var activeOption = null;

  if (selectedOptions.length && !props.isMulti) {
    activeOption = selectedOptions[0];
  }

  var initialState = {
    activeOption: activeOption,
    filteredOptions: [],
    formElementId: formElementId,
    formElementLabelDescribedBy: formElementLabelDescribedBy,
    hasFilter: false,
    hasFooter: false,
    hasPopupOpened: false,
    height: height,
    idListBox: "listBoxId_".concat((0, _v["default"])()),
    isDisabled: isDisabled,
    isInline: isInline,
    isMulti: isMulti,
    isOpen: isOpen,
    lastKnownSelectedOptions: selectedOptions.slice(0),
    listBoxHasFocus: true,
    noResultsFound: false,
    onChangeFn: null,
    options: options,
    placeholder: placeholder,
    refFilterInput: refFilterInput,
    refFooterContainer: refFooterContainer,
    refLabel: refLabel,
    refListBox: refListBox,
    refListBoxContainer: refListBoxContainer,
    refTrigger: refTrigger,
    refTriggerContainer: refTriggerContainer,
    selectedOptions: selectedOptions,
    size: size,
    triggerWidth: 0
  };
  return _objectSpread(_objectSpread({}, initialState), {}, {
    originalState: _objectSpread({}, initialState)
  });
}

var propTypes = {
  children: _propTypes["default"].node.isRequired
};

function Provider(props) {
  var refFilterInput = _react["default"].useRef(null);

  var refFooterContainer = _react["default"].useRef(null);

  var refListBox = _react["default"].useRef(null);

  var refListBoxContainer = _react["default"].useRef(null);

  var refTrigger = _react["default"].useRef(null);

  var refTriggerContainer = _react["default"].useRef(null);

  var _React$useReducer = _react["default"].useReducer(_reducer["default"], _objectSpread(_objectSpread({}, props), {}, {
    refFilterInput: refFilterInput,
    refFooterContainer: refFooterContainer,
    refListBox: refListBox,
    refListBoxContainer: refListBoxContainer,
    refTrigger: refTrigger,
    refTriggerContainer: refTriggerContainer
  }), initializeState),
      _React$useReducer2 = (0, _slicedToArray2["default"])(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var value = {
    state: state,
    dispatch: dispatch
  };
  return /*#__PURE__*/_react["default"].createElement(StoreContext.Provider, {
    value: value
  }, props.children);
}

Provider.propTypes = propTypes;
//# sourceMappingURL=Provider.js.map

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getDataOptions = getDataOptions;

var _react = _interopRequireDefault(__webpack_require__(2));

var _v = _interopRequireDefault(__webpack_require__(124));

var _options = __webpack_require__(410);

function createOption(_ref) {
  var index = _ref.index,
      child = _ref.child,
      _ref$groupLabel = _ref.groupLabel,
      groupLabel = _ref$groupLabel === void 0 ? null : _ref$groupLabel,
      _ref$groupId = _ref.groupId,
      groupId = _ref$groupId === void 0 ? null : _ref$groupId;
  var _child$props = child.props,
      isDisabled = _child$props.isDisabled,
      isHidden = _child$props.isHidden,
      label = _child$props.label,
      onClick = _child$props.onClick,
      preventDefaultOnSelect = _child$props.preventDefaultOnSelect,
      value = _child$props.value;
  var isSelected = child.props.isSelected || child.props.defaultIsSelected || false;
  return {
    content: child,
    groupId: groupId,
    groupLabel: groupLabel,
    hasLabel: label,
    id: "opt_".concat((0, _v["default"])()),
    index: index,
    isDisabled: isDisabled,
    isHidden: isHidden,
    isSelected: isSelected,
    label: label || child.props.children,
    // we will try to extract the label from the children if doesn't have label
    onClick: onClick,
    preventDefaultOnSelect: preventDefaultOnSelect,
    value: value || undefined
  };
}

function getDataOptions(children) {
  if (!children) throw new Error("ListBox.Options is a required prop, please check you are passing correctly the data");
  if (!children.length) return [];
  var options = {};
  var index = 0;

  _react["default"].Children.toArray(children).forEach(function (child) {
    if (child.type && (0, _options.isWhiteListed)(child.type.displayName)) {
      options[index] = createOption({
        index: index,
        child: child,
        groupId: child.props.groupId
      });
      index += 1;
    }

    return child;
  });

  return options;
}
//# sourceMappingURL=optionState.js.map

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover["default"];
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(1163));
//# sourceMappingURL=index.js.map

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.handleKeyUpKeyboardKeys = exports.handleKeyDownKeyboardKeys = void 0;

var _options = __webpack_require__(410);

var _useListBox = _interopRequireDefault(__webpack_require__(140));

var handleKeyDownKeyboardKeys = function handleKeyDownKeyboardKeys(_ref) {
  var state = _ref.state,
      dispatch = _ref.dispatch,
      onChangeContext = _ref.onChangeContext;
  return function (event) {
    if (state.isDisabled) {
      return;
    }

    switch (event.key) {
      case "ArrowUp":
        (0, _options.handleArrowKeys)({
          event: event,
          state: state,
          dispatch: dispatch,
          onChangeContext: onChangeContext,
          isArrowDown: false
        });
        break;

      case "ArrowDown":
        (0, _options.handleArrowKeys)({
          event: event,
          state: state,
          dispatch: dispatch,
          onChangeContext: onChangeContext,
          isArrowDown: true
        });
        break;

      default:
        break;
    }
  };
};

exports.handleKeyDownKeyboardKeys = handleKeyDownKeyboardKeys;

var handleKeyUpKeyboardKeys = function handleKeyUpKeyboardKeys(_ref2) {
  var state = _ref2.state,
      dispatch = _ref2.dispatch,
      onChangeContext = _ref2.onChangeContext;
  return function (event) {
    if (state.isDisabled) {
      return;
    }

    switch (event.key) {
      case "Escape":
        if (!state.isOpen) break;

        if (state.hasFooter) {
          dispatch({
            type: _useListBox["default"].types.cancel
          });
        } else {
          dispatch({
            type: _useListBox["default"].types.closePopover
          });
        }

        break;

      case "Enter":
      case " ":
        (0, _options.handleEnterOrSpace)({
          event: event,
          state: state,
          dispatch: dispatch,
          onChangeContext: onChangeContext
        });
        break;

      default:
        break;
    }
  };
};

exports.handleKeyUpKeyboardKeys = handleKeyUpKeyboardKeys;
//# sourceMappingURL=handleKeyboardKeys.js.map

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover["default"];
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(1188));
//# sourceMappingURL=index.js.map

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Trigger["default"];
  }
});

var _Trigger = _interopRequireDefault(__webpack_require__(1190));
//# sourceMappingURL=index.js.map

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ButtonIcon = exports.Button = exports.fullWidthStyles = exports.kindStyles = exports.sizeStyles = exports.commonStyles = exports.inactiveStyles = exports.activeStyles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var types = _interopRequireWildcard(__webpack_require__(566));

var _borderColors, _borderHoverColors, _sizeStyles, _iconColors;

var dropShadow = "0 1px 2px 0 rgba(0, 0, 0, 0.1)";

var enabled = function enabled(content) {
  return (0, _styledComponents.css)(["&:not([disabled]):not([aria-disabled=\"true\"]){", ";}"], content);
}; // Borders


var borderColors = (_borderColors = {}, (0, _defineProperty2["default"])(_borderColors, types.DEFAULT, _tokens["default"].border.color), (0, _defineProperty2["default"])(_borderColors, types.PRIMARY, _tokens["default"].color.green), (0, _defineProperty2["default"])(_borderColors, types.SECONDARY, _tokens["default"].color.purple), (0, _defineProperty2["default"])(_borderColors, types.DESTRUCTIVE, _tokens["default"].color.orange), (0, _defineProperty2["default"])(_borderColors, types.FLAT, _tokens["default"].border.color), (0, _defineProperty2["default"])(_borderColors, types.MINOR, "transparent"), (0, _defineProperty2["default"])(_borderColors, types.LINK, "transparent"), _borderColors);
var borderHoverColors = (_borderHoverColors = {}, (0, _defineProperty2["default"])(_borderHoverColors, types.DEFAULT, _tokens["default"].border.hoverColor), (0, _defineProperty2["default"])(_borderHoverColors, types.PRIMARY, _tokens["default"].color.greenDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.SECONDARY, _tokens["default"].color.purpleDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.DESTRUCTIVE, _tokens["default"].color.orangeDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.FLAT, _tokens["default"].border.hoverColor), (0, _defineProperty2["default"])(_borderHoverColors, types.MINOR, "transparent"), (0, _defineProperty2["default"])(_borderHoverColors, types.LINK, "transparent"), _borderHoverColors);

var borderStyles = function borderStyles(_ref) {
  var kind = _ref.kind;
  return (0, _styledComponents.css)(["border-color:", ";&:hover{", "}"], borderColors[kind], enabled((0, _styledComponents.css)(["border-color:", ";"], borderHoverColors[kind])));
}; // States


var disabledStyles = (0, _styledComponents.css)(["box-shadow:none;color:", ";cursor:not-allowed;text-decoration:none;text-shadow:none;&:focus{box-shadow:none;text-shadow:none;transform:none;}&,&:hover,&:focus{background:", ";border-color:", ";color:", ";text-decoration:none;}&,&:hover,&:active{box-shadow:none;transform:none;}"], _tokens["default"].color.blackDisabled, _tokens["default"].color.blackLighten70, _tokens["default"].color.blackLighten60, _tokens["default"].color.blackLighten40);
var disabledTextStyles = (0, _styledComponents.css)(["", " &,&:hover{background:none;border-color:transparent;}"], disabledStyles);
var activeStyles = (0, _styledComponents.css)(["", ""], _stylers["default"].focusRing.bordered());
exports.activeStyles = activeStyles;

var inactiveStyles = function inactiveStyles(_ref2) {
  var kind = _ref2.kind;
  return (0, _styledComponents.css)(["", " [data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{", "}"], borderStyles, enabled((0, _styledComponents.css)(["", " ", ""], borderStyles, [types.FLAT, types.MINOR, types.LINK].includes(kind) ? (0, _styledComponents.css)(["box-shadow:none;"]) : (0, _styledComponents.css)(["box-shadow:", ";"], dropShadow))));
}; // Common


exports.inactiveStyles = inactiveStyles;
var commonStyles = (0, _styledComponents.css)(["", " ", " appearance:none;border-radius:", ";border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;font-weight:bold;text-align:center;text-decoration:none;vertical-align:middle;&:focus{", "}&:active{box-shadow:", ",inset 0 1px 1px 0 rgba(0,0,0,0.1),inset 0 1px 4px 0 rgba(0,0,0,0.3);transform:scale(0.98);}"], _stylers["default"].alignMiddle, _stylers["default"].lineHeight(-1), _tokens["default"].button.borderRadius, _stylers["default"].focusRing.bordered(), _tokens["default"].highlight.active.noBorder.boxShadow);
exports.commonStyles = commonStyles;
var skeuomorphicStyles = (0, _styledComponents.css)(["box-shadow:", ";cursor:pointer;transition-duration:0.2s;transition-property:border;"], dropShadow);
var coloredButtonStyles = (0, _styledComponents.css)(["color:", ";text-shadow:0 1px 1px ", ";&:hover,&:visited{color:", ";text-decoration:none;}"], _tokens["default"].color.white, _stylers["default"].alpha(_tokens["default"].color.blackPure, 0.2), _tokens["default"].color.white);
var textButtonStyles = (0, _styledComponents.css)(["background:none;border-color:transparent;"]); // Sizes

var sizeStyles = (_sizeStyles = {}, (0, _defineProperty2["default"])(_sizeStyles, types.SMALL, (0, _styledComponents.css)(["", ";min-height:", ";padding:3px ", ";"], _stylers["default"].fontSize(-2), _stylers["default"].spacer(3), _tokens["default"].space)), (0, _defineProperty2["default"])(_sizeStyles, types.MEDIUM, (0, _styledComponents.css)(["", ";min-height:", ";padding:6.5px ", ";"], _stylers["default"].fontSize(-1), _stylers["default"].spacer(4), _tokens["default"].spaceLg)), (0, _defineProperty2["default"])(_sizeStyles, types.LARGE, (0, _styledComponents.css)(["", ";min-height:", ";padding:9px ", ";"], _stylers["default"].fontSize(), _stylers["default"].spacer(5), _stylers["default"].spacer(2))), _sizeStyles); // types

exports.sizeStyles = sizeStyles;

var kindStyles = function kindStyles(_ref3) {
  var _ref4;

  var isDisabled = _ref3.isDisabled;
  return _ref4 = {}, (0, _defineProperty2["default"])(_ref4, types.DEFAULT, (0, _styledComponents.css)(["", " &,&:hover,&:active,&:visited{background-color:", ";background-image:linear-gradient(", ",", ");color:", ";text-decoration:none;}&:hover,&:active{background:", ";}", ""], skeuomorphicStyles, _tokens["default"].color.white, _tokens["default"].color.blackLighten90, _tokens["default"].color.blackLighten70, _tokens["default"].color.black, _tokens["default"].color.blackLighten70, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.PRIMARY, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.greenLighten10, _tokens["default"].color.greenLighten10, _tokens["default"].color.green, _tokens["default"].color.green, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.SECONDARY, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.purpleLighten10, _tokens["default"].color.purpleLighten10, _tokens["default"].color.purple, _tokens["default"].color.purple, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.DESTRUCTIVE, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.orangeHighlight, _tokens["default"].color.orangeHighlight, _tokens["default"].color.orange, _tokens["default"].color.orange, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.FLAT, (0, _styledComponents.css)(["", " background-color:", ";color:", ";&:hover,&:visited{background:", ";color:", ";text-decoration:none;}", ""], skeuomorphicStyles, _tokens["default"].color.white, _tokens["default"].color.black, _tokens["default"].color.blackLighten70, _tokens["default"].color.black, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.MINOR, (0, _styledComponents.css)(["", " &:hover{text-decoration:underline;}", ""], textButtonStyles, isDisabled && disabledTextStyles)), (0, _defineProperty2["default"])(_ref4, types.LINK, (0, _styledComponents.css)(["", " color:", ";font-weight:inherit;text-decoration:underline;&:hover{color:", ";}&:active{color:", ";}", ""], textButtonStyles, _tokens["default"].textColor.link, _tokens["default"].textColor.linkHover, _tokens["default"].color.blue, isDisabled && disabledTextStyles)), _ref4;
}; // Modifiers


exports.kindStyles = kindStyles;
var fullWidthStyles = (0, _styledComponents.css)(["display:flex;width:100%;"]); //
// Composition
//

exports.fullWidthStyles = fullWidthStyles;

var Button = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyles__Button",
  componentId: "ru6wp6-0"
})(function (_ref5) {
  var size = _ref5.size,
      kind = _ref5.kind,
      isFullWidth = _ref5.isFullWidth,
      isActive = _ref5.isActive,
      props = (0, _objectWithoutProperties2["default"])(_ref5, ["size", "kind", "isFullWidth", "isActive"]);
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], commonStyles, sizeStyles[size], kindStyles(props)[kind], isFullWidth && fullWidthStyles, isActive ? activeStyles : inactiveStyles);
}); //
// Icons
//


exports.Button = Button;
var spinKeyframes = (0, _styledComponents.keyframes)(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var iconColors = (_iconColors = {}, (0, _defineProperty2["default"])(_iconColors, types.DEFAULT, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.PRIMARY, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.SECONDARY, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.DESTRUCTIVE, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.FLAT, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.MINOR, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.LINK, _tokens["default"].textColor.icon), _iconColors);

var getIconColor = function getIconColor(_ref6) {
  var isDisabled = _ref6.isDisabled,
      kind = _ref6.kind;
  return isDisabled ? _tokens["default"].color.blackDisabled : iconColors[kind];
};

var ButtonIcon = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyles__ButtonIcon",
  componentId: "ru6wp6-1"
})(function (_ref7) {
  var isPending = _ref7.isPending,
      isSuffixIcon = _ref7.isSuffixIcon,
      props = (0, _objectWithoutProperties2["default"])(_ref7, ["isPending", "isSuffixIcon"]);
  return (0, _styledComponents.css)(["align-items:center;color:", ";display:inline-flex;justify-content:center;margin:0 ", " 0 0;svg{vertical-align:-", "em;}", " ", ""], getIconColor(props), _tokens["default"].spaceSm, (_stylers["default"].lineHeightValue(-1) - 1) / 2, isPending && (0, _styledComponents.css)(["animation:", " 2s infinite linear;"], spinKeyframes), isSuffixIcon && (0, _styledComponents.css)(["margin:0 0 0 ", ";"], _tokens["default"].spaceSm));
});

exports.ButtonIcon = ButtonIcon;
//# sourceMappingURL=Button.styles.js.map

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon["default"];
  }
});

var _Icon = _interopRequireDefault(__webpack_require__(1194));
//# sourceMappingURL=index.js.map

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Label = exports.labelStyles = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var placeholderStyles = (0, _styledComponents.css)(["", ";"], _stylers["default"].placeholder);
var labelStyles = "\n  display: inline-block;\n  overflow: hidden;\n  padding-right: 48px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n";
exports.labelStyles = labelStyles;

var Label = _styledComponents["default"].span.withConfig({
  displayName: "Labelstyles__Label",
  componentId: "sc-15se3rc-0"
})(function (_ref) {
  var isPlaceholder = _ref.isPlaceholder,
      hasImplicitAll = _ref.hasImplicitAll;
  return (0, _styledComponents.css)(["", ""], isPlaceholder && !hasImplicitAll ? placeholderStyles : "");
});

exports.Label = Label;
//# sourceMappingURL=Label.styles.js.map

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PRIMARY = exports.MINOR = exports.LARGE = exports.MEDIUM = exports.SMALL = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var SMALL = constants.size.SMALL;
exports.SMALL = SMALL;
var MEDIUM = constants.size.MEDIUM;
exports.MEDIUM = MEDIUM;
var LARGE = constants.size.LARGE;
exports.LARGE = LARGE;
var MINOR = constants.kind.MINOR;
exports.MINOR = MINOR;
var PRIMARY = constants.kind.PRIMARY;
exports.PRIMARY = PRIMARY;
//# sourceMappingURL=types.js.map

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ButtonIcon = exports.Button = exports.fullWidthStyles = exports.kindStyles = exports.sizeStyles = exports.commonStyles = exports.inactiveStyles = exports.activeStyles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var types = _interopRequireWildcard(__webpack_require__(568));

var _borderColors, _borderHoverColors, _sizeStyles, _iconColors;

var dropShadow = "0 1px 2px 0 rgba(0, 0, 0, 0.1)";

var enabled = function enabled(content) {
  return (0, _styledComponents.css)(["&:not([disabled]):not([aria-disabled=\"true\"]){", ";}"], content);
}; // Borders


var borderColors = (_borderColors = {}, (0, _defineProperty2["default"])(_borderColors, types.DEFAULT, _tokens["default"].border.color), (0, _defineProperty2["default"])(_borderColors, types.PRIMARY, _tokens["default"].color.green), (0, _defineProperty2["default"])(_borderColors, types.SECONDARY, _tokens["default"].color.purple), (0, _defineProperty2["default"])(_borderColors, types.DESTRUCTIVE, _tokens["default"].color.orange), (0, _defineProperty2["default"])(_borderColors, types.FLAT, _tokens["default"].border.color), (0, _defineProperty2["default"])(_borderColors, types.MINOR, "transparent"), (0, _defineProperty2["default"])(_borderColors, types.LINK, "transparent"), _borderColors);
var borderHoverColors = (_borderHoverColors = {}, (0, _defineProperty2["default"])(_borderHoverColors, types.DEFAULT, _tokens["default"].border.hoverColor), (0, _defineProperty2["default"])(_borderHoverColors, types.PRIMARY, _tokens["default"].color.greenDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.SECONDARY, _tokens["default"].color.purpleDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.DESTRUCTIVE, _tokens["default"].color.orangeDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.FLAT, _tokens["default"].border.hoverColor), (0, _defineProperty2["default"])(_borderHoverColors, types.MINOR, "transparent"), (0, _defineProperty2["default"])(_borderHoverColors, types.LINK, "transparent"), _borderHoverColors);

var borderStyles = function borderStyles(_ref) {
  var kind = _ref.kind;
  return (0, _styledComponents.css)(["border-color:", ";&:hover{", "}"], borderColors[kind], enabled((0, _styledComponents.css)(["border-color:", ";"], borderHoverColors[kind])));
}; // States


var disabledStyles = (0, _styledComponents.css)(["box-shadow:none;color:", ";cursor:not-allowed;text-decoration:none;text-shadow:none;&:focus{box-shadow:none;text-shadow:none;transform:none;}&,&:hover,&:focus{background:", ";border-color:", ";color:", ";text-decoration:none;}&,&:hover,&:active{box-shadow:none;transform:none;}"], _tokens["default"].color.blackDisabled, _tokens["default"].color.blackLighten70, _tokens["default"].color.blackLighten60, _tokens["default"].color.blackLighten40);
var disabledTextStyles = (0, _styledComponents.css)(["", " &,&:hover{background:none;border-color:transparent;}"], disabledStyles);
var activeStyles = (0, _styledComponents.css)(["", ""], _stylers["default"].focusRing.bordered());
exports.activeStyles = activeStyles;

var inactiveStyles = function inactiveStyles(_ref2) {
  var kind = _ref2.kind;
  return (0, _styledComponents.css)(["", " [data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{", "}"], borderStyles, enabled((0, _styledComponents.css)(["", " ", ""], borderStyles, [types.FLAT, types.MINOR, types.LINK].includes(kind) ? (0, _styledComponents.css)(["box-shadow:none;"]) : (0, _styledComponents.css)(["box-shadow:", ";"], dropShadow))));
}; // Common


exports.inactiveStyles = inactiveStyles;
var commonStyles = (0, _styledComponents.css)(["", " ", " appearance:none;border-radius:", ";border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;font-weight:bold;text-align:center;text-decoration:none;vertical-align:middle;&:focus{", "}&:active{box-shadow:", ",inset 0 1px 1px 0 rgba(0,0,0,0.1),inset 0 1px 4px 0 rgba(0,0,0,0.3);transform:scale(0.98);}"], _stylers["default"].alignMiddle, _stylers["default"].lineHeight(-1), _tokens["default"].button.borderRadius, _stylers["default"].focusRing.bordered(), _tokens["default"].highlight.active.noBorder.boxShadow);
exports.commonStyles = commonStyles;
var skeuomorphicStyles = (0, _styledComponents.css)(["box-shadow:", ";cursor:pointer;transition-duration:0.2s;transition-property:border;"], dropShadow);
var coloredButtonStyles = (0, _styledComponents.css)(["color:", ";text-shadow:0 1px 1px ", ";&:hover,&:visited{color:", ";text-decoration:none;}"], _tokens["default"].color.white, _stylers["default"].alpha(_tokens["default"].color.blackPure, 0.2), _tokens["default"].color.white);
var textButtonStyles = (0, _styledComponents.css)(["background:none;border-color:transparent;"]); // Sizes

var sizeStyles = (_sizeStyles = {}, (0, _defineProperty2["default"])(_sizeStyles, types.SMALL, (0, _styledComponents.css)(["", ";min-height:", ";padding:3px ", ";"], _stylers["default"].fontSize(-2), _stylers["default"].spacer(3), _tokens["default"].space)), (0, _defineProperty2["default"])(_sizeStyles, types.MEDIUM, (0, _styledComponents.css)(["", ";min-height:", ";padding:6.5px ", ";"], _stylers["default"].fontSize(-1), _stylers["default"].spacer(4), _tokens["default"].spaceLg)), (0, _defineProperty2["default"])(_sizeStyles, types.LARGE, (0, _styledComponents.css)(["", ";min-height:", ";padding:9px ", ";"], _stylers["default"].fontSize(), _stylers["default"].spacer(5), _stylers["default"].spacer(2))), _sizeStyles); // types

exports.sizeStyles = sizeStyles;

var kindStyles = function kindStyles(_ref3) {
  var _ref4;

  var isDisabled = _ref3.isDisabled;
  return _ref4 = {}, (0, _defineProperty2["default"])(_ref4, types.DEFAULT, (0, _styledComponents.css)(["", " &,&:hover,&:active,&:visited{background-color:", ";background-image:linear-gradient(", ",", ");color:", ";text-decoration:none;}&:hover,&:active{background:", ";}", ""], skeuomorphicStyles, _tokens["default"].color.white, _tokens["default"].color.blackLighten90, _tokens["default"].color.blackLighten70, _tokens["default"].color.black, _tokens["default"].color.blackLighten70, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.PRIMARY, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.greenLighten10, _tokens["default"].color.greenLighten10, _tokens["default"].color.green, _tokens["default"].color.green, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.SECONDARY, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.purpleLighten10, _tokens["default"].color.purpleLighten10, _tokens["default"].color.purple, _tokens["default"].color.purple, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.DESTRUCTIVE, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.orangeHighlight, _tokens["default"].color.orangeHighlight, _tokens["default"].color.orange, _tokens["default"].color.orange, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.FLAT, (0, _styledComponents.css)(["", " background-color:", ";color:", ";&:hover,&:visited{background:", ";color:", ";text-decoration:none;}", ""], skeuomorphicStyles, _tokens["default"].color.white, _tokens["default"].color.black, _tokens["default"].color.blackLighten70, _tokens["default"].color.black, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.MINOR, (0, _styledComponents.css)(["", " &:hover{text-decoration:underline;}", ""], textButtonStyles, isDisabled && disabledTextStyles)), (0, _defineProperty2["default"])(_ref4, types.LINK, (0, _styledComponents.css)(["", " color:", ";font-weight:inherit;text-decoration:underline;&:hover{color:", ";}&:active{color:", ";}", ""], textButtonStyles, _tokens["default"].textColor.link, _tokens["default"].textColor.linkHover, _tokens["default"].color.blue, isDisabled && disabledTextStyles)), _ref4;
}; // Modifiers


exports.kindStyles = kindStyles;
var fullWidthStyles = (0, _styledComponents.css)(["display:flex;width:100%;"]); //
// Composition
//

exports.fullWidthStyles = fullWidthStyles;

var Button = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyles__Button",
  componentId: "ru6wp6-0"
})(function (_ref5) {
  var size = _ref5.size,
      kind = _ref5.kind,
      isFullWidth = _ref5.isFullWidth,
      isActive = _ref5.isActive,
      props = (0, _objectWithoutProperties2["default"])(_ref5, ["size", "kind", "isFullWidth", "isActive"]);
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], commonStyles, sizeStyles[size], kindStyles(props)[kind], isFullWidth && fullWidthStyles, isActive ? activeStyles : inactiveStyles);
}); //
// Icons
//


exports.Button = Button;
var spinKeyframes = (0, _styledComponents.keyframes)(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var iconColors = (_iconColors = {}, (0, _defineProperty2["default"])(_iconColors, types.DEFAULT, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.PRIMARY, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.SECONDARY, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.DESTRUCTIVE, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.FLAT, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.MINOR, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.LINK, _tokens["default"].textColor.icon), _iconColors);

var getIconColor = function getIconColor(_ref6) {
  var isDisabled = _ref6.isDisabled,
      kind = _ref6.kind;
  return isDisabled ? _tokens["default"].color.blackDisabled : iconColors[kind];
};

var ButtonIcon = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyles__ButtonIcon",
  componentId: "ru6wp6-1"
})(function (_ref7) {
  var isPending = _ref7.isPending,
      isSuffixIcon = _ref7.isSuffixIcon,
      props = (0, _objectWithoutProperties2["default"])(_ref7, ["isPending", "isSuffixIcon"]);
  return (0, _styledComponents.css)(["align-items:center;color:", ";display:inline-flex;justify-content:center;margin:0 ", " 0 0;svg{vertical-align:-", "em;}", " ", ""], getIconColor(props), _tokens["default"].spaceSm, (_stylers["default"].lineHeightValue(-1) - 1) / 2, isPending && (0, _styledComponents.css)(["animation:", " 2s infinite linear;"], spinKeyframes), isSuffixIcon && (0, _styledComponents.css)(["margin:0 0 0 ", ";"], _tokens["default"].spaceSm));
});

exports.ButtonIcon = ButtonIcon;
//# sourceMappingURL=Button.styles.js.map

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon["default"];
  }
});

var _Icon = _interopRequireDefault(__webpack_require__(1227));
//# sourceMappingURL=index.js.map

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.MINOR = exports.inputValidTypes = exports.LARGE = exports.MEDIUM = exports.SMALL = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var SMALL = constants.size.SMALL;
exports.SMALL = SMALL;
var MEDIUM = constants.size.MEDIUM;
exports.MEDIUM = MEDIUM;
var LARGE = constants.size.LARGE;
exports.LARGE = LARGE;
var inputValidTypes = {
  EMAIL: "email",
  NUMBER: "number",
  PASSWORD: "password",
  SEARCH: "search",
  TELEPHONE: "tel",
  TEXT: "text",
  URL: "url"
};
exports.inputValidTypes = inputValidTypes;
var MINOR = constants.kind.MINOR;
exports.MINOR = MINOR;
//# sourceMappingURL=types.js.map

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Option["default"];
  }
});

var _Option = _interopRequireDefault(__webpack_require__(1236));
//# sourceMappingURL=index.js.map

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appShape__ = __webpack_require__(746);



var propTypes = {
  app: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_2__appShape__["a" /* default */]).isRequired,
  shouldOpenNewTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AppRow(props) {
  var app = props.app,
      shouldOpenNewTab = props.shouldOpenNewTab;
  var Icon = app.icon;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: "app-switcher-section__app",
    key: app.title,
    href: app.link,
    "data-testid": "appRow",
    target: shouldOpenNewTab ? '_blank' : '_self',
    rel: shouldOpenNewTab ? 'noopener noreferrer' : undefined
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, {
    color: app.iconColor,
    size: "20px"
  }), app.title);
}

AppRow.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (AppRow);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var appShape = {
  icon: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  iconColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (appShape);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paprika_tokens__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__paprika_tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_ProjectsLogo__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_ProjectsLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_ProjectsLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_Notebook__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_Notebook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_Notebook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_Target__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_Target___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_Target__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_ClockPlus__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_ClockPlus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_ClockPlus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_MissionControl__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_MissionControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_MissionControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_ReportsLogo__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_ReportsLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_ReportsLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_ClipboardCheck__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_ClipboardCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_ClipboardCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_ResultsLogo__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_ResultsLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_ResultsLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_ChartArrow__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_ChartArrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_ChartArrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__acl_services_wasabicons_lib_Robot__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__acl_services_wasabicons_lib_Robot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__acl_services_wasabicons_lib_Robot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__acl_services_wasabicons_lib_AnalyticsLogoCircle__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__acl_services_wasabicons_lib_AnalyticsLogoCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__acl_services_wasabicons_lib_AnalyticsLogoCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__acl_services_wasabicons_lib_StrategyLogo__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__acl_services_wasabicons_lib_StrategyLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__acl_services_wasabicons_lib_StrategyLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__acl_services_wasabicons_lib_Flowchart__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__acl_services_wasabicons_lib_Flowchart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__acl_services_wasabicons_lib_Flowchart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__acl_services_wasabicons_lib_Clipboard__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__acl_services_wasabicons_lib_Clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__acl_services_wasabicons_lib_Clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__acl_services_wasabicons_lib_FileAdd__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__acl_services_wasabicons_lib_FileAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__acl_services_wasabicons_lib_FileAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__acl_services_wasabicons_lib_TimeAndDate__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__acl_services_wasabicons_lib_TimeAndDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__acl_services_wasabicons_lib_TimeAndDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__acl_services_wasabicons_lib_Placeholder__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__acl_services_wasabicons_lib_Placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__acl_services_wasabicons_lib_Placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__acl_services_wasabicons_lib_AssetTypes__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__acl_services_wasabicons_lib_AssetTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__acl_services_wasabicons_lib_AssetTypes__);



















var customEggplantColor = '#F6F0FA';
var appData = [{
  key: 'workspace',
  apps: [{
    backgroundColor: customEggplantColor,
    icon: __WEBPACK_IMPORTED_MODULE_18__acl_services_wasabicons_lib_AssetTypes___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.eggplantLighten30,
    key: 'asset_inventory'
  }, {
    backgroundColor: customEggplantColor,
    icon: __WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_ProjectsLogo___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.eggplantLighten30,
    key: 'projects'
  }, {
    backgroundColor: customEggplantColor,
    icon: __WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_Notebook___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.eggplantLighten30,
    key: 'issue_tracker'
  }, {
    backgroundColor: customEggplantColor,
    icon: __WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_Target___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.eggplantLighten30,
    key: 'task_tracker'
  }, {
    backgroundColor: customEggplantColor,
    icon: __WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_ClockPlus___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.eggplantLighten30,
    key: 'project_timesheets'
  }, {
    backgroundColor: customEggplantColor,
    icon: __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_MissionControl___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.eggplantLighten30,
    key: 'mission_control'
  }, {
    backgroundColor: customEggplantColor,
    icon: __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_ReportsLogo___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.eggplantLighten30,
    key: 'reports'
  }, {
    backgroundColor: customEggplantColor,
    icon: __WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_ClipboardCheck___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.eggplantLighten30,
    key: 'policy_training'
  }]
}, {
  key: 'automation',
  apps: [{
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blueLighten50,
    icon: __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_ResultsLogo___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blueDarken10,
    key: 'results'
  }, {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blueLighten50,
    icon: __WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_ChartArrow___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blueDarken10,
    key: 'storyboards'
  }, {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blueLighten50,
    icon: __WEBPACK_IMPORTED_MODULE_10__acl_services_wasabicons_lib_Robot___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blueDarken10,
    key: 'robots'
  }, {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten70,
    icon: __WEBPACK_IMPORTED_MODULE_11__acl_services_wasabicons_lib_AnalyticsLogoCircle___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten10,
    key: 'analytics'
  }]
}, {
  key: 'setup',
  apps: [{
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.greenLighten50,
    icon: __WEBPACK_IMPORTED_MODULE_12__acl_services_wasabicons_lib_StrategyLogo___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.green,
    key: 'strategy'
  }, {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.greenLighten50,
    icon: __WEBPACK_IMPORTED_MODULE_13__acl_services_wasabicons_lib_Flowchart___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.green,
    key: 'frameworks'
  }, {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.greenLighten50,
    icon: __WEBPACK_IMPORTED_MODULE_14__acl_services_wasabicons_lib_Clipboard___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.green,
    key: 'compliance_maps'
  }, {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.greenLighten50,
    icon: __WEBPACK_IMPORTED_MODULE_15__acl_services_wasabicons_lib_FileAdd___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.green,
    key: 'assurance_plans'
  }, {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.greenLighten50,
    icon: __WEBPACK_IMPORTED_MODULE_16__acl_services_wasabicons_lib_TimeAndDate___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.green,
    key: 'project_scheduler'
  }, {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.greenLighten50,
    icon: __WEBPACK_IMPORTED_MODULE_17__acl_services_wasabicons_lib_Placeholder___default.a,
    iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.green,
    key: 'master_library'
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (appData);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paprika_tokens__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__paprika_tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_LaunchpadLogo__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_LaunchpadLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_LaunchpadLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_Academy__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_Academy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_Academy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_CommunityLogo__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_CommunityLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_CommunityLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_ToolsAndTemplatesLogo__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_ToolsAndTemplatesLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_ToolsAndTemplatesLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_HelpdocsLogo__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_HelpdocsLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_HelpdocsLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_LifeBuoy__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_LifeBuoy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_LifeBuoy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_Download__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_Download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_Download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_Design__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_Design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_Design__);









var resourceData = [{
  icon: __WEBPACK_IMPORTED_MODULE_1__acl_services_wasabicons_lib_LaunchpadLogo___default.a,
  iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten10,
  key: 'launchpad'
}, {
  icon: __WEBPACK_IMPORTED_MODULE_2__acl_services_wasabicons_lib_Academy___default.a,
  iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten10,
  key: 'academy'
}, {
  icon: __WEBPACK_IMPORTED_MODULE_3__acl_services_wasabicons_lib_CommunityLogo___default.a,
  iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten10,
  key: 'community'
}, {
  icon: __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_Design___default.a,
  iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten10,
  key: 'toolkits'
}, {
  icon: __WEBPACK_IMPORTED_MODULE_4__acl_services_wasabicons_lib_ToolsAndTemplatesLogo___default.a,
  iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten10,
  key: 'tools_and_templates'
}, {
  icon: __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_HelpdocsLogo___default.a,
  iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten10,
  key: 'help_docs'
}, {
  icon: __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_LifeBuoy___default.a,
  iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten10,
  key: 'support'
}, {
  icon: __WEBPACK_IMPORTED_MODULE_7__acl_services_wasabicons_lib_Download___default.a,
  iconColor: __WEBPACK_IMPORTED_MODULE_0__paprika_tokens___default.a.color.blackLighten10,
  key: 'downloads'
}];
/* harmony default export */ __webpack_exports__["a"] = (resourceData);

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ButtonIcon = exports.Button = exports.fullWidthStyles = exports.kindStyles = exports.sizeStyles = exports.commonStyles = exports.inactiveStyles = exports.activeStyles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var types = _interopRequireWildcard(__webpack_require__(571));

var _borderColors, _borderHoverColors, _sizeStyles, _iconColors;

var dropShadow = "0 1px 2px 0 rgba(0, 0, 0, 0.1)";

var enabled = function enabled(content) {
  return (0, _styledComponents.css)(["&:not([disabled]):not([aria-disabled=\"true\"]){", ";}"], content);
}; // Borders


var borderColors = (_borderColors = {}, (0, _defineProperty2["default"])(_borderColors, types.DEFAULT, _tokens["default"].border.color), (0, _defineProperty2["default"])(_borderColors, types.PRIMARY, _tokens["default"].color.green), (0, _defineProperty2["default"])(_borderColors, types.SECONDARY, _tokens["default"].color.purple), (0, _defineProperty2["default"])(_borderColors, types.DESTRUCTIVE, _tokens["default"].color.orange), (0, _defineProperty2["default"])(_borderColors, types.FLAT, _tokens["default"].border.color), (0, _defineProperty2["default"])(_borderColors, types.MINOR, "transparent"), (0, _defineProperty2["default"])(_borderColors, types.LINK, "transparent"), _borderColors);
var borderHoverColors = (_borderHoverColors = {}, (0, _defineProperty2["default"])(_borderHoverColors, types.DEFAULT, _tokens["default"].border.hoverColor), (0, _defineProperty2["default"])(_borderHoverColors, types.PRIMARY, _tokens["default"].color.greenDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.SECONDARY, _tokens["default"].color.purpleDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.DESTRUCTIVE, _tokens["default"].color.orangeDarken10), (0, _defineProperty2["default"])(_borderHoverColors, types.FLAT, _tokens["default"].border.hoverColor), (0, _defineProperty2["default"])(_borderHoverColors, types.MINOR, "transparent"), (0, _defineProperty2["default"])(_borderHoverColors, types.LINK, "transparent"), _borderHoverColors);

var borderStyles = function borderStyles(_ref) {
  var kind = _ref.kind;
  return (0, _styledComponents.css)(["border-color:", ";&:hover{", "}"], borderColors[kind], enabled((0, _styledComponents.css)(["border-color:", ";"], borderHoverColors[kind])));
}; // States


var disabledStyles = (0, _styledComponents.css)(["box-shadow:none;color:", ";cursor:not-allowed;text-decoration:none;text-shadow:none;&:focus{box-shadow:none;text-shadow:none;transform:none;}&,&:hover,&:focus{background:", ";border-color:", ";color:", ";text-decoration:none;}&,&:hover,&:active{box-shadow:none;transform:none;}"], _tokens["default"].color.blackDisabled, _tokens["default"].color.blackLighten70, _tokens["default"].color.blackLighten60, _tokens["default"].color.blackLighten40);
var disabledTextStyles = (0, _styledComponents.css)(["", " &,&:hover{background:none;border-color:transparent;}"], disabledStyles);
var activeStyles = (0, _styledComponents.css)(["", ""], _stylers["default"].focusRing.bordered());
exports.activeStyles = activeStyles;

var inactiveStyles = function inactiveStyles(_ref2) {
  var kind = _ref2.kind;
  return (0, _styledComponents.css)(["", " [data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{", "}"], borderStyles, enabled((0, _styledComponents.css)(["", " ", ""], borderStyles, [types.FLAT, types.MINOR, types.LINK].includes(kind) ? (0, _styledComponents.css)(["box-shadow:none;"]) : (0, _styledComponents.css)(["box-shadow:", ";"], dropShadow))));
}; // Common


exports.inactiveStyles = inactiveStyles;
var commonStyles = (0, _styledComponents.css)(["", " ", " appearance:none;border-radius:", ";border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;font-weight:bold;text-align:center;text-decoration:none;vertical-align:middle;&:focus{", "}&:active{box-shadow:", ",inset 0 1px 1px 0 rgba(0,0,0,0.1),inset 0 1px 4px 0 rgba(0,0,0,0.3);transform:scale(0.98);}"], _stylers["default"].alignMiddle, _stylers["default"].lineHeight(-1), _tokens["default"].button.borderRadius, _stylers["default"].focusRing.bordered(), _tokens["default"].highlight.active.noBorder.boxShadow);
exports.commonStyles = commonStyles;
var skeuomorphicStyles = (0, _styledComponents.css)(["box-shadow:", ";cursor:pointer;transition-duration:0.2s;transition-property:border;"], dropShadow);
var coloredButtonStyles = (0, _styledComponents.css)(["color:", ";text-shadow:0 1px 1px ", ";&:hover,&:visited{color:", ";text-decoration:none;}"], _tokens["default"].color.white, _stylers["default"].alpha(_tokens["default"].color.blackPure, 0.2), _tokens["default"].color.white);
var textButtonStyles = (0, _styledComponents.css)(["background:none;border-color:transparent;"]); // Sizes

var sizeStyles = (_sizeStyles = {}, (0, _defineProperty2["default"])(_sizeStyles, types.SMALL, (0, _styledComponents.css)(["", ";min-height:", ";padding:3px ", ";"], _stylers["default"].fontSize(-2), _stylers["default"].spacer(3), _tokens["default"].space)), (0, _defineProperty2["default"])(_sizeStyles, types.MEDIUM, (0, _styledComponents.css)(["", ";min-height:", ";padding:6.5px ", ";"], _stylers["default"].fontSize(-1), _stylers["default"].spacer(4), _tokens["default"].spaceLg)), (0, _defineProperty2["default"])(_sizeStyles, types.LARGE, (0, _styledComponents.css)(["", ";min-height:", ";padding:9px ", ";"], _stylers["default"].fontSize(), _stylers["default"].spacer(5), _stylers["default"].spacer(2))), _sizeStyles); // types

exports.sizeStyles = sizeStyles;

var kindStyles = function kindStyles(_ref3) {
  var _ref4;

  var isDisabled = _ref3.isDisabled;
  return _ref4 = {}, (0, _defineProperty2["default"])(_ref4, types.DEFAULT, (0, _styledComponents.css)(["", " &,&:hover,&:active,&:visited{background-color:", ";background-image:linear-gradient(", ",", ");color:", ";text-decoration:none;}&:hover,&:active{background:", ";}", ""], skeuomorphicStyles, _tokens["default"].color.white, _tokens["default"].color.blackLighten90, _tokens["default"].color.blackLighten70, _tokens["default"].color.black, _tokens["default"].color.blackLighten70, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.PRIMARY, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.greenLighten10, _tokens["default"].color.greenLighten10, _tokens["default"].color.green, _tokens["default"].color.green, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.SECONDARY, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.purpleLighten10, _tokens["default"].color.purpleLighten10, _tokens["default"].color.purple, _tokens["default"].color.purple, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.DESTRUCTIVE, (0, _styledComponents.css)(["", " ", " background-color:", ";background-image:linear-gradient(", ",", ");&:hover{background:", ";}", ""], skeuomorphicStyles, coloredButtonStyles, _tokens["default"].color.orangeHighlight, _tokens["default"].color.orangeHighlight, _tokens["default"].color.orange, _tokens["default"].color.orange, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.FLAT, (0, _styledComponents.css)(["", " background-color:", ";color:", ";&:hover,&:visited{background:", ";color:", ";text-decoration:none;}", ""], skeuomorphicStyles, _tokens["default"].color.white, _tokens["default"].color.black, _tokens["default"].color.blackLighten70, _tokens["default"].color.black, isDisabled && disabledStyles)), (0, _defineProperty2["default"])(_ref4, types.MINOR, (0, _styledComponents.css)(["", " &:hover{text-decoration:underline;}", ""], textButtonStyles, isDisabled && disabledTextStyles)), (0, _defineProperty2["default"])(_ref4, types.LINK, (0, _styledComponents.css)(["", " color:", ";font-weight:inherit;text-decoration:underline;&:hover{color:", ";}&:active{color:", ";}", ""], textButtonStyles, _tokens["default"].textColor.link, _tokens["default"].textColor.linkHover, _tokens["default"].color.blue, isDisabled && disabledTextStyles)), _ref4;
}; // Modifiers


exports.kindStyles = kindStyles;
var fullWidthStyles = (0, _styledComponents.css)(["display:flex;width:100%;"]); //
// Composition
//

exports.fullWidthStyles = fullWidthStyles;

var Button = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyles__Button",
  componentId: "ru6wp6-0"
})(function (_ref5) {
  var size = _ref5.size,
      kind = _ref5.kind,
      isFullWidth = _ref5.isFullWidth,
      isActive = _ref5.isActive,
      props = (0, _objectWithoutProperties2["default"])(_ref5, ["size", "kind", "isFullWidth", "isActive"]);
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], commonStyles, sizeStyles[size], kindStyles(props)[kind], isFullWidth && fullWidthStyles, isActive ? activeStyles : inactiveStyles);
}); //
// Icons
//


exports.Button = Button;
var spinKeyframes = (0, _styledComponents.keyframes)(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var iconColors = (_iconColors = {}, (0, _defineProperty2["default"])(_iconColors, types.DEFAULT, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.PRIMARY, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.SECONDARY, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.DESTRUCTIVE, _tokens["default"].color.white), (0, _defineProperty2["default"])(_iconColors, types.FLAT, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.MINOR, _tokens["default"].textColor.icon), (0, _defineProperty2["default"])(_iconColors, types.LINK, _tokens["default"].textColor.icon), _iconColors);

var getIconColor = function getIconColor(_ref6) {
  var isDisabled = _ref6.isDisabled,
      kind = _ref6.kind;
  return isDisabled ? _tokens["default"].color.blackDisabled : iconColors[kind];
};

var ButtonIcon = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyles__ButtonIcon",
  componentId: "ru6wp6-1"
})(function (_ref7) {
  var isPending = _ref7.isPending,
      isSuffixIcon = _ref7.isSuffixIcon,
      props = (0, _objectWithoutProperties2["default"])(_ref7, ["isPending", "isSuffixIcon"]);
  return (0, _styledComponents.css)(["align-items:center;color:", ";display:inline-flex;justify-content:center;margin:0 ", " 0 0;svg{vertical-align:-", "em;}", " ", ""], getIconColor(props), _tokens["default"].spaceSm, (_stylers["default"].lineHeightValue(-1) - 1) / 2, isPending && (0, _styledComponents.css)(["animation:", " 2s infinite linear;"], spinKeyframes), isSuffixIcon && (0, _styledComponents.css)(["margin:0 0 0 ", ";"], _tokens["default"].spaceSm));
});

exports.ButtonIcon = ButtonIcon;
//# sourceMappingURL=Button.styles.js.map

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon["default"];
  }
});

var _Icon = _interopRequireDefault(__webpack_require__(1311));
//# sourceMappingURL=index.js.map

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "NewTab___StyledSvg",
  componentId: "sc-1cri4kc-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgNewTab = function SvgNewTab(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.213 2.394v3.08H3.071v15.392h15.355V14.71h3.071v6.157c0 1.7-1.376 3.079-3.07 3.079H3.07A3.076 3.076 0 010 20.866V5.473c0-1.7 1.376-3.079 3.071-3.079h6.142zM24 0v9.497h-2.707V4.632l-8.516 8.538-1.914-1.919 8.517-8.538h-4.854V0H24z",
    fill: "currentColor"
  }));
};

var _default = SvgNewTab;
exports["default"] = _default;
//# sourceMappingURL=NewTab.js.map

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _styledComponents = __webpack_require__(4);

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var itemStyles = (0, _styledComponents.css)(["", ";", " color:", ";cursor:pointer;display:block;font-weight:normal;padding:", " ", ";text-decoration:none;[data-pka-anchor=\"icon\"]{padding:5px;}&:focus{box-shadow:", ";outline:none;position:relative;", "}", " &:hover{", "}&:active{", "}"], _stylers["default"].fontSize(), _stylers["default"].lineHeight(), _tokens["default"].color.black, _tokens["default"].spaceSm, _stylers["default"].spacer(2), _tokens["default"].highlight.active.withBorder.insetBoxShadow, _stylers["default"].z(1), function (_ref) {
  var isDestructive = _ref.isDestructive,
      isDisabled = _ref.isDisabled;
  var colorString;

  if (isDisabled) {
    colorString = isDestructive ? "orangeDisabled" : "blackDisabled";
    return {
      color: _tokens["default"].color[colorString]
    };
  }

  colorString = isDestructive ? "orangeDarken10" : "colorBlack";
  return {
    color: _tokens["default"].color[colorString]
  };
}, function (_ref2) {
  var isDestructive = _ref2.isDestructive,
      isDisabled = _ref2.isDisabled;

  if (!isDisabled) {
    var bgColorString = isDestructive ? "orangeLighten40" : "blackLighten70";
    return {
      backgroundColor: _tokens["default"].color[bgColorString]
    };
  }
}, function (_ref3) {
  var isDestructive = _ref3.isDestructive,
      isDisabled = _ref3.isDisabled;

  if (!isDisabled) {
    var bgColorString = isDestructive ? "orangeLighten40" : "blackLighten60";
    return {
      backgroundColor: _tokens["default"].color[bgColorString]
    };
  }
});
var _default = itemStyles;
exports["default"] = _default;
//# sourceMappingURL=Item.styles.js.map

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OverflowMenuTrigger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigationIcon__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OverflowMenuTrigger_scss__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OverflowMenuTrigger_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OverflowMenuTrigger_scss__);
/* eslint-disable jsx-a11y/click-events-have-key-events */





function OverflowMenuTrigger(_ref) {
  var ariaLabel = _ref.ariaLabel,
      icon = _ref.icon,
      isOpen = _ref.isOpen,
      onClick = _ref.onClick;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "aria-label": ariaLabel,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('navigation-item__trigger', {
      'navigation-item__trigger--is-active': isOpen
    }),
    onClick: onClick,
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NavigationIcon__["a" /* default */], {
    icon: icon
  }));
}
OverflowMenuTrigger.propTypes = {
  ariaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1029);


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GlobalNavigation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__paprika_l10n__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__paprika_l10n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__paprika_l10n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SkipButton_SkipButton__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_locales__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__GlobalNavigation_scss__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__GlobalNavigation_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__GlobalNavigation_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components__ = __webpack_require__(1048);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AppSwitcherSidePanel", function() { return __WEBPACK_IMPORTED_MODULE_13__components__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CurrentApp", function() { return __WEBPACK_IMPORTED_MODULE_13__components__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Helper", function() { return __WEBPACK_IMPORTED_MODULE_13__components__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HelperWithPendo", function() { return __WEBPACK_IMPORTED_MODULE_13__components__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Logo", function() { return __WEBPACK_IMPORTED_MODULE_13__components__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return __WEBPACK_IMPORTED_MODULE_13__components__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SignIn", function() { return __WEBPACK_IMPORTED_MODULE_13__components__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OrgSwitcher", function() { return __WEBPACK_IMPORTED_MODULE_13__components__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AppSwitcherSidePanel_appSwitcherPropsShape__ = __webpack_require__(1330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "appSwitcherPropsShape", function() { return __WEBPACK_IMPORTED_MODULE_14__components_AppSwitcherSidePanel_appSwitcherPropsShape__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data__ = __webpack_require__(1331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "appData", function() { return __WEBPACK_IMPORTED_MODULE_15__data__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "resourceData", function() { return __WEBPACK_IMPORTED_MODULE_15__data__["b"]; });







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }












var GlobalNavigation = /*#__PURE__*/function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default()(GlobalNavigation, _React$Component);

  var _super = _createSuper(GlobalNavigation);

  function GlobalNavigation() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, GlobalNavigation);

    return _super.apply(this, arguments);
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(GlobalNavigation, [{
    key: "augmentedSubComponent",
    value: function augmentedSubComponent(subComponent) {
      var zIndex = this.props.zIndex;
      return subComponent ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(subComponent, {
        zIndex: zIndex,
        key: subComponent.type.componentType
      }) : null;
    }
  }, {
    key: "renderSubComponents",
    value: function renderSubComponents(children, subComponentsList) {
      var subComponents = {};
      subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].currentApp] = null;
      subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].appSwitcher] = null;
      subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].signIn] = null;
      subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].helper] = null;
      subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].helperWithPendo] = null;
      subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].logo] = null;
      subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].user] = null;
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
        if (child.type && subComponentsList.indexOf(child.type.componentType) !== -1) {
          subComponents[child.type.componentType] = child;
        }
      });
      return [this.augmentedSubComponent(subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].logo]), this.augmentedSubComponent(subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].appSwitcher]), this.augmentedSubComponent(subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].currentApp]), this.augmentedSubComponent(subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].signIn]), this.augmentedSubComponent(subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].helper]), this.augmentedSubComponent(subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].helperWithPendo]), this.augmentedSubComponent(subComponents[__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* navigationItems */].user])];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          locale = _this$props.locale,
          mainContentSelector = _this$props.mainContentSelector;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__paprika_l10n___default.a, {
        locale: locale,
        locales: __WEBPACK_IMPORTED_MODULE_11__i18n_locales__["default"]
      }, mainContentSelector ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_SkipButton_SkipButton__["a" /* default */], {
        mainContentSelector: mainContentSelector
      }) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("nav", {
        className: "sriracha-global-navigation"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", {
        className: "navigation-left"
      }, this.renderSubComponents(children, __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* leftNavigationItems */])), this.renderSubComponents(children, __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* rightNavigationItems */])));
    }
  }]);

  return GlobalNavigation;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(GlobalNavigation, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  locale: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  mainContentSelector: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  zIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(GlobalNavigation, "defaultProps", {
  children: null,
  locale: 'en',
  mainContentSelector: null,
  zIndex: null
});



/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "i18n", {
  enumerable: true,
  get: function get() {
    return _i18n.i18n;
  }
});

_Object$defineProperty(exports, "defaultLocale", {
  enumerable: true,
  get: function get() {
    return _i18n.defaultLocale;
  }
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _L10n["default"];
  }
});

var _i18n = __webpack_require__(703);

var _L10n = _interopRequireDefault(__webpack_require__(1038));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "en": {
    "translation": {
      "timePicker": {
        "am": "am",
        "custom": "Custom",
        "hours": "Hours",
        "minutes": "Minutes",
        "period": "Period",
        "pm": "pm"
      },
      "back": "Back",
      "remove": "remove",
      "moreInformation": "more information",
      "close": "Close",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. You are on row {{rowIndex}}, column {{columnIndex}}. Disregard the following information:"
      },
      "uploader": {
        "drop_files": "Drop files to upload",
        "drop_files_here_or": "Drop files to upload here or",
        "choose_from_computer": "choose from your computer",
        "choose_from_computer_a11y": "Choose files from your computer",
        "cancel_upload": "Cancel upload",
        "restart_upload": "Restart upload",
        "file_list": "List of files",
        "errors": {
          "size": "File must be smaller than {{maxFileSize}}",
          "type": "File must be one of the following types: {{- supportedTypes}}"
        },
        "status": {
          "idle": "Idle",
          "processing": "Processing",
          "uploading": "Uploading",
          "success": "Success",
          "cancel": "Cancel",
          "error": "Error"
        },
        "progress": {
          "cancelled": "Cancelled",
          "complete": "Complete",
          "idle": "Idle",
          "uploading": "Uploading {{progressWithUnits}} of {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "Delete",
        "apply": "Apply",
        "cancel": "Cancel",
        "confirm": "Save",
        "decline": "Decline"
      },
      "datePicker": {
        "confirmation_format": "MMMM DD, YYYY"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Month",
        "year": "Year"
      },
      "daterange": {
        "last_7_days": "Last 7 Days",
        "last_30_days": "Last 30 Days",
        "this_month": "This Month",
        "last_month": "Last Month",
        "start_date": "Start Date",
        "end_date": "End Date"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} opens in a new tab."
      },
      "comment": {
        "delete": "Delete comment"
      },
      "pagination": {
        "intro": "Pagination, currently on page {{currentPage}}",
        "page": "Page {{pageNumber}}",
        "ellipsis": "More pages",
        "prev": "Previous page",
        "next": "Next page"
      },
      "formElement": {
        "optional": "(optional)",
        "required": "(required)",
        "aria_info_circle": "Information"
      },
      "prevNextArrowButton": {
        "arrowup": "up",
        "arrowdown": "down",
        "escape": "escape"
      },
      "collapsible": {
        "ariaText": "Collapsible section"
      },
      "sortable": {
        "aria_description": "Draggable item. Press space to lift.",
        "aria_lift": "You have lifted an item in position {{source}}. Use the arrow keys to move, space to drop, and escape to cancel.",
        "aria_moving": "You have moved the item from position {{source}} to position {{destination}}.",
        "aria_moving_outside": "You are currently not dragging over a droppable area.",
        "aria_cancelled": "Movement cancelled. The item has returned to its starting position of {{source}}.",
        "aria_dropped": "You have dropped the item. It has moved from position {{source}} to {{destination}}.",
        "aria_dropped_outside": "The item has been dropped while not over the list. The item has returned to its starting position of {{source}}.",
        "aria_remove": "Remove"
      },
      "progressAccordion": {
        "active": "active",
        "no_response": "None"
      },
      "collapsibleText": {
        "more": "Show more",
        "less": "Show less",
        "more_about": "show more about {{topic}}",
        "less_about": "show less about {{topic}}"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Select..."
        },
        "filter": {
          "a11y_text": "Filter",
          "no_results_message": "Your search result did not match any options.",
          "placeholder": "Filter..."
        }
      },
      "listBoxBrowser": {
        "explore": "Explore more options",
        "selected": "selected options",
        "selectOne": "Select one or more items..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Hide all",
          "show_all": "Show all",
          "label": "Arrange",
          "singular_label": "1 column hidden",
          "plural_label": "{{numberOfHiddenColumn}} columns hidden",
          "search_placeholder": "Filter..."
        },
        "no_results": "No results",
        "filter": {
          "no_filters_applied": "No filters applied to this view",
          "label": "Filter",
          "singular_label": "1 filter applied",
          "plural_label": "{{numberOfFilters}} filters applied",
          "add_filter": "Add a field to filter by",
          "and": "and",
          "or": "or",
          "where": "Where",
          "rules": {
            "is": "is",
            "is_not": "is not",
            "contains": "contains",
            "does_not_contain": "does not contain",
            "is_blank": "is blank",
            "is_not_blank": "is not blank",
            "equals": "equals",
            "not_equal_to": "not equal to",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "is empty",
            "is_not_empty": "is not empty",
            "is_before": "is before",
            "is_after": "is after",
            "true": "true",
            "false": "false"
          }
        },
        "search_placeholder": "Search...",
        "search_a11y_text": "Search the data",
        "sort": {
          "no_sorts_applied": "No sorts applied to this view",
          "label": "Sort",
          "singular_label": "1 column sorted",
          "plural_label": "{{numberOfFields}} columns sorted",
          "add_field": "Add a field to sort by",
          "sort_by": "Sort by",
          "then_by": "then by",
          "rules": {
            "ascending": {
              "boolean": "Sort ascending (true → false)",
              "number": "Sort ascending (1 → 9)",
              "text": "Sort ascending (A → Z)",
              "date": "Sort ascending (1 → 9)",
              "single_select": "Sort ascending (A → Z)"
            },
            "descending": {
              "boolean": "Sort descending (false → true)",
              "number": "Sort descending (9 → 1)",
              "text": "Sort descending (Z → A)",
              "date": "Sort descending (9 → 1)",
              "single_select": "Sort descending (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Breadcrumbs",
        "aria_expand": "Show all breadcrumb items.",
        "aria_back_to": "Back to"
      },
      "sideNavigation": {
        "aria_label": "Side navigation",
        "trigger_aria_label": "Open navigation"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=en.js.map

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "de": {
    "translation": {
      "timePicker": {
        "am": "AM",
        "custom": "Angepasst",
        "hours": "Stunden",
        "minutes": "Minuten",
        "period": "Zeitraum",
        "pm": "PM"
      },
      "back": "Zurück",
      "remove": "entfernen",
      "moreInformation": "weitere Informationen",
      "close": "Schließen",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. Sie befinden sich in Reihe {{rowIndex}}, Spalte {{columnIndex}}. Ignorieren Sie die folgenden Informationen:"
      },
      "uploader": {
        "drop_files": "Dateien zum Hochladen ablegen",
        "drop_files_here_or": "Legen Sie Dateien zum Hochladen hier ab oder",
        "choose_from_computer": "wählen Sie sie auf Ihrem Computer aus",
        "choose_from_computer_a11y": "Wählen Sie Dateien auf Ihrem Computer aus",
        "cancel_upload": "Upload abbrechen",
        "restart_upload": "Upload neu starten",
        "file_list": "Liste der Dateien",
        "errors": {
          "size": "Datei muss kleiner als {{maxFileSize}} sein",
          "type": "Datei muss die Datei einen der folgenden Dateitypen aufweisen: {{- supportedTypes}}"
        },
        "status": {
          "idle": "Inaktiv",
          "processing": "In Bearbeitung",
          "uploading": "Wird hochgeladen",
          "success": "Erfolg",
          "cancel": "Abbrechen",
          "error": "Fehler"
        },
        "progress": {
          "cancelled": "Abgebrochen",
          "complete": "Abgeschlossen",
          "idle": "Inaktiv",
          "uploading": "{{progressWithUnits}} von {{sizeWithUnits}} werden hochgeladen"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "Löschen",
        "apply": "Anwenden",
        "cancel": "Abbrechen",
        "confirm": "Speichern",
        "decline": "Ablehnen"
      },
      "datePicker": {
        "confirmation_format": "DD. MMMM YYYY"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Monat",
        "year": "Jahr"
      },
      "daterange": {
        "last_7_days": "Letzte 7 Tage",
        "last_30_days": "Letzte 30 Tage",
        "this_month": "Diesen Monat",
        "last_month": "Letzten Monat",
        "start_date": "Anfangsdatum",
        "end_date": "Enddatum"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} wird auf einer neuen Registerkarte geöffnet."
      },
      "comment": {
        "delete": "Anmerkung löschen"
      },
      "pagination": {
        "intro": "Seitennummerierung, aktuell auf Seite {{currentPage}}",
        "page": "Seite {{pageNumber}}",
        "ellipsis": "Weitere Seiten",
        "prev": "Vorherige Seite",
        "next": "Nächste Seite"
      },
      "formElement": {
        "optional": "(optional)",
        "required": "(erforderlich)",
        "aria_info_circle": "Informationen"
      },
      "prevNextArrowButton": {
        "arrowup": "Auf",
        "arrowdown": "Ab",
        "escape": "Escape"
      },
      "collapsible": {
        "ariaText": "Einklappbarer Abschnitt"
      },
      "sortable": {
        "aria_description": "Ziehbares Element. Drücken Sie zum Anheben die Leertaste.",
        "aria_lift": "Sie haben ein Element in Position {{source}} angehoben. Verwenden Sie die Pfeiltasten, um es zu bewegen, die Leertaste, um es fallen zu lassen, und Esc, um Aktion abzubrechen.",
        "aria_moving": "Sie haben das Element von Position {{source}} an Position {{destination}} verschoben.",
        "aria_moving_outside": "Sie ziehen das Element derzeit nicht über einen Bereich, auf dem Sie es ablegen können.",
        "aria_cancelled": "Verschieben abgebrochen. Das Element ist in seine Ausgangsposition von {{source}} zurückgekehrt.",
        "aria_dropped": "Sie haben das Element abgelegt. Das Element wurde von Position {{source}} an Position {{destination}} verschoben.",
        "aria_dropped_outside": "Das Element wurde abgelegt, während es sich nicht über der Liste befand. Das Element ist in seine Ausgangsposition von {{source}} zurückgekehrt.",
        "aria_remove": "Entfernen"
      },
      "progressAccordion": {
        "active": "aktiv",
        "no_response": "Keine"
      },
      "collapsibleText": {
        "more": "Mehr anzeigen",
        "less": "Weniger anzeigen",
        "more_about": "Mehr über {{topic}} anzeigen",
        "less_about": "Weniger über {{topic}} anzeigen"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Auswählen..."
        },
        "filter": {
          "a11y_text": "Filtern",
          "no_results_message": "Ihr Suchergebnis entsprach keiner der Optionen.",
          "placeholder": "Filtern..."
        }
      },
      "listBoxBrowser": {
        "explore": "Weitere Optionen anzeigen",
        "selected": "ausgewählte Optionen",
        "selectOne": "Ein oder mehrere Elemente auswählen..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Alles ausblenden",
          "show_all": "Alles anzeigen",
          "label": "Neu anordnen",
          "singular_label": "1 Spalte ausgeblendet",
          "plural_label": "{{numberOfHiddenColumn}} Spalten ausgeblendet",
          "search_placeholder": "Filtern..."
        },
        "no_results": "Keine Ergebnisse",
        "filter": {
          "no_filters_applied": "Auf diese Ansicht wurden keine Filter angewendet",
          "label": "Filtern",
          "singular_label": "1 Filter angewendet",
          "plural_label": "{{numberOfFilters}} Filter angewendet",
          "add_filter": "Feld hinzufügen zum Filtern nach",
          "and": "und",
          "or": "oder",
          "where": "Mit",
          "rules": {
            "is": "ist",
            "is_not": "ist nicht",
            "contains": "enthält",
            "does_not_contain": "enthält nicht",
            "is_blank": "bleibt leer",
            "is_not_blank": "bleibt nicht leer",
            "equals": "gleich",
            "not_equal_to": "ungleich",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "ist leer",
            "is_not_empty": "ist nicht leer",
            "is_before": "ist vor",
            "is_after": "ist nach",
            "true": "wahr",
            "false": "falsch"
          }
        },
        "search_placeholder": "Suchen...",
        "search_a11y_text": "Daten durchsuchen",
        "sort": {
          "no_sorts_applied": "Auf diese Ansicht wurde keine Sortierung angewendet",
          "label": "Sortieren",
          "singular_label": "1 Spalte sortiert",
          "plural_label": "{{numberOfFields}} Spalten sortiert",
          "add_field": "Feld hinzufügen zum Sortieren nach",
          "sort_by": "Sortieren nach",
          "then_by": "dann nach",
          "rules": {
            "ascending": {
              "boolean": "Aufsteigend sortieren (wahr → falsch)",
              "number": "Aufsteigend sortieren (1 → 9)",
              "text": "Aufsteigend sortieren (A → Z)",
              "date": "Aufsteigend sortieren (1 → 9)",
              "single_select": "Aufsteigend sortieren (A → Z)"
            },
            "descending": {
              "boolean": "Absteigend sortieren (falsch → wahr)",
              "number": "Absteigend sortieren (9 → 1)",
              "text": "Absteigend sortieren (Z → A)",
              "date": "Absteigend sortieren (9 → 1)",
              "single_select": "Absteigend sortieren (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Breadcrumbs",
        "aria_expand": "Sie können alle Breadcrumb-Elemente anzeigen."
      },
      "sideNavigation": {
        "aria_label": "Seiten-Navigation",
        "trigger_aria_label": "Navigation öffnen"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=de.js.map

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "fr": {
    "translation": {
      "timePicker": {
        "am": "am",
        "custom": "Personnalisé",
        "hours": "Heures",
        "minutes": "Minutes",
        "period": "Période",
        "pm": "pm"
      },
      "back": "Retour",
      "remove": "supprimer",
      "moreInformation": "plus d'informations",
      "close": "Fermer",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. Vous êtes désormais dans la ligne {{rowIndex}}, colonne {{columnIndex}}. Ignorez les informations suivantes :"
      },
      "uploader": {
        "drop_files": "Déposer les fichiers à charger",
        "drop_files_here_or": "Déposer les fichiers à charger ici ou",
        "choose_from_computer": "parcourir votre ordinateur",
        "choose_from_computer_a11y": "Choisir des fichiers dans votre ordinateur",
        "cancel_upload": "Annuler le chargement",
        "restart_upload": "Recommencer le chargement",
        "file_list": "Liste des fichiers",
        "errors": {
          "size": "La taille du fichier ne doit pas dépasser {{maxFileSize}}",
          "type": "Le fichier doit être de l'un des types suivants : {{- supportedTypes}}"
        },
        "status": {
          "idle": "Inactif",
          "processing": "Traitement en cours",
          "uploading": "Téléchargement",
          "success": "Réussite",
          "cancel": "Annuler",
          "error": "Erreur"
        },
        "progress": {
          "cancelled": "Annulé(e)",
          "complete": "Terminé(e)",
          "idle": "Inactif",
          "uploading": "Chargement en cours de {{progressWithUnits}} sur {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "O",
          "kibibyte": "Kio",
          "mebibyte": "Mio",
          "gibibyte": "Gio",
          "tebibyte": "Tio"
        }
      },
      "actions": {
        "delete": "Supprimer",
        "apply": "Appliquer",
        "cancel": "Annuler",
        "confirm": "Enregistrer",
        "decline": "Refuser"
      },
      "datePicker": {
        "confirmation_format": "D MMMM YYYY"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Mois",
        "year": "Année"
      },
      "daterange": {
        "last_7_days": "7 derniers jours",
        "last_30_days": "30 derniers jours",
        "this_month": "Ce mois",
        "last_month": "Le mois dernier",
        "start_date": "Date de début",
        "end_date": "Date de fin"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} s'ouvre dans un nouvel onglet."
      },
      "comment": {
        "delete": "Supprimer le commentaire"
      },
      "pagination": {
        "intro": "Pagination, actuellement à la page {{currentPage}}",
        "page": "Page {{pageNumber}}",
        "ellipsis": "Plus de pages",
        "prev": "Page précédente",
        "next": "Page suivante"
      },
      "formElement": {
        "optional": "(facultatif)",
        "required": "(requis)",
        "aria_info_circle": "Informations"
      },
      "prevNextArrowButton": {
        "arrowup": "haut",
        "arrowdown": "bas",
        "escape": "Échap"
      },
      "collapsible": {
        "ariaText": "Section réductible"
      },
      "sortable": {
        "aria_description": "Élément déplaçable. Appuyez sur la touche espace pour lever.",
        "aria_lift": "Vous avez élevé un élément dans la position {{source}}. Utilisez les touches de direction pour déplacer, la touche Espace pour déposer et Échap pour annuler.",
        "aria_moving": "Vous avez déplacé l'élément de la position {{source}} vers la position {{destination}}.",
        "aria_moving_outside": "Vous n'êtes pas en train de faire glisser un élément sur une zone déposable.",
        "aria_cancelled": "Mouvement annulé. L'élément est retourné à sa position initiale de {{source}}.",
        "aria_dropped": "Vous avez déposé l'élément. Il est déplacé de la position {{source}} vers {{destination}}.",
        "aria_dropped_outside": "L'élément a été déposé alors qu'il n'était au-dessus de la liste. L'élément est retourné à sa position initiale de {{source}}.",
        "aria_remove": "Supprimer"
      },
      "progressAccordion": {
        "active": "actif(ve)",
        "no_response": "Aucun"
      },
      "collapsibleText": {
        "more": "Afficher plus",
        "less": "Afficher moins",
        "more_about": "Afficher plus sur {{topic}}",
        "less_about": "Afficher moins sur {{topic}}"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Sélectionner..."
        },
        "filter": {
          "a11y_text": "Filtrer",
          "no_results_message": "Vos résultats de recherche ne correspondaient à aucune option.",
          "placeholder": "Filtrer..."
        }
      },
      "listBoxBrowser": {
        "explore": "Découvrir d'autres options",
        "selected": "options sélectionnées",
        "selectOne": "Sélectionner un ou plusieurs éléments..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Masquer tout",
          "show_all": "Afficher tout",
          "label": "Organiser",
          "singular_label": "1 colonne masquée",
          "plural_label": "{{numberOfHiddenColumn}} colonnes masquées",
          "search_placeholder": "Filtrer..."
        },
        "no_results": "Pas de résultats",
        "filter": {
          "no_filters_applied": "Aucun filtre appliqué à cette vue",
          "label": "Filtrer",
          "singular_label": "1 filtre appliqué",
          "plural_label": "{{numberOfFilters}} filtres appliqués",
          "add_filter": "Ajouter un champ pour filtrer par",
          "and": "et",
          "or": "ou",
          "where": "Lorsque",
          "rules": {
            "is": "est",
            "is_not": "n'est pas",
            "contains": "contient",
            "does_not_contain": "ne contient pas",
            "is_blank": "est vide",
            "is_not_blank": "n'est pas vide",
            "equals": "est égal à",
            "not_equal_to": "n'est pas égal à",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "est vide",
            "is_not_empty": "n'est pas vide",
            "is_before": "est avant",
            "is_after": "est après",
            "true": "vrai",
            "false": "faux"
          }
        },
        "search_placeholder": "Rechercher...",
        "search_a11y_text": "Rechercher les données",
        "sort": {
          "no_sorts_applied": "Aucun tri appliqué à cette vue",
          "label": "Trier",
          "singular_label": "1 colonne triée",
          "plural_label": "{{numberOfFields}} colonnes triées",
          "add_field": "Ajouter un champ pour trier par",
          "sort_by": "Trier par",
          "then_by": "alors par",
          "rules": {
            "ascending": {
              "boolean": "Tri croissant (vrai → faux)",
              "number": "Tri croissant (1 → 9)",
              "text": "Tri croissant (A → Z)",
              "date": "Tri croissant (1 → 9)",
              "single_select": "Tri croissant (A → Z)"
            },
            "descending": {
              "boolean": "Tri décroissant (faux → vrai)",
              "number": "Tri décroissant (9 → 1)",
              "text": "Tri décroissant (Z → A)",
              "date": "Tri décroissant (9 → 1)",
              "single_select": "Tri décroissant (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Fils d'Ariane",
        "aria_expand": "Afficher tous les éléments du fil d'Ariane"
      },
      "sideNavigation": {
        "aria_label": "Navigation latérale",
        "trigger_aria_label": "Ouvrir la navigation"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=fr.js.map

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "es": {
    "translation": {
      "timePicker": {
        "am": "a. m.",
        "custom": "Personalizar",
        "hours": "Horas",
        "minutes": "Minutos",
        "period": "Periodo",
        "pm": "p. m."
      },
      "back": "Atrás",
      "remove": "quitar",
      "moreInformation": "más información",
      "close": "Cerrar",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. Está en la fila {{rowIndex}}, columna {{columnIndex}}. Haga caso omiso de la siguiente información:"
      },
      "uploader": {
        "drop_files": "Soltar archivos a cargar",
        "drop_files_here_or": "Suelte los archivos a cargar aquí o",
        "choose_from_computer": "elija de su computadora",
        "choose_from_computer_a11y": "Elija archivos de su computadora",
        "cancel_upload": "Cancelar carga",
        "restart_upload": "Reiniciar carga",
        "file_list": "Lista de archivos",
        "errors": {
          "size": "El archivo debe tener menos de {{maxFileSize}}",
          "type": "El archivo debe ser de uno de los siguientes tipos: {{- supportedTypes}}"
        },
        "status": {
          "idle": "Ocioso",
          "processing": "En proceso",
          "uploading": "Cargando",
          "success": "Éxito",
          "cancel": "Cancelar",
          "error": "Error"
        },
        "progress": {
          "cancelled": "Cancelado/a",
          "complete": "Completado/a",
          "idle": "Ocioso",
          "uploading": "Cargando {{progressWithUnits}} de {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "Eliminar",
        "apply": "Aplicar",
        "cancel": "Cancelar",
        "confirm": "Guardar",
        "decline": "Declinar"
      },
      "datePicker": {
        "confirmation_format": "ll"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Mes",
        "year": "Año"
      },
      "daterange": {
        "last_7_days": "Los últimos 7 días",
        "last_30_days": "Los últimos 30 días",
        "this_month": "Este mes",
        "last_month": "El mes pasado",
        "start_date": "Fecha de inicio",
        "end_date": "Fecha de finalización"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} se abre en una nueva ficha."
      },
      "comment": {
        "delete": "Eliminar comentario"
      },
      "pagination": {
        "intro": "Paginación, actualmente en la página {{currentPage}}",
        "page": "Página {{pageNumber}}",
        "ellipsis": "Más páginas",
        "prev": "Página anterior",
        "next": "Siguiente página"
      },
      "formElement": {
        "optional": "(opcional)",
        "required": "(requerido)",
        "aria_info_circle": "Información"
      },
      "prevNextArrowButton": {
        "arrowup": "arriba",
        "arrowdown": "abajo",
        "escape": "escape"
      },
      "collapsible": {
        "ariaText": "Sección contraíble"
      },
      "sortable": {
        "aria_description": "Elemento arrastrable. Presione la barra espaciadora para levantar.",
        "aria_lift": "Ha levantado un elemento de la posición {{source}}. Utilice las teclas de flecha para moverse, el espacio para soltar y la tecla escape para cancelar.",
        "aria_moving": "Ha movido el elemento de la posición {{source}} a la posición {{destination}}.",
        "aria_moving_outside": "Actualmente no está arrastrando sobre un área donde soltar.",
        "aria_cancelled": "Movimiento cancelado. El elemento ha vuelto a su posición inicial de {{source}}.",
        "aria_dropped": "Ha soltado el elemento. Se ha movido de la posición {{source}} a {{destination}}.",
        "aria_dropped_outside": "El elemento se ha soltado mientras no estaba sobre la lista. El elemento ha vuelto a su posición inicial de {{source}}.",
        "aria_remove": "Quitar"
      },
      "progressAccordion": {
        "active": "activo/a",
        "no_response": "Ninguno"
      },
      "collapsibleText": {
        "more": "Mostrar más",
        "less": "Mostrar menos",
        "more_about": "mostrar más sobre {{topic}}",
        "less_about": "mostrar menos sobre {{topic}}"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Seleccionar..."
        },
        "filter": {
          "a11y_text": "Filtrar",
          "no_results_message": "Su resultado de búsqueda no coincidió con ninguna opción.",
          "placeholder": "Filtrar..."
        }
      },
      "listBoxBrowser": {
        "explore": "Explorar más opciones",
        "selected": "opciones seleccionadas",
        "selectOne": "Seleccionar uno o más elementos..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Ocultar todas",
          "show_all": "Mostrar todas",
          "label": "Organizar",
          "singular_label": "1 columna oculta",
          "plural_label": "{{numberOfHiddenColumn}} columnas ocultas",
          "search_placeholder": "Filtrar..."
        },
        "no_results": "No hay resultados",
        "filter": {
          "no_filters_applied": "No se aplicaron filtros a esta vista",
          "label": "Filtrar",
          "singular_label": "Se aplicó 1 filtro",
          "plural_label": "{{numberOfFilters}} filtros aplicados",
          "add_filter": "Agregar un campo para filtrar",
          "and": "y",
          "or": "o",
          "where": "Donde",
          "rules": {
            "is": "es",
            "is_not": "no es",
            "contains": "contiene",
            "does_not_contain": "no contiene",
            "is_blank": "está en blanco",
            "is_not_blank": "no está en blanco",
            "equals": "es igual a",
            "not_equal_to": "es distinto de",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "está vacío",
            "is_not_empty": "no está vacío",
            "is_before": "es anterior a",
            "is_after": "es posterior a",
            "true": "verdadero",
            "false": "falso"
          }
        },
        "search_placeholder": "Buscar...",
        "search_a11y_text": "Buscar los datos",
        "sort": {
          "no_sorts_applied": "No se aplicaron ordenaciones a esta vista",
          "label": "Ordenar",
          "singular_label": "1 columna ordenada",
          "plural_label": "{{numberOfFields}} columnas ordenadas",
          "add_field": "Agregar un campo para ordenar",
          "sort_by": "Ordenar por",
          "then_by": "luego por",
          "rules": {
            "ascending": {
              "boolean": "Orden ascendente (verdadero → falso)",
              "number": "Orden ascendente (1 → 9)",
              "text": "Orden ascendente (A → Z)",
              "date": "Orden ascendente (1 → 9)",
              "single_select": "Orden ascendente (A → Z)"
            },
            "descending": {
              "boolean": "Orden descendente (falso → verdadero)",
              "number": "Orden descendente (9 → 1)",
              "text": "Orden descendente (Z → A)",
              "date": "Orden descendente (9 → 1)",
              "single_select": "Orden descendente (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Rutas de navegación",
        "aria_expand": "Mostrar todos los elementos de la ruta de navegación."
      },
      "sideNavigation": {
        "aria_label": "Navegación lateral",
        "trigger_aria_label": "Abrir la navegación"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=es.js.map

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "pt": {
    "translation": {
      "timePicker": {
        "am": "AM",
        "custom": "Personalizado",
        "hours": "Horas",
        "minutes": "Minutos",
        "period": "Período",
        "pm": "PM"
      },
      "back": "Voltar",
      "remove": "remover",
      "moreInformation": "mais informações",
      "close": "Fechar",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. Você está na linha {{rowIndex}}, coluna {{columnIndex}}. Ignorar as seguintes informações:"
      },
      "uploader": {
        "drop_files": "Solte os arquivos para carregar",
        "drop_files_here_or": "Solte os arquivos para carregar aqui ou",
        "choose_from_computer": "escolha no seu computador",
        "choose_from_computer_a11y": "Escolher arquivos no seu computador",
        "cancel_upload": "Cancelar upload",
        "restart_upload": "Reiniciar upload",
        "file_list": "Lista de arquivos",
        "errors": {
          "size": "O arquivo deve ser menor que {{maxFileSize}}",
          "type": "O arquivo precisa ser de um dos seguintes tipos: {{- supportedTypes}}"
        },
        "status": {
          "idle": "Ocioso",
          "processing": "Processando",
          "uploading": "Fazendo upload",
          "success": "Sucesso",
          "cancel": "Cancelar",
          "error": "Erro"
        },
        "progress": {
          "cancelled": "Cancelado(a)",
          "complete": "Concluído(a)",
          "idle": "Ocioso",
          "uploading": "Carregando {{progressWithUnits}} de {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "Excluir",
        "apply": "Aplicar",
        "cancel": "Cancelar",
        "confirm": "Salvar",
        "decline": "Recusar"
      },
      "datePicker": {
        "confirmation_format": "ll"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Mês",
        "year": "Ano"
      },
      "daterange": {
        "last_7_days": "Últimos 7 Dias",
        "last_30_days": "Últimos 30 Dias",
        "this_month": "Este Mês",
        "last_month": "Mês Passado",
        "start_date": "Data de Início",
        "end_date": "Data de Término"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} abre em uma nova guia."
      },
      "comment": {
        "delete": "Excluir comentário"
      },
      "pagination": {
        "intro": "Paginação, atualmente na página {{currentPage}}",
        "page": "Página {{pageNumber}}",
        "ellipsis": "Mais páginas",
        "prev": "Página anterior",
        "next": "Próxima página"
      },
      "formElement": {
        "optional": "(opcional)",
        "required": "(obrigatório)",
        "aria_info_circle": "Informação"
      },
      "prevNextArrowButton": {
        "arrowup": "para cima",
        "arrowdown": "para baixo",
        "escape": "ESC"
      },
      "collapsible": {
        "ariaText": "Seção recolhível"
      },
      "sortable": {
        "aria_description": "Item arrastável. Pressione espaço para levantar.",
        "aria_lift": "Você levantou um item em posição {{source}}. Use as teclas de seta para mover, espaço para soltar e esc para cancelar.",
        "aria_moving": "Você moveu o item da posição {{source}} para a posição {{destination}}.",
        "aria_moving_outside": "Você atualmente não está arrastando sobr euma área onde é possível soltar.",
        "aria_cancelled": "Movimento cancelado. O item voltou para sua posição inicial de {{source}}.",
        "aria_dropped": "Você soltou o item. Ele foi movido da posição {{source}} para a posição {{destination}}.",
        "aria_dropped_outside": "O item foi solto enquanto não estava sobre a lista. O item voltou para sua posição inicial de {{source}}.",
        "aria_remove": "Remover"
      },
      "progressAccordion": {
        "active": "ativo(a)",
        "no_response": "Nenhum"
      },
      "collapsibleText": {
        "more": "Mostrar mais",
        "less": "Mostrar menos",
        "more_about": "mostrar mais sobre {{topic}}",
        "less_about": "mostrar menos sobre {{topic}}"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Selecione..."
        },
        "filter": {
          "a11y_text": "Filtrar",
          "no_results_message": "O resultado da sua pesquisa não correspondeu a nenhuma opção.",
          "placeholder": "Filtrar..."
        }
      },
      "listBoxBrowser": {
        "explore": "Explorar mais opções",
        "selected": "opções selecionadas",
        "selectOne": "Selecione um ou mais itens..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Ocultar tudo",
          "show_all": "Mostrar tudo",
          "label": "Organizar",
          "singular_label": "1 coluna oculta",
          "plural_label": "{{numberOfHiddenColumn}} colunas ocultas",
          "search_placeholder": "Filtrar..."
        },
        "no_results": "Nenhum resultado",
        "filter": {
          "no_filters_applied": "Nenhum filtro aplicado a esta exibição",
          "label": "Filtrar",
          "singular_label": "1 filtro aplicado",
          "plural_label": "{{numberOfFilters}} filtros aplicados",
          "add_filter": "Adicionar um campo para filtrar",
          "and": "e",
          "or": "ou",
          "where": "Onde",
          "rules": {
            "is": "é",
            "is_not": "não é",
            "contains": "contém",
            "does_not_contain": "não contém",
            "is_blank": "está em branco",
            "is_not_blank": "não está em branco",
            "equals": "igual a",
            "not_equal_to": "diferente de",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "está em branco",
            "is_not_empty": "não está vazio",
            "is_before": "é antes de",
            "is_after": "é depois de",
            "true": "verdadeiro",
            "false": "falso"
          }
        },
        "search_placeholder": "Pesquisar...",
        "search_a11y_text": "Pesquisar os dados",
        "sort": {
          "no_sorts_applied": "Nenhum filtro aplicado a esta exibição",
          "label": "Ordenar",
          "singular_label": "1 coluna ordenada",
          "plural_label": "{{numberOfFields}} colunas ordenadas",
          "add_field": "Adicionar um campo para ordenar",
          "sort_by": "Ordenar por",
          "then_by": "depois por",
          "rules": {
            "ascending": {
              "boolean": "Ordem crescente (verdadeiro → falso)",
              "number": "Ordem crescente (1 → 9)",
              "text": "Ordem crescente (A → Z)",
              "date": "Ordem crescente (1 → 9)",
              "single_select": "Ordem crescente (A → Z)"
            },
            "descending": {
              "boolean": "Ordem decrescente (falso → verdadeiro)",
              "number": "Ordem decrescente (9 → 1)",
              "text": "Ordem decrescente (Z → A)",
              "date": "Ordem decrescente (9 → 1)",
              "single_select": "Ordem decrescente (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Navegação estrutural",
        "aria_expand": "Mostrar todos os itens de navegação estrutural."
      },
      "sideNavigation": {
        "aria_label": "Navegação lateral",
        "trigger_aria_label": "Abrir navegação"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=pt.js.map

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "ja": {
    "translation": {
      "timePicker": {
        "am": "午前",
        "custom": "カスタム",
        "hours": "時間",
        "minutes": "分",
        "period": "期間",
        "pm": "午後"
      },
      "back": "戻る",
      "remove": "削除",
      "moreInformation": "詳しい情報",
      "close": "閉じる",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. 行 {{rowIndex}}、列 {{columnIndex}} の位置にいます。次の情報は無視してください。"
      },
      "uploader": {
        "drop_files": "アップロードするファイルをドロップ",
        "drop_files_here_or": "アップロードするファイルをここにドロップまたは",
        "choose_from_computer": "コンピューターから選択",
        "choose_from_computer_a11y": "コンピューターからファイルを選択する",
        "cancel_upload": "アップロードをキャンセル",
        "restart_upload": "アップロードを再起動",
        "file_list": "ファイル一覧",
        "errors": {
          "size": "ファイルは{{maxFileSize}}未満にする必要があります",
          "type": "ファイルは次のタイプの1つにする必要があります: {{- supportedTypes}}"
        },
        "status": {
          "idle": "アイドル状態",
          "processing": "処理中",
          "uploading": "アップロード中",
          "success": "成功",
          "cancel": "キャンセル",
          "error": "エラー"
        },
        "progress": {
          "cancelled": "取り消されました",
          "complete": "完了",
          "idle": "アイドル状態",
          "uploading": "{{sizeWithUnits}}のうち{{progressWithUnits}}をアップロード"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "削除",
        "apply": "適用",
        "cancel": "キャンセル",
        "confirm": "保存",
        "decline": "辞退"
      },
      "datePicker": {
        "confirmation_format": "YYYY 年 M 月 D 日"
      },
      "calendar": {
        "header_format": "YYYY 年 M 月",
        "month": "月",
        "year": "年"
      },
      "daterange": {
        "last_7_days": "過去 7 日間",
        "last_30_days": "過去 30 日間",
        "this_month": "今月",
        "last_month": "先月",
        "start_date": "開始日",
        "end_date": "終了日"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} が新しいタブで開きます。"
      },
      "comment": {
        "delete": "コメントを削除"
      },
      "pagination": {
        "intro": "改ページ位置の自動修正、現在は {{currentPage}} ページ",
        "page": "{{pageNumber}} ページ",
        "ellipsis": "その他のページ",
        "prev": "前ページ",
        "next": "次ページ"
      },
      "formElement": {
        "optional": "(省略可能)",
        "required": "(必須)",
        "aria_info_circle": "情報"
      },
      "prevNextArrowButton": {
        "arrowup": "上",
        "arrowdown": "下",
        "escape": "エスケープ"
      },
      "collapsible": {
        "ariaText": "縮小可能セクション"
      },
      "sortable": {
        "aria_description": "ドラッグ可能な項目。スペースを押して取り除きます。",
        "aria_lift": "{{source}}のポジションにある項目を 1 つ取り除きました。移動するには矢印、ドロップするにはスペース、そしてキャンセルするにはエスケープ キーを使用します。",
        "aria_moving": "{{source}}のポジションから{{destination}}のポジションまで項目を移動しました。",
        "aria_moving_outside": "現在ドラッグしているのは、ドラッグ可能な領域ではありません。",
        "aria_cancelled": "移動がキャンセルされました。項目は、{{source}}の出発点に戻りました。",
        "aria_dropped": "項目をドロップしました。{{source}}のポジションから{{destination}}のポジションまで項目が移動しました。",
        "aria_dropped_outside": "一覧にない項目がドロップされました。項目は、{{source}}の出発点に戻りました。",
        "aria_remove": "削除"
      },
      "progressAccordion": {
        "active": "アクティブ",
        "no_response": "なし"
      },
      "collapsibleText": {
        "more": "詳しく表示",
        "less": "少なく表示",
        "more_about": "{{topic}}について詳しく表示",
        "less_about": "{{topic}}について少なく表示"
      },
      "listBox": {
        "trigger": {
          "placeholder": "選択..."
        },
        "filter": {
          "a11y_text": "フィルター",
          "no_results_message": "検索結果はどのオプションにも一致しませんでした。",
          "placeholder": "フィルター..."
        }
      },
      "listBoxBrowser": {
        "explore": "より多くのオプションを探す",
        "selected": "選択されたオプション",
        "selectOne": "1 つ以上の項目を選択..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "すべて非表示",
          "show_all": "すべて表示",
          "label": "調整",
          "singular_label": "1列非表示",
          "plural_label": "{{numberOfHiddenColumn}}列非表示",
          "search_placeholder": "フィルター..."
        },
        "no_results": "結果なし",
        "filter": {
          "no_filters_applied": "このビューに適用するフィルターなし",
          "label": "フィルター",
          "singular_label": "1フィルター適用済み",
          "plural_label": "{{numberOfFilters}}フィルター適用済み",
          "add_filter": "フィルター対象のフィールドを追加",
          "and": "および",
          "or": "または",
          "where": "条件として",
          "rules": {
            "is": "は次である:",
            "is_not": "は次でない:",
            "contains": "は次を含む:",
            "does_not_contain": "は次を含まない:",
            "is_blank": "は空白である",
            "is_not_blank": "は空白でない",
            "equals": "は次と一致する:",
            "not_equal_to": "は次と一致しない:",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "は空である",
            "is_not_empty": "は空でない",
            "is_before": "は次より前である:",
            "is_after": "は次より後である:",
            "true": "真",
            "false": "偽"
          }
        },
        "search_placeholder": "検索...",
        "search_a11y_text": "データを検索",
        "sort": {
          "no_sorts_applied": "このビューに適用する並べ替えなし",
          "label": "並べ替え",
          "singular_label": "1列並べ替え済み",
          "plural_label": "{{numberOfFields}}列並べ替え済み",
          "add_field": "ソート対象のフィールドを追加",
          "sort_by": "並べ替え条件",
          "then_by": "次の条件",
          "rules": {
            "ascending": {
              "boolean": "昇順 (真 → 偽)",
              "number": "昇順 (1 → 9)",
              "text": "昇順 (A → Z)",
              "date": "昇順 (1 → 9)",
              "single_select": "昇順 (A → Z)"
            },
            "descending": {
              "boolean": "降順 (偽 → 真)",
              "number": "降順 (9 → 1)",
              "text": "降順 (Z → A)",
              "date": "降順 (9 → 1)",
              "single_select": "降順 (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "階層リンク",
        "aria_expand": "すべての階層リンク項目を表示します。"
      },
      "sideNavigation": {
        "aria_label": "スライドのナビゲーション",
        "trigger_aria_label": "ナビゲーションを開く"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=ja.js.map

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "zh": {
    "translation": {
      "timePicker": {
        "am": "上午",
        "custom": "自定义",
        "hours": "小时",
        "minutes": "分钟",
        "period": "期间",
        "pm": "下午"
      },
      "back": "返回",
      "remove": "移除",
      "moreInformation": "更多信息",
      "close": "关闭",
      "dataGrid": {
        "a11yTextMessage": "{{value}}。您在第 {{rowIndex}} 行，第 {{columnIndex}} 列。忽略以下信息："
      },
      "uploader": {
        "drop_files": "放下文件以上传",
        "drop_files_here_or": "在此放下文件以上传或",
        "choose_from_computer": "从您的电脑中选择",
        "choose_from_computer_a11y": "从您的电脑中选择文件",
        "cancel_upload": "取消上传",
        "restart_upload": "重新启动上传",
        "file_list": "文件列表",
        "errors": {
          "size": "文件必须小于 {{maxFileSize}}",
          "type": "文件必须是以下类型之一：{{- supportedTypes}}"
        },
        "status": {
          "idle": "空闲",
          "processing": "正在处理",
          "uploading": "上传中",
          "success": "成功",
          "cancel": "取消",
          "error": "错误"
        },
        "progress": {
          "cancelled": "已取消",
          "complete": "完成",
          "idle": "空闲",
          "uploading": "正在上传 {{progressWithUnits}} / {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "删除",
        "apply": "应用",
        "cancel": "取消",
        "confirm": "保存",
        "decline": "拒绝"
      },
      "datePicker": {
        "confirmation_format": "YYYY 年 M 月 D 日"
      },
      "calendar": {
        "header_format": "YYYY 年 M 月",
        "month": "月",
        "year": "年"
      },
      "daterange": {
        "last_7_days": "过去 7 天",
        "last_30_days": "过去 30 天",
        "this_month": "本月",
        "last_month": "上月",
        "start_date": "开始日期",
        "end_date": "结束日期"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} 在新选项卡中打开。"
      },
      "comment": {
        "delete": "删除评论"
      },
      "pagination": {
        "intro": "分页，当前在第 {{currentPage}} 页",
        "page": "页 {{pageNumber}}",
        "ellipsis": "更多页面",
        "prev": "上一页",
        "next": "下一页"
      },
      "formElement": {
        "optional": "（可选）",
        "required": "（必须）",
        "aria_info_circle": "信息"
      },
      "prevNextArrowButton": {
        "arrowup": "上",
        "arrowdown": "下",
        "escape": "Esc 键"
      },
      "collapsible": {
        "ariaText": "可折叠部分"
      },
      "sortable": {
        "aria_description": "可拖动项目。按空格键提起。",
        "aria_lift": "您已将一个项目提起到位 {{source}}。使用箭头键移动，使用空格键放下，使用 Esc 键取消。",
        "aria_moving": "您已将项目从位置{{source}移动到位置{{destination}。",
        "aria_moving_outside": "您当前不是在可拖放区域上拖动。",
        "aria_cancelled": "已取消移动。项目已返回到其{{source}}的起始位置。",
        "aria_dropped": "您已放下该项目。它已从位置{{source}移到{{destination}。",
        "aria_dropped_outside": "该项目不在列表上方时已被放下。项目已返回到其{{source}}的起始位置。",
        "aria_remove": "移除"
      },
      "progressAccordion": {
        "active": "活动的",
        "no_response": "无"
      },
      "collapsibleText": {
        "more": "显示更多",
        "less": "显示更少",
        "more_about": "显示关于{{topic}}的更多信息",
        "less_about": "显示关于{{topic}}的更少信息"
      },
      "listBox": {
        "trigger": {
          "placeholder": "选择…"
        },
        "filter": {
          "a11y_text": "筛选",
          "no_results_message": "您的搜索结果没有匹配任何选项。",
          "placeholder": "筛选…"
        }
      },
      "listBoxBrowser": {
        "explore": "探索更多选项",
        "selected": "选定选项",
        "selectOne": "选择一项或多项…"
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "全部隐藏",
          "show_all": "全部显示",
          "label": "排列",
          "singular_label": "隐藏 1 列",
          "plural_label": "隐藏 {{numberOfHiddenColumn}} 列",
          "search_placeholder": "筛选…"
        },
        "no_results": "没有结果",
        "filter": {
          "no_filters_applied": "没有过滤器应用于此视图",
          "label": "筛选",
          "singular_label": "已应用 1 个过滤器",
          "plural_label": "已应用 {{numberOfFilters}} 个过滤器",
          "add_filter": "添加过滤字段",
          "and": "和",
          "or": "或",
          "where": "如果",
          "rules": {
            "is": "是",
            "is_not": "不是",
            "contains": "包含",
            "does_not_contain": "不包含",
            "is_blank": "为空",
            "is_not_blank": "不为空",
            "equals": "等于",
            "not_equal_to": "不等于",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "是空的",
            "is_not_empty": "不是空的",
            "is_before": "早于",
            "is_after": "晚于",
            "true": "真",
            "false": "假"
          }
        },
        "search_placeholder": "搜索…",
        "search_a11y_text": "搜索数据",
        "sort": {
          "no_sorts_applied": "没有排序应用于此视图",
          "label": "排序",
          "singular_label": "已排序 1 列",
          "plural_label": "已排序 {{numberOfFields}} 列",
          "add_field": "添加排序字段",
          "sort_by": "排序依据",
          "then_by": "随之排序依据",
          "rules": {
            "ascending": {
              "boolean": "升序排序（真 → 假）",
              "number": "升序排序 (1 → 9)",
              "text": "升序排序 (A → Z)",
              "date": "升序排序 (1 → 9)",
              "single_select": "升序排序 (A → Z)"
            },
            "descending": {
              "boolean": "降序排序（假 → 真）",
              "number": "降序排序 (9 → 1)",
              "text": "降序排序 (Z → A)",
              "date": "降序排序 (9 → 1)",
              "single_select": "降序排序 (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "面包屑",
        "aria_expand": "显示所有面包屑项目。"
      },
      "sideNavigation": {
        "aria_label": "侧边导航",
        "trigger_aria_label": "打开导航"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=zh.js.map

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = L10n;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useI18n = __webpack_require__(174);

var _L10nContext = _interopRequireDefault(__webpack_require__(705));

var propTypes = {
  /** Sets the preferred language */
  locale: _propTypes["default"].string,
  locales: _propTypes["default"].object
  /* eslint-disable-line react/forbid-prop-types */
  ,

  /** Children of the L10n */
  children: _propTypes["default"].node.isRequired
};
var defaultProps = {
  locale: "en",
  locales: null
};

function L10n(props) {
  var value = _react["default"].useMemo(function () {
    return (0, _useI18n.getI18nObject)(props.locale, props.locales);
  }, [props.locale, props.locales]);

  return /*#__PURE__*/_react["default"].createElement(_L10nContext["default"].Provider, {
    value: value
  }, props.children);
}

L10n.propTypes = propTypes;
L10n.defaultProps = defaultProps;
L10n.displayName = "L10n";
//# sourceMappingURL=L10n.js.map

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_raw_button__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_raw_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__paprika_raw_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_tokens__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paprika_tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_ArrowRightB__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_ArrowRightB___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_ArrowRightB__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SkipButton_scss__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SkipButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SkipButton_scss__);








function SkipButton(_ref) {
  var mainContentSelector = _ref.mainContentSelector;
  var i18n = __WEBPACK_IMPORTED_MODULE_3__paprika_l10n_lib_useI18n___default()();

  function handleClickSkipToMain() {
    var mainElement = document.querySelector(mainContentSelector);
    mainElement.tabIndex = -1;
    mainElement.focus({
      preventScroll: true
    });
    window.scrollTo({
      top: mainElement.getBoundingClientRect().top + document.documentElement.scrollTop,
      behavior: 'smooth'
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__paprika_raw_button___default.a, {
    className: "sriracha-global-navigation__skip-main",
    onClick: handleClickSkipToMain
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "sriracha-global-navigation__skip-label"
  }, i18n.t('global_navigation.skip_button'), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_ArrowRightB___default.a, {
    className: "skip-main__icon",
    color: __WEBPACK_IMPORTED_MODULE_4__paprika_tokens___default.a.color.white,
    size: 14
  })));
}

SkipButton.propTypes = {
  mainContentSelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SkipButton);

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var sc = _interopRequireWildcard(__webpack_require__(1041));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** If the visual focus ring should be displayed with an inset style. */
  hasInsetFocusStyle: _propTypes["default"].bool,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  isActive: null,
  isDisabled: false,
  hasInsetFocusStyle: false,
  onClick: function onClick() {},
  role: "button",
  tabIndex: null
};

var isTriggerKey = function isTriggerKey(key) {
  return [" ", "Enter"].includes(key);
};

var RawButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      onClick = props.onClick,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "isActive", "isDisabled", "onClick", "tabIndex"]);

  var rawButtonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        rawButtonRef.current.focus();
      }
    };
  });

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);
    if (!canPropagate) event.stopPropagation();
    if (!isDisabled) onClick(event);
  };

  function handleBlur(event) {
    if (moreProps.onBlur) moreProps.onBlur(event);
    setHasForcedFocus(false);
  }

  var handleKeyDown = function handleKeyDown(event) {
    // Prevent scrolling the page with a spacerbar keypress
    // Prevent submitting forms in IE/Edge with and enter keypress
    if (isTriggerKey(event.key)) event.preventDefault();
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;
    if (shouldHandle && moreProps.onKeyDown) moreProps.onKeyDown(event);
  };

  var handleKeyUp = function handleKeyUp(event) {
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;

    if (!isDisabled && shouldHandle && isTriggerKey(event.key)) {
      onClick(event);
    }

    if (shouldHandle && moreProps.onKeyUp) moreProps.onKeyUp(event);
  };

  var bestTabIndex = isDisabled && tabIndex === null ? -1 : tabIndex || 0;
  return /*#__PURE__*/_react["default"].createElement(sc.RawButton, (0, _extends2["default"])({
    "aria-pressed": isActive,
    "data-pka-anchor": "raw-button",
    tabIndex: bestTabIndex,
    "aria-label": a11yText
  }, moreProps, {
    "aria-disabled": isDisabled,
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isDisabled,
    onBlur: handleBlur,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: rawButtonRef
  }), children);
});

RawButton.displayName = "RawButton";
RawButton.propTypes = propTypes;
RawButton.defaultProps = defaultProps;
var _default = RawButton;
exports["default"] = _default;
//# sourceMappingURL=RawButton.js.map

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RawButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var focusStyles = function focusStyles(isInset) {
  return (0, _styledComponents.css)(["&:focus{", "}[data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{box-shadow:none;outline:none;}"], _stylers["default"].focusRing(isInset));
};

var disabledStyles = (0, _styledComponents.css)(["cursor:not-allowed;&:focus{box-shadow:none;}"]);

var RawButton = _styledComponents["default"].span.withConfig({
  displayName: "RawButtonstyles__RawButton",
  componentId: "sc-1jqcbbw-0"
})(function (_ref) {
  var hasInsetFocusStyle = _ref.hasInsetFocusStyle,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["cursor:pointer;display:inline-block;", ";", ";"], isActive ? _stylers["default"].focusRing(hasInsetFocusStyle) : focusStyles(hasInsetFocusStyle), isDisabled && disabledStyles);
});

exports.RawButton = RawButton;
//# sourceMappingURL=RawButton.styles.js.map

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "AppSwitcher___StyledSvg",
  componentId: "sc-1l26x5x-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var AppSwitcher = function AppSwitcher(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M433.5 30c9.66 0 17.5 7.84 17.5 17.5v70c0 9.66-7.84 17.5-17.5 17.5h-70c-9.66 0-17.5-7.84-17.5-17.5v-70c0-9.66 7.84-17.5 17.5-17.5h70zm-158 0c9.66 0 17.5 7.84 17.5 17.5v70c0 9.66-7.84 17.5-17.5 17.5h-70c-9.66 0-17.5-7.84-17.5-17.5v-70c0-9.66 7.84-17.5 17.5-17.5h70zm158 157c9.66 0 17.5 7.84 17.5 17.5v70c0 9.66-7.84 17.5-17.5 17.5h-70c-9.66 0-17.5-7.84-17.5-17.5v-70c0-9.66 7.84-17.5 17.5-17.5h70zm-158 0c9.66 0 17.5 7.84 17.5 17.5v70c0 9.66-7.84 17.5-17.5 17.5h-70c-9.66 0-17.5-7.84-17.5-17.5v-70c0-9.66 7.84-17.5 17.5-17.5h70zm-157-157c9.66 0 17.5 7.84 17.5 17.5v70c0 9.66-7.84 17.5-17.5 17.5h-70c-9.66 0-17.5-7.84-17.5-17.5v-70C31 37.84 38.84 30 48.5 30h70zm0 157c9.66 0 17.5 7.84 17.5 17.5v70c0 9.66-7.84 17.5-17.5 17.5h-70c-9.66 0-17.5-7.84-17.5-17.5v-70c0-9.66 7.84-17.5 17.5-17.5h70zm315 158c9.66 0 17.5 7.84 17.5 17.5v70c0 9.66-7.84 17.5-17.5 17.5h-70c-9.66 0-17.5-7.84-17.5-17.5v-70c0-9.66 7.84-17.5 17.5-17.5h70zm-158 0c9.66 0 17.5 7.84 17.5 17.5v70c0 9.66-7.84 17.5-17.5 17.5h-70c-9.66 0-17.5-7.84-17.5-17.5v-70c0-9.66 7.84-17.5 17.5-17.5h70zm-157 0c9.66 0 17.5 7.84 17.5 17.5v70c0 9.66-7.84 17.5-17.5 17.5h-70c-9.66 0-17.5-7.84-17.5-17.5v-70c0-9.66 7.84-17.5 17.5-17.5h70z"
  }));
};

var _default = AppSwitcher;
exports["default"] = _default;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "HelpCircle___StyledSvg",
  componentId: "sc-1ahouck-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var HelpCircle = function HelpCircle(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M261 279.354V303h-42v-63h21c23.163 0 42-18.837 42-42 0-23.184-18.837-42-42-42s-42 18.816-42 42h-42c0-46.326 37.674-84 84-84s84 37.674 84 84c0 39.06-26.817 71.988-63 81.354m-21 91.896c-14.49 0-26.25-11.76-26.25-26.25s11.76-26.25 26.25-26.25 26.25 11.76 26.25 26.25-11.76 26.25-26.25 26.25M240 30C124.206 30 30 124.206 30 240c0 115.815 94.206 210 210 210s210-94.185 210-210c0-115.794-94.206-210-210-210"
  }));
};

var _default = HelpCircle;
exports["default"] = _default;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "AclLogo___StyledSvg",
  componentId: "sc-1m7o7w4-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var AclLogo = function AclLogo(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M324.34 310.924h-13.18s-12.342 0-12.342 12.76c0 14.466-10.199 31.051-32.321 31.051-19.79 0-31.476-10.702-33.003-34.81v.002c-13.255 11.34-23.716 21.928-32.911 30.952 9.966 26.133 32.312 39.586 65.914 39.586 29.34 0 71.023-15.736 71.023-66.353 0-9.358-5.095-13.188-13.18-13.188zm112.503 43.811h-8.503c-27.218 0-29.358-16.16-29.358-32.327V102.072c0-7.232-5.526-12.336-11.906-12.336h-15.312c-6.38 0-11.484 5.104-11.484 12.336v220.336c0 42.11 22.122 68.057 68.06 68.057h8.503c7.23 0 12.343-5.528 12.343-11.909V366.22c0-6.38-5.113-11.485-12.343-11.485zm-203.535-99.169v.061-17.521c0-17.865 13.189-30.202 30.626-30.202 19.57 0 28.503 9.783 28.503 22.123 0 7.654 5.104 12.33 11.485 12.33h15.742c6.38 0 11.473-4.676 11.473-12.33 0-35.309-28.492-57.853-67.203-57.853-36.579 0-69.328 24.246-69.328 75.29v44.222c15.428-7.899 28.52-14.186 38.702-18.307v-17.813zm-99.937 58.763c0 19.563-15.32 40.406-37.434 40.406-16.17 0-27.217-13.61-27.217-27.223 0-7.657 2.963-19.994 19.982-23.815l44.67-10.638v21.27zm-30.626-142.498c-38.71 0-67.202 22.544-67.202 57.85 0 7.657 5.095 12.333 11.476 12.333h15.739c6.38 0 11.484-4.676 11.484-12.333 0-12.337 8.934-22.12 28.503-22.12 17.438 0 30.626 12.336 30.626 30.201v17.865L82.75 267.961C42.76 277.744 30 296.039 30 329.213c0 25.534 15.425 46.863 37.085 56.195.887.381 1.783.724 2.684 1.044 4.427.782 13.535 1 27.017-5.377 20.596-10.784 36.565-42.67 64.202-66.28l5.33-4.738c1.137-.928 3.577-2.815 5.755-4.496v-58.44c0-51.045-32.749-75.29-69.328-75.29z"
  }), _react["default"].createElement("path", {
    d: "M134.04 358.644c45.903-38.493 110.494-80.996 225.42-95.9 3.062-.398 8.484-1.15 8.484-1.15l-.304 10.649s-57.357 15.774-79.25 28.38c-81.91 47.156-81.58 88.985-119.152 88.985H91.043c-12.16 0-22.088-3.43-22.088-3.43s19.18 10.956 65.085-27.534z"
  })));
};

var _default = AclLogo;
exports["default"] = _default;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "UserCircle___StyledSvg",
  componentId: "sc-7w9bnt-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var UserCircle = function UserCircle(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M240 30C123.542 30 30 123.542 30 240s93.542 210 210 210 210-93.542 210-210S356.458 30 240 30zm5.723 383.722c-72.542 1.904-131.723-34.36-154.64-80.18 13.362-11.458 43.904-21 70.64-32.458 32.458-13.362 40.096-17.18 40.096-17.18V253.36s-11.458-9.542-15.277-38.18c-7.639 1.903-15.278-11.459-15.278-17.181 0-5.723 1.904-24.82 9.542-22.903-1.903-13.361-3.82-24.82-3.82-32.458 1.904-24.82 26.723-49.639 63-49.639 36.278 0 61.098 24.82 63 49.639 0 5.722 0 19.097-1.902 32.458 9.542-1.903 9.542 17.18 9.542 22.903 0 7.639-7.64 21-15.278 17.18-3.82 28.64-15.277 38.181-15.277 38.181v30.542s11.458 5.723 43.903 19.097c26.722 11.458 53.458 22.903 66.82 32.458-5.723 11.458-49.64 80.18-145.098 78.278l.027-.014z"
  }));
};

var _default = UserCircle;
exports["default"] = _default;

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppSwitcherSidePanel_AppSwitcherSidePanel__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CurrentApp_CurrentApp__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Helper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperWithPendo_HelperWithPendo__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Logo_Logo__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__User__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SignIn__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AppSwitcherSidePanel_OrgSwitcher_OrgSwitcher__ = __webpack_require__(728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AppSwitcherSidePanel_AppSwitcherSidePanel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CurrentApp_CurrentApp__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Helper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__HelperWithPendo_HelperWithPendo__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Logo_Logo__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__User__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__SignIn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__AppSwitcherSidePanel_OrgSwitcher_OrgSwitcher__["a"]; });










/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__paprika_panel__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__paprika_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__paprika_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigationButton__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigationIcon__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AppSwitcherTitle_AppSwitcherTitle__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrganizationSwitcher_OrganizationSwitcher__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Sections_Section_AppRow__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Sections_Sections__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_resourceData__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__organizationShape__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__availableAppShape__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AppSwitcherSidePanel_scss__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AppSwitcherSidePanel_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AppSwitcherSidePanel_scss__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















function AppSwitcherSidePanel(_ref) {
  var launchpadUrl = _ref.launchpadUrl,
      productTitle = _ref.productTitle,
      organizations = _ref.organizations,
      apps = _ref.apps,
      initialOrganizationId = _ref.initialOrganizationId,
      resourceLinks = _ref.resourceLinks,
      zIndex = _ref.zIndex;
  var i18n = __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default()();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      _React$useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(initialOrganizationId),
      _React$useState4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_React$useState3, 2),
      activeOrganizationId = _React$useState4[0],
      setActiveOrganizationId = _React$useState4[1];

  var activeOrganization = organizations.find(function (organization) {
    return organization.id === activeOrganizationId;
  });

  function handleToggleSidePanel() {
    setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
    setActiveOrganizationId(initialOrganizationId);
  }

  function renderResourceLinks() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: "app-switcher-section resource-section",
      "data-testid": "resource-section"
    }, Object.keys(resourceLinks).map(function (resourceKey) {
      var foundResource = __WEBPACK_IMPORTED_MODULE_13__data_resourceData__["a" /* default */].find(function (data) {
        return data.key === resourceKey;
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Sections_Section_AppRow__["a" /* default */], {
        app: _objectSpread({
          link: activeOrganization && activeOrganization[resourceKey] || resourceLinks[resourceKey],
          title: i18n.t("global_navigation.apps.".concat(resourceKey))
        }, foundResource),
        shouldOpenNewTab: ['academy', 'community'].indexOf(resourceKey) !== -1,
        key: foundResource.key
      });
    }));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "navigation-app-switcher"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NavigationButton__["a" /* default */], {
    ariaLabel: i18n.t('global_navigation.navigation_items.app_switcher'),
    isActive: isOpen,
    onClick: handleToggleSidePanel,
    zIndex: zIndex
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NavigationIcon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* icons */].appSwitcher
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paprika_panel___default.a, {
    a11yText: i18n.t('global_navigation.navigation_items.app_switcher'),
    className: "navigation-app-switcher__side-panel",
    isOpen: isOpen,
    onClose: handleToggleSidePanel,
    isSlideFromLeft: true,
    width: "350px",
    zIndex: zIndex
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paprika_panel___default.a.FocusLock, {
    className: "sriracha"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paprika_panel___default.a.Overlay, {
    onClose: handleToggleSidePanel
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paprika_panel___default.a.Header, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AppSwitcherTitle_AppSwitcherTitle__["a" /* default */], {
    launchpadUrl: launchpadUrl
  }, productTitle)), activeOrganization ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__OrganizationSwitcher_OrganizationSwitcher__["a" /* default */], {
    organizations: organizations,
    activeOrganizationId: activeOrganizationId
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sections_Sections__["a" /* default */], {
    apps: apps
  }), renderResourceLinks())) : renderResourceLinks()));
}

AppSwitcherSidePanel.componentType = __WEBPACK_IMPORTED_MODULE_12__constants__["d" /* navigationItems */].appSwitcher;
AppSwitcherSidePanel.propTypes = {
  launchpadUrl: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  productTitle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  organizations: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_14__organizationShape__["a" /* default */])).isRequired,
  apps: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_15__availableAppShape__["a" /* default */])).isRequired,
  initialOrganizationId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  resourceLinks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.exact({
    launchpad: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    academy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    community: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
  }).isRequired,
  zIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number])
};
AppSwitcherSidePanel.defaultProps = {
  productTitle: '',
  initialOrganizationId: null,
  zIndex: null
};
/* harmony default export */ __webpack_exports__["a"] = (AppSwitcherSidePanel);

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Panel["default"];
  }
});

var _Panel = _interopRequireDefault(__webpack_require__(1051));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Panel;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(109);

var _LockBodyScroll = _interopRequireDefault(__webpack_require__(1052));

var _Portal = _interopRequireDefault(__webpack_require__(1053));

var _Content = _interopRequireDefault(__webpack_require__(1054));

var _Dialog = _interopRequireDefault(__webpack_require__(1057));

var _Footer = _interopRequireDefault(__webpack_require__(1060));

var _Header = _interopRequireDefault(__webpack_require__(1063));

var _Overlay = _interopRequireDefault(__webpack_require__(718));

var _Trigger = _interopRequireDefault(__webpack_require__(1081));

var _Group = _interopRequireDefault(__webpack_require__(1083));

var _FocusLock = _interopRequireDefault(__webpack_require__(1086));

var types = _interopRequireWildcard(__webpack_require__(555));

var _helpers2 = __webpack_require__(719);

var _hooks = __webpack_require__(1122);

var PUSH_REF_TRANSITION_STYLE = "margin-right 0.2s ease";
var PUSH_REF_TRANSITION_DELAY_STYLE = "0.1s";

function Panel(props) {
  // Props
  var a11yText = props.a11yText,
      getPushContentElement = props.getPushContentElement,
      groupOffsetY = props.groupOffsetY,
      isCompact = props.isCompact,
      isOpen = props.isOpen,
      isInline = props.isInline,
      isSlideFromLeft = props.isSlideFromLeft,
      kind = props.kind,
      offsetY = props.offsetY,
      onAfterClose = props.onAfterClose,
      onAfterOpen = props.onAfterOpen,
      onClose = props.onClose,
      width = props.width,
      zIndex = props.zIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "getPushContentElement", "groupOffsetY", "isCompact", "isOpen", "isInline", "isSlideFromLeft", "kind", "offsetY", "onAfterClose", "onAfterOpen", "onClose", "width", "zIndex"]); // Hooks

  var _React$useState = _react["default"].useState(isOpen),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isVisible = _React$useState2[0],
      setIsVisible = _React$useState2[1];

  var offsetScroll = (0, _hooks.useOffsetScroll)(offsetY); // Refs

  var refTrigger = _react["default"].useRef(null);

  var refPanelContent = _react["default"].useRef(null);

  var refHeader = _react["default"].useRef(null); // Extracts


  var _extractChildren = (0, _helpers2.extractChildren)(props.children, ["Panel.FocusLock", "Panel.Footer", "Panel.Header", "Panel.Overlay", "Panel.Trigger"]),
      focusLockExtracted = _extractChildren["Panel.FocusLock"],
      footerExtracted = _extractChildren["Panel.Footer"],
      headerExtracted = _extractChildren["Panel.Header"],
      overlayExtracted = _extractChildren["Panel.Overlay"],
      triggerExtracted = _extractChildren["Panel.Trigger"],
      children = _extractChildren.children;

  var handleAnimationEnd = function handleAnimationEnd() {
    if (!isOpen) {
      setIsVisible(false);
      onAfterClose();

      if (triggerExtracted) {
        refTrigger.current.focus();
      }

      return;
    }

    onAfterOpen();
  };

  _react["default"].useEffect(function () {
    if (isOpen) {
      setIsVisible(true);
    }
  }, [isOpen]);

  _react["default"].useLayoutEffect(function () {
    if (getPushContentElement === null) return;
    var pushContentRefStyle = getPushContentElement().style;
    pushContentRefStyle.transition = PUSH_REF_TRANSITION_STYLE;
    pushContentRefStyle.transitionDelay = PUSH_REF_TRANSITION_DELAY_STYLE;

    if (isOpen) {
      pushContentRefStyle.marginRight = width;
    } else {
      pushContentRefStyle.transitionDelay = "0s";
      pushContentRefStyle.marginRight = "0";
    }

    return function () {
      pushContentRefStyle.transition = PUSH_REF_TRANSITION_STYLE;
      pushContentRefStyle.transitionDelay = PUSH_REF_TRANSITION_DELAY_STYLE;
    };
  }, [isOpen, getPushContentElement, width]);

  var focusLockProps = focusLockExtracted ? focusLockExtracted.props : {};

  function handleEscKey(event) {
    if (event.key === "Escape") {
      event.stopPropagation();
      onClose();
    }
  }

  var ariaLabel = a11yText || (headerExtracted ? headerExtracted.props.children : null);
  var sidePanel = null;

  if (isVisible) {
    var dialog = /*#__PURE__*/_react["default"].createElement(_Dialog["default"], (0, _extends2["default"])({
      a11yText: ariaLabel,
      "data-pka-anchor": "panel",
      footer: footerExtracted,
      getPushContentElement: getPushContentElement,
      groupOffsetY: groupOffsetY,
      header: headerExtracted,
      isCompact: isCompact,
      isInline: isInline,
      isOpen: isOpen,
      isSlideFromLeft: isSlideFromLeft,
      kind: kind,
      offsetY: offsetScroll,
      onAnimationEnd: handleAnimationEnd,
      onClose: onClose,
      onKeyDown: handleEscKey,
      refHeader: refHeader,
      refPanelContent: refPanelContent,
      width: width,
      zIndex: zIndex
    }, moreProps), children);

    if (isInline) {
      sidePanel = dialog;
    } else {
      sidePanel = /*#__PURE__*/_react["default"].createElement(_Portal["default"], {
        active: !isInline
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, overlayExtracted ? /*#__PURE__*/_react["default"].cloneElement(overlayExtracted, {
        onClose: onClose,
        zIndex: zIndex
      }) : null, /*#__PURE__*/_react["default"].createElement(_FocusLock["default"], (0, _extends2["default"])({
        as: "div"
      }, focusLockProps), dialog)));
    }
  }

  var trigger = triggerExtracted ? /*#__PURE__*/_react["default"].cloneElement(triggerExtracted, {
    ref: refTrigger
  }) : null;
  var shouldDisableBodyOverflow = (overlayExtracted || isInline) && isOpen;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, shouldDisableBodyOverflow && /*#__PURE__*/_react["default"].createElement(_LockBodyScroll["default"], null), trigger, sidePanel);
}

Panel.types = {
  kind: types.sidePanelKinds
};
var propTypes = {
  /* Description of the Panel dialog for assistive technology */
  a11yText: _propTypes["default"].string,

  /** The content for the Panel. */
  children: _propTypes["default"].node.isRequired,

  /** Function that provides the container DOM element to be pushed. */
  getPushContentElement: _propTypes["default"].func,

  /** Y offset that is passed down from <Panel.Group> */
  groupOffsetY: _propTypes["default"].number,

  /** Control the compactness of the side panel */
  isCompact: _propTypes["default"].bool,

  /** Render the panel inline */
  isInline: _propTypes["default"].bool,

  /** Control the visibility of the side panel. This prop makes the side panel appear */
  isOpen: _propTypes["default"].bool.isRequired,

  /** Control if the side panel slides from the left */
  isSlideFromLeft: _propTypes["default"].bool,

  /** Modify the look of the Panel */
  kind: _propTypes["default"].oneOf([Panel.types.kind.DEFAULT, Panel.types.kind.CHILD, Panel.types.kind.PRIMARY]),

  /** Control y offset of the panel */
  offsetY: _propTypes["default"].number,

  /** Callback once the panel has been closed event */
  onAfterClose: _propTypes["default"].func,

  /** Callback once the panel has been opened event */
  onAfterOpen: _propTypes["default"].func,

  /** Callback triggered when the side panel needs to be close */
  onClose: _propTypes["default"].func,

  /** The width of the open panel. */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Control the z position of the panel */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  getPushContentElement: null,
  groupOffsetY: 0,
  isCompact: false,
  isInline: false,
  isSlideFromLeft: false,
  kind: Panel.types.kind.DEFAULT,
  offsetY: 0,
  onAfterClose: function onAfterClose() {},
  onAfterOpen: function onAfterOpen() {},
  onClose: null,
  width: "33%",
  zIndex: (0, _helpers.zValue)(7)
};
Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;
Panel.displayName = "Panel";
Panel.Content = _Content["default"];
Panel.FocusLock = _FocusLock["default"];
Panel.Footer = _Footer["default"];
Panel.Group = _Group["default"];
Panel.Header = _Header["default"];
Panel.Overlay = _Overlay["default"];
Panel.Trigger = _Trigger["default"];
//# sourceMappingURL=Panel.js.map

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var LockBodyScroll = function LockBodyScroll() {
  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("style", {
    type: "text/css"
  }, "body { overflow: hidden !important; }"), document.head);
};

var _default = LockBodyScroll;
exports["default"] = _default;
//# sourceMappingURL=LockBodyScroll.js.map

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  children: _propTypes["default"].node,
  active: _propTypes["default"].bool,
  container: _propTypes["default"].instanceOf(Element)
};
var defaultProps = {
  children: null,
  active: true,
  container: null
};

function Portal(props) {
  var active = props.active,
      children = props.children,
      container = props.container;
  return active ? /*#__PURE__*/_reactDom["default"].createPortal(children, container || document.body) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
}

Portal.propTypes = propTypes;
Portal.defaultProps = defaultProps;
var _default = Portal;
exports["default"] = _default;
//# sourceMappingURL=Portal.js.map

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Content["default"];
  }
});

var _Content = _interopRequireDefault(__webpack_require__(1055));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var sc = _interopRequireWildcard(__webpack_require__(1056));

var propTypes = {
  /** Body content of the Content */
  children: _propTypes["default"].node
};
var defaultProps = {
  children: null
};

var Content = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement(sc.Content, (0, _extends2["default"])({
    "data-pka-anchor": "panel.content",
    ref: ref
  }, props), children);
});

Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
Content.displayName = "Panel.Content";
var _default = Content;
exports["default"] = _default;
//# sourceMappingURL=Content.js.map

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Content = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var Content = _styledComponents["default"].div.withConfig({
  displayName: "Contentstyles__Content",
  componentId: "sc-1i4grbm-0"
})(["padding:", ";"], _stylers["default"].spacer(3));

exports.Content = Content;
//# sourceMappingURL=Content.styles.js.map

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Dialog["default"];
  }
});

var _Dialog = _interopRequireDefault(__webpack_require__(1058));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var types = _interopRequireWildcard(__webpack_require__(555));

var sc = _interopRequireWildcard(__webpack_require__(1059));

function Dialog(props) {
  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isAnimating = _React$useState2[0],
      setIsAnimating = _React$useState2[1];

  var refPanel = _react["default"].useRef(null);

  var a11yText = props.a11yText,
      children = props.children,
      footer = props.footer,
      getPushContentElement = props.getPushContentElement,
      groupOffsetY = props.groupOffsetY,
      onAnimationEnd = props.onAnimationEnd,
      header = props.header,
      kind = props.kind,
      isCompact = props.isCompact,
      isInline = props.isInline,
      offsetY = props.offsetY,
      onClose = props.onClose,
      refHeader = props.refHeader,
      refPanelContent = props.refPanelContent,
      width = props.width,
      isOpen = props.isOpen,
      isSlideFromLeft = props.isSlideFromLeft,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "footer", "getPushContentElement", "groupOffsetY", "onAnimationEnd", "header", "kind", "isCompact", "isInline", "offsetY", "onClose", "refHeader", "refPanelContent", "width", "isOpen", "isSlideFromLeft"]);
  var isFooterSticky = footer && footer.props.isSticky;
  var isHeaderSticky = header && header.props.isSticky;

  var dialogMain = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(sc.DialogContent, {
    "data-pka-anchor": "panel.content",
    hasPushedElement: !!getPushContentElement,
    isCompact: isCompact,
    isOpen: isOpen,
    kind: kind,
    ref: refPanelContent,
    role: "region",
    tabIndex: "0"
  }, children));

  _react["default"].useEffect(function () {
    setIsAnimating(true);
  }, [isOpen]);

  var dialogFooter = footer ? /*#__PURE__*/_react["default"].cloneElement(footer, {
    refPanel: refPanel,
    isCompact: isCompact
  }) : null;
  var dialogHeader = header ? /*#__PURE__*/_react["default"].cloneElement(header, {
    ref: refHeader,
    isCompact: isCompact,
    onClose: onClose,
    getPushContentElement: getPushContentElement
  }) : null;

  var handleAnimationEnd = function handleAnimationEnd() {
    setIsAnimating(false);
    onAnimationEnd();
  };

  var renderDialogContent = function renderDialogContent() {
    return isFooterSticky || isHeaderSticky ? /*#__PURE__*/_react["default"].createElement(sc.Main, null, isHeaderSticky && dialogHeader, /*#__PURE__*/_react["default"].createElement(sc.DialogMain, null, !isHeaderSticky && dialogHeader, dialogMain, !isFooterSticky && dialogFooter), isFooterSticky && dialogFooter) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, dialogHeader, dialogMain, dialogFooter);
  };

  return /*#__PURE__*/_react["default"].createElement(sc.Dialog, (0, _extends2["default"])({
    "aria-modal": isInline ? null : "true",
    "aria-label": a11yText,
    hasPushedElement: !!getPushContentElement,
    groupOffsetY: groupOffsetY,
    kind: kind,
    isCompact: isCompact,
    isInline: isInline,
    isOpen: isOpen,
    offsetY: offsetY,
    isAnimating: isAnimating,
    onAnimationEnd: handleAnimationEnd,
    ref: refPanel,
    role: "dialog",
    tabIndex: "-1",
    isSlideFromLeft: isSlideFromLeft,
    width: width
  }, moreProps), renderDialogContent());
}

Dialog.types = {
  kind: {
    DEFAULT: types.sidePanelKinds.DEFAULT,
    PRIMARY: types.sidePanelKinds.PRIMARY
  }
};
var propTypes = {
  a11yText: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  footer: _propTypes["default"].node,
  getPushContentElement: _propTypes["default"].func,
  groupOffsetY: _propTypes["default"].number,
  header: _propTypes["default"].node,
  kind: _propTypes["default"].oneOf([Dialog.types.kind.DEFAULT, Dialog.types.kind.CHILD]),
  isCompact: _propTypes["default"].bool,
  isInline: _propTypes["default"].bool,
  offsetY: _propTypes["default"].number,
  onAnimationEnd: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func,
  refHeader: _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  }).isRequired,
  refPanelContent: _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  }).isRequired,
  isSlideFromLeft: _propTypes["default"].bool,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  isOpen: _propTypes["default"].bool.isRequired
};
var defaultProps = {
  a11yText: null,
  footer: null,
  getPushContentElement: function getPushContentElement() {},
  groupOffsetY: 0,
  header: null,
  kind: Dialog.types.kind.DEFAULT,
  isCompact: false,
  isInline: false,
  offsetY: 0,
  onClose: function onClose() {},
  isSlideFromLeft: false
};
Dialog.propTypes = propTypes;
Dialog.defaultProps = defaultProps;
var _default = Dialog;
exports["default"] = _default;
//# sourceMappingURL=Dialog.js.map

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.DialogMain = exports.Main = exports.DialogContent = exports.Dialog = void 0;

var _isNan = _interopRequireDefault(__webpack_require__(181));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var childPanelCss = function childPanelCss(_ref) {
  var isCompact = _ref.isCompact,
      groupOffsetY = _ref.groupOffsetY,
      offsetY = _ref.offsetY;
  var totalOffset = isCompact ? 48 : 64;
  var childBottomOffsetY = totalOffset + groupOffsetY + offsetY;
  return (0, _styledComponents.css)(["border-bottom-left-radius:", ";border-top-left-radius:", ";height:calc(100% - ", "px);margin-top:", ";"], _tokens["default"].spaceSm, _tokens["default"].spaceSm, childBottomOffsetY, isCompact ? "".concat(_stylers["default"].spacer(3)) : "".concat(_stylers["default"].spacer(4)));
};

function slideIn(slideInTransform, slideOutTransform) {
  return (0, _styledComponents.keyframes)(["from{transform:", ";}to{transform:", ";}"], slideOutTransform, slideInTransform);
}

function slideOut(slideInTransform, slideOutTransform) {
  return (0, _styledComponents.keyframes)(["from{transform:", ";}to{transform:", ";}"], slideInTransform, slideOutTransform);
}

var compactStyles = (0, _styledComponents.css)(["padding:", ";"], _stylers["default"].spacer(2));

var Dialog = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__Dialog",
  componentId: "aynya2-0"
})(function (_ref2) {
  var width = _ref2.width,
      isAnimating = _ref2.isAnimating,
      isSlideFromLeft = _ref2.isSlideFromLeft,
      isOpen = _ref2.isOpen,
      hasPushedElement = _ref2.hasPushedElement,
      kind = _ref2.kind,
      offsetY = _ref2.offsetY,
      zIndex = _ref2.zIndex,
      isInline = _ref2.isInline;
  var widthAsPx = (0, _isNan["default"])(Number(width)) ? width : "".concat(width, "px");
  var slideOutTransform = isSlideFromLeft ? "translateX(-100%)" : "translateX(100%)";
  var slideInTransform = "translateX(0)";
  var animationStyle = isAnimating ? (0, _styledComponents.css)(["animation:", " 0.4s forwards;"], isOpen ? slideIn(slideInTransform, slideOutTransform) : slideOut(slideInTransform, slideOutTransform)) : "";
  var childPanel = kind === "child" ? childPanelCss : "";
  var boxShadow = hasPushedElement ? "none" : _tokens["default"].modal.shadow;
  return (0, _styledComponents.css)(["", ";background:", ";border:0;box-shadow:", ";box-sizing:border-box;", " display:flex;flex-direction:column;height:100%;", " ", " margin:0;overflow:auto;padding:0;", " right:0;top:0;top:", "px;width:", ";z-index:", ";&:focus{outline:0;}"], animationStyle, _tokens["default"].color.white, boxShadow, childPanel, offsetY ? "height: calc(100% - ".concat(offsetY, "px);") : "", isSlideFromLeft ? "left: 0;" : "right: 0;", isInline ? "position: relative;" : "position: fixed;", offsetY, widthAsPx, zIndex);
});

exports.Dialog = Dialog;

var DialogContent = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__DialogContent",
  componentId: "aynya2-1"
})(function (_ref3) {
  var hasPushedElement = _ref3.hasPushedElement,
      isSlideFromLeft = _ref3.isSlideFromLeft,
      isCompact = _ref3.isCompact,
      kind = _ref3.kind;
  return (0, _styledComponents.css)(["flex-grow:1;margin:0;padding:0;&:focus{", ";}", " ", " ", ";"], _stylers["default"].focusRing.subtle(true), hasPushedElement && isSlideFromLeft ? "border-right: 1px solid ".concat(_tokens["default"].border.color) : "", hasPushedElement && !isSlideFromLeft ? "border-left: 1px solid ".concat(_tokens["default"].border.color) : "", isCompact || kind === "child" ? compactStyles : "");
});

exports.DialogContent = DialogContent;

var Main = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__Main",
  componentId: "aynya2-2"
})(["display:flex;flex-direction:column;height:100%;position:relative;width:100%;"]);

exports.Main = Main;

var DialogMain = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__DialogMain",
  componentId: "aynya2-3"
})(["flex-grow:1;overflow-y:auto;"]);

exports.DialogMain = DialogMain;
//# sourceMappingURL=Dialog.styles.js.map

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Footer["default"];
  }
});

var _Footer = _interopRequireDefault(__webpack_require__(1061));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Footer;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var sc = _interopRequireWildcard(__webpack_require__(1062));

var propTypes = {
  children: _propTypes["default"].node.isRequired,
  height: _propTypes["default"].number,
  isSticky: _propTypes["default"].bool
};
var defaultProps = {
  height: 72,
  isSticky: false
};

function Footer(props) {
  var children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children"]);
  return /*#__PURE__*/_react["default"].createElement(sc.Footer, (0, _extends2["default"])({
    "data-pka-anchor": "panel.footer"
  }, moreProps), children);
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;
Footer.displayName = "Panel.Footer";
//# sourceMappingURL=Footer.js.map

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Footer = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _tokens = _interopRequireDefault(__webpack_require__(332));

var compactStyles = (0, _styledComponents.css)(["padding:", ";"], _stylers["default"].spacer(2));

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyles__Footer",
  componentId: "sc-1ap4cog-0"
})(function (_ref) {
  var height = _ref.height,
      isCompact = _ref.isCompact;
  return (0, _styledComponents.css)(["align-items:center;background:", ";box-sizing:border-box;display:flex;flex-shrink:0;height:", ";padding:", " ", ";position:relative;transition:opacity 0.3s ease-in;width:100%;", ""], _tokens["default"].color.blackLighten80, height ? "".concat(height, "px") : _stylers["default"].spacer(9), _stylers["default"].spacer(2), _stylers["default"].spacer(3), isCompact ? compactStyles : "");
});

exports.Footer = Footer;
//# sourceMappingURL=Footer.styles.js.map

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Header["default"];
  }
});

var _Header = _interopRequireDefault(__webpack_require__(1064));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _customPropTypes = __webpack_require__(634);

var _button = _interopRequireDefault(__webpack_require__(635));

var _heading = _interopRequireDefault(__webpack_require__(1075));

var types = _interopRequireWildcard(__webpack_require__(555));

var sc = _interopRequireWildcard(__webpack_require__(1078));

var Header = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
      hasCloseButton = props.hasCloseButton,
      getPushContentElement = props.getPushContentElement,
      isCompact = props.isCompact,
      kind = props.kind,
      level = props.level,
      onClose = props.onClose,
      refHeading = props.refHeading,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "hasCloseButton", "getPushContentElement", "isCompact", "kind", "level", "onClose", "refHeading"]);
  return /*#__PURE__*/_react["default"].createElement(sc.Header, (0, _extends2["default"])({
    "data-pka-anchor": "panel.header",
    hasPushedElement: !!getPushContentElement,
    isCompact: isCompact,
    kind: kind,
    ref: ref
  }, moreProps), /*#__PURE__*/_react["default"].createElement(_heading["default"], {
    level: level,
    displayLevel: isCompact ? 4 : 3,
    ref: refHeading
  }, children), hasCloseButton && /*#__PURE__*/_react["default"].createElement(_button["default"].Close, {
    "data-pka-anchor": "panel.header.close",
    isSemantic: false,
    onClick: onClose,
    size: isCompact ? types.SMALL : types.MEDIUM,
    isDark: kind === types.sidePanelKinds.PRIMARY
  }));
});

Header.types = {
  kind: types.sidePanelKinds
};
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  getPushContentElement: _propTypes["default"].func,
  hasCloseButton: _propTypes["default"].bool,
  isCompact: _propTypes["default"].bool,
  isHeaderSticky: _propTypes["default"].bool,
  kind: _propTypes["default"].oneOf([Header.types.kind.DEFAULT, Header.types.kind.PRIMARY]),
  level: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),
  onClose: _propTypes["default"].func,
  refHeading: (0, _customPropTypes.RefOf)()
};
var defaultProps = {
  hasCloseButton: true,
  getPushContentElement: function getPushContentElement() {},
  kind: Header.types.kind.DEFAULT,
  isHeaderSticky: false,
  level: 2,
  isCompact: false,
  onClose: function onClose() {},
  refHeading: null
};
Header.displayName = "Panel.Header";
Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
var _default = Header;
exports["default"] = _default;
//# sourceMappingURL=Header.js.map

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var sc = _interopRequireWildcard(__webpack_require__(1066));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** If the visual focus ring should be displayed with an inset style. */
  hasInsetFocusStyle: _propTypes["default"].bool,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  isActive: null,
  isDisabled: false,
  hasInsetFocusStyle: false,
  onClick: function onClick() {},
  role: "button",
  tabIndex: null
};

var isTriggerKey = function isTriggerKey(key) {
  return [" ", "Enter"].includes(key);
};

var RawButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      onClick = props.onClick,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "isActive", "isDisabled", "onClick", "tabIndex"]);

  var rawButtonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        rawButtonRef.current.focus();
      }
    };
  });

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);
    if (!canPropagate) event.stopPropagation();
    if (!isDisabled) onClick(event);
  };

  function handleBlur(event) {
    if (moreProps.onBlur) moreProps.onBlur(event);
    setHasForcedFocus(false);
  }

  var handleKeyDown = function handleKeyDown(event) {
    // Prevent scrolling the page with a spacerbar keypress
    // Prevent submitting forms in IE/Edge with and enter keypress
    if (isTriggerKey(event.key)) event.preventDefault();
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;
    if (shouldHandle && moreProps.onKeyDown) moreProps.onKeyDown(event);
  };

  var handleKeyUp = function handleKeyUp(event) {
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;

    if (!isDisabled && shouldHandle && isTriggerKey(event.key)) {
      onClick(event);
    }

    if (shouldHandle && moreProps.onKeyUp) moreProps.onKeyUp(event);
  };

  var bestTabIndex = isDisabled && tabIndex === null ? -1 : tabIndex || 0;
  return /*#__PURE__*/_react["default"].createElement(sc.RawButton, (0, _extends2["default"])({
    "aria-pressed": isActive,
    "data-pka-anchor": "raw-button",
    tabIndex: bestTabIndex,
    "aria-label": a11yText
  }, moreProps, {
    "aria-disabled": isDisabled,
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isDisabled,
    onBlur: handleBlur,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: rawButtonRef
  }), children);
});

RawButton.displayName = "RawButton";
RawButton.propTypes = propTypes;
RawButton.defaultProps = defaultProps;
var _default = RawButton;
exports["default"] = _default;
//# sourceMappingURL=RawButton.js.map

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RawButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var focusStyles = function focusStyles(isInset) {
  return (0, _styledComponents.css)(["&:focus{", "}[data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{box-shadow:none;outline:none;}"], _stylers["default"].focusRing(isInset));
};

var disabledStyles = (0, _styledComponents.css)(["cursor:not-allowed;&:focus{box-shadow:none;}"]);

var RawButton = _styledComponents["default"].span.withConfig({
  displayName: "RawButtonstyles__RawButton",
  componentId: "sc-1jqcbbw-0"
})(function (_ref) {
  var hasInsetFocusStyle = _ref.hasInsetFocusStyle,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["cursor:pointer;display:inline-block;", ";", ";"], isActive ? _stylers["default"].focusRing(hasInsetFocusStyle) : focusStyles(hasInsetFocusStyle), isDisabled && disabledStyles);
});

exports.RawButton = RawButton;
//# sourceMappingURL=RawButton.styles.js.map

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Close["default"];
  }
});

var _Close = _interopRequireDefault(__webpack_require__(1068));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Times = _interopRequireDefault(__webpack_require__(362));

var constants = _interopRequireWildcard(__webpack_require__(40));

var types = _interopRequireWildcard(__webpack_require__(557));

var sc = _interopRequireWildcard(__webpack_require__(1069));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If the close button will be rendered on a dark background and will use inverted colours. */
  isDark: _propTypes["default"].bool
};
var defaultProps = {
  a11yText: null,
  isDark: false
};

var Close = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    a11yText: props.a11yText || "close",
    // TODO: use L10n
    isDark: props.isDark,
    kind: types.MINOR
  };
  return /*#__PURE__*/_react["default"].createElement(sc.CloseButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_Times["default"], null));
});

Close.types = {
  kind: constants.kind
};
Close.displayName = "Button.Close";
Close.propTypes = propTypes;
Close.defaultProps = defaultProps;
var _default = Close;
exports["default"] = _default;
//# sourceMappingURL=Close.js.map

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CloseButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Icon = _interopRequireDefault(__webpack_require__(717));

var darkStyles = (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;&:hover{background-color:", ";[data-pka-anchor=\"button.icon\"]{color:", ";}}&:active{background-color:", ";transition:none;[data-pka-anchor=\"button.icon\"]{color:", ";transition:none;}}[data-pka-anchor=\"button.icon\"]{color:", ";transition:color 0.2s ease-out;}"], _stylers["default"].alpha(_tokens["default"].color.white, 0.2), _tokens["default"].color.white, _stylers["default"].alpha(_tokens["default"].color.white, 0.3), _tokens["default"].color.white, _tokens["default"].color.blackLighten50);
var CloseButton = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "CloseButtonstyles__CloseButton",
  componentId: "sc-17tyw7-0"
})(function (_ref) {
  var isDark = _ref.isDark;
  return (0, _styledComponents.css)(["[data-pka-anchor=\"button.icon\"]{color:", ";}", ""], _tokens["default"].textColor.icon, isDark ? darkStyles : "");
});
exports.CloseButton = CloseButton;
//# sourceMappingURL=CloseButton.styles.js.map

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var constants = _interopRequireWildcard(__webpack_require__(40));

var sc = _interopRequireWildcard(__webpack_require__(1071));

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    children: null,
    icon: props.children,
    isFullWidth: false
  };
  return /*#__PURE__*/_react["default"].createElement(sc.IconButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }));
});

Icon.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var IconPropTypes = {
  /** Body content of the button (an icon). */
  children: _propTypes["default"].node.isRequired,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Icon.types.kind.DEFAULT, Icon.types.kind.PRIMARY, Icon.types.kind.SECONDARY, Icon.types.kind.DESTRUCTIVE, Icon.types.kind.FLAT, Icon.types.kind.MINOR, Icon.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Icon.types.size.SMALL, Icon.types.size.MEDIUM, Icon.types.size.LARGE])
};
var IconDefaultProps = {
  kind: Icon.types.kind.DEFAULT,
  size: Icon.types.size.MEDIUM
};
Icon.displayName = "Button.Icon";
Icon.propTypes = IconPropTypes;
Icon.defaultProps = IconDefaultProps;
var _default = Icon;
exports["default"] = _default;
//# sourceMappingURL=Icon.js.map

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.IconButton = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Button = _interopRequireDefault(__webpack_require__(556));

var types = _interopRequireWildcard(__webpack_require__(557));

var _iconButtonSizes;

var iconButtonSizes = (_iconButtonSizes = {}, (0, _defineProperty2["default"])(_iconButtonSizes, types.SMALL, (0, _styledComponents.css)(["font-size:14px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(3), (0, _parseInt["default"])(_tokens["default"].space, 10) * 3 - 2, _stylers["default"].spacer(3))), (0, _defineProperty2["default"])(_iconButtonSizes, types.MEDIUM, (0, _styledComponents.css)(["font-size:18px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(4), (0, _parseInt["default"])(_tokens["default"].space, 10) * 4 - 2, _stylers["default"].spacer(4))), (0, _defineProperty2["default"])(_iconButtonSizes, types.LARGE, (0, _styledComponents.css)(["font-size:22px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(5), (0, _parseInt["default"])(_tokens["default"].space, 10) * 5 - 2, _stylers["default"].spacer(5))), _iconButtonSizes);

var minorStyles = function minorStyles(_ref) {
  var isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;", ""], isDisabled ? (0, _styledComponents.css)(["&,&:hover,&:active{[data-pka-anchor=\"button.icon\"] svg{color:", ";}}"], _tokens["default"].color.blackDisabled) : (0, _styledComponents.css)(["&:hover{background-color:", ";}&:active{background-color:", ";}"], _stylers["default"].alpha(_tokens["default"].color.black, 0.1), _stylers["default"].alpha(_tokens["default"].color.black, 0.2)));
};

var IconButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "IconButtonstyles__IconButton",
  componentId: "sc-1rmwp4p-0"
})(function (_ref2) {
  var size = _ref2.size,
      kind = _ref2.kind;
  return (0, _styledComponents.css)(["", " ", " [data-pka-anchor=\"button.icon\"]{color:inherit;margin:0;}"], iconButtonSizes[size], kind === types.MINOR ? minorStyles : "");
});
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.styles.js.map

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Link["default"];
  }
});

var _Link = _interopRequireDefault(__webpack_require__(1073));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _NewTab = _interopRequireDefault(__webpack_require__(363));

var constants = _interopRequireWildcard(__webpack_require__(40));

var types = _interopRequireWildcard(__webpack_require__(557));

var sc = _interopRequireWildcard(__webpack_require__(1074));

var _Button = __webpack_require__(556);

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      children = props.children,
      href = props.href,
      isDisabled = props.isDisabled,
      shouldOpenNewTab = props.shouldOpenNewTab,
      kind = props.kind,
      icon = props.icon,
      size = props.size,
      suffixIcon = props.suffixIcon,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "href", "isDisabled", "shouldOpenNewTab", "kind", "icon", "size", "suffixIcon"]);
  var shouldOpenNewTabProps = {
    target: "_blank",
    rel: "noopener noreferrer"
  };

  function renderSuffix(_ref) {
    var kind = _ref.kind,
        isDisabled = _ref.isDisabled,
        suffixIcon = _ref.suffixIcon,
        shouldOpenNewTab = _ref.shouldOpenNewTab;

    if (kind === types.LINK && shouldOpenNewTab && suffixIcon) {
      return /*#__PURE__*/_react["default"].createElement(sc.LinkButtonIcon, {
        isDisabled: isDisabled,
        kind: types.LINK,
        isSuffixIcon: true
      }, suffixIcon);
    }

    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(sc.LinkButton, (0, _extends2["default"])({
    "aria-disabled": isDisabled,
    "aria-label": a11yText,
    href: !isDisabled ? href : null,
    isDisabled: isDisabled,
    kind: kind,
    size: size
  }, shouldOpenNewTab ? shouldOpenNewTabProps : {}, moreProps, {
    as: isDisabled ? "span" : "a",
    ref: ref
  }), icon ? /*#__PURE__*/_react["default"].createElement(_Button.ButtonIcon, {
    isDisabled: isDisabled
  }, icon) : null, children, renderSuffix(props));
});

Link.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** Url for the link. */
  href: _propTypes["default"].string.isRequired,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Link.types.kind.DEFAULT, Link.types.kind.PRIMARY, Link.types.kind.SECONDARY, Link.types.kind.DESTRUCTIVE, Link.types.kind.FLAT, Link.types.kind.MINOR, Link.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Link.types.size.SMALL, Link.types.size.MEDIUM, Link.types.size.LARGE]),

  /** Whether the link should open a new tab. */
  shouldOpenNewTab: _propTypes["default"].bool,

  /** Size of the button (font size, min-height, padding, etc). */
  suffixIcon: _propTypes["default"].node
};
var defaultProps = {
  a11yText: null,
  icon: null,
  isDisabled: false,
  kind: Link.types.kind.LINK,
  shouldOpenNewTab: false,
  size: Link.types.size.MEDIUM,
  suffixIcon: /*#__PURE__*/_react["default"].createElement(_NewTab["default"], null)
};
Link.displayName = "Button.Link";
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;
var _default = Link;
exports["default"] = _default;
//# sourceMappingURL=Link.js.map

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LinkButtonIcon = exports.LinkButton = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Button = __webpack_require__(716);

var _Button2 = __webpack_require__(556);

var LinkButton = _styledComponents["default"].a.withConfig({
  displayName: "LinkButtonstyles__LinkButton",
  componentId: "fsc7ri-0"
})(function (_ref) {
  var size = _ref.size,
      kind = _ref.kind,
      isFullWidth = _ref.isFullWidth,
      isActive = _ref.isActive,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "kind", "isFullWidth", "isActive"]);
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], _Button.commonStyles, _Button.sizeStyles[size], (0, _Button.kindStyles)(props)[kind], isFullWidth && _Button.fullWidthStyles, isActive ? _Button.activeStyles : _Button.inactiveStyles);
});

exports.LinkButton = LinkButton;
var LinkButtonIcon = (0, _styledComponents["default"])(_Button2.ButtonIcon).withConfig({
  displayName: "LinkButtonstyles__LinkButtonIcon",
  componentId: "fsc7ri-1"
})(["", " color:", ";margin-top:-", ";"], _stylers["default"].fontSize(-3), _tokens["default"].textColor.icon, _tokens["default"].spaceSm);
exports.LinkButtonIcon = LinkButtonIcon;
//# sourceMappingURL=LinkButton.styles.js.map

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Heading["default"];
  }
});

var _Heading = _interopRequireDefault(__webpack_require__(1076));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _isNan = _interopRequireDefault(__webpack_require__(181));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var sc = _interopRequireWildcard(__webpack_require__(1077));

var propTypes = {
  /** Optional aria text if it should be more descriptive than what is rendered */
  a11yText: _propTypes["default"].string,

  /** Heading content is required */
  children: _propTypes["default"].node.isRequired,

  /** Optional display level(1-6) affects styles only */
  displayLevel: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),

  /** Horizontal divider style */
  hasDivider: _propTypes["default"].bool,

  /** Underline style */
  hasUnderline: _propTypes["default"].bool,

  /** Optional, visually hide the header */
  isHidden: _propTypes["default"].bool,

  /** Optional, renders the children at a lighter font weight */
  isLight: _propTypes["default"].bool,

  /** Optional, using <div> to avoid styles override by global css. */
  isSemantic: _propTypes["default"].bool,

  /** Heading level(1-6) is required. */
  level: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]).isRequired
};
var defaultProps = {
  a11yText: null,
  displayLevel: null,
  hasDivider: false,
  hasUnderline: false,
  isHidden: false,
  isLight: false,
  isSemantic: true
};

var safeValue = function safeValue(n) {
  return n === undefined || n < 1 || (0, _isNan["default"])(n) ? 6 : Math.min(n, 6);
};

function renderHeadingContent(a11yText, children) {
  return a11yText ? /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": true
  }, children) : children;
}

var Heading = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      children = props.children,
      displayLevel = props.displayLevel,
      hasDivider = props.hasDivider,
      isSemantic = props.isSemantic,
      level = props.level,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "displayLevel", "hasDivider", "isSemantic", "level"]);

  var headingRef = _react["default"].useRef(null);

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        if (headingRef.current) {
          if (!moreProps.tabIndex) headingRef.current.setAttribute("tabindex", "-1");
          headingRef.current.focus();
        }
      }
    };
  });

  var safeLevel = safeValue(level);

  var divider = /*#__PURE__*/_react["default"].createElement(sc.Divider, null);

  var elementProps = {
    "aria-label": a11yText || null,
    "aria-level": isSemantic ? null : safeLevel,
    as: isSemantic ? "h".concat(safeLevel) : "div",
    hasDivider: hasDivider,
    ref: headingRef,
    role: isSemantic ? null : "heading",
    safeDisplayLevel: displayLevel ? safeValue(displayLevel) : null,
    safeLevel: safeLevel
  };
  return /*#__PURE__*/_react["default"].createElement(sc.Heading, (0, _extends2["default"])({
    "data-pka-anchor": "heading"
  }, elementProps, moreProps), renderHeadingContent(a11yText, children), hasDivider && divider);
});

Heading.displayName = "Heading";
Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;
var _default = Heading;
exports["default"] = _default;
//# sourceMappingURL=Heading.js.map

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Heading = exports.Divider = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var defaultHeadingStyles = (0, _styledComponents.css)(["align-items:center;color:inherit;font-weight:700;letter-spacing:0;", ";margin:", " 0;&:focus{outline:none;}"], _stylers["default"].lineHeight(-1), _stylers["default"].spacer(2));
var heading = {
  HEADING_LEVEL_1: (0, _styledComponents.css)(["", " ", " font-weight:400;"], _stylers["default"].fontSize(7), _stylers["default"].lineHeight(-2)),
  HEADING_LEVEL_2: (0, _styledComponents.css)(["", " ", ""], _stylers["default"].fontSize(5), _stylers["default"].lineHeight(-2)),
  HEADING_LEVEL_3: (0, _styledComponents.css)(["", ""], _stylers["default"].fontSize(3)),
  HEADING_LEVEL_4: (0, _styledComponents.css)(["", ""], _stylers["default"].fontSize(1)),
  HEADING_LEVEL_5: (0, _styledComponents.css)(["", " margin:", " 0;"], _stylers["default"].fontSize(), _tokens["default"].space),
  HEADING_LEVEL_6: (0, _styledComponents.css)(["", " margin:", " 0;"], _stylers["default"].fontSize(-1), _tokens["default"].space)
};

var underline = function underline(level) {
  var result = "border-bottom: 1px solid ".concat(_tokens["default"].border.color, ";");

  if (level === 1) {
    result += "padding-bottom: ".concat(_tokens["default"].space, ";");
  } else if (level > 1 && level < 5) {
    result += "padding-bottom: ".concat(_tokens["default"].spaceSm, ";");
  } else {
    result += "padding-bottom: 2px;";
  }

  return result;
};

var Divider = _styledComponents["default"].span.withConfig({
  displayName: "Headingstyles__Divider",
  componentId: "sc-1l2r6np-0"
})(["border-bottom:2px solid ", ";flex-grow:1;margin-left:", ";"], _tokens["default"].color.blackLighten70, _tokens["default"].space);

exports.Divider = Divider;

var Heading = _styledComponents["default"].div.withConfig({
  displayName: "Headingstyles__Heading",
  componentId: "sc-1l2r6np-1"
})(function (_ref) {
  var safeDisplayLevel = _ref.safeDisplayLevel,
      safeLevel = _ref.safeLevel,
      isHidden = _ref.isHidden,
      hasUnderline = _ref.hasUnderline,
      hasDivider = _ref.hasDivider,
      isLight = _ref.isLight;
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", ""], defaultHeadingStyles, heading["HEADING_LEVEL_".concat(safeDisplayLevel || safeLevel)], isHidden ? _stylers["default"].visuallyHidden : "", hasUnderline ? underline(safeDisplayLevel || safeLevel) : "", hasDivider ? "display: flex;" : "", isLight ? "font-weight: 400;" : "");
});

exports.Heading = Heading;
//# sourceMappingURL=Heading.styles.js.map

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Header = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _helpers = __webpack_require__(109);

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _tokens = _interopRequireDefault(__webpack_require__(332));

var _button = _interopRequireDefault(__webpack_require__(635));

var _typeKinds;

var typeKinds = (_typeKinds = {}, (0, _defineProperty2["default"])(_typeKinds, _button["default"].types.kind.DEFAULT, "background: ".concat(_tokens["default"].color.white, "; color: ").concat(_tokens["default"].color.black, ";")), (0, _defineProperty2["default"])(_typeKinds, _button["default"].types.kind.PRIMARY, "background: ".concat(_tokens["default"].color.purple, "; color: ").concat(_tokens["default"].color.white, ";")), _typeKinds);
var compactStyles = "\n  height: ".concat((0, _helpers.spacer)(6), ";\n  padding: ").concat(_tokens["default"].spaceLg, " ").concat((0, _helpers.spacer)(2), ";\n  \n  [data-pka-anchor=\"heading\"] {\n    margin: 0;\n  }\n");

var Header = _styledComponents["default"].div.withConfig({
  displayName: "Headerstyles__Header",
  componentId: "alzkw1-0"
})(function (_ref) {
  var kind = _ref.kind,
      hasPushedElement = _ref.hasPushedElement,
      isSlideFromLeft = _ref.isSlideFromLeft,
      isCompact = _ref.isCompact;
  return (0, _styledComponents.css)(["align-items:center;border-bottom:1px solid ", ";", " ", " box-sizing:border-box;display:flex;height:", ";justify-content:space-between;min-height:", ";padding:", " ", ";width:100%;&:focus{outline:0;}[data-pka-anchor=\"heading\"]{", " display:block;margin:0;}[data-pka-anchor=\"button.icon\"]{", "}", ";", ";"], _tokens["default"].border.color, hasPushedElement && !(kind === "primary") && isSlideFromLeft ? "border-right: 1px solid ".concat(_tokens["default"].border.color) : "", hasPushedElement && !(kind === "primary") && !isSlideFromLeft ? "border-left: 1px solid ".concat(_tokens["default"].border.color) : "", (0, _helpers.spacer)(8), (0, _helpers.spacer)(6), (0, _helpers.spacer)(2), (0, _helpers.spacer)(3), _stylers["default"].truncateText, kind === [_button["default"].types.kind.PRIMARY] ? "color: ".concat(_tokens["default"].color.white) : "color: inherit", isCompact ? compactStyles : "", kind ? typeKinds[kind] : "");
});

exports.Header = Header;
//# sourceMappingURL=Header.styles.js.map

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = Overlay;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useI18n = _interopRequireDefault(__webpack_require__(174));

var sc = _interopRequireWildcard(__webpack_require__(1080));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var propTypes = {
  /** Will call an onClose handler when clicked on (outside of the Panel) */
  hasOutsideClick: _propTypes["default"].bool,

  /** Callback for click event */
  onClose: _propTypes["default"].func,

  /** The z-index of the Panel Overlay */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  hasOutsideClick: true,
  onClose: null,
  zIndex: null
};

function Overlay(props) {
  var onClose = props.onClose,
      hasOutsideClick = props.hasOutsideClick,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["onClose", "hasOutsideClick"]);
  var I18n = (0, _useI18n["default"])();

  var handleClick = function handleClick() {
    if (hasOutsideClick) {
      onClose();
    }
  };

  var overlayProps = _objectSpread(_objectSpread({
    a11yText: I18n.t("close")
  }, moreProps), {}, {
    children: "",
    "data-pka-anchor": "side-panel.overlay",
    onClick: handleClick
  });

  return /*#__PURE__*/_react["default"].createElement(sc.Overlay, overlayProps);
}

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
Overlay.displayName = "Panel.Overlay";
//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Overlay = void 0;

var _tokens = _interopRequireDefault(__webpack_require__(332));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _rawButton = _interopRequireDefault(__webpack_require__(715));

var Overlay = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "Overlaystyles__Overlay",
  componentId: "sc-1bma9br-0"
})(function (_ref) {
  var zIndex = _ref.zIndex;
  return (0, _styledComponents.css)(["background-color:", ";box-sizing:content-box;display:block;height:100%;position:fixed;top:0;width:100%;", ";"], _tokens["default"].overlay.backdrop.backgroundColor, zIndex ? "z-index: ".concat(zIndex) : null);
});
exports.Overlay = Overlay;
//# sourceMappingURL=Overlay.styles.js.map

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Trigger["default"];
  }
});

var _Trigger = _interopRequireDefault(__webpack_require__(1082));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _button = _interopRequireDefault(__webpack_require__(635));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var types = _interopRequireWildcard(__webpack_require__(555));

var Trigger = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
    ref: ref
  }, props, {
    isSemantic: false,
    "data-pka-anchor": "panel.trigger"
  }));
});

Trigger.types = {
  kind: types.sidePanelKinds
};
var propTypes = {
  children: _propTypes["default"].node.isRequired
};
var defaultProps = {};
Trigger.propTypes = propTypes;
Trigger.defaultProps = defaultProps;
Trigger.displayName = "Panel.Trigger";
var _default = Trigger;
exports["default"] = _default;
//# sourceMappingURL=Trigger.js.map

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Group["default"];
  }
});

var _Group = _interopRequireDefault(__webpack_require__(1084));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Group;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _isArray = _interopRequireDefault(__webpack_require__(95));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var _helpers = __webpack_require__(109);

var _helpers2 = __webpack_require__(719);

var _Overlay = _interopRequireDefault(__webpack_require__(718));

var sc = _interopRequireWildcard(__webpack_require__(1085));

var _useOffsetScroll = _interopRequireDefault(__webpack_require__(720));

var propTypes = {
  children: _propTypes["default"].node.isRequired,
  offsetY: _propTypes["default"].number,
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  offsetY: 0,
  zIndex: (0, _helpers.zValue)(6)
};

function Group(props) {
  var children = props.children,
      offsetY = props.offsetY,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "offsetY"]);

  var _extractChildren = (0, _helpers2.extractChildren)(children, ["Panel", "Panel.Overlay"]),
      sidePanels = _extractChildren.Panel,
      OverlayExtracted = _extractChildren["Panel.Overlay"];

  if (!(0, _isArray["default"])(sidePanels)) {
    throw new Error("<Panel.Group /> is intented to be use with two or more Panels");
  }

  var offsetScroll = (0, _useOffsetScroll["default"])(offsetY);

  if (sidePanels.filter(function (sidePanel) {
    return !sidePanel.props.isOpen;
  }).length === sidePanels.length) {
    return null;
  }

  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, OverlayExtracted, /*#__PURE__*/_react["default"].createElement(sc.Group, (0, _extends2["default"])({}, moreProps, {
    offsetY: offsetScroll,
    "data-pka-anchor": "panel.group"
  }), sidePanels.map(function (sidePanel) {
    return /*#__PURE__*/_react["default"].cloneElement(sidePanel, {
      isInline: true,
      groupOffsetY: offsetY
    });
  }))), document.body);
}

Group.propTypes = propTypes;
Group.defaultProps = defaultProps;
Group.Overlay = _Overlay["default"];
//# sourceMappingURL=Group.js.map

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Group = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var Group = _styledComponents["default"].div.withConfig({
  displayName: "Groupstyles__Group",
  componentId: "sc-1ljnpbp-0"
})(function (_ref) {
  var zIndex = _ref.zIndex,
      offsetY = _ref.offsetY;
  return (0, _styledComponents.css)(["box-sizing:border-box;display:flex;height:100%;justify-content:flex-end;position:fixed;right:0;top:", "px;visibility:hidden;width:100%;z-index:", ";> div[role=\"dialog\"]{visibility:visible;}"], offsetY, zIndex);
});

exports.Group = Group;
//# sourceMappingURL=Group.styles.js.map

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FocusLock["default"];
  }
});

var _FocusLock = _interopRequireDefault(__webpack_require__(1087));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactFocusLock = _interopRequireDefault(__webpack_require__(1088));

var _customPropTypes = __webpack_require__(634);

var propTypes = _customPropTypes.FocusPropTypes;
var defaultProps = {
  returnFocus: true
};

var FocusLock = function FocusLock(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactFocusLock["default"], props);
};

FocusLock.propTypes = propTypes;
FocusLock.defaultProps = defaultProps;
FocusLock.displayName = "Panel.FocusLock";
var _default = FocusLock;
exports["default"] = _default;
//# sourceMappingURL=FocusLock.js.map

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Combination__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI__ = __webpack_require__(1118);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AutoFocusInside", function() { return __WEBPACK_IMPORTED_MODULE_1__UI__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MoveFocusInside", function() { return __WEBPACK_IMPORTED_MODULE_1__UI__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FreeFocusInside", function() { return __WEBPACK_IMPORTED_MODULE_1__UI__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "InFocusGuard", function() { return __WEBPACK_IMPORTED_MODULE_1__UI__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FocusLockUI", function() { return __WEBPACK_IMPORTED_MODULE_1__UI__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "useFocusInside", function() { return __WEBPACK_IMPORTED_MODULE_1__UI__["f"]; });


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Combination__["a" /* default */]);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lock__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Trap__ = __webpack_require__(1105);





/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/

var FocusLockCombination = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function (props, ref) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Lock__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    sideCar: __WEBPACK_IMPORTED_MODULE_4__Trap__["a" /* default */],
    ref: ref
  }, props));
});

var _ref = __WEBPACK_IMPORTED_MODULE_3__Lock__["a" /* default */].propTypes || {},
    sideCar = _ref.sideCar,
    propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["sideCar"]);

FocusLockCombination.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (FocusLockCombination);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignRef__ = __webpack_require__(499);
/* unused harmony reexport assignRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useRef__ = __webpack_require__(637);
/* unused harmony reexport useCallbackRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createRef__ = __webpack_require__(638);
/* unused harmony reexport createCallbackRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mergeRef__ = __webpack_require__(1092);
/* unused harmony reexport mergeRefs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useMergeRef__ = __webpack_require__(1093);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__useMergeRef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useTransformRef__ = __webpack_require__(1094);
/* unused harmony reexport useTransformRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__transformRef__ = __webpack_require__(1095);
/* unused harmony reexport transformRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__refToCallback__ = __webpack_require__(1096);
/* unused harmony reexport refToCallback */
/* unused harmony reexport useRefToCallback */

// callback ref


// merge ref


// transform ref


// refToCallback



/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeRefs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRef__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignRef__ = __webpack_require__(499);


/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link useMergeRefs} to be used in ReactComponents
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = mergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function mergeRefs(refs) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__createRef__["a" /* createCallbackRef */])(function (newValue) {
        return refs.forEach(function (ref) { return Object(__WEBPACK_IMPORTED_MODULE_1__assignRef__["a" /* assignRef */])(ref, newValue); });
    });
}


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMergeRefs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRef__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignRef__ = __webpack_require__(499);


/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__useRef__["a" /* useCallbackRef */])(defaultValue, function (newValue) {
        return refs.forEach(function (ref) { return Object(__WEBPACK_IMPORTED_MODULE_1__assignRef__["a" /* assignRef */])(ref, newValue); });
    });
}


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useTransformRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRef__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignRef__ = __webpack_require__(499);


/**
 * Create a _lense_ on Ref, making it possible to transform ref value
 * @param {ReactRef} ref
 * @param {Function} transformer. 👉 Ref would be __NOT updated__ on `transformer` update.
 * @returns {RefObject}
 *
 * @see https://github.com/theKashey/use-callback-ref#usetransformref-to-replace-reactuseimperativehandle
 * @example
 *
 * const ResizableWithRef = forwardRef((props, ref) =>
 *  <Resizable {...props} ref={useTransformRef(ref, i => i ? i.resizable : null)}/>
 * );
 */
function useTransformRef(ref, transformer) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__useRef__["a" /* useCallbackRef */])(undefined, function (value) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__assignRef__["a" /* assignRef */])(ref, transformer(value));
    });
}


/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transformRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignRef__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRef__ = __webpack_require__(638);


function transformRef(ref, transformer) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__createRef__["a" /* createCallbackRef */])(function (value) { return Object(__WEBPACK_IMPORTED_MODULE_0__assignRef__["a" /* assignRef */])(ref, transformer(value)); });
}


/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export refToCallback */
/* unused harmony export useRefToCallback */
/**
 * Unmemoized version of {@link useRefToCallback}
 * @see {@link useRefToCallback}
 * @param ref
 */
function refToCallback(ref) {
    return function (newValue) {
        if (typeof ref === 'function') {
            ref(newValue);
        }
        else if (ref) {
            ref.current = newValue;
        }
    };
}
var nullCallback = function () { return null; };
// lets maintain a weak ref to, well, ref :)
// not using `kashe` to keep this package small
var weakMem = new WeakMap();
var weakMemoize = function (ref) {
    var usedRef = ref || nullCallback;
    if (weakMem.has(usedRef)) {
        return weakMem.get(usedRef);
    }
    var cb = refToCallback(usedRef);
    weakMem.set(usedRef, cb);
    return cb;
};
/**
 * Transforms a given `ref` into `callback`.
 *
 * To transform `callback` into ref use {@link useCallbackRef|useCallbackRef(undefined, callback)}
 *
 * @param {ReactRef} ref
 * @returns {Function}
 *
 * @see https://github.com/theKashey/use-callback-ref#reftocallback
 *
 * @example
 * const ref = useRef(0);
 * const setRef = useRefToCallback(ref);
 * 👉 setRef(10);
 * ✅ ref.current === 10
 */
function useRefToCallback(ref) {
    return weakMemoize(ref);
}


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hoc__ = __webpack_require__(1098);
/* unused harmony reexport sidecar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hook__ = __webpack_require__(723);
/* unused harmony reexport useSidecar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1101);
/* unused harmony reexport setConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__medium__ = __webpack_require__(1102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__medium__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__medium__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__renderProp__ = __webpack_require__(1103);
/* unused harmony reexport renderCar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exports__ = __webpack_require__(1104);
/* unused harmony reexport exportSidecar */








/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sidecar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hook__ = __webpack_require__(723);



function sidecar(importer, errorComponent) {
    var ErrorCase = function () { return errorComponent; };
    return function Sidecar(props) {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_2__hook__["a" /* useSidecar */])(importer, props.sideCar), Car = _a[0], error = _a[1];
        if (error && errorComponent) {
            return ErrorCase;
        }
        return Car ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Car, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props)) : null;
    };
}


/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return env; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_node_es__ = __webpack_require__(1100);

var env = {
    isNode: __WEBPACK_IMPORTED_MODULE_0_detect_node_es__["a" /* isNode */],
    forceCache: false,
};


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isNode; });
var isNode = false;

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export config */
/* unused harmony export setConfig */
var config = {
    onError: function (e) { return console.error(e); },
};
var setConfig = function (conf) {
    Object.assign(config, conf);
};


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMedium;
/* harmony export (immutable) */ __webpack_exports__["b"] = createSidecarMedium;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(558);

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ async: true, ssr: false }, options);
    return medium;
}


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export renderCar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



function renderCar(WrappedComponent, defaults, options) {
    if (options === void 0) { options = {}; }
    function State(_a) {
        var stateRef = _a.stateRef, props = _a.props;
        var renderTarget = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function SideTarget() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            Object(__WEBPACK_IMPORTED_MODULE_1_react__["useLayoutEffect"])(function () {
                stateRef.current(args);
            });
            return null;
        }, []);
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](WrappedComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props, { children: renderTarget }));
    }
    var Children = __WEBPACK_IMPORTED_MODULE_1_react__["memo"](function (_a) {
        var stateRef = _a.stateRef, defaultState = _a.defaultState, children = _a.children;
        var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(defaultState.current), state = _b[0], setState = _b[1];
        __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
            stateRef.current = setState;
        }, []);
        return children.apply(void 0, state);
    }, function () { return true; });
    return function Combiner(props) {
        var defaultState = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](defaults(props));
        var ref = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](function (state) { return defaultState.current = state; });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](State, { stateRef: ref, props: props }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Children, { stateRef: ref, defaultState: defaultState, children: props.children })));
    };
}


/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export exportSidecar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __rest */](_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Target, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}


/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_clientside_effect__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__medium__ = __webpack_require__(639);







var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["c" /* focusIsHidden */])();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    // with cross frame return true for any value
    return Boolean(focusWasOutsideWindow);
  } // in other case return only of focus went a while aho


  return focusWasOutsideWindow === 'meanwhile';
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards,
        crossFrame = _lastActiveTrap.crossFrame;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["b" /* focusInside */])(workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              // Check if blur() exists, which is missing on certain elements on IE
              if (activeElement.blur) {
                activeElement.blur();
              }

              document.body.focus();
            } else {
              result = Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["a" /* default */])(workingArea, lastActiveFocus);
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["d" /* getFocusabledIn */])(workingArea);
        var focusedIndex = allNodes.map(function (_ref) {
          var node = _ref.node;
          return node;
        }).indexOf(newActiveElement);

        if (focusedIndex > -1) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
                node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* deferAction */])(activateTrap);
};

var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};

FocusTrap.propTypes = process.env.NODE_ENV !== "production" ? {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired
} : {};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction

  setTimeout(function () {
    focusWasOutsideWindow = 'meanwhile';
  }, 0);
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap, true);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap, true);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}

function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];

  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation(); // return focus only of last trap was removed

    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      // allow defer is no other trap is awaiting restore
      lastTrap.returnFocus(!trap);
    }
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap(true);
    Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* deferAction */])(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
} // bind medium


__WEBPACK_IMPORTED_MODULE_5__medium__["c" /* mediumFocus */].assignSyncMedium(onFocus);
__WEBPACK_IMPORTED_MODULE_5__medium__["a" /* mediumBlur */].assignMedium(onBlur);
__WEBPACK_IMPORTED_MODULE_5__medium__["b" /* mediumEffect */].assignMedium(function (cb) {
  return cb({
    moveFocusInside: __WEBPACK_IMPORTED_MODULE_3_focus_lock__["a" /* default */],
    focusInside: __WEBPACK_IMPORTED_MODULE_3_focus_lock__["b" /* focusInside */]
  });
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_clientside_effect__["a" /* default */])(reducePropsToState, handleStateChangeOnClient)(FocusWatcher));

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }

    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (withSideEffect);


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabHook__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__focusMerge__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__focusInside__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__setFocus__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_all_affected__ = __webpack_require__(641);
/* unused harmony reexport tabHook */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__focusInside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__["a"]; });
/* unused harmony reexport focusMerge */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__focusMerge__["b"]; });
/* unused harmony reexport constants */
/* unused harmony reexport getAllAffectedNodes */










/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__setFocus__["a" /* default */]);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
  attach: function attach() {},
  detach: function detach() {}
});

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isVisible */
/* unused harmony export notHiddenInput */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCommonParent; });
/* unused harmony export filterFocusable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTabbableNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllTabbableNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parentAutofocusables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabOrder__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabUtils__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(368);




var isElementHidden = function isElementHidden(computedStyle) {
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};

var isVisible = function isVisible(node) {
  return !node || node === document || node.nodeType === Node.DOCUMENT_NODE || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode && node.parentNode.nodeType === node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode);
};

var notHiddenInput = function notHiddenInput(node) {
  return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
};

var getParents = function getParents(node) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode, parents);
  }
  return parents;
};

var getCommonParent = function getCommonParent(nodea, nodeb) {
  var parentsA = getParents(nodea);
  var parentsB = getParents(nodeb);

  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};

var filterFocusable = function filterFocusable(nodes) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__array__["c" /* toArray */])(nodes).filter(function (node) {
    return isVisible(node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};

var getTabbableNodes = function getTabbableNodes(topNodes, withGuards) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a" /* orderByTabIndex */])(filterFocusable(Object(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a" /* getFocusables */])(topNodes, withGuards)), true, withGuards);
};

/**
 * actually anything focusable
 */
var getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a" /* orderByTabIndex */])(filterFocusable(Object(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a" /* getFocusables */])(topNodes)), false);
};

var parentAutofocusables = function parentAutofocusables(topNode) {
  return filterFocusable(Object(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["b" /* getParentAutofocusables */])(topNode));
};

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tabSort */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderByTabIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(368);


var tabSort = function tabSort(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;

  if (tabDiff) {
    if (!a.tabIndex) return 1;
    if (!b.tabIndex) return -1;
  }

  return tabDiff || indexDiff;
};

var orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__array__["c" /* toArray */])(nodes).map(function (node, index) {
    return {
      node: node,
      index: index,
      tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
    };
  }).filter(function (data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFocusables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getParentAutofocusables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabbables__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(333);




var queryTabbables = __WEBPACK_IMPORTED_MODULE_0__tabbables__["a" /* default */].join(',');
var queryGuardTabbables = queryTabbables + ', [data-focus-guard]';

var getFocusables = function getFocusables(parents, withGuards) {
  return parents.reduce(function (acc, parent) {
    return acc.concat(
    // add all tabbables inside
    Object(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* toArray */])(parent.querySelectorAll(withGuards ? queryGuardTabbables : queryTabbables)),
    // add if node is tabble itself
    parent.parentNode ? Object(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* toArray */])(parent.parentNode.querySelectorAll(__WEBPACK_IMPORTED_MODULE_0__tabbables__["a" /* default */].join(','))).filter(function (node) {
      return node === parent;
    }) : []);
  }, []);
};

var getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* FOCUS_AUTO */] + ']');
  return Object(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* toArray */])(parentFocus).map(function (node) {
    return getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]']);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pickFocusable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__correctFocus__ = __webpack_require__(725);


var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__correctFocus__["a" /* correctNode */])(nodes[0], nodes);
  }
  return nodes[0];
};

var pickFocusable = function pickFocusable(nodes, index) {
  if (nodes.length > 1) {
    return nodes.indexOf(Object(__WEBPACK_IMPORTED_MODULE_0__correctFocus__["a" /* correctNode */])(nodes[index], nodes));
  }
  return index;
};

/* harmony default export */ __webpack_exports__["a"] = (pickFirstFocus);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_all_affected__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(368);



var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInsideIframe = function focusInsideIframe(topNode) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayFind */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["c" /* toArray */])(topNode.querySelectorAll('iframe')), focusInFrame);
};

var focusInside = function focusInside(topNode) {
  var activeElement = document && document.activeElement;

  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_all_affected__["a" /* default */])(topNode).reduce(function (result, node) {
    return result || node.contains(activeElement) || focusInsideIframe(node);
  }, false);
};

/* harmony default export */ __webpack_exports__["a"] = (focusInside);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(333);



var focusIsHidden = function focusIsHidden() {
  return document && Object(__WEBPACK_IMPORTED_MODULE_0__utils_array__["c" /* toArray */])(document.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FOCUS_ALLOW */] + ']')).some(function (node) {
    return node.contains(document.activeElement);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (focusIsHidden);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export focusOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__focusMerge__ = __webpack_require__(724);


var focusOn = function focusOn(target) {
  target.focus();
  if (target.contentWindow) {
    target.contentWindow.focus();
  }
};

var guardCount = 0;
var lockDisabled = false;

/* harmony default export */ __webpack_exports__["a"] = (function (topNode, lastNode) {
  var focusable = Object(__WEBPACK_IMPORTED_MODULE_0__focusMerge__["a" /* default */])(topNode, lastNode);

  if (lockDisabled) {
    return;
  }

  if (focusable) {
    if (guardCount > 2) {
      // eslint-disable-next-line no-console
      console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
      lockDisabled = true;
      setTimeout(function () {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node);
    guardCount--;
  }
});

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Lock__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoFocusInside__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MoveFocusInside__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FreeFocusInside__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FocusGuard__ = __webpack_require__(722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoFocusInside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__MoveFocusInside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__FreeFocusInside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__FocusGuard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Lock__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__MoveFocusInside__["b"]; });






/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Lock__["a" /* default */]);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock_constants__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(559);






var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* inlineProp */])(__WEBPACK_IMPORTED_MODULE_3_focus_lock_constants__["b" /* FOCUS_AUTO */], !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes = process.env.NODE_ENV !== "production" ? {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
} : {};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (AutoFocusInside);

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useFocusInside; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock_constants__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__medium__ = __webpack_require__(639);






var useFocusInside = function useFocusInside(observedRef) {
  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    var enabled = true;
    __WEBPACK_IMPORTED_MODULE_5__medium__["b" /* mediumEffect */].useMedium(function (car) {
      var observed = observedRef && observedRef.current;

      if (enabled && observed) {
        if (!car.focusInside(observed)) {
          car.moveFocusInside(observed, null);
        }
      }
    });
    return function () {
      enabled = false;
    };
  }, [observedRef]);
};

function MoveFocusInside(_ref) {
  var isDisabled = _ref.disabled,
      className = _ref.className,
      children = _ref.children;
  var ref = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](null);
  useFocusInside(isDisabled ? undefined : ref);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* inlineProp */])(__WEBPACK_IMPORTED_MODULE_3_focus_lock_constants__["b" /* FOCUS_AUTO */], !isDisabled), {
    ref: ref,
    className: className
  }), children);
}

MoveFocusInside.propTypes = process.env.NODE_ENV !== "production" ? {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
} : {};
MoveFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (MoveFocusInside);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock_constants__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(559);






var FreeFocusInside = function FreeFocusInside(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* inlineProp */])(__WEBPACK_IMPORTED_MODULE_3_focus_lock_constants__["a" /* FOCUS_ALLOW */], true), {
    className: className
  }), children);
};

FreeFocusInside.propTypes = process.env.NODE_ENV !== "production" ? {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
} : {};
FreeFocusInside.defaultProps = {
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (FreeFocusInside);

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "useOffsetScroll", {
  enumerable: true,
  get: function get() {
    return _useOffsetScroll["default"];
  }
});

var _useOffsetScroll = _interopRequireDefault(__webpack_require__(720));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _parseInt2 = _interopRequireDefault(__webpack_require__(112));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _construct = _interopRequireDefault(__webpack_require__(216));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(217));

var _createClass2 = _interopRequireDefault(__webpack_require__(218));

var _inherits2 = _interopRequireDefault(__webpack_require__(219));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(220));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(221));

var _react = _interopRequireDefault(__webpack_require__(2));

var _memoizeOne = _interopRequireDefault(__webpack_require__(207));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = _interopRequireDefault(__webpack_require__(222));

var _v = _interopRequireDefault(__webpack_require__(124));

var constants = _interopRequireWildcard(__webpack_require__(40));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _helpers = __webpack_require__(109);

var types = _interopRequireWildcard(__webpack_require__(1124));

var _isInsideBoundaries = _interopRequireDefault(__webpack_require__(1125));

var _getPosition = __webpack_require__(1126);

var _getBoundingClientRect = _interopRequireDefault(__webpack_require__(1128));

var _PopoverContext = _interopRequireWildcard(__webpack_require__(502));

var _Content = _interopRequireDefault(__webpack_require__(1129));

var _Card = _interopRequireDefault(__webpack_require__(1134));

var _Trigger = _interopRequireDefault(__webpack_require__(1136));

var _Tip = _interopRequireDefault(__webpack_require__(1138));

var sc = _interopRequireWildcard(__webpack_require__(503));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var openDelay = 350;
var closeDelay = 150;
var throttleDelay = 20;
var focusableElementSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]'; // TODO: To handle cases where there are multiple scrolling containers, we need to implement
//       getScrollContainer as oneOfType([func, arrayOf(func)])

var Popover = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popover);
    _this = _super.call(this, props);
    _this.getContextValues = (0, _memoizeOne["default"])(function (content, maxWidth, minWidth, width, isEager, isOpen, isPortal, portalElement, refContent, refTip, shouldKeepFocus, tip, zIndex, ariaIdForContent) {
      return {
        content: _objectSpread(_objectSpread({}, content), {}, {
          maxWidth: maxWidth,
          minWidth: minWidth,
          width: width,
          zIndex: zIndex,
          ariaId: ariaIdForContent
        }),
        isEager: isEager,
        isOpen: isOpen,
        onClick: _this.handleClick,
        onClose: _this.handleClose,
        onDelayedClose: _this.handleDelayedClose,
        onDelayedOpen: _this.handleDelayedOpen,
        onOpen: _this.handleOpen,
        isPortal: isPortal,
        portalElement: portalElement,
        refContent: refContent,
        refTip: refTip,
        shouldKeepFocus: shouldKeepFocus,
        tip: tip
      };
    });

    _this.getCoordinates = function () {
      var _this$props = _this.props,
          align = _this$props.align,
          edge = _this$props.edge,
          getScrollContainer = _this$props.getScrollContainer;
      var targetRect = _this.props.getPositioningElement === null ? (0, _getBoundingClientRect["default"])(_this.$popover.current) : (0, _getBoundingClientRect["default"])(_this.props.getPositioningElement());
      var contentCoords = (0, _getPosition.getContentCoordinates)({
        rect: _this.$content ? (0, _getBoundingClientRect["default"])(_this.$content) : null,
        targetRect: targetRect,
        scrollRect: getScrollContainer !== null ? (0, _getBoundingClientRect["default"])(getScrollContainer()) : null,
        align: align,
        offset: _this.props.offset,
        edge: edge
      });
      var tipCoords = {
        x: null,
        y: null,
        rotate: null
      };

      if (_this.$tip) {
        tipCoords = (0, _getPosition.getTipCoordinates)({
          tipRect: (0, _getBoundingClientRect["default"])(_this.$tip),
          targetRect: targetRect,
          contentRect: (0, _getBoundingClientRect["default"])(_this.$content),
          contentCoords: contentCoords,
          align: align
        });
      }

      return {
        tip: tipCoords,
        content: contentCoords
      };
    };

    _this.handleReposition = (0, _lodash["default"])(function () {
      if (_this.isOpen()) {
        var scrollContainer = _this.props.getScrollContainer === null ? document.body : _this.props.getScrollContainer();

        if (!(0, _isInsideBoundaries["default"])({
          $container: scrollContainer,
          $element: _this.$popover.current,
          align: _this.props.align
        })) {
          _this.close();

          return;
        }

        _this.setVisibilityAndPosition();
      }
    }, throttleDelay);

    _this.handleKeyUp = function (event) {
      if (event.key === "Escape") {
        _this.close();

        if (_this.$trigger) _this.$trigger.focus();
      }
    };

    _this.handleKeyDown = function (event) {
      if (event.key === "Tab" && _this.isOpen() && _this.$trigger) {
        var isFocusOnFirst = _this.focusIsOnCertainElementInPopover("first") || document.activeElement === _this.$content;

        var isFocusOnLast = _this.focusIsOnCertainElementInPopover("last");

        if (event.shiftKey && isFocusOnFirst) {
          event.preventDefault();

          _this.focusableElements[_this.triggerFocusIndex].focus();
        } else if (!event.shiftKey && isFocusOnLast) {
          event.preventDefault();

          _this.focusableElements[_this.triggerFocusIndex + 1].focus();
        }
      }
    };

    _this.focusIsOnCertainElementInPopover = function (which) {
      var focusableElementsInPopover = _this.$content.querySelectorAll(focusableElementSelector);

      var index = which === "first" ? 0 : focusableElementsInPopover.length - 1;
      return document.activeElement === focusableElementsInPopover[index];
    };

    _this.elementIsDescendentOfPopover = function (elem) {
      var elementsParent = elem.parentNode;

      while (elementsParent !== null) {
        if (elementsParent.getAttribute && elementsParent.getAttribute("data-pka-anchor") === "popover.content") {
          return true;
        }

        elementsParent = elementsParent.parentNode;
      }

      return false;
    };

    _this.getPopoverTriggerFocusIndex = function () {
      _this.focusableElements.forEach(function (focusableElement, index) {
        if (focusableElement === _this.$trigger) {
          _this.triggerFocusIndex = index;
        }
      });
    };

    _this.handleTransitionEnd = function (event) {
      // NOTE: do this should make more that only focus the content div? should as well
      //       find the first focusable element like button, input, etc?
      //       can focus automatically
      if (!_this.props.shouldKeepFocus && !_this.props.isEager && _this.isOpen() && event.propertyName === "visibility") {
        _this.getPopoverTriggerFocusIndex();

        event.target.focus();
      }
    };

    _this.handleOpen = function () {
      _this.open();
    };

    _this.handleClose = function () {
      _this.close();
    };

    _this.handleDelayedOpen = function () {
      clearTimeout(_this.closeTimer);
      _this.openTimer = setTimeout(_this.handleOpen, openDelay);
    };

    _this.handleDelayedClose = function () {
      clearTimeout(_this.openTimer);
      _this.closeTimer = setTimeout(_this.handleClose, closeDelay);
    };

    _this.handleClick = function () {
      if (_this.isOpen() && !_this.props.shouldKeepFocus && !_this.props.isEager) _this.close();else _this.open();
    };

    _this.refTip = function (ref) {
      _this.$tip = ref;
    };

    _this.refContent = function (ref) {
      _this.$content = ref;
    };

    _this.handleChildChange = function () {
      setTimeout(function () {
        _this.setVisibilityAndPosition();
      });
    };

    _this.hasListeners = false;
    _this.$popover = /*#__PURE__*/_react["default"].createRef();
    _this.$trigger = null;
    _this.$tip = null; // this ref comes from a callback of the <Tip /> component

    if (props.isPortal) {
      var portalNode = document.createElement("div");
      _this.$portal = document.body.appendChild(portalNode);
    }

    _this.focusableElements = [];
    _this.triggerFocusIndex = null;
    _this.state = {
      isOpen: _this.props.defaultIsOpen || false,
      tip: {
        x: 0,
        y: 0
      },
      content: {
        x: 0,
        y: 0
      },
      width: "auto"
    }; // NOTE: should we created a link explaining more deeply this kind of errors?
    //       this type of validation should live in the constructor or somewhere else?

    if (props.isOpen !== null && props.defaultIsOpen !== null) {
      console.error("The use of defaultIsOpen prop is for uncontrolled components only and cannot be used when\n        isOpen prop is also provided.");
    }

    _this.ariaIdForContent = "popover-content-".concat((0, _v["default"])());
    return _this;
  }

  (0, _createClass2["default"])(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // about setState for Popovers and Tooltips in ComponentDidMount
      // https://reactjs.org/docs/react-component.html#componentdidmount
      if (this.isOpen()) {
        this.addListeners();
        this.setVisibilityAndPosition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        this.open();
      }

      if (this.isOpen() && !this.hasListeners) {
        this.focusableElements = document.querySelectorAll(focusableElementSelector);
        this.addListeners();
      }

      if (this.isOpen() && prevProps !== this.props) this.setVisibilityAndPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
      clearTimeout(this.openTimer);
      this.openTimer = null;
      clearTimeout(this.closeTimer);
      this.closeTimer = null;

      if (this.props.isPortal) {
        document.body.removeChild(this.$portal);
      }
    }
  }, {
    key: "getContentWidth",
    value: function getContentWidth() {
      var $shadowContent = this.$content.cloneNode(true);
      $shadowContent.style.visibility = "hidden";
      $shadowContent.style.top = 0;
      $shadowContent.style.left = 0;
      $shadowContent.style.width = "auto";
      $shadowContent.style.maxWidth = this.props.maxWidth;
      $shadowContent.style.minWidth = this.props.minWidth;
      document.body.appendChild($shadowContent);
      var contentWidth = (0, _getBoundingClientRect["default"])($shadowContent).width;
      document.body.removeChild($shadowContent);
      return contentWidth;
    }
  }, {
    key: "setVisibilityAndPosition",
    value: function setVisibilityAndPosition() {
      var _this2 = this;

      var isOpening = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.$content) {
        // dynamically setting a fixed width before positioning avoids issues at the
        // right edge of the screen
        if (isOpening && [types.TOP, types.BOTTOM].includes(this.props.align)) {
          var newWidth = this.getContentWidth();

          if (newWidth !== this.state.width) {
            this.setState({
              width: newWidth
            }, function () {
              _this2.updateVisibilityAndPositionState(isOpening);
            });
            return;
          }
        }

        this.updateVisibilityAndPositionState(isOpening);
      }
    }
  }, {
    key: "open",
    value: function open() {
      this.$trigger = document.activeElement;
      this.setVisibilityAndPosition(true);
    }
  }, {
    key: "close",
    value: function close() {
      // NOTE: Even if uncontrolled, the app may want to be notified when closed via the onClose callback
      if (this.props.onClose !== null) {
        this.props.onClose();
      }

      if (this.props.isOpen === null) {
        this.setState({
          isOpen: false
        });
        this.removeListeners();
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      this.focusableElements = document.querySelectorAll(focusableElementSelector);
      return this.props.isOpen !== null ? this.props.isOpen : this.state.isOpen;
    }
  }, {
    key: "updateVisibilityAndPositionState",
    value: function updateVisibilityAndPositionState() {
      var isOpening = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _this$getCoordinates = this.getCoordinates(),
          content = _this$getCoordinates.content,
          tip = _this$getCoordinates.tip;

      var newState = {
        content: content,
        tip: tip
      };
      if (isOpening) newState.isOpen = true;
      this.setState(newState);
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      if (this.$content) {
        document.addEventListener("keyup", this.handleKeyUp, false);
        document.addEventListener("keydown", this.handleKeyDown, false);
        document.addEventListener("resize", this.handleReposition, false);
        document.addEventListener("scroll", this.handleReposition, false);

        if (this.props.getScrollContainer !== null) {
          this.props.getScrollContainer().addEventListener("scroll", this.handleReposition, false);
        }

        this.$content.addEventListener("transitionend", this.handleTransitionEnd, false);
        this.hasListeners = true;
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (this.$content) {
        document.removeEventListener("resize", this.handleReposition);

        if (this.props.getScrollContainer === null) {
          document.removeEventListener("scroll", this.handleReposition);
        } else {
          this.props.getScrollContainer().removeEventListener("scroll", this.handleReposition);
        }

        document.removeEventListener("keyup", this.handleKeyUp);
        document.removeEventListener("keydown", this.handleKeyDown);
        this.$content.removeEventListener("transitionend", this.handleTransitionEnd);
        this.hasListeners = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          align = _this$props2.align,
          children = _this$props2.children,
          isDark = _this$props2.isDark,
          isEager = _this$props2.isEager,
          isOpen = _this$props2.isOpen,
          isPortal = _this$props2.isPortal,
          defaultIsOpen = _this$props2.defaultIsOpen,
          maxWidth = _this$props2.maxWidth,
          minWidth = _this$props2.minWidth,
          onClose = _this$props2.onClose,
          offset = _this$props2.offset,
          getPositioningElement = _this$props2.getPositioningElement,
          getScrollContainer = _this$props2.getScrollContainer,
          zIndex = _this$props2.zIndex,
          moreProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["align", "children", "isDark", "isEager", "isOpen", "isPortal", "defaultIsOpen", "maxWidth", "minWidth", "onClose", "offset", "getPositioningElement", "getScrollContainer", "zIndex"]);
      var contextValue = this.getContextValues(this.state.content, maxWidth, minWidth, this.state.width, isEager, this.isOpen(), isPortal, this.$portal, this.refContent, this.refTip, this.props.shouldKeepFocus, this.state.tip, zIndex, this.ariaIdForContent);
      return /*#__PURE__*/_react["default"].createElement(_PopoverContext.ThemeContext.Provider, {
        value: isDark
      }, /*#__PURE__*/_react["default"].createElement(_PopoverContext["default"].Provider, {
        value: contextValue
      }, /*#__PURE__*/_react["default"].createElement(sc.Popover, (0, _extends2["default"])({
        "data-pka-anchor": "popover"
      }, moreProps, {
        ref: this.$popover
      }), /*#__PURE__*/_react["default"].createElement(PopoverChildren, {
        onChildChange: this.handleChildChange
      }, this.props.children))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!prevState.isOpen && nextProps.isOpen) {
        return {
          isOpen: true
        };
      }

      return null;
    }
  }]);
  return Popover;
}(_react["default"].Component); // Todo Refactor this when we convert popover component to use hooks


function PopoverChildren(props) {
  var children = props.children,
      onChildChange = props.onChildChange;

  _react["default"].useLayoutEffect(function () {
    if (children) onChildChange();
  }, [children, onChildChange]);

  return children;
}

Popover.types = {
  align: constants.align
};
var propTypes = {
  /** Where the popover content is positioned relative to the trigger or getPositioningElement. */
  align: _propTypes["default"].oneOf([Popover.types.align.TOP, Popover.types.align.RIGHT, Popover.types.align.BOTTOM, Popover.types.align.LEFT]),

  /** Content of the popover */
  children: _propTypes["default"].node.isRequired,

  /** Displays as a "tooltip" style with white text on black background. */
  isDark: _propTypes["default"].bool,

  /** Activated by mouseOver / focus instead of onClick. */
  isEager: _propTypes["default"].bool,

  /** How "controlled" popovers are shown / hidden. */
  isOpen: _propTypes["default"].bool,

  /** This renders the popover inline in the DOM and not in a react portal. WARNING: will have side effects with paprika side panels and modals, use with caution. */
  isPortal: _propTypes["default"].bool,

  /** How "uncontrolled" popovers can be rendered open by default. */
  defaultIsOpen: _propTypes["default"].bool,

  /** Where the edge of the popover content is based on the trigger or getPositioningElement */
  edge: _propTypes["default"].oneOf([Popover.types.align.LEFT, Popover.types.align.RIGHT, null]),

  /** Maximum width of popover content. Using a number is recommended and implies px units. */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Minimumn width of popover content. Using a number is recommended and implies px units. */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Callback to fire when user closes popover. */
  onClose: _propTypes["default"].func,

  /** Distance, in px, between popover content edge and trigger / getPositioningElement. */
  offset: _propTypes["default"].number,

  /** Function that provides DOM element to use as target for positioning the popover. */
  getPositioningElement: _propTypes["default"].func,

  /** Function that provides the scrolling DOM element that contains the popover. */
  getScrollContainer: _propTypes["default"].func,

  /** If focus will stay at the trigger when showing popover. Popover can still be closed when clicking outside or pressing escape key. */
  shouldKeepFocus: _propTypes["default"].bool,

  /** Number setting the z-index for the popover content / tip. */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  align: Popover.types.align.BOTTOM,
  isDark: false,
  isEager: false,
  isOpen: null,
  isPortal: true,
  defaultIsOpen: null,
  edge: null,
  maxWidth: 320,
  minWidth: 0,
  onClose: null,
  offset: (0, _parseInt2["default"])(_tokens["default"].spaceLg, 10),
  getPositioningElement: null,
  getScrollContainer: null,
  shouldKeepFocus: false,
  zIndex: (0, _helpers.zValue)(1)
};
Popover.displayName = "Popover";
Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
Popover.Trigger = _Trigger["default"];
Popover.Content = _Content["default"];
Popover.Card = _Card["default"];
Popover.Tip = _Tip["default"];
var _default = Popover;
exports["default"] = _default;
//# sourceMappingURL=Popover.js.map

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LEFT = exports.BOTTOM = exports.RIGHT = exports.TOP = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var TOP = constants.align.TOP;
exports.TOP = TOP;
var RIGHT = constants.align.RIGHT;
exports.RIGHT = RIGHT;
var BOTTOM = constants.align.BOTTOM;
exports.BOTTOM = BOTTOM;
var LEFT = constants.align.LEFT;
exports.LEFT = LEFT;
//# sourceMappingURL=types.js.map

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var isInsideBoundaries = function isInsideBoundaries(_ref) {
  var $container = _ref.$container,
      $element = _ref.$element,
      align = _ref.align;

  if ($container && $element) {
    var containerRect = $container.getBoundingClientRect();
    var elementRect = $element.getBoundingClientRect();
    var alignVert = ["bottom", "top"].includes(align); // avoid some weirdness with the tip and with scrollbars
    // we might actually want the dimensions of the Tip to do this right
    // half tip + edgePadding

    var edgeBuffer = {
      vert: alignVert ? 0 : 15,
      horz: alignVert ? 15 : 0
    }; // ¿ maybe just round up to 20 ?

    var scrollbarBuffer = 17;
    var elementLimit = {
      left: alignVert ? elementRect.right - elementRect.width / 2 : elementRect.right,
      right: alignVert ? elementRect.right - elementRect.width / 2 : elementRect.left + scrollbarBuffer,
      top: alignVert ? elementRect.bottom : elementRect.bottom - elementRect.height / 2,
      bottom: alignVert ? elementRect.top + scrollbarBuffer : elementRect.bottom - elementRect.height / 2
    };
    return elementLimit.top - edgeBuffer.vert >= containerRect.top && elementLimit.bottom + edgeBuffer.vert <= containerRect.bottom && elementLimit.right + edgeBuffer.horz <= containerRect.right && elementLimit.left - edgeBuffer.horz >= containerRect.left;
  }

  return true;
};

var _default = isInsideBoundaries;
exports["default"] = _default;
//# sourceMappingURL=isInsideBoundaries.js.map

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.getTipCoordinates = exports.getContentCoordinates = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _isNan = _interopRequireDefault(__webpack_require__(181));

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _customPropTypes = __webpack_require__(1127);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var rotate = {
  top: 180,
  right: 270,
  bottom: 0,
  left: 90
};
var edgePadding = (0, _parseInt["default"])(_tokens["default"].space, 10);

var getAdjustedContentCoordinates = function getAdjustedContentCoordinates(_ref) {
  var x = _ref.x,
      y = _ref.y,
      contentRect = _ref.contentRect,
      targetRect = _ref.targetRect,
      scrollRect = _ref.scrollRect,
      align = _ref.align,
      offset = _ref.offset;
  var viewport = {
    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  };
  var boundary = {
    top: scrollRect ? scrollRect.top : 0,
    right: scrollRect ? Math.min(scrollRect.right, viewport.width) : viewport.width,
    bottom: scrollRect ? Math.min(scrollRect.bottom, viewport.height) : viewport.height,
    left: scrollRect ? scrollRect.left : 0
  };
  var alignVert = ["bottom", "top"].includes(align);
  var isOnRightSide = targetRect.x + targetRect.width / 2 > boundary.left + (boundary.right - boundary.left) / 2;
  var isOnBottomHalf = targetRect.y + targetRect.height / 2 > boundary.top + (boundary.bottom - boundary.top) / 2;
  var overflowsViewportLeft = x < boundary.left;
  var overflowsViewportRight = x + contentRect.width > boundary.right;
  var overflowsViewportTop = y < boundary.top;
  var overflowsViewportBottom = y + contentRect.height > boundary.bottom;
  var newX = (0, _isNan["default"])(x) ? 0 : x;
  var newY = (0, _isNan["default"])(y) ? 0 : y;

  if (overflowsViewportLeft && !isOnRightSide) {
    newX = alignVert ? boundary.left + edgePadding : newX = targetRect.x + targetRect.width + offset;
  }

  if (overflowsViewportRight && isOnRightSide) {
    newX = alignVert ? boundary.right - contentRect.width - edgePadding : targetRect.x - contentRect.width - offset;
  }

  if (overflowsViewportTop && !isOnBottomHalf) {
    newY = alignVert ? targetRect.y + targetRect.height + offset : boundary.top + edgePadding;
  }

  if (overflowsViewportBottom && isOnBottomHalf) {
    newY = alignVert ? y - (contentRect.height + offset * 2 + targetRect.height) : boundary.bottom - contentRect.height - edgePadding;
  }

  return {
    x: newX,
    y: newY
  };
};

var getAnchor = function getAnchor(rect, align) {
  var positions = {
    top: function top() {
      return {
        x: rect.left + rect.width / 2,
        y: rect.top
      };
    },
    right: function right() {
      return {
        x: rect.right,
        y: rect.y + rect.height / 2
      };
    },
    bottom: function bottom() {
      return {
        x: rect.left + rect.width / 2,
        y: rect.y + rect.height
      };
    },
    left: function left() {
      return {
        x: rect.left,
        y: rect.y + rect.height / 2
      };
    }
  };
  return positions[align]();
};

var getContentCoordinates = function getContentCoordinates(_ref2) {
  var _alignedPosition;

  var rect = _ref2.rect,
      targetRect = _ref2.targetRect,
      scrollRect = _ref2.scrollRect,
      align = _ref2.align,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 12 : _ref2$offset,
      edge = _ref2.edge;
  var anchor = getAnchor(targetRect, align);

  var getContentXByEdge = function getContentXByEdge() {
    if (edge === _customPropTypes.AlignTypes.LEFT) {
      return anchor.x - targetRect.width / 2;
    }

    if (edge === _customPropTypes.AlignTypes.RIGHT) {
      return anchor.x - rect.width + targetRect.width / 2;
    }

    return anchor.x - rect.width / 2;
  };

  var alignedPosition = (_alignedPosition = {}, (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.TOP, function () {
    return getAdjustedContentCoordinates({
      x: getContentXByEdge(),
      y: anchor.y - (rect.height + offset),
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.RIGHT, function () {
    return getAdjustedContentCoordinates({
      x: anchor.x + offset,
      y: anchor.y - rect.height / 2,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.BOTTOM, function () {
    return getAdjustedContentCoordinates({
      x: getContentXByEdge(),
      y: anchor.y + offset,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.LEFT, function () {
    return getAdjustedContentCoordinates({
      x: anchor.x - rect.width - offset,
      y: anchor.y - rect.height / 2,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), _alignedPosition);
  return alignedPosition[align]();
}; // The default value of 1.2 pixels for offset is to ensure a small overlap so that at certain browser zoom levels
// we do not see a slim piece of the underlying content (Popover.Card border)


exports.getContentCoordinates = getContentCoordinates;

var getTipCoordinates = function getTipCoordinates(_ref3) {
  var tipRect = _ref3.tipRect,
      targetRect = _ref3.targetRect,
      contentRect = _ref3.contentRect,
      contentCoords = _ref3.contentCoords,
      align = _ref3.align,
      _ref3$offset = _ref3.offset,
      offset = _ref3$offset === void 0 ? -1.2 : _ref3$offset;
  var alignedPosition = {
    top: function top() {
      return {
        x: targetRect.x + targetRect.width / 2 - tipRect.width / 2,
        y: contentCoords.y + contentRect.height + offset
      };
    },
    right: function right() {
      return {
        x: contentCoords.x - tipRect.width - offset,
        y: targetRect.y + targetRect.height / 2 - tipRect.height / 2
      };
    },
    bottom: function bottom() {
      return {
        x: targetRect.x + targetRect.width / 2 - tipRect.width / 2,
        y: contentCoords.y - tipRect.height - offset
      };
    },
    left: function left() {
      return {
        x: contentCoords.x + contentRect.width + offset,
        y: targetRect.y + targetRect.height / 2 - tipRect.height / 2
      };
    }
  };
  var tipAlign = {
    top: function top() {
      return contentCoords.y > targetRect.y ? "bottom" : align;
    },
    right: function right() {
      return contentCoords.x < targetRect.x ? "left" : align;
    },
    bottom: function bottom() {
      return contentCoords.y < targetRect.y ? "top" : align;
    },
    left: function left() {
      return contentCoords.x > targetRect.x ? "right" : align;
    }
  };
  var adjustedAlign = tipAlign[align]();
  return _objectSpread(_objectSpread({}, alignedPosition[adjustedAlign]()), {}, {
    rotate: rotate[adjustedAlign]
  });
};

exports.getTipCoordinates = getTipCoordinates;
//# sourceMappingURL=getPosition.js.map

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RefOf = exports.FocusPropTypes = exports.InputValidTypes = exports.deprecated = exports.AlignTypes = exports.ShirtSizes = void 0;

var _values = _interopRequireDefault(__webpack_require__(96));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

// NOTE: Maybe this should be provided as a consumable package?
var ShirtSizes = {
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge"
};
exports.ShirtSizes = ShirtSizes;
ShirtSizes.DEFAULT = [ShirtSizes.SMALL, ShirtSizes.MEDIUM, ShirtSizes.LARGE];
ShirtSizes.LIMITED = [ShirtSizes.SMALL, ShirtSizes.MEDIUM];
ShirtSizes.ALL = (0, _values["default"])(ShirtSizes);
var AlignTypes = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left"
};
exports.AlignTypes = AlignTypes;
AlignTypes.ALL = (0, _values["default"])(AlignTypes);

var deprecated = function deprecated(name) {
  return function (props, propName, component) {
    if (props[propName] !== undefined) {
      return new Error("Deprecated prop '".concat(propName, "' supplied to ").concat(component, ". Use '").concat(name, "' instead."));
    }

    return null;
  };
};

exports.deprecated = deprecated;
var InputValidTypes = {
  EMAIL: "email",
  NUMBER: "number",
  PASSWORD: "password",
  SEARCH: "search",
  TELEPHONE: "tel",
  TEXT: "text",
  URL: "url"
};
exports.InputValidTypes = InputValidTypes;
var FocusPropTypes = {
  // properties copy from https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/src/Lock.js#L160
  // see description for props here: https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/interfaces.d.ts#L4
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  returnFocus: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
  noFocusGuards: _propTypes["default"].bool,
  allowTextSelection: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  persistentFocus: _propTypes["default"].bool,
  group: _propTypes["default"].string,
  className: _propTypes["default"].string,
  whiteList: _propTypes["default"].func,
  shards: _propTypes["default"].arrayOf(_propTypes["default"].any),
  as: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  lockProps: _propTypes["default"].object,
  onActivation: _propTypes["default"].func,
  onDeactivation: _propTypes["default"].func,
  sideCar: _propTypes["default"].any
};
exports.FocusPropTypes = FocusPropTypes;
InputValidTypes.ALL = (0, _values["default"])(InputValidTypes);

var RefOf = function RefOf() {
  var propType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _propTypes["default"].object;
  return _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: propType
  })]);
};

exports.RefOf = RefOf;
//# sourceMappingURL=customPropTypes.js.map

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = getBoundingClientRect;

function getBoundingClientRect(el) {
  var rect = el.getBoundingClientRect();
  var x;
  var y;

  if (rect.x === undefined) {
    x = rect.left;
  } else {
    x = rect.x;
  }

  if (rect.y === undefined) {
    y = rect.top;
  } else {
    y = rect.y;
  }

  return {
    left: rect.left,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    x: x,
    y: y,
    width: rect.width,
    height: rect.height
  };
}
//# sourceMappingURL=getBoundingClientRect.js.map

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _parseInt2 = _interopRequireDefault(__webpack_require__(112));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _isElementContainsFocus = _interopRequireDefault(__webpack_require__(1130));

var _PopoverContext = _interopRequireDefault(__webpack_require__(502));

var _Popover = __webpack_require__(503);

var _Content = __webpack_require__(1133);

var propTypes = {
  children: _propTypes["default"].node,

  /** Callback to indicate the element loses focus */
  onBlur: _propTypes["default"].func
};
var defaultProps = {
  children: null,
  onBlur: function onBlur() {}
};

var Content = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onBlur = props.onBlur,
      children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["onBlur", "children"]);

  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      isEager = _React$useContext.isEager,
      isOpen = _React$useContext.isOpen,
      isPortal = _React$useContext.isPortal,
      onClose = _React$useContext.onClose,
      onDelayedClose = _React$useContext.onDelayedClose,
      onDelayedOpen = _React$useContext.onDelayedOpen,
      portalElement = _React$useContext.portalElement,
      refContent = _React$useContext.refContent; // TODO: extract this to Storybook story somehow so supporting numbers as strings is not required


  function isNumber(n) {
    return RegExp(/^[0-9]+$/).test(n);
  }

  function handleMouseEvent(event) {
    if (!isEager) return;

    if (event.type === "mouseover") {
      onDelayedOpen();
    } else if (event.type === "mouseout") {
      onDelayedClose();
    }
  }

  function handleBlur(event) {
    // onblur canceling onclick the following happens when:
    // Clicking twice the trigger button (open, close), will fire an onclick and onblur event
    // creating a race condition nullyfing the onClick and keeping the popover open
    // https://stackoverflow.com/questions/121499/when-a-blur-event-occurs-how-can-i-find-out-which-element-focus-went-to
    // the previous link answer suggested the use of the mouseDown event, thought, that will kill all accessibility of onClick,
    // as well will affect the devUX when you want to have a controlled Popover forcing the use of mouseDown event instead of onClick
    // Solution https://stackoverflow.com/a/121708/196038
    // Use timeout to delay examination of activeElement until after blur/focus
    // events have been processed.
    var currentTarget = event.currentTarget;
    setTimeout(function () {
      if (!(0, _isElementContainsFocus["default"])(currentTarget)) {
        onClose();
        onBlur();
      }
    }, (0, _parseInt2["default"])(_Popover.consts.transition, 10));
  }

  function cssValue(value) {
    return isNumber(value) ? "".concat(value, "px") : value;
  }

  var handleRef = function handleRef(_ref) {
    refContent(_ref);

    if (ref) {
      // https://github.com/reactjs/rfcs/blob/master/text/0017-new-create-ref.md#basic-example
      ref.current = _ref; // eslint-disable-line
    }
  };

  var contentStyles = {
    left: content.x,
    top: content.y,
    maxWidth: cssValue(content.maxWidth),
    minWidth: cssValue(content.minWidth)
  };

  if (content.width && content.width !== "auto") {
    contentStyles.width = content.width;
  }
  /* eslint-disable jsx-a11y/mouse-events-have-key-events */


  var ContentStyledComponent = /*#__PURE__*/_react["default"].createElement(_Content.ContentStyled, (0, _extends2["default"])({
    "aria-hidden": !isOpen,
    "data-component-name": "PopoverContent",
    "data-pka-anchor": "popover.content",
    ref: handleRef,
    id: isEager ? content.ariaId : null,
    isOpen: isOpen,
    onBlur: handleBlur,
    onMouseOut: handleMouseEvent,
    onMouseOver: handleMouseEvent,
    style: contentStyles,
    tabIndex: "-1",
    zIndex: content.zIndex
  }, moreProps), props.children);

  if (isPortal) {
    return /*#__PURE__*/_reactDom["default"].createPortal(ContentStyledComponent, portalElement);
  }

  return ContentStyledComponent;
});
/* eslint-enable jsx-a11y/mouse-events-have-key-events */


Content.displayName = "Popover.Content";
Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
var _default = Content;
exports["default"] = _default;
//# sourceMappingURL=Content.js.map

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var isElementContainsFocus = function isElementContainsFocus(element) {
  if (document.activeElement === element) return true;
  return element.contains(document.activeElement);
};

var _default = isElementContainsFocus;
exports["default"] = _default;
//# sourceMappingURL=isElementContainsFocus.js.map

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var sc = _interopRequireWildcard(__webpack_require__(1132));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** If the visual focus ring should be displayed with an inset style. */
  hasInsetFocusStyle: _propTypes["default"].bool,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  isActive: null,
  isDisabled: false,
  hasInsetFocusStyle: false,
  onClick: function onClick() {},
  role: "button",
  tabIndex: null
};

var isTriggerKey = function isTriggerKey(key) {
  return [" ", "Enter"].includes(key);
};

var RawButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      onClick = props.onClick,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "isActive", "isDisabled", "onClick", "tabIndex"]);

  var rawButtonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        rawButtonRef.current.focus();
      }
    };
  });

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);
    if (!canPropagate) event.stopPropagation();
    if (!isDisabled) onClick(event);
  };

  function handleBlur(event) {
    if (moreProps.onBlur) moreProps.onBlur(event);
    setHasForcedFocus(false);
  }

  var handleKeyDown = function handleKeyDown(event) {
    // Prevent scrolling the page with a spacerbar keypress
    // Prevent submitting forms in IE/Edge with and enter keypress
    if (isTriggerKey(event.key)) event.preventDefault();
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;
    if (shouldHandle && moreProps.onKeyDown) moreProps.onKeyDown(event);
  };

  var handleKeyUp = function handleKeyUp(event) {
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;

    if (!isDisabled && shouldHandle && isTriggerKey(event.key)) {
      onClick(event);
    }

    if (shouldHandle && moreProps.onKeyUp) moreProps.onKeyUp(event);
  };

  var bestTabIndex = isDisabled && tabIndex === null ? -1 : tabIndex || 0;
  return /*#__PURE__*/_react["default"].createElement(sc.RawButton, (0, _extends2["default"])({
    "aria-pressed": isActive,
    "data-pka-anchor": "raw-button",
    tabIndex: bestTabIndex,
    "aria-label": a11yText
  }, moreProps, {
    "aria-disabled": isDisabled,
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isDisabled,
    onBlur: handleBlur,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: rawButtonRef
  }), children);
});

RawButton.displayName = "RawButton";
RawButton.propTypes = propTypes;
RawButton.defaultProps = defaultProps;
var _default = RawButton;
exports["default"] = _default;
//# sourceMappingURL=RawButton.js.map

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RawButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var focusStyles = function focusStyles(isInset) {
  return (0, _styledComponents.css)(["&:focus{", "}[data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{box-shadow:none;outline:none;}"], _stylers["default"].focusRing(isInset));
};

var disabledStyles = (0, _styledComponents.css)(["cursor:not-allowed;&:focus{box-shadow:none;}"]);

var RawButton = _styledComponents["default"].span.withConfig({
  displayName: "RawButtonstyles__RawButton",
  componentId: "sc-1jqcbbw-0"
})(function (_ref) {
  var hasInsetFocusStyle = _ref.hasInsetFocusStyle,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["cursor:pointer;display:inline-block;", ";", ";"], isActive ? _stylers["default"].focusRing(hasInsetFocusStyle) : focusStyles(hasInsetFocusStyle), isDisabled && disabledStyles);
});

exports.RawButton = RawButton;
//# sourceMappingURL=RawButton.styles.js.map

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ContentStyled = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _Popover = __webpack_require__(503);

var ContentStyled = _styledComponents["default"].div.withConfig({
  displayName: "Contentstyles__ContentStyled",
  componentId: "sc-1abapfp-0"
})(["opacity:", ";position:fixed;transition:opacity ", " ease,visibility ", " ease;visibility:", ";z-index:", ";&:focus{outline:none;}"], function (props) {
  return props.isOpen ? 1 : 0;
}, _Popover.consts.transition, _Popover.consts.transition, function (props) {
  return props.isOpen ? "visible" : "hidden";
}, function (props) {
  return props.zIndex;
});

exports.ContentStyled = ContentStyled;
//# sourceMappingURL=Content.styles.js.map

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _PopoverContext = __webpack_require__(502);

var _Card = _interopRequireDefault(__webpack_require__(1135));

function Card(props) {
  var children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children"]);

  var isDark = _react["default"].useContext(_PopoverContext.ThemeContext);

  return /*#__PURE__*/_react["default"].createElement(_Card["default"], (0, _extends2["default"])({
    isDark: isDark,
    "data-pka-anchor": "popover.card"
  }, moreProps), children);
}

Card.displayName = "Popover.Card";
Card.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = Card;
exports["default"] = _default;
//# sourceMappingURL=Card.js.map

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var defaultStyles = "\n  background-color: ".concat(_tokens["default"].color.white, ";\n  border: 1px solid ").concat(_tokens["default"].border.color, ";\n  border-radius: ").concat(_tokens["default"].card.borderRadius, ";\n  box-shadow: ").concat(_tokens["default"].shadow, ";\n  color: ").concat(_tokens["default"].textColor["default"], ";\n  padding: ").concat(_tokens["default"].space, " ").concat(_tokens["default"].spaceLg, ";\n");
var darkStyles = "\n  background-color: ".concat(_tokens["default"].color.black, ";\n  border: 1px solid ").concat(_tokens["default"].color.black, ";\n  border-radius: ").concat(_tokens["default"].border.radius, ";\n  color: ").concat(_tokens["default"].color.white, ";\n  padding: ").concat(_tokens["default"].spaceSm, " ").concat(_tokens["default"].space, ";\n");

var CardStyled = _styledComponents["default"].div.withConfig({
  displayName: "Cardstyles__CardStyled",
  componentId: "sc-1penuek-0"
})(["", ";", ";", ";overflow:hidden;"], function (props) {
  return props.isDark ? darkStyles : defaultStyles;
}, _stylers["default"].fontSize(-1), _stylers["default"].lineHeight());

var _default = CardStyled;
exports["default"] = _default;
//# sourceMappingURL=Card.styles.js.map

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _rawButton = _interopRequireDefault(__webpack_require__(727));

var _isActiveElementPopover = __webpack_require__(1137);

var _PopoverContext = _interopRequireDefault(__webpack_require__(502));

var sc = _interopRequireWildcard(__webpack_require__(503));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var propTypes = {
  /** Descriptive a11y text for assistive technologies for the trigger. */
  a11yText: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]).isRequired
};
var defaultProps = {
  a11yText: null
};

function Trigger(props) {
  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      isEager = _React$useContext.isEager,
      isOpen = _React$useContext.isOpen,
      onClick = _React$useContext.onClick,
      onClose = _React$useContext.onClose,
      onDelayedClose = _React$useContext.onDelayedClose,
      onDelayedOpen = _React$useContext.onDelayedOpen,
      onOpen = _React$useContext.onOpen,
      shouldKeepFocus = _React$useContext.shouldKeepFocus;

  function handleTriggerEvent(event) {
    if (isEager && (event.type === "mouseover" || event.type === "focus")) {
      if (event.type === "mouseover") {
        onDelayedOpen();
      } else {
        onOpen();
      }
    } else if (isEager && event.type === "mouseout") {
      onDelayedClose();
    } else if ((shouldKeepFocus || isEager) && event.type === "blur") {
      window.requestAnimationFrame(function () {
        if (!(0, _isActiveElementPopover.isActiveElementPopover)()) onClose();
      });
    } else if (event.type === "click" || event.key === " " || event.key === "Enter") {
      onClick(event);
    }
  }

  var children = props.children,
      a11yText = props.a11yText,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "a11yText"]);

  if (typeof children === "function") {
    var a11yAttributes = {
      "aria-describedby": content.ariaId
    };
    return /*#__PURE__*/_react["default"].cloneElement(children(handleTriggerEvent, a11yAttributes, isOpen), _objectSpread({}, moreProps));
  }

  if (isEager) {
    return /*#__PURE__*/_react["default"].createElement(sc.Trigger, (0, _extends2["default"])({
      a11yText: a11yText,
      "data-pka-anchor": "popover.trigger",
      onMouseOver: handleTriggerEvent,
      onMouseOut: handleTriggerEvent,
      onFocus: handleTriggerEvent,
      onBlur: handleTriggerEvent,
      "aria-describedby": content.ariaId
    }, moreProps), children);
  }

  return /*#__PURE__*/_react["default"].createElement(_rawButton["default"], (0, _extends2["default"])({
    a11yText: a11yText,
    "data-pka-anchor": "popover.trigger",
    onClick: handleTriggerEvent,
    onBlur: shouldKeepFocus ? handleTriggerEvent : null
  }, moreProps), children);
}

Trigger.displayName = "Popover.Trigger";
Trigger.propTypes = propTypes;
Trigger.defaultProps = defaultProps;
var _default = Trigger;
exports["default"] = _default;
//# sourceMappingURL=Trigger.js.map

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isActiveElementPopover = void 0;

var isActiveElementPopover = function isActiveElementPopover() {
  return document.activeElement.dataset.componentName === "PopoverContent";
};

exports.isActiveElementPopover = isActiveElementPopover;
//# sourceMappingURL=isActiveElementPopover.js.map

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _PopoverContext = _interopRequireWildcard(__webpack_require__(502));

var _Tip = __webpack_require__(1139);

var propTypes = {
  /** Number setting the z-index */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  zIndex: null
};

function Tip(props) {
  var zIndex = props.zIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["zIndex"]);

  var isDark = _react["default"].useContext(_PopoverContext.ThemeContext);

  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      tip = _React$useContext.tip,
      refTip = _React$useContext.refTip,
      isOpen = _React$useContext.isOpen,
      isPortal = _React$useContext.isPortal,
      portalElement = _React$useContext.portalElement;

  var borderColor = isDark ? _tokens["default"].color.black : _tokens["default"].border.color;
  var backgroundColor = isDark ? _tokens["default"].color.black : _tokens["default"].color.white;

  var TipStyledComponent = /*#__PURE__*/_react["default"].createElement(_Tip.TipStyled, (0, _extends2["default"])({
    isOpen: isOpen,
    "data-pka-anchor": "popover.tip",
    ref: refTip,
    rotate: tip.rotate,
    style: {
      left: tip.x,
      top: tip.y
    },
    zIndex: zIndex || content.zIndex
  }, moreProps), /*#__PURE__*/_react["default"].createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "0 0 12 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "0 12 12 12 6 6",
    fill: borderColor
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "1 12 11 12 6 7",
    fill: backgroundColor
  })));

  if (isPortal) {
    return /*#__PURE__*/_reactDom["default"].createPortal(TipStyledComponent, portalElement);
  }

  return TipStyledComponent;
}

Tip.displayName = "Popover.Tip";
Tip.propTypes = propTypes;
Tip.defaultProps = defaultProps;
var _default = Tip;
exports["default"] = _default;
//# sourceMappingURL=Tip.js.map

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TipStyled = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Popover = __webpack_require__(503);

var TipStyled = _styledComponents["default"].div.withConfig({
  displayName: "Tipstyles__TipStyled",
  componentId: "sc-15lrbjo-0"
})(["display:block;height:", ";line-height:", ";opacity:", ";pointer-events:none;position:fixed;transform:rotate(", "deg);transition:opacity ", " ease,visibility ", " ease;visibility:", ";width:", ";z-index:", ";"], _stylers["default"].spacer(2), _stylers["default"].spacer(2), function (props) {
  return props.isOpen ? 1 : 0;
}, function (props) {
  return props.rotate || "0";
}, _Popover.consts.transition, _Popover.consts.transition, function (props) {
  return props.isOpen ? "visible" : "hidden";
}, _stylers["default"].spacer(2), function (props) {
  return props.zIndex;
});

exports.TipStyled = TipStyled;
//# sourceMappingURL=Tip.styles.js.map

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AppSwitcherTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n__);



var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  launchpadUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
var defaultProps = {
  children: ''
};
function AppSwitcherTitle(props) {
  var launchpadUrl = props.launchpadUrl,
      children = props.children;
  var i18n = __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n___default()();
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "navigation-app-switcher__title-bar"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    "aria-label": i18n.t('global_navigation.navigation_items.logo'),
    className: "navigation-app-switcher__logo",
    href: launchpadUrl,
    target: "_top"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 639 548"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#F0A117",
    fillRule: "evenodd",
    d: "M456.396,365.44 L638.97,0.317 L456.417,0.317 L298.212,316.7 L298.213,316.687 C292.286,328.291 281.386,331.669 273.701,331.669 C266.569,331.669 256.407,328.196 250.599,318.936 L182.553,182.876 L0,182.876 L91.292,365.44 L91.297,365.44 L0,548 L182.553,548 L249.482,414.176 L249.481,414.192 C255.407,402.585 266.307,399.21 273.992,399.21 C281.124,399.21 291.287,402.681 297.094,411.943 L365.14,548 L547.695,548 L456.401,365.44 L456.396,365.44"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "navigation-app-switcher__product-title"
  }, children));
}
AppSwitcherTitle.propTypes = propTypes;
AppSwitcherTitle.defaultProps = defaultProps;

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__paprika_raw_button__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__paprika_raw_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__paprika_raw_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__paprika_tokens__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__paprika_tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__paprika_tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_CaretUp__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_CaretUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_CaretUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_CaretDown__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_CaretDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_CaretDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__organizationShape__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DefaultLogo__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OrgSwitcher_OrgSwitcher__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OrganizationSwitcher_scss__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OrganizationSwitcher_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__OrganizationSwitcher_scss__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













function OrganizationSwitcher(_ref) {
  var activeOrganizationId = _ref.activeOrganizationId,
      organizations = _ref.organizations,
      logoText = _ref.logoText,
      otherText = _ref.otherText,
      moreProps = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["activeOrganizationId", "organizations", "logoText", "otherText"]);

  var activeOrganization = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useMemo(function () {
    return organizations.find(function (organization) {
      return organization.id === activeOrganizationId;
    });
  }, [organizations]);

  function renderOrganizationValue(ariaLabel, _onClick, isExpanded, triggerRef) {
    if (organizations.length === 1) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
        "aria-label": ariaLabel,
        className: "organization-switcher switcher-simple"
      }, activeOrganization.logo ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
        className: "logo-wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", {
        alt: "".concat(activeOrganization.name, " ").concat(logoText),
        src: activeOrganization.logo,
        className: "organization-switcher__company-logo"
      })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DefaultLogo__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
        className: "organization-switcher__value-wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
        className: "organization-switcher__value",
        "data-testid": "organizationSwitcherCustomerName"
      }, activeOrganization.name)));
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: "organization-switcher__listbox-wrapper"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__paprika_raw_button___default.a, {
      ariaLabel: ariaLabel,
      className: "organization-switcher",
      onClick: function onClick(e) {
        return _onClick(e);
      },
      ref: triggerRef
    }, activeOrganization.logo ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      className: "logo-wrapper"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", {
      alt: "".concat(activeOrganization.customerName, " ").concat(activeOrganization.name, " ").concat(logoText),
      src: activeOrganization.logo,
      className: "organization-switcher__company-logo"
    })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DefaultLogo__["a" /* default */], {
      className: "organization-switcher__default-logo"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: "organization-switcher__value-wrapper"
    }, activeOrganization.customerName && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      className: "organization-switcher__value",
      "data-testid": "organizationSwitcherCustomerName"
    }, activeOrganization.customerName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      className: "organization-switcher__value",
      "data-testid": "organizationSwitcherOrganizationName"
    }, activeOrganization.name)), isExpanded ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__acl_services_wasabicons_lib_CaretUp___default.a, {
      color: __WEBPACK_IMPORTED_MODULE_7__paprika_tokens___default.a.color.white
    }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__acl_services_wasabicons_lib_CaretDown___default.a, {
      color: __WEBPACK_IMPORTED_MODULE_7__paprika_tokens___default.a.color.white
    })));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__OrgSwitcher_OrgSwitcher__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, moreProps, {
    className: "organization-switcher-wrapper",
    organizations: organizations,
    renderTrigger: renderOrganizationValue,
    selectedOrg: {
      id: activeOrganization.id,
      heading: activeOrganization.customerName || otherText,
      title: activeOrganization.name,
      logo: activeOrganization.logo,
      isSelected: false
    }
  }));
}

var commonPropTypes = {
  activeOrganizationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
  organizations: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__organizationShape__["a" /* default */])).isRequired
};
OrganizationSwitcher.propTypes = _objectSpread(_objectSpread({}, commonPropTypes), {}, {
  logoText: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  otherText: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
});

function OrganizationSwitcherWithContext(props) {
  var i18n = __WEBPACK_IMPORTED_MODULE_5__paprika_l10n_lib_useI18n___default()();
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(OrganizationSwitcher, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, props, {
    logoText: i18n.t('global_navigation.logo'),
    otherText: i18n.t('global_navigation.other')
  }));
}

OrganizationSwitcherWithContext.propTypes = commonPropTypes;
/* harmony default export */ __webpack_exports__["a"] = (OrganizationSwitcherWithContext);

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "CaretUp___StyledSvg",
  componentId: "rwdaeu-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgCaretUp = function SvgCaretUp(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.099 8.742a1.501 1.501 0 00-2.223 0c-1.41 1.554-3.83 4.22-5.256 5.789a.753.753 0 00.556 1.257h11.623a.751.751 0 00.556-1.257l-5.256-5.789z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgCaretUp;
exports["default"] = _default;
//# sourceMappingURL=CaretUp.js.map

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "CaretDown___StyledSvg",
  componentId: "dw438p-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgCaretDown = function SvgCaretDown(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.099 15.258a1.501 1.501 0 01-2.223 0c-1.41-1.554-3.83-4.22-5.256-5.789a.753.753 0 01.556-1.257h11.623a.751.751 0 01.556 1.257l-5.256 5.789z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgCaretDown;
exports["default"] = _default;
//# sourceMappingURL=CaretDown.js.map

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var DefaultLogo = function DefaultLogo(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156 156"
  }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("title", null, "no-logo-1"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
    id: "no-logo-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
    id: "icon-building"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect", {
    id: "Frame",
    width: "156",
    height: "156",
    rx: "20",
    fill: "#f0f0f0"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", {
    id: "Shape",
    d: "M118.12,29a4.49,4.49,0,0,1,4.48,4.27v88.85a4.48,4.48,0,0,1-4.27,4.48H37.48A4.49,4.49,0,0,1,33,122.33V33.48A4.49,4.49,0,0,1,37.27,29h80.85ZM86.28,104.68h-17v13h17ZM113.64,38H42v79.68h18.4V100.2a4.49,4.49,0,0,1,4.27-4.48H90.76A4.5,4.5,0,0,1,95.24,100v17.65h18.4Zm-13.84,33v9h-9v-9Zm-17.92,0v9h-9v-9ZM64,70.92v9H55v-9ZM81.88,53v9h-9V53ZM99.8,53v9h-9V53ZM64,53v9H55V53Z",
    fill: "#a3a3a3"
  }))));
};

/* harmony default export */ __webpack_exports__["a"] = (DefaultLogo);

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _ListBox = _interopRequireWildcard(__webpack_require__(1146));

var _extractChildren2 = _interopRequireDefault(__webpack_require__(1209));

var _Divider = _interopRequireDefault(__webpack_require__(1210));

var _BoxShell = _interopRequireDefault(__webpack_require__(1213));

var _Filter = _interopRequireDefault(__webpack_require__(1214));

var _Footer = _interopRequireDefault(__webpack_require__(1233));

var _Option = _interopRequireDefault(__webpack_require__(744));

var _Popover = _interopRequireDefault(__webpack_require__(735));

var _RawItem = _interopRequireDefault(__webpack_require__(1239));

var _Trigger = _interopRequireDefault(__webpack_require__(736));

var _Provider = _interopRequireDefault(__webpack_require__(731));

var _OnChangeProvider = _interopRequireDefault(__webpack_require__(508));

var ListBoxWithProvider = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children"]);
  /*
  Assures the structure of the children is one of the following:
   <React.Fragrment>
    <ListBox.Option />
  </React.Fragrment>
   - OR -
    [
      <React.Fragrment>
        <ListBox.Option />
      </React.Fragrment>,
      <React.Fragrment>
        <ListBox.Option />
      </React.Fragrment>
    ]
    */

  var _children = _react["default"].Children.map(children, function (child) {
    return child !== null && _react["default"].Fragment === child.type ? child.props.children : child;
  });

  var _extractChildren = (0, _extractChildren2["default"])(_children, ["ListBox.Filter", "ListBox.Footer", "ListBox.Popover", "ListBox.Trigger", "ListBox.Box"]),
      filter = _extractChildren["ListBox.Filter"],
      footer = _extractChildren["ListBox.Footer"],
      popover = _extractChildren["ListBox.Popover"],
      trigger = _extractChildren["ListBox.Trigger"],
      box = _extractChildren["ListBox.Box"],
      options = _extractChildren.children;

  return /*#__PURE__*/_react["default"].createElement(_Provider["default"], (0, _extends2["default"])({}, moreProps, {
    childrenOptions: options
  }), /*#__PURE__*/_react["default"].createElement(_OnChangeProvider["default"], {
    onChange: props.onChange
  }, /*#__PURE__*/_react["default"].createElement(_ListBox["default"], (0, _extends2["default"])({}, moreProps, {
    ref: ref,
    filter: filter,
    footer: footer,
    popover: popover,
    trigger: trigger,
    box: box
  }), options)));
});

var _default = ListBoxWithProvider;
exports["default"] = _default;
ListBoxWithProvider.Box = _BoxShell["default"];
ListBoxWithProvider.Divider = _Divider["default"];
ListBoxWithProvider.Filter = _Filter["default"];
ListBoxWithProvider.Footer = _Footer["default"];
ListBoxWithProvider.Option = _Option["default"];
ListBoxWithProvider.Popover = _Popover["default"];
ListBoxWithProvider.RawItem = _RawItem["default"];
ListBoxWithProvider.Trigger = _Trigger["default"];
ListBoxWithProvider.defaultProps = _ListBox.defaultProps;
ListBoxWithProvider.displayName = "ListBox";
ListBoxWithProvider.propTypes = _ListBox.propTypes;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.ListBox = ListBox;
exports["default"] = exports.defaultProps = exports.propTypes = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useI18n = _interopRequireDefault(__webpack_require__(729));

var constants = _interopRequireWildcard(__webpack_require__(40));

var _Box = _interopRequireDefault(__webpack_require__(1156));

var _Content = _interopRequireDefault(__webpack_require__(1161));

var _List = _interopRequireDefault(__webpack_require__(1180));

var _NoResults = _interopRequireDefault(__webpack_require__(1183));

var _Options = _interopRequireDefault(__webpack_require__(1186));

var _Popover = _interopRequireDefault(__webpack_require__(735));

var _Trigger = _interopRequireDefault(__webpack_require__(736));

var _useListBox5 = _interopRequireDefault(__webpack_require__(140));

var _OnChangeProvider = __webpack_require__(508);

var _imperative = _interopRequireDefault(__webpack_require__(1204));

__webpack_require__(1206);

var _hooks = __webpack_require__(1207);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function ListBox(props) {
  var _useListBox = (0, _useListBox5["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 1),
      state = _useListBox2[0];

  var children = props.children,
      hasImplicitAll = props.hasImplicitAll,
      height = props.height,
      placeholder = props.placeholder,
      _trigger = props.trigger,
      footer = props.footer,
      filter = props.filter,
      _props$box = props.box,
      box = _props$box === void 0 ? {
    props: {}
  } : _props$box;
  var I18n = (0, _useI18n["default"])();
  var propsForTrigger = {
    hasClearButton: true,
    hasImplicitAll: hasImplicitAll,
    onClickClear: null,
    placeholder: placeholder || I18n.t("listBox.trigger.placeholder"),
    onFooterClickAccept: footer ? footer.props.onClickAccept : null
  };
  var trigger = _trigger ? /*#__PURE__*/_react["default"].cloneElement(_trigger, _objectSpread(_objectSpread({}, propsForTrigger), _trigger.props)) : /*#__PURE__*/_react["default"].createElement(_Trigger["default"], propsForTrigger);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, trigger, /*#__PURE__*/_react["default"].createElement(_Content["default"], {
    onCancelFooter: footer ? footer.props.onClickCancel : null
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], box.props, filter, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    height: height
  }, /*#__PURE__*/_react["default"].createElement(_Options["default"], {
    isPopoverOpen: props.isOpen
  }, children)), filter ? /*#__PURE__*/_react["default"].createElement(_NoResults["default"], {
    label: filter.props.noResultsMessage || I18n.t("listBox.filter.no_results_message")
  }) : null, footer ? /*#__PURE__*/_react["default"].cloneElement(footer, {
    ref: state.refFooterContainer
  }) : null)));
}

var ListBoxContainer = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useListBox3 = (0, _useListBox5["default"])(),
      _useListBox4 = (0, _slicedToArray2["default"])(_useListBox3, 2),
      state = _useListBox4[0],
      dispatch = _useListBox4[1];

  var onChangeContext = _react["default"].useContext(_OnChangeProvider.OnChangeContext);

  var I18n = (0, _useI18n["default"])();
  var box = props.box,
      children = props.children,
      filter = props.filter,
      footer = props.footer,
      hasImplicitAll = props.hasImplicitAll,
      height = props.height,
      isInline = props.isInline,
      placeholder = props.placeholder,
      popover = props.popover,
      isOpen = props.isOpen,
      trigger = props.trigger; // IMPERATIVE API

  var imperativeHandle = (0, _imperative["default"])({
    state: state,
    dispatch: dispatch,
    onChangeContext: onChangeContext
  });

  _react["default"].useImperativeHandle(ref, imperativeHandle); // HOOKS
  // eslint-disable-next-line react/prop-types


  var shouldTriggerKeepFocus = popover && popover.props.shouldKeepFocus;
  (0, _hooks.useAdjustWidth)();
  (0, _hooks.useChildrenChange)(children);
  (0, _hooks.useIsDisabled)(props.isDisabled);
  (0, _hooks.useIsPopOverOpen)(shouldTriggerKeepFocus);
  (0, _hooks.useOnScrolled)();
  (0, _hooks.useOptionSelected)();
  (0, _hooks.useHasFooter)(footer);
  var propsForListBox = {
    children: children,
    filter: filter,
    footer: footer,
    hasImplicitAll: hasImplicitAll,
    height: height,
    placeholder: placeholder || I18n.t("listBox.trigger.placeholder"),
    trigger: trigger,
    isOpen: isOpen,
    box: box
  };

  var listBox = /*#__PURE__*/_react["default"].createElement(ListBox, propsForListBox, children);

  if (isInline) {
    return listBox;
  }

  if (popover) {
    var PopoverClone = /*#__PURE__*/_react["default"].cloneElement(popover, _objectSpread(_objectSpread({}, popover.props), {}, {
      children: listBox
    }));

    return PopoverClone;
  }

  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], null, listBox);
});

ListBoxContainer.types = {
  size: constants.defaultSize
};
var propTypes = {
  /** Child of type <ListBox.Option /> */
  children: _propTypes["default"].node,

  /** Has implicit "All items selected" value when no item is selected */
  hasImplicitAll: _propTypes["default"].bool,

  /** Indicate which is the height for the options container */
  height: _propTypes["default"].number,

  /** Disables the ListBox if true */
  isDisabled: _propTypes["default"].bool,

  /** This options will display the list-box without the Popover */
  isInline: _propTypes["default"].bool,

  /** Let the user to select multiple options at same time */
  isMulti: _propTypes["default"].bool,

  /** Indicates if the popover is visible */
  isOpen: _propTypes["default"].bool,

  /** Callback returning the current selection on the ListBox */
  onChange: _propTypes["default"].func,

  /** Defaults label to display when the ListBox has not option selected */
  placeholder: _propTypes["default"].string,

  /** Size of the trigger and options (font size, height, padding, etc). */
  size: _propTypes["default"].oneOf([ListBoxContainer.types.size.SMALL, ListBoxContainer.types.size.MEDIUM, ListBoxContainer.types.size.LARGE])
};
exports.propTypes = propTypes;
ListBox.propTypes = _objectSpread(_objectSpread({}, propTypes), {}, {
  children: _propTypes["default"].node.isRequired,
  height: _propTypes["default"].number.isRequired,
  placeholder: _propTypes["default"].string.isRequired
});
var defaultProps = {
  children: null,
  filter: null,
  // eslint-disable-line
  footer: null,
  // eslint-disable-line
  hasImplicitAll: false,
  height: 200,
  isDisabled: false,
  isInline: false,
  isMulti: false,
  isOpen: null,
  onChange: function onChange() {},
  placeholder: null,
  size: ListBoxContainer.types.size.MEDIUM,
  trigger: null // eslint-disable-line

};
exports.defaultProps = defaultProps;
ListBoxContainer.propTypes = propTypes;
ListBoxContainer.defaultProps = defaultProps;
var _default = ListBoxContainer;
exports["default"] = _default;
//# sourceMappingURL=ListBox.js.map

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var L10nContext = _react["default"].createContext();

var _default = L10nContext;
exports["default"] = _default;
//# sourceMappingURL=L10nContext.js.map

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.i18n = exports.defaultLocale = void 0;

var _i18next = _interopRequireDefault(__webpack_require__(100));

var _locales = _interopRequireDefault(__webpack_require__(730));

var defaultLocale = "en";
exports.defaultLocale = defaultLocale;

var i18n = function i18n(locales) {
  var i18nConfig = {
    lng: defaultLocale,
    fallbackLng: defaultLocale,
    lowerCaseLng: true,
    resources: locales || _locales["default"]
  };

  var newInstance = _i18next["default"].createInstance(i18nConfig, function (err) {
    if (err) return console.log("something went wrong loading i18next", err);
    return null;
  });

  return newInstance;
};

exports.i18n = i18n;
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "en": {
    "translation": {
      "timePicker": {
        "am": "am",
        "custom": "Custom",
        "hours": "Hours",
        "minutes": "Minutes",
        "period": "Period",
        "pm": "pm"
      },
      "back": "Back",
      "remove": "remove",
      "moreInformation": "more information",
      "close": "Close",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. You are on row {{rowIndex}}, column {{columnIndex}}. Disregard the following information:"
      },
      "uploader": {
        "drop_files": "Drop files to upload",
        "drop_files_here_or": "Drop files to upload here or",
        "choose_from_computer": "choose from your computer",
        "choose_from_computer_a11y": "Choose files from your computer",
        "cancel_upload": "Cancel upload",
        "restart_upload": "Restart upload",
        "file_list": "List of files",
        "errors": {
          "size": "File must be smaller than {{maxFileSize}}",
          "type": "File must be one of the following types: {{- supportedTypes}}"
        },
        "status": {
          "idle": "Idle",
          "processing": "Processing",
          "uploading": "Uploading",
          "success": "Success",
          "cancel": "Cancel",
          "error": "Error"
        },
        "progress": {
          "cancelled": "Cancelled",
          "complete": "Complete",
          "idle": "Idle",
          "uploading": "Uploading {{progressWithUnits}} of {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "Delete",
        "apply": "Apply",
        "cancel": "Cancel",
        "confirm": "Save",
        "decline": "Decline"
      },
      "datePicker": {
        "confirmation_format": "MMMM DD, YYYY"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Month",
        "year": "Year"
      },
      "daterange": {
        "last_7_days": "Last 7 Days",
        "last_30_days": "Last 30 Days",
        "this_month": "This Month",
        "last_month": "Last Month",
        "start_date": "Start Date",
        "end_date": "End Date"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} opens in a new tab."
      },
      "comment": {
        "delete": "Delete comment"
      },
      "pagination": {
        "intro": "Pagination, currently on page {{currentPage}}",
        "page": "Page {{pageNumber}}",
        "ellipsis": "More pages",
        "prev": "Previous page",
        "next": "Next page"
      },
      "formElement": {
        "optional": "(optional)",
        "required": "(required)",
        "aria_info_circle": "Information"
      },
      "prevNextArrowButton": {
        "arrowup": "up",
        "arrowdown": "down",
        "escape": "escape"
      },
      "collapsible": {
        "ariaText": "Collapsible section"
      },
      "sortable": {
        "aria_description": "Draggable item. Press space to lift.",
        "aria_lift": "You have lifted an item in position {{source}}. Use the arrow keys to move, space to drop, and escape to cancel.",
        "aria_moving": "You have moved the item from position {{source}} to position {{destination}}.",
        "aria_moving_outside": "You are currently not dragging over a droppable area.",
        "aria_cancelled": "Movement cancelled. The item has returned to its starting position of {{source}}.",
        "aria_dropped": "You have dropped the item. It has moved from position {{source}} to {{destination}}.",
        "aria_dropped_outside": "The item has been dropped while not over the list. The item has returned to its starting position of {{source}}.",
        "aria_remove": "Remove"
      },
      "progressAccordion": {
        "active": "active",
        "no_response": "None"
      },
      "collapsibleText": {
        "more": "Show more",
        "less": "Show less",
        "more_about": "show more about {{topic}}",
        "less_about": "show less about {{topic}}"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Select..."
        },
        "filter": {
          "a11y_text": "Filter",
          "no_results_message": "Your search result did not match any options.",
          "placeholder": "Filter..."
        }
      },
      "listBoxBrowser": {
        "explore": "Explore more options",
        "selected": "selected options",
        "selectOne": "Select one or more items..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Hide all",
          "show_all": "Show all",
          "label": "Arrange",
          "singular_label": "1 column hidden",
          "plural_label": "{{numberOfHiddenColumn}} columns hidden",
          "search_placeholder": "Filter..."
        },
        "no_results": "No results",
        "filter": {
          "no_filters_applied": "No filters applied to this view",
          "label": "Filter",
          "singular_label": "1 filter applied",
          "plural_label": "{{numberOfFilters}} filters applied",
          "add_filter": "Add a field to filter by",
          "and": "and",
          "or": "or",
          "where": "Where",
          "rules": {
            "is": "is",
            "is_not": "is not",
            "contains": "contains",
            "does_not_contain": "does not contain",
            "is_blank": "is blank",
            "is_not_blank": "is not blank",
            "equals": "equals",
            "not_equal_to": "not equal to",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "is empty",
            "is_not_empty": "is not empty",
            "is_before": "is before",
            "is_after": "is after",
            "true": "true",
            "false": "false"
          }
        },
        "search_placeholder": "Search...",
        "search_a11y_text": "Search the data",
        "sort": {
          "no_sorts_applied": "No sorts applied to this view",
          "label": "Sort",
          "singular_label": "1 column sorted",
          "plural_label": "{{numberOfFields}} columns sorted",
          "add_field": "Add a field to sort by",
          "sort_by": "Sort by",
          "then_by": "then by",
          "rules": {
            "ascending": {
              "boolean": "Sort ascending (true → false)",
              "number": "Sort ascending (1 → 9)",
              "text": "Sort ascending (A → Z)",
              "date": "Sort ascending (1 → 9)",
              "single_select": "Sort ascending (A → Z)"
            },
            "descending": {
              "boolean": "Sort descending (false → true)",
              "number": "Sort descending (9 → 1)",
              "text": "Sort descending (Z → A)",
              "date": "Sort descending (9 → 1)",
              "single_select": "Sort descending (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Breadcrumbs",
        "aria_expand": "Show all breadcrumb items.",
        "aria_back_to": "Back to"
      },
      "sideNavigation": {
        "aria_label": "Side navigation",
        "trigger_aria_label": "Open navigation"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=en.js.map

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "de": {
    "translation": {
      "timePicker": {
        "am": "AM",
        "custom": "Angepasst",
        "hours": "Stunden",
        "minutes": "Minuten",
        "period": "Zeitraum",
        "pm": "PM"
      },
      "back": "Zurück",
      "remove": "entfernen",
      "moreInformation": "weitere Informationen",
      "close": "Schließen",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. Sie befinden sich in Reihe {{rowIndex}}, Spalte {{columnIndex}}. Ignorieren Sie die folgenden Informationen:"
      },
      "uploader": {
        "drop_files": "Dateien zum Hochladen ablegen",
        "drop_files_here_or": "Legen Sie Dateien zum Hochladen hier ab oder",
        "choose_from_computer": "wählen Sie sie auf Ihrem Computer aus",
        "choose_from_computer_a11y": "Wählen Sie Dateien auf Ihrem Computer aus",
        "cancel_upload": "Upload abbrechen",
        "restart_upload": "Upload neu starten",
        "file_list": "Liste der Dateien",
        "errors": {
          "size": "Datei muss kleiner als {{maxFileSize}} sein",
          "type": "Datei muss die Datei einen der folgenden Dateitypen aufweisen: {{- supportedTypes}}"
        },
        "status": {
          "idle": "Inaktiv",
          "processing": "In Bearbeitung",
          "uploading": "Wird hochgeladen",
          "success": "Erfolg",
          "cancel": "Abbrechen",
          "error": "Fehler"
        },
        "progress": {
          "cancelled": "Abgebrochen",
          "complete": "Abgeschlossen",
          "idle": "Inaktiv",
          "uploading": "{{progressWithUnits}} von {{sizeWithUnits}} werden hochgeladen"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "Löschen",
        "apply": "Anwenden",
        "cancel": "Abbrechen",
        "confirm": "Speichern",
        "decline": "Ablehnen"
      },
      "datePicker": {
        "confirmation_format": "DD. MMMM YYYY"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Monat",
        "year": "Jahr"
      },
      "daterange": {
        "last_7_days": "Letzte 7 Tage",
        "last_30_days": "Letzte 30 Tage",
        "this_month": "Diesen Monat",
        "last_month": "Letzten Monat",
        "start_date": "Anfangsdatum",
        "end_date": "Enddatum"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} wird auf einer neuen Registerkarte geöffnet."
      },
      "comment": {
        "delete": "Anmerkung löschen"
      },
      "pagination": {
        "intro": "Seitennummerierung, aktuell auf Seite {{currentPage}}",
        "page": "Seite {{pageNumber}}",
        "ellipsis": "Weitere Seiten",
        "prev": "Vorherige Seite",
        "next": "Nächste Seite"
      },
      "formElement": {
        "optional": "(optional)",
        "required": "(erforderlich)",
        "aria_info_circle": "Informationen"
      },
      "prevNextArrowButton": {
        "arrowup": "Auf",
        "arrowdown": "Ab",
        "escape": "Escape"
      },
      "collapsible": {
        "ariaText": "Einklappbarer Abschnitt"
      },
      "sortable": {
        "aria_description": "Ziehbares Element. Drücken Sie zum Anheben die Leertaste.",
        "aria_lift": "Sie haben ein Element in Position {{source}} angehoben. Verwenden Sie die Pfeiltasten, um es zu bewegen, die Leertaste, um es fallen zu lassen, und Esc, um Aktion abzubrechen.",
        "aria_moving": "Sie haben das Element von Position {{source}} an Position {{destination}} verschoben.",
        "aria_moving_outside": "Sie ziehen das Element derzeit nicht über einen Bereich, auf dem Sie es ablegen können.",
        "aria_cancelled": "Verschieben abgebrochen. Das Element ist in seine Ausgangsposition von {{source}} zurückgekehrt.",
        "aria_dropped": "Sie haben das Element abgelegt. Das Element wurde von Position {{source}} an Position {{destination}} verschoben.",
        "aria_dropped_outside": "Das Element wurde abgelegt, während es sich nicht über der Liste befand. Das Element ist in seine Ausgangsposition von {{source}} zurückgekehrt.",
        "aria_remove": "Entfernen"
      },
      "progressAccordion": {
        "active": "aktiv",
        "no_response": "Keine"
      },
      "collapsibleText": {
        "more": "Mehr anzeigen",
        "less": "Weniger anzeigen",
        "more_about": "Mehr über {{topic}} anzeigen",
        "less_about": "Weniger über {{topic}} anzeigen"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Auswählen..."
        },
        "filter": {
          "a11y_text": "Filtern",
          "no_results_message": "Ihr Suchergebnis entsprach keiner der Optionen.",
          "placeholder": "Filtern..."
        }
      },
      "listBoxBrowser": {
        "explore": "Weitere Optionen anzeigen",
        "selected": "ausgewählte Optionen",
        "selectOne": "Ein oder mehrere Elemente auswählen..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Alles ausblenden",
          "show_all": "Alles anzeigen",
          "label": "Neu anordnen",
          "singular_label": "1 Spalte ausgeblendet",
          "plural_label": "{{numberOfHiddenColumn}} Spalten ausgeblendet",
          "search_placeholder": "Filtern..."
        },
        "no_results": "Keine Ergebnisse",
        "filter": {
          "no_filters_applied": "Auf diese Ansicht wurden keine Filter angewendet",
          "label": "Filtern",
          "singular_label": "1 Filter angewendet",
          "plural_label": "{{numberOfFilters}} Filter angewendet",
          "add_filter": "Feld hinzufügen zum Filtern nach",
          "and": "und",
          "or": "oder",
          "where": "Mit",
          "rules": {
            "is": "ist",
            "is_not": "ist nicht",
            "contains": "enthält",
            "does_not_contain": "enthält nicht",
            "is_blank": "bleibt leer",
            "is_not_blank": "bleibt nicht leer",
            "equals": "gleich",
            "not_equal_to": "ungleich",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "ist leer",
            "is_not_empty": "ist nicht leer",
            "is_before": "ist vor",
            "is_after": "ist nach",
            "true": "wahr",
            "false": "falsch"
          }
        },
        "search_placeholder": "Suchen...",
        "search_a11y_text": "Daten durchsuchen",
        "sort": {
          "no_sorts_applied": "Auf diese Ansicht wurde keine Sortierung angewendet",
          "label": "Sortieren",
          "singular_label": "1 Spalte sortiert",
          "plural_label": "{{numberOfFields}} Spalten sortiert",
          "add_field": "Feld hinzufügen zum Sortieren nach",
          "sort_by": "Sortieren nach",
          "then_by": "dann nach",
          "rules": {
            "ascending": {
              "boolean": "Aufsteigend sortieren (wahr → falsch)",
              "number": "Aufsteigend sortieren (1 → 9)",
              "text": "Aufsteigend sortieren (A → Z)",
              "date": "Aufsteigend sortieren (1 → 9)",
              "single_select": "Aufsteigend sortieren (A → Z)"
            },
            "descending": {
              "boolean": "Absteigend sortieren (falsch → wahr)",
              "number": "Absteigend sortieren (9 → 1)",
              "text": "Absteigend sortieren (Z → A)",
              "date": "Absteigend sortieren (9 → 1)",
              "single_select": "Absteigend sortieren (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Breadcrumbs",
        "aria_expand": "Sie können alle Breadcrumb-Elemente anzeigen."
      },
      "sideNavigation": {
        "aria_label": "Seiten-Navigation",
        "trigger_aria_label": "Navigation öffnen"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=de.js.map

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "fr": {
    "translation": {
      "timePicker": {
        "am": "am",
        "custom": "Personnalisé",
        "hours": "Heures",
        "minutes": "Minutes",
        "period": "Période",
        "pm": "pm"
      },
      "back": "Retour",
      "remove": "supprimer",
      "moreInformation": "plus d'informations",
      "close": "Fermer",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. Vous êtes désormais dans la ligne {{rowIndex}}, colonne {{columnIndex}}. Ignorez les informations suivantes :"
      },
      "uploader": {
        "drop_files": "Déposer les fichiers à charger",
        "drop_files_here_or": "Déposer les fichiers à charger ici ou",
        "choose_from_computer": "parcourir votre ordinateur",
        "choose_from_computer_a11y": "Choisir des fichiers dans votre ordinateur",
        "cancel_upload": "Annuler le chargement",
        "restart_upload": "Recommencer le chargement",
        "file_list": "Liste des fichiers",
        "errors": {
          "size": "La taille du fichier ne doit pas dépasser {{maxFileSize}}",
          "type": "Le fichier doit être de l'un des types suivants : {{- supportedTypes}}"
        },
        "status": {
          "idle": "Inactif",
          "processing": "Traitement en cours",
          "uploading": "Téléchargement",
          "success": "Réussite",
          "cancel": "Annuler",
          "error": "Erreur"
        },
        "progress": {
          "cancelled": "Annulé(e)",
          "complete": "Terminé(e)",
          "idle": "Inactif",
          "uploading": "Chargement en cours de {{progressWithUnits}} sur {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "O",
          "kibibyte": "Kio",
          "mebibyte": "Mio",
          "gibibyte": "Gio",
          "tebibyte": "Tio"
        }
      },
      "actions": {
        "delete": "Supprimer",
        "apply": "Appliquer",
        "cancel": "Annuler",
        "confirm": "Enregistrer",
        "decline": "Refuser"
      },
      "datePicker": {
        "confirmation_format": "D MMMM YYYY"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Mois",
        "year": "Année"
      },
      "daterange": {
        "last_7_days": "7 derniers jours",
        "last_30_days": "30 derniers jours",
        "this_month": "Ce mois",
        "last_month": "Le mois dernier",
        "start_date": "Date de début",
        "end_date": "Date de fin"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} s'ouvre dans un nouvel onglet."
      },
      "comment": {
        "delete": "Supprimer le commentaire"
      },
      "pagination": {
        "intro": "Pagination, actuellement à la page {{currentPage}}",
        "page": "Page {{pageNumber}}",
        "ellipsis": "Plus de pages",
        "prev": "Page précédente",
        "next": "Page suivante"
      },
      "formElement": {
        "optional": "(facultatif)",
        "required": "(requis)",
        "aria_info_circle": "Informations"
      },
      "prevNextArrowButton": {
        "arrowup": "haut",
        "arrowdown": "bas",
        "escape": "Échap"
      },
      "collapsible": {
        "ariaText": "Section réductible"
      },
      "sortable": {
        "aria_description": "Élément déplaçable. Appuyez sur la touche espace pour lever.",
        "aria_lift": "Vous avez élevé un élément dans la position {{source}}. Utilisez les touches de direction pour déplacer, la touche Espace pour déposer et Échap pour annuler.",
        "aria_moving": "Vous avez déplacé l'élément de la position {{source}} vers la position {{destination}}.",
        "aria_moving_outside": "Vous n'êtes pas en train de faire glisser un élément sur une zone déposable.",
        "aria_cancelled": "Mouvement annulé. L'élément est retourné à sa position initiale de {{source}}.",
        "aria_dropped": "Vous avez déposé l'élément. Il est déplacé de la position {{source}} vers {{destination}}.",
        "aria_dropped_outside": "L'élément a été déposé alors qu'il n'était au-dessus de la liste. L'élément est retourné à sa position initiale de {{source}}.",
        "aria_remove": "Supprimer"
      },
      "progressAccordion": {
        "active": "actif(ve)",
        "no_response": "Aucun"
      },
      "collapsibleText": {
        "more": "Afficher plus",
        "less": "Afficher moins",
        "more_about": "Afficher plus sur {{topic}}",
        "less_about": "Afficher moins sur {{topic}}"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Sélectionner..."
        },
        "filter": {
          "a11y_text": "Filtrer",
          "no_results_message": "Vos résultats de recherche ne correspondaient à aucune option.",
          "placeholder": "Filtrer..."
        }
      },
      "listBoxBrowser": {
        "explore": "Découvrir d'autres options",
        "selected": "options sélectionnées",
        "selectOne": "Sélectionner un ou plusieurs éléments..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Masquer tout",
          "show_all": "Afficher tout",
          "label": "Organiser",
          "singular_label": "1 colonne masquée",
          "plural_label": "{{numberOfHiddenColumn}} colonnes masquées",
          "search_placeholder": "Filtrer..."
        },
        "no_results": "Pas de résultats",
        "filter": {
          "no_filters_applied": "Aucun filtre appliqué à cette vue",
          "label": "Filtrer",
          "singular_label": "1 filtre appliqué",
          "plural_label": "{{numberOfFilters}} filtres appliqués",
          "add_filter": "Ajouter un champ pour filtrer par",
          "and": "et",
          "or": "ou",
          "where": "Lorsque",
          "rules": {
            "is": "est",
            "is_not": "n'est pas",
            "contains": "contient",
            "does_not_contain": "ne contient pas",
            "is_blank": "est vide",
            "is_not_blank": "n'est pas vide",
            "equals": "est égal à",
            "not_equal_to": "n'est pas égal à",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "est vide",
            "is_not_empty": "n'est pas vide",
            "is_before": "est avant",
            "is_after": "est après",
            "true": "vrai",
            "false": "faux"
          }
        },
        "search_placeholder": "Rechercher...",
        "search_a11y_text": "Rechercher les données",
        "sort": {
          "no_sorts_applied": "Aucun tri appliqué à cette vue",
          "label": "Trier",
          "singular_label": "1 colonne triée",
          "plural_label": "{{numberOfFields}} colonnes triées",
          "add_field": "Ajouter un champ pour trier par",
          "sort_by": "Trier par",
          "then_by": "alors par",
          "rules": {
            "ascending": {
              "boolean": "Tri croissant (vrai → faux)",
              "number": "Tri croissant (1 → 9)",
              "text": "Tri croissant (A → Z)",
              "date": "Tri croissant (1 → 9)",
              "single_select": "Tri croissant (A → Z)"
            },
            "descending": {
              "boolean": "Tri décroissant (faux → vrai)",
              "number": "Tri décroissant (9 → 1)",
              "text": "Tri décroissant (Z → A)",
              "date": "Tri décroissant (9 → 1)",
              "single_select": "Tri décroissant (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Fils d'Ariane",
        "aria_expand": "Afficher tous les éléments du fil d'Ariane"
      },
      "sideNavigation": {
        "aria_label": "Navigation latérale",
        "trigger_aria_label": "Ouvrir la navigation"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=fr.js.map

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "es": {
    "translation": {
      "timePicker": {
        "am": "a. m.",
        "custom": "Personalizar",
        "hours": "Horas",
        "minutes": "Minutos",
        "period": "Periodo",
        "pm": "p. m."
      },
      "back": "Atrás",
      "remove": "quitar",
      "moreInformation": "más información",
      "close": "Cerrar",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. Está en la fila {{rowIndex}}, columna {{columnIndex}}. Haga caso omiso de la siguiente información:"
      },
      "uploader": {
        "drop_files": "Soltar archivos a cargar",
        "drop_files_here_or": "Suelte los archivos a cargar aquí o",
        "choose_from_computer": "elija de su computadora",
        "choose_from_computer_a11y": "Elija archivos de su computadora",
        "cancel_upload": "Cancelar carga",
        "restart_upload": "Reiniciar carga",
        "file_list": "Lista de archivos",
        "errors": {
          "size": "El archivo debe tener menos de {{maxFileSize}}",
          "type": "El archivo debe ser de uno de los siguientes tipos: {{- supportedTypes}}"
        },
        "status": {
          "idle": "Ocioso",
          "processing": "En proceso",
          "uploading": "Cargando",
          "success": "Éxito",
          "cancel": "Cancelar",
          "error": "Error"
        },
        "progress": {
          "cancelled": "Cancelado/a",
          "complete": "Completado/a",
          "idle": "Ocioso",
          "uploading": "Cargando {{progressWithUnits}} de {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "Eliminar",
        "apply": "Aplicar",
        "cancel": "Cancelar",
        "confirm": "Guardar",
        "decline": "Declinar"
      },
      "datePicker": {
        "confirmation_format": "ll"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Mes",
        "year": "Año"
      },
      "daterange": {
        "last_7_days": "Los últimos 7 días",
        "last_30_days": "Los últimos 30 días",
        "this_month": "Este mes",
        "last_month": "El mes pasado",
        "start_date": "Fecha de inicio",
        "end_date": "Fecha de finalización"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} se abre en una nueva ficha."
      },
      "comment": {
        "delete": "Eliminar comentario"
      },
      "pagination": {
        "intro": "Paginación, actualmente en la página {{currentPage}}",
        "page": "Página {{pageNumber}}",
        "ellipsis": "Más páginas",
        "prev": "Página anterior",
        "next": "Siguiente página"
      },
      "formElement": {
        "optional": "(opcional)",
        "required": "(requerido)",
        "aria_info_circle": "Información"
      },
      "prevNextArrowButton": {
        "arrowup": "arriba",
        "arrowdown": "abajo",
        "escape": "escape"
      },
      "collapsible": {
        "ariaText": "Sección contraíble"
      },
      "sortable": {
        "aria_description": "Elemento arrastrable. Presione la barra espaciadora para levantar.",
        "aria_lift": "Ha levantado un elemento de la posición {{source}}. Utilice las teclas de flecha para moverse, el espacio para soltar y la tecla escape para cancelar.",
        "aria_moving": "Ha movido el elemento de la posición {{source}} a la posición {{destination}}.",
        "aria_moving_outside": "Actualmente no está arrastrando sobre un área donde soltar.",
        "aria_cancelled": "Movimiento cancelado. El elemento ha vuelto a su posición inicial de {{source}}.",
        "aria_dropped": "Ha soltado el elemento. Se ha movido de la posición {{source}} a {{destination}}.",
        "aria_dropped_outside": "El elemento se ha soltado mientras no estaba sobre la lista. El elemento ha vuelto a su posición inicial de {{source}}.",
        "aria_remove": "Quitar"
      },
      "progressAccordion": {
        "active": "activo/a",
        "no_response": "Ninguno"
      },
      "collapsibleText": {
        "more": "Mostrar más",
        "less": "Mostrar menos",
        "more_about": "mostrar más sobre {{topic}}",
        "less_about": "mostrar menos sobre {{topic}}"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Seleccionar..."
        },
        "filter": {
          "a11y_text": "Filtrar",
          "no_results_message": "Su resultado de búsqueda no coincidió con ninguna opción.",
          "placeholder": "Filtrar..."
        }
      },
      "listBoxBrowser": {
        "explore": "Explorar más opciones",
        "selected": "opciones seleccionadas",
        "selectOne": "Seleccionar uno o más elementos..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Ocultar todas",
          "show_all": "Mostrar todas",
          "label": "Organizar",
          "singular_label": "1 columna oculta",
          "plural_label": "{{numberOfHiddenColumn}} columnas ocultas",
          "search_placeholder": "Filtrar..."
        },
        "no_results": "No hay resultados",
        "filter": {
          "no_filters_applied": "No se aplicaron filtros a esta vista",
          "label": "Filtrar",
          "singular_label": "Se aplicó 1 filtro",
          "plural_label": "{{numberOfFilters}} filtros aplicados",
          "add_filter": "Agregar un campo para filtrar",
          "and": "y",
          "or": "o",
          "where": "Donde",
          "rules": {
            "is": "es",
            "is_not": "no es",
            "contains": "contiene",
            "does_not_contain": "no contiene",
            "is_blank": "está en blanco",
            "is_not_blank": "no está en blanco",
            "equals": "es igual a",
            "not_equal_to": "es distinto de",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "está vacío",
            "is_not_empty": "no está vacío",
            "is_before": "es anterior a",
            "is_after": "es posterior a",
            "true": "verdadero",
            "false": "falso"
          }
        },
        "search_placeholder": "Buscar...",
        "search_a11y_text": "Buscar los datos",
        "sort": {
          "no_sorts_applied": "No se aplicaron ordenaciones a esta vista",
          "label": "Ordenar",
          "singular_label": "1 columna ordenada",
          "plural_label": "{{numberOfFields}} columnas ordenadas",
          "add_field": "Agregar un campo para ordenar",
          "sort_by": "Ordenar por",
          "then_by": "luego por",
          "rules": {
            "ascending": {
              "boolean": "Orden ascendente (verdadero → falso)",
              "number": "Orden ascendente (1 → 9)",
              "text": "Orden ascendente (A → Z)",
              "date": "Orden ascendente (1 → 9)",
              "single_select": "Orden ascendente (A → Z)"
            },
            "descending": {
              "boolean": "Orden descendente (falso → verdadero)",
              "number": "Orden descendente (9 → 1)",
              "text": "Orden descendente (Z → A)",
              "date": "Orden descendente (9 → 1)",
              "single_select": "Orden descendente (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Rutas de navegación",
        "aria_expand": "Mostrar todos los elementos de la ruta de navegación."
      },
      "sideNavigation": {
        "aria_label": "Navegación lateral",
        "trigger_aria_label": "Abrir la navegación"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=es.js.map

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "pt": {
    "translation": {
      "timePicker": {
        "am": "AM",
        "custom": "Personalizado",
        "hours": "Horas",
        "minutes": "Minutos",
        "period": "Período",
        "pm": "PM"
      },
      "back": "Voltar",
      "remove": "remover",
      "moreInformation": "mais informações",
      "close": "Fechar",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. Você está na linha {{rowIndex}}, coluna {{columnIndex}}. Ignorar as seguintes informações:"
      },
      "uploader": {
        "drop_files": "Solte os arquivos para carregar",
        "drop_files_here_or": "Solte os arquivos para carregar aqui ou",
        "choose_from_computer": "escolha no seu computador",
        "choose_from_computer_a11y": "Escolher arquivos no seu computador",
        "cancel_upload": "Cancelar upload",
        "restart_upload": "Reiniciar upload",
        "file_list": "Lista de arquivos",
        "errors": {
          "size": "O arquivo deve ser menor que {{maxFileSize}}",
          "type": "O arquivo precisa ser de um dos seguintes tipos: {{- supportedTypes}}"
        },
        "status": {
          "idle": "Ocioso",
          "processing": "Processando",
          "uploading": "Fazendo upload",
          "success": "Sucesso",
          "cancel": "Cancelar",
          "error": "Erro"
        },
        "progress": {
          "cancelled": "Cancelado(a)",
          "complete": "Concluído(a)",
          "idle": "Ocioso",
          "uploading": "Carregando {{progressWithUnits}} de {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "Excluir",
        "apply": "Aplicar",
        "cancel": "Cancelar",
        "confirm": "Salvar",
        "decline": "Recusar"
      },
      "datePicker": {
        "confirmation_format": "ll"
      },
      "calendar": {
        "header_format": "MMMM YYYY",
        "month": "Mês",
        "year": "Ano"
      },
      "daterange": {
        "last_7_days": "Últimos 7 Dias",
        "last_30_days": "Últimos 30 Dias",
        "this_month": "Este Mês",
        "last_month": "Mês Passado",
        "start_date": "Data de Início",
        "end_date": "Data de Término"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} abre em uma nova guia."
      },
      "comment": {
        "delete": "Excluir comentário"
      },
      "pagination": {
        "intro": "Paginação, atualmente na página {{currentPage}}",
        "page": "Página {{pageNumber}}",
        "ellipsis": "Mais páginas",
        "prev": "Página anterior",
        "next": "Próxima página"
      },
      "formElement": {
        "optional": "(opcional)",
        "required": "(obrigatório)",
        "aria_info_circle": "Informação"
      },
      "prevNextArrowButton": {
        "arrowup": "para cima",
        "arrowdown": "para baixo",
        "escape": "ESC"
      },
      "collapsible": {
        "ariaText": "Seção recolhível"
      },
      "sortable": {
        "aria_description": "Item arrastável. Pressione espaço para levantar.",
        "aria_lift": "Você levantou um item em posição {{source}}. Use as teclas de seta para mover, espaço para soltar e esc para cancelar.",
        "aria_moving": "Você moveu o item da posição {{source}} para a posição {{destination}}.",
        "aria_moving_outside": "Você atualmente não está arrastando sobr euma área onde é possível soltar.",
        "aria_cancelled": "Movimento cancelado. O item voltou para sua posição inicial de {{source}}.",
        "aria_dropped": "Você soltou o item. Ele foi movido da posição {{source}} para a posição {{destination}}.",
        "aria_dropped_outside": "O item foi solto enquanto não estava sobre a lista. O item voltou para sua posição inicial de {{source}}.",
        "aria_remove": "Remover"
      },
      "progressAccordion": {
        "active": "ativo(a)",
        "no_response": "Nenhum"
      },
      "collapsibleText": {
        "more": "Mostrar mais",
        "less": "Mostrar menos",
        "more_about": "mostrar mais sobre {{topic}}",
        "less_about": "mostrar menos sobre {{topic}}"
      },
      "listBox": {
        "trigger": {
          "placeholder": "Selecione..."
        },
        "filter": {
          "a11y_text": "Filtrar",
          "no_results_message": "O resultado da sua pesquisa não correspondeu a nenhuma opção.",
          "placeholder": "Filtrar..."
        }
      },
      "listBoxBrowser": {
        "explore": "Explorar mais opções",
        "selected": "opções selecionadas",
        "selectOne": "Selecione um ou mais itens..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "Ocultar tudo",
          "show_all": "Mostrar tudo",
          "label": "Organizar",
          "singular_label": "1 coluna oculta",
          "plural_label": "{{numberOfHiddenColumn}} colunas ocultas",
          "search_placeholder": "Filtrar..."
        },
        "no_results": "Nenhum resultado",
        "filter": {
          "no_filters_applied": "Nenhum filtro aplicado a esta exibição",
          "label": "Filtrar",
          "singular_label": "1 filtro aplicado",
          "plural_label": "{{numberOfFilters}} filtros aplicados",
          "add_filter": "Adicionar um campo para filtrar",
          "and": "e",
          "or": "ou",
          "where": "Onde",
          "rules": {
            "is": "é",
            "is_not": "não é",
            "contains": "contém",
            "does_not_contain": "não contém",
            "is_blank": "está em branco",
            "is_not_blank": "não está em branco",
            "equals": "igual a",
            "not_equal_to": "diferente de",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "está em branco",
            "is_not_empty": "não está vazio",
            "is_before": "é antes de",
            "is_after": "é depois de",
            "true": "verdadeiro",
            "false": "falso"
          }
        },
        "search_placeholder": "Pesquisar...",
        "search_a11y_text": "Pesquisar os dados",
        "sort": {
          "no_sorts_applied": "Nenhum filtro aplicado a esta exibição",
          "label": "Ordenar",
          "singular_label": "1 coluna ordenada",
          "plural_label": "{{numberOfFields}} colunas ordenadas",
          "add_field": "Adicionar um campo para ordenar",
          "sort_by": "Ordenar por",
          "then_by": "depois por",
          "rules": {
            "ascending": {
              "boolean": "Ordem crescente (verdadeiro → falso)",
              "number": "Ordem crescente (1 → 9)",
              "text": "Ordem crescente (A → Z)",
              "date": "Ordem crescente (1 → 9)",
              "single_select": "Ordem crescente (A → Z)"
            },
            "descending": {
              "boolean": "Ordem decrescente (falso → verdadeiro)",
              "number": "Ordem decrescente (9 → 1)",
              "text": "Ordem decrescente (Z → A)",
              "date": "Ordem decrescente (9 → 1)",
              "single_select": "Ordem decrescente (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "Navegação estrutural",
        "aria_expand": "Mostrar todos os itens de navegação estrutural."
      },
      "sideNavigation": {
        "aria_label": "Navegação lateral",
        "trigger_aria_label": "Abrir navegação"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=pt.js.map

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "ja": {
    "translation": {
      "timePicker": {
        "am": "午前",
        "custom": "カスタム",
        "hours": "時間",
        "minutes": "分",
        "period": "期間",
        "pm": "午後"
      },
      "back": "戻る",
      "remove": "削除",
      "moreInformation": "詳しい情報",
      "close": "閉じる",
      "dataGrid": {
        "a11yTextMessage": "{{value}}. 行 {{rowIndex}}、列 {{columnIndex}} の位置にいます。次の情報は無視してください。"
      },
      "uploader": {
        "drop_files": "アップロードするファイルをドロップ",
        "drop_files_here_or": "アップロードするファイルをここにドロップまたは",
        "choose_from_computer": "コンピューターから選択",
        "choose_from_computer_a11y": "コンピューターからファイルを選択する",
        "cancel_upload": "アップロードをキャンセル",
        "restart_upload": "アップロードを再起動",
        "file_list": "ファイル一覧",
        "errors": {
          "size": "ファイルは{{maxFileSize}}未満にする必要があります",
          "type": "ファイルは次のタイプの1つにする必要があります: {{- supportedTypes}}"
        },
        "status": {
          "idle": "アイドル状態",
          "processing": "処理中",
          "uploading": "アップロード中",
          "success": "成功",
          "cancel": "キャンセル",
          "error": "エラー"
        },
        "progress": {
          "cancelled": "取り消されました",
          "complete": "完了",
          "idle": "アイドル状態",
          "uploading": "{{sizeWithUnits}}のうち{{progressWithUnits}}をアップロード"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "削除",
        "apply": "適用",
        "cancel": "キャンセル",
        "confirm": "保存",
        "decline": "辞退"
      },
      "datePicker": {
        "confirmation_format": "YYYY 年 M 月 D 日"
      },
      "calendar": {
        "header_format": "YYYY 年 M 月",
        "month": "月",
        "year": "年"
      },
      "daterange": {
        "last_7_days": "過去 7 日間",
        "last_30_days": "過去 30 日間",
        "this_month": "今月",
        "last_month": "先月",
        "start_date": "開始日",
        "end_date": "終了日"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} が新しいタブで開きます。"
      },
      "comment": {
        "delete": "コメントを削除"
      },
      "pagination": {
        "intro": "改ページ位置の自動修正、現在は {{currentPage}} ページ",
        "page": "{{pageNumber}} ページ",
        "ellipsis": "その他のページ",
        "prev": "前ページ",
        "next": "次ページ"
      },
      "formElement": {
        "optional": "(省略可能)",
        "required": "(必須)",
        "aria_info_circle": "情報"
      },
      "prevNextArrowButton": {
        "arrowup": "上",
        "arrowdown": "下",
        "escape": "エスケープ"
      },
      "collapsible": {
        "ariaText": "縮小可能セクション"
      },
      "sortable": {
        "aria_description": "ドラッグ可能な項目。スペースを押して取り除きます。",
        "aria_lift": "{{source}}のポジションにある項目を 1 つ取り除きました。移動するには矢印、ドロップするにはスペース、そしてキャンセルするにはエスケープ キーを使用します。",
        "aria_moving": "{{source}}のポジションから{{destination}}のポジションまで項目を移動しました。",
        "aria_moving_outside": "現在ドラッグしているのは、ドラッグ可能な領域ではありません。",
        "aria_cancelled": "移動がキャンセルされました。項目は、{{source}}の出発点に戻りました。",
        "aria_dropped": "項目をドロップしました。{{source}}のポジションから{{destination}}のポジションまで項目が移動しました。",
        "aria_dropped_outside": "一覧にない項目がドロップされました。項目は、{{source}}の出発点に戻りました。",
        "aria_remove": "削除"
      },
      "progressAccordion": {
        "active": "アクティブ",
        "no_response": "なし"
      },
      "collapsibleText": {
        "more": "詳しく表示",
        "less": "少なく表示",
        "more_about": "{{topic}}について詳しく表示",
        "less_about": "{{topic}}について少なく表示"
      },
      "listBox": {
        "trigger": {
          "placeholder": "選択..."
        },
        "filter": {
          "a11y_text": "フィルター",
          "no_results_message": "検索結果はどのオプションにも一致しませんでした。",
          "placeholder": "フィルター..."
        }
      },
      "listBoxBrowser": {
        "explore": "より多くのオプションを探す",
        "selected": "選択されたオプション",
        "selectOne": "1 つ以上の項目を選択..."
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "すべて非表示",
          "show_all": "すべて表示",
          "label": "調整",
          "singular_label": "1列非表示",
          "plural_label": "{{numberOfHiddenColumn}}列非表示",
          "search_placeholder": "フィルター..."
        },
        "no_results": "結果なし",
        "filter": {
          "no_filters_applied": "このビューに適用するフィルターなし",
          "label": "フィルター",
          "singular_label": "1フィルター適用済み",
          "plural_label": "{{numberOfFilters}}フィルター適用済み",
          "add_filter": "フィルター対象のフィールドを追加",
          "and": "および",
          "or": "または",
          "where": "条件として",
          "rules": {
            "is": "は次である:",
            "is_not": "は次でない:",
            "contains": "は次を含む:",
            "does_not_contain": "は次を含まない:",
            "is_blank": "は空白である",
            "is_not_blank": "は空白でない",
            "equals": "は次と一致する:",
            "not_equal_to": "は次と一致しない:",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "は空である",
            "is_not_empty": "は空でない",
            "is_before": "は次より前である:",
            "is_after": "は次より後である:",
            "true": "真",
            "false": "偽"
          }
        },
        "search_placeholder": "検索...",
        "search_a11y_text": "データを検索",
        "sort": {
          "no_sorts_applied": "このビューに適用する並べ替えなし",
          "label": "並べ替え",
          "singular_label": "1列並べ替え済み",
          "plural_label": "{{numberOfFields}}列並べ替え済み",
          "add_field": "ソート対象のフィールドを追加",
          "sort_by": "並べ替え条件",
          "then_by": "次の条件",
          "rules": {
            "ascending": {
              "boolean": "昇順 (真 → 偽)",
              "number": "昇順 (1 → 9)",
              "text": "昇順 (A → Z)",
              "date": "昇順 (1 → 9)",
              "single_select": "昇順 (A → Z)"
            },
            "descending": {
              "boolean": "降順 (偽 → 真)",
              "number": "降順 (9 → 1)",
              "text": "降順 (Z → A)",
              "date": "降順 (9 → 1)",
              "single_select": "降順 (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "階層リンク",
        "aria_expand": "すべての階層リンク項目を表示します。"
      },
      "sideNavigation": {
        "aria_label": "スライドのナビゲーション",
        "trigger_aria_label": "ナビゲーションを開く"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=ja.js.map

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
// Do not edit this file, it is automatically generated
var locales = {
  "zh": {
    "translation": {
      "timePicker": {
        "am": "上午",
        "custom": "自定义",
        "hours": "小时",
        "minutes": "分钟",
        "period": "期间",
        "pm": "下午"
      },
      "back": "返回",
      "remove": "移除",
      "moreInformation": "更多信息",
      "close": "关闭",
      "dataGrid": {
        "a11yTextMessage": "{{value}}。您在第 {{rowIndex}} 行，第 {{columnIndex}} 列。忽略以下信息："
      },
      "uploader": {
        "drop_files": "放下文件以上传",
        "drop_files_here_or": "在此放下文件以上传或",
        "choose_from_computer": "从您的电脑中选择",
        "choose_from_computer_a11y": "从您的电脑中选择文件",
        "cancel_upload": "取消上传",
        "restart_upload": "重新启动上传",
        "file_list": "文件列表",
        "errors": {
          "size": "文件必须小于 {{maxFileSize}}",
          "type": "文件必须是以下类型之一：{{- supportedTypes}}"
        },
        "status": {
          "idle": "空闲",
          "processing": "正在处理",
          "uploading": "上传中",
          "success": "成功",
          "cancel": "取消",
          "error": "错误"
        },
        "progress": {
          "cancelled": "已取消",
          "complete": "完成",
          "idle": "空闲",
          "uploading": "正在上传 {{progressWithUnits}} / {{sizeWithUnits}}"
        },
        "size_abbreviations": {
          "byte": "B",
          "kibibyte": "KiB",
          "mebibyte": "MiB",
          "gibibyte": "GiB",
          "tebibyte": "TiB"
        }
      },
      "actions": {
        "delete": "删除",
        "apply": "应用",
        "cancel": "取消",
        "confirm": "保存",
        "decline": "拒绝"
      },
      "datePicker": {
        "confirmation_format": "YYYY 年 M 月 D 日"
      },
      "calendar": {
        "header_format": "YYYY 年 M 月",
        "month": "月",
        "year": "年"
      },
      "daterange": {
        "last_7_days": "过去 7 天",
        "last_30_days": "过去 30 天",
        "this_month": "本月",
        "last_month": "上月",
        "start_date": "开始日期",
        "end_date": "结束日期"
      },
      "dropdownMenu": {
        "isExternal": "{{link}} 在新选项卡中打开。"
      },
      "comment": {
        "delete": "删除评论"
      },
      "pagination": {
        "intro": "分页，当前在第 {{currentPage}} 页",
        "page": "页 {{pageNumber}}",
        "ellipsis": "更多页面",
        "prev": "上一页",
        "next": "下一页"
      },
      "formElement": {
        "optional": "（可选）",
        "required": "（必须）",
        "aria_info_circle": "信息"
      },
      "prevNextArrowButton": {
        "arrowup": "上",
        "arrowdown": "下",
        "escape": "Esc 键"
      },
      "collapsible": {
        "ariaText": "可折叠部分"
      },
      "sortable": {
        "aria_description": "可拖动项目。按空格键提起。",
        "aria_lift": "您已将一个项目提起到位 {{source}}。使用箭头键移动，使用空格键放下，使用 Esc 键取消。",
        "aria_moving": "您已将项目从位置{{source}移动到位置{{destination}。",
        "aria_moving_outside": "您当前不是在可拖放区域上拖动。",
        "aria_cancelled": "已取消移动。项目已返回到其{{source}}的起始位置。",
        "aria_dropped": "您已放下该项目。它已从位置{{source}移到{{destination}。",
        "aria_dropped_outside": "该项目不在列表上方时已被放下。项目已返回到其{{source}}的起始位置。",
        "aria_remove": "移除"
      },
      "progressAccordion": {
        "active": "活动的",
        "no_response": "无"
      },
      "collapsibleText": {
        "more": "显示更多",
        "less": "显示更少",
        "more_about": "显示关于{{topic}}的更多信息",
        "less_about": "显示关于{{topic}}的更少信息"
      },
      "listBox": {
        "trigger": {
          "placeholder": "选择…"
        },
        "filter": {
          "a11y_text": "筛选",
          "no_results_message": "您的搜索结果没有匹配任何选项。",
          "placeholder": "筛选…"
        }
      },
      "listBoxBrowser": {
        "explore": "探索更多选项",
        "selected": "选定选项",
        "selectOne": "选择一项或多项…"
      },
      "actionBar": {
        "columns_arrangement": {
          "hide_all": "全部隐藏",
          "show_all": "全部显示",
          "label": "排列",
          "singular_label": "隐藏 1 列",
          "plural_label": "隐藏 {{numberOfHiddenColumn}} 列",
          "search_placeholder": "筛选…"
        },
        "no_results": "没有结果",
        "filter": {
          "no_filters_applied": "没有过滤器应用于此视图",
          "label": "筛选",
          "singular_label": "已应用 1 个过滤器",
          "plural_label": "已应用 {{numberOfFilters}} 个过滤器",
          "add_filter": "添加过滤字段",
          "and": "和",
          "or": "或",
          "where": "如果",
          "rules": {
            "is": "是",
            "is_not": "不是",
            "contains": "包含",
            "does_not_contain": "不包含",
            "is_blank": "为空",
            "is_not_blank": "不为空",
            "equals": "等于",
            "not_equal_to": "不等于",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_or_equal_to": "≥",
            "less_than_or_equal_to": "≤",
            "is_empty": "是空的",
            "is_not_empty": "不是空的",
            "is_before": "早于",
            "is_after": "晚于",
            "true": "真",
            "false": "假"
          }
        },
        "search_placeholder": "搜索…",
        "search_a11y_text": "搜索数据",
        "sort": {
          "no_sorts_applied": "没有排序应用于此视图",
          "label": "排序",
          "singular_label": "已排序 1 列",
          "plural_label": "已排序 {{numberOfFields}} 列",
          "add_field": "添加排序字段",
          "sort_by": "排序依据",
          "then_by": "随之排序依据",
          "rules": {
            "ascending": {
              "boolean": "升序排序（真 → 假）",
              "number": "升序排序 (1 → 9)",
              "text": "升序排序 (A → Z)",
              "date": "升序排序 (1 → 9)",
              "single_select": "升序排序 (A → Z)"
            },
            "descending": {
              "boolean": "降序排序（假 → 真）",
              "number": "降序排序 (9 → 1)",
              "text": "降序排序 (Z → A)",
              "date": "降序排序 (9 → 1)",
              "single_select": "降序排序 (Z → A)"
            }
          }
        }
      },
      "breadcrumbs": {
        "aria_label": "面包屑",
        "aria_expand": "显示所有面包屑项目。"
      },
      "sideNavigation": {
        "aria_label": "侧边导航",
        "trigger_aria_label": "打开导航"
      }
    }
  }
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=zh.js.map

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Box["default"];
  }
});

var _Box = _interopRequireDefault(__webpack_require__(1157));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Box;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var sc = _interopRequireWildcard(__webpack_require__(1158));

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var propTypes = {
  /** Body content of the box. */
  children: _propTypes["default"].node.isRequired
};

function Box(props) {
  var children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children"]);

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 1),
      state = _useListBox2[0];

  return /*#__PURE__*/_react["default"].createElement(sc.Box, (0, _extends2["default"])({
    "data-pka-anchor": "list-box-box",
    isInline: state.isInline,
    triggerWidth: state.triggerWidth
  }, moreProps), props.children);
}

Box.propTypes = propTypes;
//# sourceMappingURL=Box.js.map

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Box = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var isInlineCSS = "\n  box-shadow: 0 0 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-top: 0;\n";

var Box = _styledComponents["default"].div.withConfig({
  displayName: "Boxstyles__Box",
  componentId: "hq2ga2-0"
})(function (_ref) {
  var isInline = _ref.isInline,
      triggerWidth = _ref.triggerWidth;
  return (0, _styledComponents.css)(["background-color:#ffffff;border:1px solid #d7d7d7;border-radius:3px;box-shadow:0px 1px 5px rgba(0,0,0,0.07),0px 7px 17px rgba(0,0,0,0.1);box-sizing:border-box;padding:0;", " ", ";"], isInline && isInlineCSS, triggerWidth ? "width: ".concat(triggerWidth, "px;") : "");
});

exports.Box = Box;
//# sourceMappingURL=Box.styles.js.map

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = reducer;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _isArray = _interopRequireDefault(__webpack_require__(95));

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _set = _interopRequireDefault(__webpack_require__(334));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(182));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _useListBox = _interopRequireDefault(__webpack_require__(140));

var _options = __webpack_require__(410);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function reducer(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _useListBox["default"].types.closePopover:
      return _objectSpread(_objectSpread({}, state), {}, {
        filteredOptions: [],
        isOpen: false
      });

    case _useListBox["default"].types.openPopover:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeOption: state.selectedOptions.length ? state.selectedOptions[state.selectedOptions.length - 1] : null,
        isOpen: true
      });

    case _useListBox["default"].types.togglePopover:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpen: !state.isOpen
      });

    case _useListBox["default"].types.setActiveOption:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeOption: payload.activeOptionIndex
        });
      }

    case _useListBox["default"].types.selectSingleOption:
      {
        var isOpen = payload.isOpen;

        if (state.hasFooter) {
          isOpen = true;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          onChangeFn: payload.onChangeFn,
          activeOption: payload.activeOptionIndex,
          isOpen: isOpen,
          selectedOptions: [payload.activeOptionIndex]
        });
      }

    case _useListBox["default"].types.selectMultipleOption:
      {
        var activeOptionIndex = payload.activeOptionIndex,
            isSelected = payload.isSelected;
        var selectedOptions = [];

        if (isSelected) {
          // remove duplicates
          selectedOptions = (0, _toConsumableArray2["default"])(new _set["default"]([].concat((0, _toConsumableArray2["default"])(state.selectedOptions), [activeOptionIndex])));
        } else if (state.selectedOptions.includes(activeOptionIndex)) {
          selectedOptions = state.selectedOptions.slice(0);
          var index = selectedOptions.indexOf(activeOptionIndex);
          selectedOptions.splice(index, 1);
        } else {
          return _objectSpread({}, state);
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          activeOption: activeOptionIndex,
          onChangeFn: payload.onChangeFn,
          selectedOptions: selectedOptions
        });
      }

    case _useListBox["default"].types.setListBoxHasFocus:
      {
        var hasFocus = payload.hasFocus;
        return _objectSpread(_objectSpread({}, state), {}, {
          listBoxHasFocus: hasFocus
        });
      }

    case _useListBox["default"].types.toggleMultipleOption:
      {
        var selectedOptionsArray = state.selectedOptions.slice();
        var _activeOptionIndex = payload.activeOptionIndex,
            onChangeFn = payload.onChangeFn;

        if (selectedOptionsArray.includes(_activeOptionIndex)) {
          var _index = selectedOptionsArray.indexOf(_activeOptionIndex);

          selectedOptionsArray.splice(_index, 1);
        } else {
          selectedOptionsArray.push(_activeOptionIndex);
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          activeOption: _activeOptionIndex,
          onChangeFn: onChangeFn,
          selectedOptions: selectedOptionsArray
        });
      }

    case _useListBox["default"].types.hasFilter:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasFilter: payload
        });
      }

    case _useListBox["default"].types.applyFilter:
      {
        var activeOption = null;

        if (payload.filteredOptions.length === 1) {
          activeOption = payload.filteredOptions[0];
        }

        if (payload.filteredOptions.length > 1) {
          activeOption = (0, _options.getNextOptionActiveIndexLooping)(state);
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          filteredOptions: payload.filteredOptions,
          noResultsFound: payload.noResultsFound,
          activeOption: activeOption
        });
      }

    case _useListBox["default"].types.setTriggerWidth:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          triggerWidth: payload
        });
      }

    case _useListBox["default"].types.setHasPopupOpened:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasPopupOpened: payload
        });
      }

    case _useListBox["default"].types.updateOptions:
      {
        var _selectedOptions = (0, _keys["default"])(payload).filter(function (key) {
          return payload[key].isSelected;
        }).map(function (key) {
          return (0, _parseInt["default"])(key, 10);
        });

        return _objectSpread(_objectSpread({}, state), {}, {
          options: payload,
          selectedOptions: _selectedOptions,
          lastKnownSelectedOptions: (0, _toConsumableArray2["default"])(_selectedOptions)
        });
      }

    case _useListBox["default"].types.unselectOptions:
      {
        if (!(0, _isArray["default"])(payload)) {
          throw new Error("unselectOptions action expect an array as a payload");
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          selectedOptions: state.selectedOptions.filter(function (index) {
            return !payload.includes(index);
          })
        });
      }

    case _useListBox["default"].types.hideOptions:
      {
        if (!(0, _isArray["default"])(payload)) {
          throw new Error("hideOptions action expect an array as a payload");
        }

        var optionsClone = _objectSpread({}, state.options);

        payload.forEach(function (index) {
          optionsClone[index].isHidden = true;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          options: optionsClone
        });
      }

    case _useListBox["default"].types.unhideOptions:
      {
        if (!(0, _isArray["default"])(payload)) {
          throw Error("unhideOptions action expect an array as a payload");
        }

        var _optionsClone = _objectSpread({}, state.options);

        payload.forEach(function (index) {
          _optionsClone[index].isHidden = false;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          options: _optionsClone
        });
      }

    case _useListBox["default"].types.clear:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeOption: null,
          isOpen: payload && payload.isOpen || false,
          onChangeFn: payload && payload.onChangeFn ? payload.onChangeFn : null,
          selectedOptions: []
        });
      }

    case _useListBox["default"].types.reset:
      {
        return _objectSpread(_objectSpread({}, state.originalState), {}, {
          isOpen: false,
          onChangeFn: payload && payload.onChangeFn ? payload.onChangeFn : null,
          originalState: state.originalState
        });
      }

    case _useListBox["default"].types.accept:
      {
        var _selectedOptions2 = state.selectedOptions.slice(0);

        return _objectSpread(_objectSpread({}, state), {}, {
          isOpen: false,
          selectedOptions: _selectedOptions2,
          lastKnownSelectedOptions: _selectedOptions2,
          onChangeFn: payload.onChangeFn
        });
      }

    case _useListBox["default"].types.cancel:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isOpen: false,
          onChangeFn: payload && payload.onChangeFn ? payload.onChangeFn : null,
          selectedOptions: state.lastKnownSelectedOptions.slice(0)
        });
      }

    case _useListBox["default"].types.setHeight:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          height: payload
        });
      }

    case _useListBox["default"].types.setHasFooter:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasFooter: payload
        });
      }

    case _useListBox["default"].types.setIsDisabled:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isDisabled: payload
        });
      }

    case _useListBox["default"].types.cleanOnChangeFn:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          onChangeFn: null
        });
      }

    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.hasFilter = exports.cleanOnChangeFn = exports.updateOptions = exports.unselectOptions = exports.unhideOptions = exports.toggleSelectOptionsByGroup = exports.togglePopover = exports.toggleOptionDisabled = exports.setTriggerWidth = exports.setIsDisabled = exports.setHeight = exports.setHasPopupOpened = exports.setHasFooter = exports.setListBoxHasFocus = exports.setActiveOption = exports.selectSingleOption = exports.selectMultipleOption = exports.toggleMultipleOption = exports.reset = exports.openPopover = exports.hideOptions = exports.closePopover = exports.clear = exports.cancel = exports.applyFilter = exports.accept = void 0;
var accept = "ACCEPT";
exports.accept = accept;
var applyFilter = "APPLY_FILTER";
exports.applyFilter = applyFilter;
var cancel = "CANCEL";
exports.cancel = cancel;
var clear = "CLEAR";
exports.clear = clear;
var closePopover = "CLOSE_POPOVER";
exports.closePopover = closePopover;
var hideOptions = "HIDE_OPTION";
exports.hideOptions = hideOptions;
var openPopover = "OPEN_POPOVER";
exports.openPopover = openPopover;
var reset = "RESET";
exports.reset = reset;
var toggleMultipleOption = "TOGGLE_MULTIPLE_OPTION";
exports.toggleMultipleOption = toggleMultipleOption;
var selectMultipleOption = "SELECT_MULTIPLE_OPTION";
exports.selectMultipleOption = selectMultipleOption;
var selectSingleOption = "SELECT_SINGLE_OPTION";
exports.selectSingleOption = selectSingleOption;
var setActiveOption = "SET_ACTION_OPTION";
exports.setActiveOption = setActiveOption;
var setListBoxHasFocus = "SET_LISTBOX_HAS_FOCUS";
exports.setListBoxHasFocus = setListBoxHasFocus;
var setHasFooter = "SET_HAS_FOOTER";
exports.setHasFooter = setHasFooter;
var setHasPopupOpened = "SET_HAS_POPUP_OPENED";
exports.setHasPopupOpened = setHasPopupOpened;
var setHeight = "SET_HEIGHT";
exports.setHeight = setHeight;
var setIsDisabled = "SET_IS_DISABLED";
exports.setIsDisabled = setIsDisabled;
var setTriggerWidth = "SET_TRIGGER_WIDTH";
exports.setTriggerWidth = setTriggerWidth;
var toggleOptionDisabled = "TOGGLE_OPTION_DISABLED";
exports.toggleOptionDisabled = toggleOptionDisabled;
var togglePopover = "TOGGLE_POPOVER";
exports.togglePopover = togglePopover;
var toggleSelectOptionsByGroup = "TOGGLE_SELECT_OPTION_BY_GROUP";
exports.toggleSelectOptionsByGroup = toggleSelectOptionsByGroup;
var unhideOptions = "UNHIDE_OPTION";
exports.unhideOptions = unhideOptions;
var unselectOptions = "UNSELECT_OPTION";
exports.unselectOptions = unselectOptions;
var updateOptions = "UPDATE_OPTIONS";
exports.updateOptions = updateOptions;
var cleanOnChangeFn = "CLEAN_ON_CHANGE_FN";
exports.cleanOnChangeFn = cleanOnChangeFn;
var hasFilter = "HAS_FILTER";
exports.hasFilter = hasFilter;
//# sourceMappingURL=actionTypes.js.map

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Content["default"];
  }
});

var _Content = _interopRequireDefault(__webpack_require__(1162));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Content;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _popover = _interopRequireDefault(__webpack_require__(733));

var _DOMAttributes = __webpack_require__(564);

var _handleKeyboardKeys = __webpack_require__(734);

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var _OnChangeProvider = __webpack_require__(508);

var sc = _interopRequireWildcard(__webpack_require__(1179));

var propTypes = {
  /** Body content of the content. */
  children: _propTypes["default"].node.isRequired,
  onCancelFooter: _propTypes["default"].func
};
var defaultProps = {
  onCancelFooter: null
};

var handleBlur = function handleBlur(state, dispatch, onCancelFooter) {
  return function () {
    var refListBoxContainer = state.refListBoxContainer;

    if (state.isDisabled) {
      return;
    } // requestAnimationFrame give time to process
    // the element that has received the click event
    // via document.activeElement instead of returning
    // the body element automatically


    window.requestAnimationFrame(function () {
      if (state.refTriggerContainer.current && state.refTriggerContainer.current.contains(document.activeElement)) {
        // close the popover if the target is the trigger, this make easier to handle tab events
        dispatch({
          type: _useListBox3["default"].types.closePopover
        });
        return;
      }

      if (refListBoxContainer && refListBoxContainer.current && !refListBoxContainer.current.contains(document.activeElement)) {
        dispatch({
          type: _useListBox3["default"].types.closePopover
        });

        if (state.hasFooter) {
          dispatch({
            type: _useListBox3["default"].types.cancel
          });
          if (onCancelFooter) onCancelFooter();
        }
      }
    });
  };
};

var handleContentFocusChange = function handleContentFocusChange(hasFocus, dispatch) {
  return dispatch({
    type: _useListBox3["default"].types.setListBoxHasFocus,
    payload: {
      hasFocus: hasFocus
    }
  });
};

function Content(props) {
  var onChangeContext = _react["default"].useContext(_OnChangeProvider.OnChangeContext);

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  var refListBoxContainer = state.refListBoxContainer;
  /* NOTE no idea what ROLE should be this div when the ListBox is INLINE */

  if (state.isInline) {
    return /*#__PURE__*/_react["default"].createElement(sc.Content, (0, _extends2["default"])({}, (0, _DOMAttributes.getDOMAttributesForListBoxContainer)({
      isInline: true
    }), {
      onFocus: function onFocus() {
        handleContentFocusChange(true, dispatch);
      },
      onBlur: function onBlur() {
        handleContentFocusChange(false, dispatch);
      },
      onKeyDown: (0, _handleKeyboardKeys.handleKeyDownKeyboardKeys)({
        state: state,
        dispatch: dispatch,
        onChangeContext: onChangeContext
      }),
      onKeyUp: (0, _handleKeyboardKeys.handleKeyUpKeyboardKeys)({
        state: state,
        dispatch: dispatch,
        onChangeContext: onChangeContext
      }),
      ref: refListBoxContainer,
      "data-pka-anchor": "list-box-content-inline"
    }), props.children);
  }

  return /*#__PURE__*/_react["default"].createElement(_popover["default"].Content, (0, _extends2["default"])({
    onBlur: handleBlur(state, dispatch, props.onCancelFooter),
    ref: refListBoxContainer
  }, (0, _DOMAttributes.getDOMAttributesForListBoxContainer)(), {
    onKeyDown: (0, _handleKeyboardKeys.handleKeyDownKeyboardKeys)({
      state: state,
      dispatch: dispatch,
      onChangeContext: onChangeContext
    }),
    onKeyUp: (0, _handleKeyboardKeys.handleKeyUpKeyboardKeys)({
      state: state,
      dispatch: dispatch,
      onChangeContext: onChangeContext
    })
  }), props.children);
}

Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
//# sourceMappingURL=Content.js.map

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _parseInt2 = _interopRequireDefault(__webpack_require__(112));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _construct = _interopRequireDefault(__webpack_require__(216));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(217));

var _createClass2 = _interopRequireDefault(__webpack_require__(218));

var _inherits2 = _interopRequireDefault(__webpack_require__(219));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(220));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(221));

var _react = _interopRequireDefault(__webpack_require__(2));

var _memoizeOne = _interopRequireDefault(__webpack_require__(207));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = _interopRequireDefault(__webpack_require__(222));

var _v = _interopRequireDefault(__webpack_require__(124));

var constants = _interopRequireWildcard(__webpack_require__(40));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _helpers = __webpack_require__(109);

var types = _interopRequireWildcard(__webpack_require__(1164));

var _isInsideBoundaries = _interopRequireDefault(__webpack_require__(1165));

var _getPosition = __webpack_require__(1166);

var _getBoundingClientRect = _interopRequireDefault(__webpack_require__(1167));

var _PopoverContext = _interopRequireWildcard(__webpack_require__(506));

var _Content = _interopRequireDefault(__webpack_require__(1168));

var _Card = _interopRequireDefault(__webpack_require__(1173));

var _Trigger = _interopRequireDefault(__webpack_require__(1175));

var _Tip = _interopRequireDefault(__webpack_require__(1177));

var sc = _interopRequireWildcard(__webpack_require__(507));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var openDelay = 350;
var closeDelay = 150;
var throttleDelay = 20;
var focusableElementSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]'; // TODO: To handle cases where there are multiple scrolling containers, we need to implement
//       getScrollContainer as oneOfType([func, arrayOf(func)])

var Popover = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popover);
    _this = _super.call(this, props);
    _this.getContextValues = (0, _memoizeOne["default"])(function (content, maxWidth, minWidth, width, isEager, isOpen, isPortal, portalElement, refContent, refTip, shouldKeepFocus, tip, zIndex, ariaIdForContent) {
      return {
        content: _objectSpread(_objectSpread({}, content), {}, {
          maxWidth: maxWidth,
          minWidth: minWidth,
          width: width,
          zIndex: zIndex,
          ariaId: ariaIdForContent
        }),
        isEager: isEager,
        isOpen: isOpen,
        onClick: _this.handleClick,
        onClose: _this.handleClose,
        onDelayedClose: _this.handleDelayedClose,
        onDelayedOpen: _this.handleDelayedOpen,
        onOpen: _this.handleOpen,
        isPortal: isPortal,
        portalElement: portalElement,
        refContent: refContent,
        refTip: refTip,
        shouldKeepFocus: shouldKeepFocus,
        tip: tip
      };
    });

    _this.getCoordinates = function () {
      var _this$props = _this.props,
          align = _this$props.align,
          edge = _this$props.edge,
          getScrollContainer = _this$props.getScrollContainer;
      var targetRect = _this.props.getPositioningElement === null ? (0, _getBoundingClientRect["default"])(_this.$popover.current) : (0, _getBoundingClientRect["default"])(_this.props.getPositioningElement());
      var contentCoords = (0, _getPosition.getContentCoordinates)({
        rect: _this.$content ? (0, _getBoundingClientRect["default"])(_this.$content) : null,
        targetRect: targetRect,
        scrollRect: getScrollContainer !== null ? (0, _getBoundingClientRect["default"])(getScrollContainer()) : null,
        align: align,
        offset: _this.props.offset,
        edge: edge
      });
      var tipCoords = {
        x: null,
        y: null,
        rotate: null
      };

      if (_this.$tip) {
        tipCoords = (0, _getPosition.getTipCoordinates)({
          tipRect: (0, _getBoundingClientRect["default"])(_this.$tip),
          targetRect: targetRect,
          contentRect: (0, _getBoundingClientRect["default"])(_this.$content),
          contentCoords: contentCoords,
          align: align
        });
      }

      return {
        tip: tipCoords,
        content: contentCoords
      };
    };

    _this.handleReposition = (0, _lodash["default"])(function () {
      if (_this.isOpen()) {
        var scrollContainer = _this.props.getScrollContainer === null ? document.body : _this.props.getScrollContainer();

        if (!(0, _isInsideBoundaries["default"])({
          $container: scrollContainer,
          $element: _this.$popover.current,
          align: _this.props.align
        })) {
          _this.close();

          return;
        }

        _this.setVisibilityAndPosition();
      }
    }, throttleDelay);

    _this.handleKeyUp = function (event) {
      if (event.key === "Escape") {
        _this.close();

        if (_this.$trigger) _this.$trigger.focus();
      }
    };

    _this.handleKeyDown = function (event) {
      if (event.key === "Tab" && _this.isOpen() && _this.$trigger) {
        var isFocusOnFirst = _this.focusIsOnCertainElementInPopover("first") || document.activeElement === _this.$content;

        var isFocusOnLast = _this.focusIsOnCertainElementInPopover("last");

        if (event.shiftKey && isFocusOnFirst) {
          event.preventDefault();

          _this.focusableElements[_this.triggerFocusIndex].focus();
        } else if (!event.shiftKey && isFocusOnLast) {
          event.preventDefault();

          _this.focusableElements[_this.triggerFocusIndex + 1].focus();
        }
      }
    };

    _this.focusIsOnCertainElementInPopover = function (which) {
      var focusableElementsInPopover = _this.$content.querySelectorAll(focusableElementSelector);

      var index = which === "first" ? 0 : focusableElementsInPopover.length - 1;
      return document.activeElement === focusableElementsInPopover[index];
    };

    _this.elementIsDescendentOfPopover = function (elem) {
      var elementsParent = elem.parentNode;

      while (elementsParent !== null) {
        if (elementsParent.getAttribute && elementsParent.getAttribute("data-pka-anchor") === "popover.content") {
          return true;
        }

        elementsParent = elementsParent.parentNode;
      }

      return false;
    };

    _this.getPopoverTriggerFocusIndex = function () {
      _this.focusableElements.forEach(function (focusableElement, index) {
        if (focusableElement === _this.$trigger) {
          _this.triggerFocusIndex = index;
        }
      });
    };

    _this.handleTransitionEnd = function (event) {
      // NOTE: do this should make more that only focus the content div? should as well
      //       find the first focusable element like button, input, etc?
      //       can focus automatically
      if (!_this.props.shouldKeepFocus && !_this.props.isEager && _this.isOpen() && event.propertyName === "visibility") {
        _this.getPopoverTriggerFocusIndex();

        event.target.focus();
      }
    };

    _this.handleOpen = function () {
      _this.open();
    };

    _this.handleClose = function () {
      _this.close();
    };

    _this.handleDelayedOpen = function () {
      clearTimeout(_this.closeTimer);
      _this.openTimer = setTimeout(_this.handleOpen, openDelay);
    };

    _this.handleDelayedClose = function () {
      clearTimeout(_this.openTimer);
      _this.closeTimer = setTimeout(_this.handleClose, closeDelay);
    };

    _this.handleClick = function () {
      if (_this.isOpen() && !_this.props.shouldKeepFocus && !_this.props.isEager) _this.close();else _this.open();
    };

    _this.refTip = function (ref) {
      _this.$tip = ref;
    };

    _this.refContent = function (ref) {
      _this.$content = ref;
    };

    _this.handleChildChange = function () {
      setTimeout(function () {
        _this.setVisibilityAndPosition();
      });
    };

    _this.hasListeners = false;
    _this.$popover = /*#__PURE__*/_react["default"].createRef();
    _this.$trigger = null;
    _this.$tip = null; // this ref comes from a callback of the <Tip /> component

    if (props.isPortal) {
      var portalNode = document.createElement("div");
      _this.$portal = document.body.appendChild(portalNode);
    }

    _this.focusableElements = [];
    _this.triggerFocusIndex = null;
    _this.state = {
      isOpen: _this.props.defaultIsOpen || false,
      tip: {
        x: 0,
        y: 0
      },
      content: {
        x: 0,
        y: 0
      },
      width: "auto"
    }; // NOTE: should we created a link explaining more deeply this kind of errors?
    //       this type of validation should live in the constructor or somewhere else?

    if (props.isOpen !== null && props.defaultIsOpen !== null) {
      console.error("The use of defaultIsOpen prop is for uncontrolled components only and cannot be used when\n        isOpen prop is also provided.");
    }

    _this.ariaIdForContent = "popover-content-".concat((0, _v["default"])());
    return _this;
  }

  (0, _createClass2["default"])(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // about setState for Popovers and Tooltips in ComponentDidMount
      // https://reactjs.org/docs/react-component.html#componentdidmount
      if (this.isOpen()) {
        this.addListeners();
        this.setVisibilityAndPosition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        this.open();
      }

      if (this.isOpen() && !this.hasListeners) {
        this.focusableElements = document.querySelectorAll(focusableElementSelector);
        this.addListeners();
      }

      if (this.isOpen() && prevProps !== this.props) this.setVisibilityAndPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
      clearTimeout(this.openTimer);
      this.openTimer = null;
      clearTimeout(this.closeTimer);
      this.closeTimer = null;

      if (this.props.isPortal) {
        document.body.removeChild(this.$portal);
      }
    }
  }, {
    key: "getContentWidth",
    value: function getContentWidth() {
      var $shadowContent = this.$content.cloneNode(true);
      $shadowContent.style.visibility = "hidden";
      $shadowContent.style.top = 0;
      $shadowContent.style.left = 0;
      $shadowContent.style.width = "auto";
      $shadowContent.style.maxWidth = this.props.maxWidth;
      $shadowContent.style.minWidth = this.props.minWidth;
      document.body.appendChild($shadowContent);
      var contentWidth = (0, _getBoundingClientRect["default"])($shadowContent).width;
      document.body.removeChild($shadowContent);
      return contentWidth;
    }
  }, {
    key: "setVisibilityAndPosition",
    value: function setVisibilityAndPosition() {
      var _this2 = this;

      var isOpening = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.$content) {
        // dynamically setting a fixed width before positioning avoids issues at the
        // right edge of the screen
        if (isOpening && [types.TOP, types.BOTTOM].includes(this.props.align)) {
          var newWidth = this.getContentWidth();

          if (newWidth !== this.state.width) {
            this.setState({
              width: newWidth
            }, function () {
              _this2.updateVisibilityAndPositionState(isOpening);
            });
            return;
          }
        }

        this.updateVisibilityAndPositionState(isOpening);
      }
    }
  }, {
    key: "open",
    value: function open() {
      this.$trigger = document.activeElement;
      this.setVisibilityAndPosition(true);
    }
  }, {
    key: "close",
    value: function close() {
      // NOTE: Even if uncontrolled, the app may want to be notified when closed via the onClose callback
      if (this.props.onClose !== null) {
        this.props.onClose();
      }

      if (this.props.isOpen === null) {
        this.setState({
          isOpen: false
        });
        this.removeListeners();
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      this.focusableElements = document.querySelectorAll(focusableElementSelector);
      return this.props.isOpen !== null ? this.props.isOpen : this.state.isOpen;
    }
  }, {
    key: "updateVisibilityAndPositionState",
    value: function updateVisibilityAndPositionState() {
      var isOpening = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _this$getCoordinates = this.getCoordinates(),
          content = _this$getCoordinates.content,
          tip = _this$getCoordinates.tip;

      var newState = {
        content: content,
        tip: tip
      };
      if (isOpening) newState.isOpen = true;
      this.setState(newState);
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      if (this.$content) {
        document.addEventListener("keyup", this.handleKeyUp, false);
        document.addEventListener("keydown", this.handleKeyDown, false);
        document.addEventListener("resize", this.handleReposition, false);
        document.addEventListener("scroll", this.handleReposition, false);

        if (this.props.getScrollContainer !== null) {
          this.props.getScrollContainer().addEventListener("scroll", this.handleReposition, false);
        }

        this.$content.addEventListener("transitionend", this.handleTransitionEnd, false);
        this.hasListeners = true;
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (this.$content) {
        document.removeEventListener("resize", this.handleReposition);

        if (this.props.getScrollContainer === null) {
          document.removeEventListener("scroll", this.handleReposition);
        } else {
          this.props.getScrollContainer().removeEventListener("scroll", this.handleReposition);
        }

        document.removeEventListener("keyup", this.handleKeyUp);
        document.removeEventListener("keydown", this.handleKeyDown);
        this.$content.removeEventListener("transitionend", this.handleTransitionEnd);
        this.hasListeners = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          align = _this$props2.align,
          children = _this$props2.children,
          isDark = _this$props2.isDark,
          isEager = _this$props2.isEager,
          isOpen = _this$props2.isOpen,
          isPortal = _this$props2.isPortal,
          defaultIsOpen = _this$props2.defaultIsOpen,
          maxWidth = _this$props2.maxWidth,
          minWidth = _this$props2.minWidth,
          onClose = _this$props2.onClose,
          offset = _this$props2.offset,
          getPositioningElement = _this$props2.getPositioningElement,
          getScrollContainer = _this$props2.getScrollContainer,
          zIndex = _this$props2.zIndex,
          moreProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["align", "children", "isDark", "isEager", "isOpen", "isPortal", "defaultIsOpen", "maxWidth", "minWidth", "onClose", "offset", "getPositioningElement", "getScrollContainer", "zIndex"]);
      var contextValue = this.getContextValues(this.state.content, maxWidth, minWidth, this.state.width, isEager, this.isOpen(), isPortal, this.$portal, this.refContent, this.refTip, this.props.shouldKeepFocus, this.state.tip, zIndex, this.ariaIdForContent);
      return /*#__PURE__*/_react["default"].createElement(_PopoverContext.ThemeContext.Provider, {
        value: isDark
      }, /*#__PURE__*/_react["default"].createElement(_PopoverContext["default"].Provider, {
        value: contextValue
      }, /*#__PURE__*/_react["default"].createElement(sc.Popover, (0, _extends2["default"])({
        "data-pka-anchor": "popover"
      }, moreProps, {
        ref: this.$popover
      }), /*#__PURE__*/_react["default"].createElement(PopoverChildren, {
        onChildChange: this.handleChildChange
      }, this.props.children))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!prevState.isOpen && nextProps.isOpen) {
        return {
          isOpen: true
        };
      }

      return null;
    }
  }]);
  return Popover;
}(_react["default"].Component); // Todo Refactor this when we convert popover component to use hooks


function PopoverChildren(props) {
  var children = props.children,
      onChildChange = props.onChildChange;

  _react["default"].useLayoutEffect(function () {
    if (children) onChildChange();
  }, [children, onChildChange]);

  return children;
}

Popover.types = {
  align: constants.align
};
var propTypes = {
  /** Where the popover content is positioned relative to the trigger or getPositioningElement. */
  align: _propTypes["default"].oneOf([Popover.types.align.TOP, Popover.types.align.RIGHT, Popover.types.align.BOTTOM, Popover.types.align.LEFT]),

  /** Content of the popover */
  children: _propTypes["default"].node.isRequired,

  /** Displays as a "tooltip" style with white text on black background. */
  isDark: _propTypes["default"].bool,

  /** Activated by mouseOver / focus instead of onClick. */
  isEager: _propTypes["default"].bool,

  /** How "controlled" popovers are shown / hidden. */
  isOpen: _propTypes["default"].bool,

  /** This renders the popover inline in the DOM and not in a react portal. WARNING: will have side effects with paprika side panels and modals, use with caution. */
  isPortal: _propTypes["default"].bool,

  /** How "uncontrolled" popovers can be rendered open by default. */
  defaultIsOpen: _propTypes["default"].bool,

  /** Where the edge of the popover content is based on the trigger or getPositioningElement */
  edge: _propTypes["default"].oneOf([Popover.types.align.LEFT, Popover.types.align.RIGHT, null]),

  /** Maximum width of popover content. Using a number is recommended and implies px units. */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Minimumn width of popover content. Using a number is recommended and implies px units. */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Callback to fire when user closes popover. */
  onClose: _propTypes["default"].func,

  /** Distance, in px, between popover content edge and trigger / getPositioningElement. */
  offset: _propTypes["default"].number,

  /** Function that provides DOM element to use as target for positioning the popover. */
  getPositioningElement: _propTypes["default"].func,

  /** Function that provides the scrolling DOM element that contains the popover. */
  getScrollContainer: _propTypes["default"].func,

  /** If focus will stay at the trigger when showing popover. Popover can still be closed when clicking outside or pressing escape key. */
  shouldKeepFocus: _propTypes["default"].bool,

  /** Number setting the z-index for the popover content / tip. */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  align: Popover.types.align.BOTTOM,
  isDark: false,
  isEager: false,
  isOpen: null,
  isPortal: true,
  defaultIsOpen: null,
  edge: null,
  maxWidth: 320,
  minWidth: 0,
  onClose: null,
  offset: (0, _parseInt2["default"])(_tokens["default"].spaceLg, 10),
  getPositioningElement: null,
  getScrollContainer: null,
  shouldKeepFocus: false,
  zIndex: (0, _helpers.zValue)(1)
};
Popover.displayName = "Popover";
Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
Popover.Trigger = _Trigger["default"];
Popover.Content = _Content["default"];
Popover.Card = _Card["default"];
Popover.Tip = _Tip["default"];
var _default = Popover;
exports["default"] = _default;
//# sourceMappingURL=Popover.js.map

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LEFT = exports.BOTTOM = exports.RIGHT = exports.TOP = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var TOP = constants.align.TOP;
exports.TOP = TOP;
var RIGHT = constants.align.RIGHT;
exports.RIGHT = RIGHT;
var BOTTOM = constants.align.BOTTOM;
exports.BOTTOM = BOTTOM;
var LEFT = constants.align.LEFT;
exports.LEFT = LEFT;
//# sourceMappingURL=types.js.map

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var isInsideBoundaries = function isInsideBoundaries(_ref) {
  var $container = _ref.$container,
      $element = _ref.$element,
      align = _ref.align;

  if ($container && $element) {
    var containerRect = $container.getBoundingClientRect();
    var elementRect = $element.getBoundingClientRect();
    var alignVert = ["bottom", "top"].includes(align); // avoid some weirdness with the tip and with scrollbars
    // we might actually want the dimensions of the Tip to do this right
    // half tip + edgePadding

    var edgeBuffer = {
      vert: alignVert ? 0 : 15,
      horz: alignVert ? 15 : 0
    }; // ¿ maybe just round up to 20 ?

    var scrollbarBuffer = 17;
    var elementLimit = {
      left: alignVert ? elementRect.right - elementRect.width / 2 : elementRect.right,
      right: alignVert ? elementRect.right - elementRect.width / 2 : elementRect.left + scrollbarBuffer,
      top: alignVert ? elementRect.bottom : elementRect.bottom - elementRect.height / 2,
      bottom: alignVert ? elementRect.top + scrollbarBuffer : elementRect.bottom - elementRect.height / 2
    };
    return elementLimit.top - edgeBuffer.vert >= containerRect.top && elementLimit.bottom + edgeBuffer.vert <= containerRect.bottom && elementLimit.right + edgeBuffer.horz <= containerRect.right && elementLimit.left - edgeBuffer.horz >= containerRect.left;
  }

  return true;
};

var _default = isInsideBoundaries;
exports["default"] = _default;
//# sourceMappingURL=isInsideBoundaries.js.map

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.getTipCoordinates = exports.getContentCoordinates = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _isNan = _interopRequireDefault(__webpack_require__(181));

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _customPropTypes = __webpack_require__(634);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var rotate = {
  top: 180,
  right: 270,
  bottom: 0,
  left: 90
};
var edgePadding = (0, _parseInt["default"])(_tokens["default"].space, 10);

var getAdjustedContentCoordinates = function getAdjustedContentCoordinates(_ref) {
  var x = _ref.x,
      y = _ref.y,
      contentRect = _ref.contentRect,
      targetRect = _ref.targetRect,
      scrollRect = _ref.scrollRect,
      align = _ref.align,
      offset = _ref.offset;
  var viewport = {
    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  };
  var boundary = {
    top: scrollRect ? scrollRect.top : 0,
    right: scrollRect ? Math.min(scrollRect.right, viewport.width) : viewport.width,
    bottom: scrollRect ? Math.min(scrollRect.bottom, viewport.height) : viewport.height,
    left: scrollRect ? scrollRect.left : 0
  };
  var alignVert = ["bottom", "top"].includes(align);
  var isOnRightSide = targetRect.x + targetRect.width / 2 > boundary.left + (boundary.right - boundary.left) / 2;
  var isOnBottomHalf = targetRect.y + targetRect.height / 2 > boundary.top + (boundary.bottom - boundary.top) / 2;
  var overflowsViewportLeft = x < boundary.left;
  var overflowsViewportRight = x + contentRect.width > boundary.right;
  var overflowsViewportTop = y < boundary.top;
  var overflowsViewportBottom = y + contentRect.height > boundary.bottom;
  var newX = (0, _isNan["default"])(x) ? 0 : x;
  var newY = (0, _isNan["default"])(y) ? 0 : y;

  if (overflowsViewportLeft && !isOnRightSide) {
    newX = alignVert ? boundary.left + edgePadding : newX = targetRect.x + targetRect.width + offset;
  }

  if (overflowsViewportRight && isOnRightSide) {
    newX = alignVert ? boundary.right - contentRect.width - edgePadding : targetRect.x - contentRect.width - offset;
  }

  if (overflowsViewportTop && !isOnBottomHalf) {
    newY = alignVert ? targetRect.y + targetRect.height + offset : boundary.top + edgePadding;
  }

  if (overflowsViewportBottom && isOnBottomHalf) {
    newY = alignVert ? y - (contentRect.height + offset * 2 + targetRect.height) : boundary.bottom - contentRect.height - edgePadding;
  }

  return {
    x: newX,
    y: newY
  };
};

var getAnchor = function getAnchor(rect, align) {
  var positions = {
    top: function top() {
      return {
        x: rect.left + rect.width / 2,
        y: rect.top
      };
    },
    right: function right() {
      return {
        x: rect.right,
        y: rect.y + rect.height / 2
      };
    },
    bottom: function bottom() {
      return {
        x: rect.left + rect.width / 2,
        y: rect.y + rect.height
      };
    },
    left: function left() {
      return {
        x: rect.left,
        y: rect.y + rect.height / 2
      };
    }
  };
  return positions[align]();
};

var getContentCoordinates = function getContentCoordinates(_ref2) {
  var _alignedPosition;

  var rect = _ref2.rect,
      targetRect = _ref2.targetRect,
      scrollRect = _ref2.scrollRect,
      align = _ref2.align,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 12 : _ref2$offset,
      edge = _ref2.edge;
  var anchor = getAnchor(targetRect, align);

  var getContentXByEdge = function getContentXByEdge() {
    if (edge === _customPropTypes.AlignTypes.LEFT) {
      return anchor.x - targetRect.width / 2;
    }

    if (edge === _customPropTypes.AlignTypes.RIGHT) {
      return anchor.x - rect.width + targetRect.width / 2;
    }

    return anchor.x - rect.width / 2;
  };

  var alignedPosition = (_alignedPosition = {}, (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.TOP, function () {
    return getAdjustedContentCoordinates({
      x: getContentXByEdge(),
      y: anchor.y - (rect.height + offset),
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.RIGHT, function () {
    return getAdjustedContentCoordinates({
      x: anchor.x + offset,
      y: anchor.y - rect.height / 2,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.BOTTOM, function () {
    return getAdjustedContentCoordinates({
      x: getContentXByEdge(),
      y: anchor.y + offset,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.LEFT, function () {
    return getAdjustedContentCoordinates({
      x: anchor.x - rect.width - offset,
      y: anchor.y - rect.height / 2,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), _alignedPosition);
  return alignedPosition[align]();
}; // The default value of 1.2 pixels for offset is to ensure a small overlap so that at certain browser zoom levels
// we do not see a slim piece of the underlying content (Popover.Card border)


exports.getContentCoordinates = getContentCoordinates;

var getTipCoordinates = function getTipCoordinates(_ref3) {
  var tipRect = _ref3.tipRect,
      targetRect = _ref3.targetRect,
      contentRect = _ref3.contentRect,
      contentCoords = _ref3.contentCoords,
      align = _ref3.align,
      _ref3$offset = _ref3.offset,
      offset = _ref3$offset === void 0 ? -1.2 : _ref3$offset;
  var alignedPosition = {
    top: function top() {
      return {
        x: targetRect.x + targetRect.width / 2 - tipRect.width / 2,
        y: contentCoords.y + contentRect.height + offset
      };
    },
    right: function right() {
      return {
        x: contentCoords.x - tipRect.width - offset,
        y: targetRect.y + targetRect.height / 2 - tipRect.height / 2
      };
    },
    bottom: function bottom() {
      return {
        x: targetRect.x + targetRect.width / 2 - tipRect.width / 2,
        y: contentCoords.y - tipRect.height - offset
      };
    },
    left: function left() {
      return {
        x: contentCoords.x + contentRect.width + offset,
        y: targetRect.y + targetRect.height / 2 - tipRect.height / 2
      };
    }
  };
  var tipAlign = {
    top: function top() {
      return contentCoords.y > targetRect.y ? "bottom" : align;
    },
    right: function right() {
      return contentCoords.x < targetRect.x ? "left" : align;
    },
    bottom: function bottom() {
      return contentCoords.y < targetRect.y ? "top" : align;
    },
    left: function left() {
      return contentCoords.x > targetRect.x ? "right" : align;
    }
  };
  var adjustedAlign = tipAlign[align]();
  return _objectSpread(_objectSpread({}, alignedPosition[adjustedAlign]()), {}, {
    rotate: rotate[adjustedAlign]
  });
};

exports.getTipCoordinates = getTipCoordinates;
//# sourceMappingURL=getPosition.js.map

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = getBoundingClientRect;

function getBoundingClientRect(el) {
  var rect = el.getBoundingClientRect();
  var x;
  var y;

  if (rect.x === undefined) {
    x = rect.left;
  } else {
    x = rect.x;
  }

  if (rect.y === undefined) {
    y = rect.top;
  } else {
    y = rect.y;
  }

  return {
    left: rect.left,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    x: x,
    y: y,
    width: rect.width,
    height: rect.height
  };
}
//# sourceMappingURL=getBoundingClientRect.js.map

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _parseInt2 = _interopRequireDefault(__webpack_require__(112));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _isElementContainsFocus = _interopRequireDefault(__webpack_require__(1169));

var _PopoverContext = _interopRequireDefault(__webpack_require__(506));

var _Popover = __webpack_require__(507);

var _Content = __webpack_require__(1172);

var propTypes = {
  children: _propTypes["default"].node,

  /** Callback to indicate the element loses focus */
  onBlur: _propTypes["default"].func
};
var defaultProps = {
  children: null,
  onBlur: function onBlur() {}
};

var Content = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onBlur = props.onBlur,
      children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["onBlur", "children"]);

  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      isEager = _React$useContext.isEager,
      isOpen = _React$useContext.isOpen,
      isPortal = _React$useContext.isPortal,
      onClose = _React$useContext.onClose,
      onDelayedClose = _React$useContext.onDelayedClose,
      onDelayedOpen = _React$useContext.onDelayedOpen,
      portalElement = _React$useContext.portalElement,
      refContent = _React$useContext.refContent; // TODO: extract this to Storybook story somehow so supporting numbers as strings is not required


  function isNumber(n) {
    return RegExp(/^[0-9]+$/).test(n);
  }

  function handleMouseEvent(event) {
    if (!isEager) return;

    if (event.type === "mouseover") {
      onDelayedOpen();
    } else if (event.type === "mouseout") {
      onDelayedClose();
    }
  }

  function handleBlur(event) {
    // onblur canceling onclick the following happens when:
    // Clicking twice the trigger button (open, close), will fire an onclick and onblur event
    // creating a race condition nullyfing the onClick and keeping the popover open
    // https://stackoverflow.com/questions/121499/when-a-blur-event-occurs-how-can-i-find-out-which-element-focus-went-to
    // the previous link answer suggested the use of the mouseDown event, thought, that will kill all accessibility of onClick,
    // as well will affect the devUX when you want to have a controlled Popover forcing the use of mouseDown event instead of onClick
    // Solution https://stackoverflow.com/a/121708/196038
    // Use timeout to delay examination of activeElement until after blur/focus
    // events have been processed.
    var currentTarget = event.currentTarget;
    setTimeout(function () {
      if (!(0, _isElementContainsFocus["default"])(currentTarget)) {
        onClose();
        onBlur();
      }
    }, (0, _parseInt2["default"])(_Popover.consts.transition, 10));
  }

  function cssValue(value) {
    return isNumber(value) ? "".concat(value, "px") : value;
  }

  var handleRef = function handleRef(_ref) {
    refContent(_ref);

    if (ref) {
      // https://github.com/reactjs/rfcs/blob/master/text/0017-new-create-ref.md#basic-example
      ref.current = _ref; // eslint-disable-line
    }
  };

  var contentStyles = {
    left: content.x,
    top: content.y,
    maxWidth: cssValue(content.maxWidth),
    minWidth: cssValue(content.minWidth)
  };

  if (content.width && content.width !== "auto") {
    contentStyles.width = content.width;
  }
  /* eslint-disable jsx-a11y/mouse-events-have-key-events */


  var ContentStyledComponent = /*#__PURE__*/_react["default"].createElement(_Content.ContentStyled, (0, _extends2["default"])({
    "aria-hidden": !isOpen,
    "data-component-name": "PopoverContent",
    "data-pka-anchor": "popover.content",
    ref: handleRef,
    id: isEager ? content.ariaId : null,
    isOpen: isOpen,
    onBlur: handleBlur,
    onMouseOut: handleMouseEvent,
    onMouseOver: handleMouseEvent,
    style: contentStyles,
    tabIndex: "-1",
    zIndex: content.zIndex
  }, moreProps), props.children);

  if (isPortal) {
    return /*#__PURE__*/_reactDom["default"].createPortal(ContentStyledComponent, portalElement);
  }

  return ContentStyledComponent;
});
/* eslint-enable jsx-a11y/mouse-events-have-key-events */


Content.displayName = "Popover.Content";
Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
var _default = Content;
exports["default"] = _default;
//# sourceMappingURL=Content.js.map

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var isElementContainsFocus = function isElementContainsFocus(element) {
  if (document.activeElement === element) return true;
  return element.contains(document.activeElement);
};

var _default = isElementContainsFocus;
exports["default"] = _default;
//# sourceMappingURL=isElementContainsFocus.js.map

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var sc = _interopRequireWildcard(__webpack_require__(1171));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** If the visual focus ring should be displayed with an inset style. */
  hasInsetFocusStyle: _propTypes["default"].bool,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  isActive: null,
  isDisabled: false,
  hasInsetFocusStyle: false,
  onClick: function onClick() {},
  role: "button",
  tabIndex: null
};

var isTriggerKey = function isTriggerKey(key) {
  return [" ", "Enter"].includes(key);
};

var RawButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      onClick = props.onClick,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "isActive", "isDisabled", "onClick", "tabIndex"]);

  var rawButtonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        rawButtonRef.current.focus();
      }
    };
  });

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);
    if (!canPropagate) event.stopPropagation();
    if (!isDisabled) onClick(event);
  };

  function handleBlur(event) {
    if (moreProps.onBlur) moreProps.onBlur(event);
    setHasForcedFocus(false);
  }

  var handleKeyDown = function handleKeyDown(event) {
    // Prevent scrolling the page with a spacerbar keypress
    // Prevent submitting forms in IE/Edge with and enter keypress
    if (isTriggerKey(event.key)) event.preventDefault();
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;
    if (shouldHandle && moreProps.onKeyDown) moreProps.onKeyDown(event);
  };

  var handleKeyUp = function handleKeyUp(event) {
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;

    if (!isDisabled && shouldHandle && isTriggerKey(event.key)) {
      onClick(event);
    }

    if (shouldHandle && moreProps.onKeyUp) moreProps.onKeyUp(event);
  };

  var bestTabIndex = isDisabled && tabIndex === null ? -1 : tabIndex || 0;
  return /*#__PURE__*/_react["default"].createElement(sc.RawButton, (0, _extends2["default"])({
    "aria-pressed": isActive,
    "data-pka-anchor": "raw-button",
    tabIndex: bestTabIndex,
    "aria-label": a11yText
  }, moreProps, {
    "aria-disabled": isDisabled,
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isDisabled,
    onBlur: handleBlur,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: rawButtonRef
  }), children);
});

RawButton.displayName = "RawButton";
RawButton.propTypes = propTypes;
RawButton.defaultProps = defaultProps;
var _default = RawButton;
exports["default"] = _default;
//# sourceMappingURL=RawButton.js.map

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RawButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var focusStyles = function focusStyles(isInset) {
  return (0, _styledComponents.css)(["&:focus{", "}[data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{box-shadow:none;outline:none;}"], _stylers["default"].focusRing(isInset));
};

var disabledStyles = (0, _styledComponents.css)(["cursor:not-allowed;&:focus{box-shadow:none;}"]);

var RawButton = _styledComponents["default"].span.withConfig({
  displayName: "RawButtonstyles__RawButton",
  componentId: "sc-1jqcbbw-0"
})(function (_ref) {
  var hasInsetFocusStyle = _ref.hasInsetFocusStyle,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["cursor:pointer;display:inline-block;", ";", ";"], isActive ? _stylers["default"].focusRing(hasInsetFocusStyle) : focusStyles(hasInsetFocusStyle), isDisabled && disabledStyles);
});

exports.RawButton = RawButton;
//# sourceMappingURL=RawButton.styles.js.map

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ContentStyled = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _Popover = __webpack_require__(507);

var ContentStyled = _styledComponents["default"].div.withConfig({
  displayName: "Contentstyles__ContentStyled",
  componentId: "sc-1abapfp-0"
})(["opacity:", ";position:fixed;transition:opacity ", " ease,visibility ", " ease;visibility:", ";z-index:", ";&:focus{outline:none;}"], function (props) {
  return props.isOpen ? 1 : 0;
}, _Popover.consts.transition, _Popover.consts.transition, function (props) {
  return props.isOpen ? "visible" : "hidden";
}, function (props) {
  return props.zIndex;
});

exports.ContentStyled = ContentStyled;
//# sourceMappingURL=Content.styles.js.map

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _PopoverContext = __webpack_require__(506);

var _Card = _interopRequireDefault(__webpack_require__(1174));

function Card(props) {
  var children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children"]);

  var isDark = _react["default"].useContext(_PopoverContext.ThemeContext);

  return /*#__PURE__*/_react["default"].createElement(_Card["default"], (0, _extends2["default"])({
    isDark: isDark,
    "data-pka-anchor": "popover.card"
  }, moreProps), children);
}

Card.displayName = "Popover.Card";
Card.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = Card;
exports["default"] = _default;
//# sourceMappingURL=Card.js.map

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var defaultStyles = "\n  background-color: ".concat(_tokens["default"].color.white, ";\n  border: 1px solid ").concat(_tokens["default"].border.color, ";\n  border-radius: ").concat(_tokens["default"].card.borderRadius, ";\n  box-shadow: ").concat(_tokens["default"].shadow, ";\n  color: ").concat(_tokens["default"].textColor["default"], ";\n  padding: ").concat(_tokens["default"].space, " ").concat(_tokens["default"].spaceLg, ";\n");
var darkStyles = "\n  background-color: ".concat(_tokens["default"].color.black, ";\n  border: 1px solid ").concat(_tokens["default"].color.black, ";\n  border-radius: ").concat(_tokens["default"].border.radius, ";\n  color: ").concat(_tokens["default"].color.white, ";\n  padding: ").concat(_tokens["default"].spaceSm, " ").concat(_tokens["default"].space, ";\n");

var CardStyled = _styledComponents["default"].div.withConfig({
  displayName: "Cardstyles__CardStyled",
  componentId: "sc-1penuek-0"
})(["", ";", ";", ";overflow:hidden;"], function (props) {
  return props.isDark ? darkStyles : defaultStyles;
}, _stylers["default"].fontSize(-1), _stylers["default"].lineHeight());

var _default = CardStyled;
exports["default"] = _default;
//# sourceMappingURL=Card.styles.js.map

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _rawButton = _interopRequireDefault(__webpack_require__(563));

var _isActiveElementPopover = __webpack_require__(1176);

var _PopoverContext = _interopRequireDefault(__webpack_require__(506));

var sc = _interopRequireWildcard(__webpack_require__(507));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var propTypes = {
  /** Descriptive a11y text for assistive technologies for the trigger. */
  a11yText: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]).isRequired
};
var defaultProps = {
  a11yText: null
};

function Trigger(props) {
  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      isEager = _React$useContext.isEager,
      isOpen = _React$useContext.isOpen,
      onClick = _React$useContext.onClick,
      onClose = _React$useContext.onClose,
      onDelayedClose = _React$useContext.onDelayedClose,
      onDelayedOpen = _React$useContext.onDelayedOpen,
      onOpen = _React$useContext.onOpen,
      shouldKeepFocus = _React$useContext.shouldKeepFocus;

  function handleTriggerEvent(event) {
    if (isEager && (event.type === "mouseover" || event.type === "focus")) {
      if (event.type === "mouseover") {
        onDelayedOpen();
      } else {
        onOpen();
      }
    } else if (isEager && event.type === "mouseout") {
      onDelayedClose();
    } else if ((shouldKeepFocus || isEager) && event.type === "blur") {
      window.requestAnimationFrame(function () {
        if (!(0, _isActiveElementPopover.isActiveElementPopover)()) onClose();
      });
    } else if (event.type === "click" || event.key === " " || event.key === "Enter") {
      onClick();
    }
  }

  var children = props.children,
      a11yText = props.a11yText,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "a11yText"]);

  if (typeof children === "function") {
    var a11yAttributes = {
      "aria-describedby": content.ariaId
    };
    return /*#__PURE__*/_react["default"].cloneElement(children(handleTriggerEvent, a11yAttributes, isOpen), _objectSpread({}, moreProps));
  }

  if (isEager) {
    return /*#__PURE__*/_react["default"].createElement(sc.Trigger, (0, _extends2["default"])({
      a11yText: a11yText,
      "data-pka-anchor": "popover.trigger",
      onMouseOver: handleTriggerEvent,
      onMouseOut: handleTriggerEvent,
      onFocus: handleTriggerEvent,
      onBlur: handleTriggerEvent,
      "aria-describedby": content.ariaId
    }, moreProps), children);
  }

  return /*#__PURE__*/_react["default"].createElement(_rawButton["default"], (0, _extends2["default"])({
    a11yText: a11yText,
    "data-pka-anchor": "popover.trigger",
    onClick: handleTriggerEvent,
    onBlur: shouldKeepFocus ? handleTriggerEvent : null
  }, moreProps), children);
}

Trigger.displayName = "Popover.Trigger";
Trigger.propTypes = propTypes;
Trigger.defaultProps = defaultProps;
var _default = Trigger;
exports["default"] = _default;
//# sourceMappingURL=Trigger.js.map

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isActiveElementPopover = void 0;

var isActiveElementPopover = function isActiveElementPopover() {
  return document.activeElement.dataset.componentName === "PopoverContent";
};

exports.isActiveElementPopover = isActiveElementPopover;
//# sourceMappingURL=isActiveElementPopover.js.map

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _PopoverContext = _interopRequireWildcard(__webpack_require__(506));

var _Tip = __webpack_require__(1178);

var propTypes = {
  /** Number setting the z-index */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  zIndex: null
};

function Tip(props) {
  var zIndex = props.zIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["zIndex"]);

  var isDark = _react["default"].useContext(_PopoverContext.ThemeContext);

  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      tip = _React$useContext.tip,
      refTip = _React$useContext.refTip,
      isOpen = _React$useContext.isOpen,
      isPortal = _React$useContext.isPortal,
      portalElement = _React$useContext.portalElement;

  var borderColor = isDark ? _tokens["default"].color.black : _tokens["default"].border.color;
  var backgroundColor = isDark ? _tokens["default"].color.black : _tokens["default"].color.white;

  var TipStyledComponent = /*#__PURE__*/_react["default"].createElement(_Tip.TipStyled, (0, _extends2["default"])({
    isOpen: isOpen,
    "data-pka-anchor": "popover.tip",
    ref: refTip,
    rotate: tip.rotate,
    style: {
      left: tip.x,
      top: tip.y
    },
    zIndex: zIndex || content.zIndex
  }, moreProps), /*#__PURE__*/_react["default"].createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "0 0 12 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "0 12 12 12 6 6",
    fill: borderColor
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "1 12 11 12 6 7",
    fill: backgroundColor
  })));

  if (isPortal) {
    return /*#__PURE__*/_reactDom["default"].createPortal(TipStyledComponent, portalElement);
  }

  return TipStyledComponent;
}

Tip.displayName = "Popover.Tip";
Tip.propTypes = propTypes;
Tip.defaultProps = defaultProps;
var _default = Tip;
exports["default"] = _default;
//# sourceMappingURL=Tip.js.map

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TipStyled = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Popover = __webpack_require__(507);

var TipStyled = _styledComponents["default"].div.withConfig({
  displayName: "Tipstyles__TipStyled",
  componentId: "sc-15lrbjo-0"
})(["display:block;height:", ";line-height:", ";opacity:", ";pointer-events:none;position:fixed;transform:rotate(", "deg);transition:opacity ", " ease,visibility ", " ease;visibility:", ";width:", ";z-index:", ";"], _stylers["default"].spacer(2), _stylers["default"].spacer(2), function (props) {
  return props.isOpen ? 1 : 0;
}, function (props) {
  return props.rotate || "0";
}, _Popover.consts.transition, _Popover.consts.transition, function (props) {
  return props.isOpen ? "visible" : "hidden";
}, _stylers["default"].spacer(2), function (props) {
  return props.zIndex;
});

exports.TipStyled = TipStyled;
//# sourceMappingURL=Tip.styles.js.map

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Content = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var Content = _styledComponents["default"].div.withConfig({
  displayName: "Contentstyles__Content",
  componentId: "sc-1vgomek-0"
})([":focus{outline:2px ", " dotted;z-index:1;}"], _tokens["default"].color.blackLighten30);

exports.Content = Content;
//# sourceMappingURL=Content.styles.js.map

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});

var _List = _interopRequireDefault(__webpack_require__(1181));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = List;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var _DOMAttributes = __webpack_require__(564);

var sc = _interopRequireWildcard(__webpack_require__(1182));

var propTypes = {
  /** Sets the height for the list */
  height: _propTypes["default"].number.isRequired,

  /** Body content of the list. */
  children: _propTypes["default"].node.isRequired
};

function List(props) {
  var children = props.children,
      height = props.height;

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 1),
      state = _useListBox2[0];

  var refListBox = state.refListBox;
  return /*#__PURE__*/_react["default"].createElement(sc.List, (0, _extends2["default"])({
    "data-pka-anchor": "styled-list"
  }, (0, _DOMAttributes.getDOMAttributesForListBox)(state), {
    noResultsFound: state.noResultsFound,
    height: height,
    ref: refListBox
  }), children);
}

List.propTypes = propTypes;
//# sourceMappingURL=List.js.map

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.List = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var List = _styledComponents["default"].ul.withConfig({
  displayName: "Liststyles__List",
  componentId: "sc-1ic4ckz-0"
})(function (_ref) {
  var noResultsFound = _ref.noResultsFound,
      height = _ref.height;
  return (0, _styledComponents.css)(["box-sizing:border-box;list-style:none;margin:0;max-height:", "px;overflow:auto;&:focus{outline:none;}li{box-sizing:border-box;}padding:8px;", ""], height, noResultsFound ? "padding: 0" : "");
});

exports.List = List;
//# sourceMappingURL=List.styles.js.map

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NoResults["default"];
  }
});

var _NoResults = _interopRequireDefault(__webpack_require__(1184));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = NoResults;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var sc = _interopRequireWildcard(__webpack_require__(1185));

var propTypes = {
  /** Sets label for NoResults */
  label: _propTypes["default"].node.isRequired
};

function NoResults(props) {
  var label = props.label;

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 1),
      state = _useListBox2[0];

  if ((state.isOpen || state.isInline) && state.noResultsFound) {
    return /*#__PURE__*/_react["default"].createElement(sc.NoResults, {
      "data-pka-anchor": "no-results"
    }, label);
  }

  return null;
}

NoResults.propTypes = propTypes;
//# sourceMappingURL=NoResults.js.map

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.NoResults = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var NoResults = _styledComponents["default"].div.withConfig({
  displayName: "NoResultsstyles__NoResults",
  componentId: "erbho4-0"
})(["margin-top:-4px;padding:8px;"]);

exports.NoResults = NoResults;
//# sourceMappingURL=NoResults.styles.js.map

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Options["default"];
  }
});

var _Options = _interopRequireDefault(__webpack_require__(1187));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = Options;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(2));

var _options = __webpack_require__(410);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function Options(props) {
  var children = props.children,
      isPopoverOpen = props.isPopoverOpen;
  var index = -1;
  return _react["default"].Children.map(children, function (child) {
    var _child$type$displayNa = child.type.displayName,
        displayName = _child$type$displayNa === void 0 ? null : _child$type$displayNa;

    if (child.type && (0, _options.isWhiteListed)(displayName)) {
      index += 1;
      return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
        index: index,
        isPopoverOpen: isPopoverOpen
      }));
    }

    return child;
  });
}
//# sourceMappingURL=Options.js.map

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Popover;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var sc = _interopRequireWildcard(__webpack_require__(1189));

var propTypes = {
  /** Body content of the PopOver. */
  children: _propTypes["default"].node,
  // eslint-disable-line

  /** Sets the z-index value of the PopOver */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  zIndex: 100
};

function Popover(props) {
  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 1),
      state = _useListBox2[0];

  var children = props.children,
      zIndex = props.zIndex;
  return /*#__PURE__*/_react["default"].createElement(sc.PopoverWrapper, (0, _extends2["default"])({}, props, {
    isOpen: state.isOpen,
    maxWidth: state.triggerWidth,
    offset: 0,
    zIndex: zIndex
  }), children);
}

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
Popover.displayName = "ListBox.Popover";
//# sourceMappingURL=Popover.js.map

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PopoverWrapper = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _popover = _interopRequireDefault(__webpack_require__(733));

var PopoverWrapper = (0, _styledComponents["default"])(_popover["default"]).withConfig({
  displayName: "Popoverstyles__PopoverWrapper",
  componentId: "sc-54yfzb-0"
})(["display:inline-block;width:100%;"]);
exports.PopoverWrapper = PopoverWrapper;
//# sourceMappingURL=Popover.styles.js.map

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Trigger;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _nanoid = _interopRequireDefault(__webpack_require__(289));

var _rawButton = _interopRequireDefault(__webpack_require__(563));

var _button = _interopRequireDefault(__webpack_require__(643));

var _CaretDown = _interopRequireDefault(__webpack_require__(310));

var _CaretUp = _interopRequireDefault(__webpack_require__(644));

var _TimesCircle = _interopRequireDefault(__webpack_require__(509));

var _Label = _interopRequireDefault(__webpack_require__(1199));

var _handleKeyboardKeys = __webpack_require__(734);

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var _OnChangeProvider = __webpack_require__(508);

var _invokeOnChange = _interopRequireWildcard(__webpack_require__(562));

var sc = _interopRequireWildcard(__webpack_require__(1203));

var _DOMAttributes = __webpack_require__(564);

var propTypes = {
  /** Custom clear icon */
  clearIcon: _propTypes["default"].node,

  /** Body content of the trigger. */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /** If true it adds a clear button */
  hasClearButton: _propTypes["default"].bool,

  /** Has implicit "All items selected" value when no item is selected */
  hasImplicitAll: _propTypes["default"].bool,

  /** Override the label with a custom one. */
  label: _propTypes["default"].string,

  /** Callback to be executed when the clear button is clicked or activated by keyboard. */
  onClickClear: _propTypes["default"].func,

  /** Callback to be executed when the accept button is clicked or activated by keyboard. */
  onClickFooterAccept: _propTypes["default"].func,

  /** Sets a placeholder for the trigger */
  placeholder: _propTypes["default"].string,

  /** If true the trigger will be hidden */
  isHidden: _propTypes["default"].bool
};
var defaultProps = {
  clearIcon: null,
  children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  hasClearButton: true,
  hasImplicitAll: false,
  label: null,
  onClickClear: null,
  onClickFooterAccept: null,
  placeholder: "Select...",
  isHidden: false
};

var _StyledCaretUpIcon = (0, _styledComponents["default"])(_CaretUp["default"]).withConfig({
  displayName: "Trigger___StyledCaretUpIcon",
  componentId: "sc-1kdta3o-0"
})(["", ""], function (p) {
  return p._css;
});

var _StyledCaretDownIcon = (0, _styledComponents["default"])(_CaretDown["default"]).withConfig({
  displayName: "Trigger___StyledCaretDownIcon",
  componentId: "sc-1kdta3o-1"
})(["", ""], function (p) {
  return p._css2;
});

var _StyledTimesCircleIcon = (0, _styledComponents["default"])(_TimesCircle["default"]).withConfig({
  displayName: "Trigger___StyledTimesCircleIcon",
  componentId: "sc-1kdta3o-2"
})(["", ""], function (p) {
  return p._css3;
});

function Trigger(props) {
  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  var onChangeContext = _react["default"].useContext(_OnChangeProvider.OnChangeContext);

  var clearIcon = props.clearIcon,
      placeholder = props.placeholder,
      hasClearButton = props.hasClearButton,
      hasImplicitAll = props.hasImplicitAll,
      label = props.label,
      onClickFooterAccept = props.onClickFooterAccept,
      children = props.children,
      isHidden = props.isHidden,
      onClickClear = props.onClickClear,
      onFooterClickAccept = props.onFooterClickAccept,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["clearIcon", "placeholder", "hasClearButton", "hasImplicitAll", "label", "onClickFooterAccept", "children", "isHidden", "onClickClear", "onFooterClickAccept"]);
  var isDisabled = state.isDisabled,
      formElementLabelDescribedBy = state.formElementLabelDescribedBy,
      refTriggerContainer = state.refTriggerContainer,
      refTrigger = state.refTrigger,
      isMulti = state.isMulti,
      idListBox = state.idListBox,
      refLabel = state.refLabel,
      size = state.size;

  var triggerButtonId = _react["default"].useRef((0, _nanoid["default"])());

  var handleClick = function handleClick() {
    if (isDisabled) {
      return;
    }

    dispatch({
      type: _useListBox3["default"].types.togglePopover
    });
  };

  _react["default"].useEffect(function () {
    var $label = refLabel && refLabel.current;
    if (!$label) return;

    function handleClickLabel() {
      refTrigger.current.focus();
    }

    $label.addEventListener("click", handleClickLabel);
    return function () {
      $label.removeEventListener("click", handleClickLabel);
    };
  }, [refLabel, refTrigger]);

  var handleClickClear = function handleClickClear() {
    if (isDisabled) {
      return;
    }

    if (onClickClear) {
      onClickClear(state, dispatch);
      return;
    }

    if (state.hasFooter) {
      dispatch({
        type: _useListBox3["default"].types.clear,
        payload: {
          isOpen: false,
          onChangeFn: (0, _invokeOnChange["default"])(onClickFooterAccept, "list-box:footer:clear")
        }
      });
      return;
    }

    dispatch({
      type: _useListBox3["default"].types.clear,
      payload: {
        isOpen: false,
        onChangeFn: (0, _invokeOnChange["default"])(state.onChange, "list-box:clear")
      }
    });
  };

  function renderLabel() {
    return state.isInline ? /*#__PURE__*/_react["default"].createElement(_Label["default"], {
      activeOption: state.options[state.activeOption],
      hasImplicitAll: hasImplicitAll,
      isMulti: isMulti,
      options: state.options,
      placeholder: placeholder,
      selectedOptions: state.selectedOptions,
      label: label
    }) : /*#__PURE__*/_react["default"].createElement(_rawButton["default"], {
      id: triggerButtonId.current,
      onClick: handleClick,
      ref: refTrigger,
      onKeyDown: (0, _handleKeyboardKeys.handleKeyDownKeyboardKeys)({
        state: state,
        dispatch: dispatch,
        onChangeContext: onChangeContext
      }),
      onKeyUp: (0, _handleKeyboardKeys.handleKeyUpKeyboardKeys)({
        state: state,
        dispatch: dispatch,
        onChangeContext: onChangeContext
      }),
      isDisabled: isDisabled,
      "data-pka-anchor": "list-box-trigger",
      "aria-describedby": formElementLabelDescribedBy,
      "aria-labelledby": triggerButtonId.current
    }, refLabel && refLabel.current ? /*#__PURE__*/_react["default"].createElement(sc.VisuallyHiddenFormLabel, null, refLabel.current.innerText) : null, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
      activeOption: state.options[state.activeOption],
      hasImplicitAll: hasImplicitAll,
      isMulti: isMulti,
      options: state.options,
      placeholder: placeholder,
      selectedOptions: state.selectedOptions,
      label: label
    }));
  }

  var hasRenderTrigger = typeof children === "function";
  var renderChildrenProps = null;
  renderChildrenProps = _react["default"].useMemo(function () {
    if (hasRenderTrigger) {
      if (isMulti) {
        var _getSelectedOptionsMu = (0, _invokeOnChange.getSelectedOptionsMulti)(state),
            _getSelectedOptionsMu2 = (0, _slicedToArray2["default"])(_getSelectedOptionsMu, 3),
            _selected = _getSelectedOptionsMu2[0],
            _options = _getSelectedOptionsMu2[1],
            current = _getSelectedOptionsMu2[2];

        return children(_selected, _options, current, {
          dispatch: dispatch,
          propsForTrigger: (0, _DOMAttributes.getDOMAttributesForListBoxButton)(idListBox),
          types: (0, _invokeOnChange.sanitizeActionTypes)(_useListBox3["default"].types),
          refTrigger: refTrigger,
          isOpen: state.isOpen
        });
      }

      var _getSelectedOptionSin = (0, _invokeOnChange.getSelectedOptionSingle)(state),
          _getSelectedOptionSin2 = (0, _slicedToArray2["default"])(_getSelectedOptionSin, 2),
          selected = _getSelectedOptionSin2[0],
          options = _getSelectedOptionSin2[1];

      return children(selected, options, {
        dispatch: dispatch,
        propsForTrigger: (0, _DOMAttributes.getDOMAttributesForListBoxButton)(idListBox),
        types: (0, _invokeOnChange.sanitizeActionTypes)(_useListBox3["default"].types),
        refTrigger: refTrigger,
        isOpen: state.isOpen
      });
    }
  }, [hasRenderTrigger, children, isMulti, state, dispatch, idListBox, refTrigger]);
  var caret = state.isOpen ? /*#__PURE__*/_react["default"].createElement(_StyledCaretUpIcon, {
    isDisabled: isDisabled,
    _css: sc.iconStyles
  }) : /*#__PURE__*/_react["default"].createElement(_StyledCaretDownIcon, {
    isDisabled: isDisabled,
    _css2: sc.iconStyles
  });
  var shouldHideClearButton = state.hasFooter && state.isOpen || hasRenderTrigger;
  var shouldHideCaret = hasRenderTrigger || state.isInline;

  if (isHidden && state.isInline) {
    return /*#__PURE__*/_react["default"].createElement(sc.ListBoxTrigger, {
      "data-pka-anchor": "list-box-trigger",
      isHidden: true
    });
  }

  return /*#__PURE__*/_react["default"].createElement(sc.ListBoxTrigger, (0, _extends2["default"])({
    isInline: state.isInline,
    isDisabled: isDisabled,
    ref: refTriggerContainer,
    size: size
  }, (0, _DOMAttributes.getDOMAttributesForListBoxButton)(state.idListBox)(), moreProps), hasRenderTrigger ? renderChildrenProps : renderLabel(), state.selectedOptions.length && hasClearButton && !shouldHideClearButton ? /*#__PURE__*/_react["default"].createElement(sc.ClearButton, {
    isSemantic: false,
    isDisabled: isDisabled,
    "data-pka-anchor": "clear-button",
    kind: _button["default"].types.kind.MINOR,
    onClick: handleClickClear,
    shouldHideCaret: shouldHideCaret,
    size: size
  }, clearIcon || /*#__PURE__*/_react["default"].createElement(_StyledTimesCircleIcon, {
    isDisabled: isDisabled,
    _css3: sc.iconStyles
  })) : null, shouldHideCaret ? null : caret);
}

Trigger.propTypes = propTypes;
Trigger.defaultProps = defaultProps;
Trigger.displayName = "ListBox.Trigger";
//# sourceMappingURL=Trigger.js.map

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Close["default"];
  }
});

var _Close = _interopRequireDefault(__webpack_require__(1192));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Times = _interopRequireDefault(__webpack_require__(362));

var constants = _interopRequireWildcard(__webpack_require__(40));

var types = _interopRequireWildcard(__webpack_require__(566));

var sc = _interopRequireWildcard(__webpack_require__(1193));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If the close button will be rendered on a dark background and will use inverted colours. */
  isDark: _propTypes["default"].bool
};
var defaultProps = {
  a11yText: null,
  isDark: false
};

var Close = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    a11yText: props.a11yText || "close",
    // TODO: use L10n
    isDark: props.isDark,
    kind: types.MINOR
  };
  return /*#__PURE__*/_react["default"].createElement(sc.CloseButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_Times["default"], null));
});

Close.types = {
  kind: constants.kind
};
Close.displayName = "Button.Close";
Close.propTypes = propTypes;
Close.defaultProps = defaultProps;
var _default = Close;
exports["default"] = _default;
//# sourceMappingURL=Close.js.map

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CloseButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Icon = _interopRequireDefault(__webpack_require__(738));

var darkStyles = (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;&:hover{background-color:", ";[data-pka-anchor=\"button.icon\"]{color:", ";}}&:active{background-color:", ";transition:none;[data-pka-anchor=\"button.icon\"]{color:", ";transition:none;}}[data-pka-anchor=\"button.icon\"]{color:", ";transition:color 0.2s ease-out;}"], _stylers["default"].alpha(_tokens["default"].color.white, 0.2), _tokens["default"].color.white, _stylers["default"].alpha(_tokens["default"].color.white, 0.3), _tokens["default"].color.white, _tokens["default"].color.blackLighten50);
var CloseButton = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "CloseButtonstyles__CloseButton",
  componentId: "sc-17tyw7-0"
})(function (_ref) {
  var isDark = _ref.isDark;
  return (0, _styledComponents.css)(["[data-pka-anchor=\"button.icon\"]{color:", ";}", ""], _tokens["default"].textColor.icon, isDark ? darkStyles : "");
});
exports.CloseButton = CloseButton;
//# sourceMappingURL=CloseButton.styles.js.map

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var constants = _interopRequireWildcard(__webpack_require__(40));

var sc = _interopRequireWildcard(__webpack_require__(1195));

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    children: null,
    icon: props.children,
    isFullWidth: false
  };
  return /*#__PURE__*/_react["default"].createElement(sc.IconButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }));
});

Icon.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var IconPropTypes = {
  /** Body content of the button (an icon). */
  children: _propTypes["default"].node.isRequired,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Icon.types.kind.DEFAULT, Icon.types.kind.PRIMARY, Icon.types.kind.SECONDARY, Icon.types.kind.DESTRUCTIVE, Icon.types.kind.FLAT, Icon.types.kind.MINOR, Icon.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Icon.types.size.SMALL, Icon.types.size.MEDIUM, Icon.types.size.LARGE])
};
var IconDefaultProps = {
  kind: Icon.types.kind.DEFAULT,
  size: Icon.types.size.MEDIUM
};
Icon.displayName = "Button.Icon";
Icon.propTypes = IconPropTypes;
Icon.defaultProps = IconDefaultProps;
var _default = Icon;
exports["default"] = _default;
//# sourceMappingURL=Icon.js.map

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.IconButton = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Button = _interopRequireDefault(__webpack_require__(565));

var types = _interopRequireWildcard(__webpack_require__(566));

var _iconButtonSizes;

var iconButtonSizes = (_iconButtonSizes = {}, (0, _defineProperty2["default"])(_iconButtonSizes, types.SMALL, (0, _styledComponents.css)(["font-size:14px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(3), (0, _parseInt["default"])(_tokens["default"].space, 10) * 3 - 2, _stylers["default"].spacer(3))), (0, _defineProperty2["default"])(_iconButtonSizes, types.MEDIUM, (0, _styledComponents.css)(["font-size:18px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(4), (0, _parseInt["default"])(_tokens["default"].space, 10) * 4 - 2, _stylers["default"].spacer(4))), (0, _defineProperty2["default"])(_iconButtonSizes, types.LARGE, (0, _styledComponents.css)(["font-size:22px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(5), (0, _parseInt["default"])(_tokens["default"].space, 10) * 5 - 2, _stylers["default"].spacer(5))), _iconButtonSizes);

var minorStyles = function minorStyles(_ref) {
  var isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;", ""], isDisabled ? (0, _styledComponents.css)(["&,&:hover,&:active{[data-pka-anchor=\"button.icon\"] svg{color:", ";}}"], _tokens["default"].color.blackDisabled) : (0, _styledComponents.css)(["&:hover{background-color:", ";}&:active{background-color:", ";}"], _stylers["default"].alpha(_tokens["default"].color.black, 0.1), _stylers["default"].alpha(_tokens["default"].color.black, 0.2)));
};

var IconButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "IconButtonstyles__IconButton",
  componentId: "sc-1rmwp4p-0"
})(function (_ref2) {
  var size = _ref2.size,
      kind = _ref2.kind;
  return (0, _styledComponents.css)(["", " ", " [data-pka-anchor=\"button.icon\"]{color:inherit;margin:0;}"], iconButtonSizes[size], kind === types.MINOR ? minorStyles : "");
});
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.styles.js.map

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Link["default"];
  }
});

var _Link = _interopRequireDefault(__webpack_require__(1197));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _NewTab = _interopRequireDefault(__webpack_require__(363));

var constants = _interopRequireWildcard(__webpack_require__(40));

var types = _interopRequireWildcard(__webpack_require__(566));

var sc = _interopRequireWildcard(__webpack_require__(1198));

var _Button = __webpack_require__(565);

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      children = props.children,
      href = props.href,
      isDisabled = props.isDisabled,
      shouldOpenNewTab = props.shouldOpenNewTab,
      kind = props.kind,
      icon = props.icon,
      size = props.size,
      suffixIcon = props.suffixIcon,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "href", "isDisabled", "shouldOpenNewTab", "kind", "icon", "size", "suffixIcon"]);
  var shouldOpenNewTabProps = {
    target: "_blank",
    rel: "noopener noreferrer"
  };

  function renderSuffix(_ref) {
    var kind = _ref.kind,
        isDisabled = _ref.isDisabled,
        suffixIcon = _ref.suffixIcon,
        shouldOpenNewTab = _ref.shouldOpenNewTab;

    if (kind === types.LINK && shouldOpenNewTab && suffixIcon) {
      return /*#__PURE__*/_react["default"].createElement(sc.LinkButtonIcon, {
        isDisabled: isDisabled,
        kind: types.LINK,
        isSuffixIcon: true
      }, suffixIcon);
    }

    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(sc.LinkButton, (0, _extends2["default"])({
    "aria-disabled": isDisabled,
    "aria-label": a11yText,
    href: !isDisabled ? href : null,
    isDisabled: isDisabled,
    kind: kind,
    size: size
  }, shouldOpenNewTab ? shouldOpenNewTabProps : {}, moreProps, {
    as: isDisabled ? "span" : "a",
    ref: ref
  }), icon ? /*#__PURE__*/_react["default"].createElement(_Button.ButtonIcon, {
    isDisabled: isDisabled
  }, icon) : null, children, renderSuffix(props));
});

Link.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** Url for the link. */
  href: _propTypes["default"].string.isRequired,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Link.types.kind.DEFAULT, Link.types.kind.PRIMARY, Link.types.kind.SECONDARY, Link.types.kind.DESTRUCTIVE, Link.types.kind.FLAT, Link.types.kind.MINOR, Link.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Link.types.size.SMALL, Link.types.size.MEDIUM, Link.types.size.LARGE]),

  /** Whether the link should open a new tab. */
  shouldOpenNewTab: _propTypes["default"].bool,

  /** Size of the button (font size, min-height, padding, etc). */
  suffixIcon: _propTypes["default"].node
};
var defaultProps = {
  a11yText: null,
  icon: null,
  isDisabled: false,
  kind: Link.types.kind.LINK,
  shouldOpenNewTab: false,
  size: Link.types.size.MEDIUM,
  suffixIcon: /*#__PURE__*/_react["default"].createElement(_NewTab["default"], null)
};
Link.displayName = "Button.Link";
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;
var _default = Link;
exports["default"] = _default;
//# sourceMappingURL=Link.js.map

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LinkButtonIcon = exports.LinkButton = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Button = __webpack_require__(737);

var _Button2 = __webpack_require__(565);

var LinkButton = _styledComponents["default"].a.withConfig({
  displayName: "LinkButtonstyles__LinkButton",
  componentId: "fsc7ri-0"
})(function (_ref) {
  var size = _ref.size,
      kind = _ref.kind,
      isFullWidth = _ref.isFullWidth,
      isActive = _ref.isActive,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "kind", "isFullWidth", "isActive"]);
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], _Button.commonStyles, _Button.sizeStyles[size], (0, _Button.kindStyles)(props)[kind], isFullWidth && _Button.fullWidthStyles, isActive ? _Button.activeStyles : _Button.inactiveStyles);
});

exports.LinkButton = LinkButton;
var LinkButtonIcon = (0, _styledComponents["default"])(_Button2.ButtonIcon).withConfig({
  displayName: "LinkButtonstyles__LinkButtonIcon",
  componentId: "fsc7ri-1"
})(["", " color:", ";margin-top:-", ";"], _stylers["default"].fontSize(-3), _tokens["default"].textColor.icon, _tokens["default"].spaceSm);
exports.LinkButtonIcon = LinkButtonIcon;
//# sourceMappingURL=LinkButton.styles.js.map

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Label["default"];
  }
});

var _Label = _interopRequireDefault(__webpack_require__(1200));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Label;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var sc = _interopRequireWildcard(__webpack_require__(739));

var _LabelMulti = _interopRequireDefault(__webpack_require__(1201));

var _LabelSingle = _interopRequireDefault(__webpack_require__(1202));

var propTypes = {
  hasImplicitAll: _propTypes["default"].bool,

  /** Override the label with a custom one. */
  label: _propTypes["default"].string,

  /** Sets a placeholder for the label. */
  placeholder: _propTypes["default"].string
};
var defaultProps = {
  label: null,
  hasImplicitAll: false,
  placeholder: ""
};

function Label(props) {
  var hasImplicitAll = props.hasImplicitAll,
      placeholder = props.placeholder,
      customLabel = props.label;

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 1),
      state = _useListBox2[0];

  var selectedOptions = state.selectedOptions,
      isMulti = state.isMulti,
      options = state.options;

  var _React$useState = _react["default"].useState(placeholder),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      label = _React$useState2[0],
      setLabel = _React$useState2[1];

  _react["default"].useEffect(function () {
    if (selectedOptions.length) {
      var _label = isMulti ? /*#__PURE__*/_react["default"].createElement(_LabelMulti["default"], {
        options: options,
        selectedOptions: selectedOptions
      }) : /*#__PURE__*/_react["default"].createElement(_LabelSingle["default"], {
        options: options,
        selectedOptions: selectedOptions
      });

      setLabel(_label);
      return;
    }

    setLabel(placeholder);
  }, [isMulti, options, placeholder, selectedOptions]);

  return /*#__PURE__*/_react["default"].createElement(sc.Label, {
    hasImplicitAll: hasImplicitAll,
    isPlaceholder: !selectedOptions.length
  }, customLabel || label);
}

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;
//# sourceMappingURL=Label.js.map

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = LabelMulti;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Label = __webpack_require__(739);

var propTypes = {
  selectedOptions: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  // complex object not worth declaring the shape of the strcuture
  options: _propTypes["default"].object.isRequired // eslint-disable-line

};

function getFormattedLabel(selectedOptions, options) {
  return selectedOptions.map(function (index) {
    var option = options[index];
    if (!option) return null;

    if (typeof option.content === "string") {
      return option.content;
    }

    if (option.label) {
      return option.label;
    }

    throw new Error("The trigger label on the ListBox needs that either <ListBox.Option> children are typeof string\n      or a label prop is add to the <ListBox.Option label='my description'> component");
  }).filter(function (label) {
    return label !== null;
  }).join(", ");
}

var _StyledSpan = (0, _styledComponents["default"])("span").withConfig({
  displayName: "LabelMulti___StyledSpan",
  componentId: "sc-1jpuj4v-0"
})(["", ""], _Label.labelStyles);

var _StyledSpan2 = (0, _styledComponents["default"])("span").withConfig({
  displayName: "LabelMulti___StyledSpan2",
  componentId: "sc-1jpuj4v-1"
})(["", ""], _Label.labelStyles);

function LabelMulti(props) {
  var optionsLength = props.selectedOptions.length;
  var label = getFormattedLabel(props.selectedOptions, props.options);

  if (optionsLength > 1) {
    return /*#__PURE__*/_react["default"].createElement(_StyledSpan, null, /*#__PURE__*/_react["default"].createElement("span", null, "(", optionsLength, ")\xA0"), label);
  }

  return /*#__PURE__*/_react["default"].createElement(_StyledSpan2, null, label);
}

LabelMulti.propTypes = propTypes;
//# sourceMappingURL=LabelMulti.js.map

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = LabelSingle;
var propTypes = {};
var defaultProps = {};

function LabelSingle(props) {
  var selectedOptions = props.selectedOptions,
      options = props.options;
  var option = options[selectedOptions[0]];

  if (option.label) {
    return option.label;
  }

  if (typeof options.content === "string") {
    return option.content;
  }

  console.log("Warning: Your Option required a label prop, <ListBox.Option label='your label' /><MyCoolContent /></ListBox.Option>");
  return option.content;
}

LabelSingle.propTypes = propTypes;
LabelSingle.defaultProps = defaultProps;
//# sourceMappingURL=LabelSingle.js.map

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.VisuallyHiddenFormLabel = exports.ClearButton = exports.iconStyles = exports.ListBoxTrigger = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _button = _interopRequireDefault(__webpack_require__(643));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _includes = __webpack_require__(288);

var _tokens = _interopRequireDefault(__webpack_require__(27));

var types = _interopRequireWildcard(__webpack_require__(740));

var _triggerSizes;

var triggerStyles = "\n  ".concat(_stylers["default"].truncateText, "\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 3px;\n  border: 1px solid #d7d7d7;\n  box-sizing: border-box;\n  color: #3f3d3c;\n  display: block;\n  padding: 0 50px 0 ").concat(_tokens["default"].space, ";\n  position: relative;\n  text-align: left;\n  transition: border-color 0.2s;\n  width: 100%;\n\n  /* RawButton span */\n  & > span{\n    width: calc(100% - 48px);\n  }\n");
var triggerSizes = (_triggerSizes = {}, (0, _defineProperty2["default"])(_triggerSizes, types.SMALL, "\n    ".concat(_stylers["default"].fontSize(-2), "\n    height: ").concat(_stylers["default"].spacer(3), ";\n    line-height: ").concat(_stylers["default"].spacer(3), ";\n  ")), (0, _defineProperty2["default"])(_triggerSizes, types.MEDIUM, "\n    ".concat(_stylers["default"].fontSize(-1), "\n    height: ").concat(_stylers["default"].spacer(4), ";\n    line-height: ").concat(_stylers["default"].spacer(4), ";\n  ")), (0, _defineProperty2["default"])(_triggerSizes, types.LARGE, "\n    ".concat(_stylers["default"].fontSize(), "\n    height: ").concat(_stylers["default"].spacer(5), ";\n    line-height: ").concat(_stylers["default"].spacer(5), ";\n  ")), _triggerSizes);

var triggerStylesProps = function triggerStylesProps() {
  return function (_ref) {
    var isHidden = _ref.isHidden,
        isDisabled = _ref.isDisabled,
        isInline = _ref.isInline,
        size = _ref.size;

    if (isHidden) {
      return (0, _styledComponents.css)(["border:1px solid #d7d7d7;"]);
    }

    return isInline ? "\n      ".concat(triggerStyles, "\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      ").concat(triggerSizes[size], ";\n      ").concat(isDisabled ? "color: ".concat(_tokens["default"].color.blackLighten60, ";") : "", "\n    ") : "\n      & > [data-pka-anchor='list-box-trigger'] {\n        ".concat(triggerStyles, ";\n        ").concat(triggerSizes[size], ";\n        ").concat(isDisabled ? "color: ".concat(_tokens["default"].color.blackLighten60, ";") : "", ";\n      }\n    ");
  };
};

var ListBoxTrigger = _styledComponents["default"].div.withConfig({
  displayName: "Triggerstyles__ListBoxTrigger",
  componentId: "sc-1x0n9kt-0"
})(["position:relative;", ""], triggerStylesProps());

exports.ListBoxTrigger = ListBoxTrigger;

var iconStyles = function iconStyles(_ref2) {
  var isDisabled = _ref2.isDisabled;
  return (0, _styledComponents.css)(["height:100%;pointer-events:none;position:absolute;right:", ";top:0;", " ", ""], _tokens["default"].space, _stylers["default"].fontSize(-1), isDisabled && "color: ".concat(_tokens["default"].color.blackLighten60, ";"));
};

exports.iconStyles = iconStyles;
var ClearButton = (0, _styledComponents["default"])(_button["default"].Icon).withConfig({
  displayName: "Triggerstyles__ClearButton",
  componentId: "sc-1x0n9kt-1"
})(function (_ref3) {
  var shouldHideCaret = _ref3.shouldHideCaret;
  return (0, _styledComponents.css)(["height:100%;margin-right:2px;position:absolute;right:", ";top:0;> span{height:14px;line-height:14px;> svg{color:", ";vertical-align:text-top;", "}}&:hover{background-color:transparent;}"], shouldHideCaret ? 0 : "22px", _tokens["default"].color.blackLighten20, iconStyles);
});
exports.ClearButton = ClearButton;

var VisuallyHiddenFormLabel = _styledComponents["default"].span.withConfig({
  displayName: "Triggerstyles__VisuallyHiddenFormLabel",
  componentId: "sc-1x0n9kt-2"
})(["", ";"], _includes.visuallyHidden);

exports.VisuallyHiddenFormLabel = VisuallyHiddenFormLabel;
//# sourceMappingURL=Trigger.styles.js.map

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _imperative["default"];
  }
});

var _imperative = _interopRequireDefault(__webpack_require__(1205));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _useListBox = _interopRequireDefault(__webpack_require__(140));

var _invokeOnChange = _interopRequireDefault(__webpack_require__(562));

var handleImperative = function handleImperative(_ref) {
  var state = _ref.state,
      dispatch = _ref.dispatch,
      onChangeContext = _ref.onChangeContext;
  return function () {
    return {
      clear: function clear() {
        var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        dispatch({
          type: _useListBox["default"].types.clear,
          payload: {
            isOpen: isOpen,
            onChangeFn: (0, _invokeOnChange["default"])(onChangeContext, "list-box:imperative:clear")
          }
        });
      },
      reset: function reset() {
        dispatch({
          type: _useListBox["default"].types.reset,
          payload: {
            onChangeFn: (0, _invokeOnChange["default"])(onChangeContext, "list-box:imperative:reset")
          }
        });
      },
      focus: function focus() {
        state.refTrigger.current.focus();
      },
      selected: state.isMulti ? state.selectedOptions : state.selectedOptions[0],
      options: state.options,
      close: function close() {
        dispatch({
          type: _useListBox["default"].types.closePopover
        });
      }
    };
  };
};

var _default = handleImperative;
exports["default"] = _default;
//# sourceMappingURL=imperative.js.map

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(138);

// https://github.com/idmadj/element-scroll-polyfill/blob/master/index.js

/* eslint-disable */
(function () {
  var normalizeNonFiniteValue = function normalizeNonFiniteValue(value) {
    value = +value;
    return isNaN(value) || value == Infinity || value == -Infinity ? 0 : value;
  };

  var isBodyPotentiallyScrollable = function isBodyPotentiallyScrollable(body) {
    body = body || document.getElementsByTagName("BODY")[0];
    var bodyComputedStyle = window.getComputedStyle(body);
    var parentComputedStyle = window.getComputedStyle(body.parent);
    var bodyComputedOverflowX = bodyComputedStyle.overflowX;
    var bodyComputedOverflowY = bodyComputedStyle.overflowY;
    var parentComputedOverflowX = parentComputedStyle.overflowX;
    var parentComputedOverflowY = parentComputedStyle.overflowY;
    return (bodyComputedStyle.display == "table-column" || bodyComputedStyle.display == "table-column-group") && parentComputedOverflowX != "visible" && parentComputedOverflowX != "clip" && parentComputedOverflowY != "visible" && parentComputedOverflowY != "clip" && bodyComputedOverflowX != "visible" && bodyComputedOverflowX != "clip" && bodyComputedOverflowY != "visible" && bodyComputedOverflowY != "clip";
  };

  if (!Element.prototype.scroll) {
    Element.prototype.scroll = function () {
      var argsLength = arguments.length;
      var doc = this.ownerDocument;
      var win = doc.defaultView;
      var quirksMode = doc.compatMode == "BackCompat";
      var body = document.getElementsByTagName("BODY")[0];
      var options = {};
      var x;
      var y;
      if (doc != window.document) return;
      if (!win) return;

      if (argsLength === 0) {
        return;
      }

      if (argsLength === 1) {
        var arg = arguments[0];
        if (_typeof(arg) !== "object") throw "Failed to execute 'scrollBy' on 'Element': parameter 1 ('options') is not an object.";

        if ("left" in arg) {
          options.left = normalizeNonFiniteValue(arg.left);
        }

        if ("top" in arg) {
          options.top = normalizeNonFiniteValue(arg.top);
        }

        x = "left" in options ? options.left : this.scrollLeft;
        y = "top" in options ? options.top : this.scrollTop;
      } else {
        options.left = x = normalizeNonFiniteValue(arguments[0]);
        options.top = y = normalizeNonFiniteValue(arguments[1]);
      }

      if (this == document.documentElement) {
        if (quirksMode) return;
        win.scroll("scrollX" in win ? win.scrollX : "pageXOffset" in win ? win.pageXOffset : this.scrollLeft, y);
        return;
      }

      if (this == body && quirksMode && !isBodyPotentiallyScrollable(body)) {
        win.scroll(options.left, options.top);
        return;
      }

      this.scrollLeft = x;
      this.scrollTop = y;
    };
  }

  if (!Element.prototype.scrollTo) {
    Element.prototype.scrollTo = Element.prototype.scroll;
  }
})();
//# sourceMappingURL=elementScrollToPolyfill.js.map

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$keys = __webpack_require__(13);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _hooks = __webpack_require__(1208);

_Object$keys(_hooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hooks[key];
    }
  });
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useChildrenChange = useChildrenChange;
exports.useIsPopOverOpen = useIsPopOverOpen;
exports.useAdjustWidth = useAdjustWidth;
exports.useOnScrolled = useOnScrolled;
exports.useIsDisabled = useIsDisabled;
exports.useOptionSelected = useOptionSelected;
exports.useHasFooter = useHasFooter;

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _values = _interopRequireDefault(__webpack_require__(96));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _lodash = _interopRequireDefault(__webpack_require__(192));

var _useListBox15 = _interopRequireDefault(__webpack_require__(140));

var _optionState = __webpack_require__(732);

// we should export a hook from the popover so we get notify when the popover state for isOpen change meanwhile:
function waitForPopoverAnimation(func) {
  setTimeout(func, 300);
}

function useChildrenChange(children) {
  var _useListBox = (0, _useListBox15["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  _react["default"].useEffect(function () {
    var options = (0, _optionState.getDataOptions)(children);

    if ((0, _keys["default"])(state.options).length === (0, _keys["default"])(options).length) {
      var difference = (0, _values["default"])(state.options).find(function (prevOption, key) {
        return !(0, _lodash["default"])(prevOption.value, options[key].value) || prevOption.isDisabled !== options[key].isDisabled || prevOption.isSelected !== options[key].isSelected;
      });
      if (!difference) return;
    }

    dispatch({
      type: _useListBox15["default"].types.updateOptions,
      payload: options
    });
  }, [children, dispatch, state.hasFooter, state.options]);
}

function useIsPopOverOpen(shouldKeepTriggerFocus) {
  var _useListBox3 = (0, _useListBox15["default"])(),
      _useListBox4 = (0, _slicedToArray2["default"])(_useListBox3, 2),
      state = _useListBox4[0],
      dispatch = _useListBox4[1];

  _react["default"].useLayoutEffect(function () {
    if (state.isInline) return;
    if (!state.refListBoxContainer.current) return;
    var filterInput = state.refFilterInput.current;
    var listBoxContainer = state.refListBoxContainer.current;
    var trigger = state.refTrigger.current;

    if (state.isOpen) {
      if (state.hasFilter && !shouldKeepTriggerFocus) {
        waitForPopoverAnimation(function () {
          return filterInput.focus();
        });
        return;
      }

      dispatch({
        type: _useListBox15["default"].types.setTriggerWidth,
        payload: state.refTriggerContainer.current.offsetWidth
      });
      dispatch({
        type: _useListBox15["default"].types.setHasPopupOpened,
        payload: true
      });

      if (!shouldKeepTriggerFocus) {
        waitForPopoverAnimation(function () {
          return listBoxContainer.focus();
        });
      }

      return;
    }

    if (state.hasPopupOpened) {
      listBoxContainer.focus();

      if (state.isInline === false && state.isOpen === false) {
        trigger.focus();
      }
    }
  }, [dispatch, shouldKeepTriggerFocus, state.hasFilter, state.hasPopupOpened, state.isInline, state.isOpen, state.refFilterInput, state.refListBoxContainer, state.refTrigger, state.refTriggerContainer]);
}

function useAdjustWidth() {
  var _useListBox5 = (0, _useListBox15["default"])(),
      _useListBox6 = (0, _slicedToArray2["default"])(_useListBox5, 2),
      state = _useListBox6[0],
      dispatch = _useListBox6[1];

  _react["default"].useLayoutEffect(function () {
    var $triggerContainer = state.refTriggerContainer.current;

    if ($triggerContainer) {
      dispatch({
        type: _useListBox15["default"].types.setTriggerWidth,
        payload: $triggerContainer.offsetWidth
      });
    }

    var handleResize = function handleResize() {
      if ($triggerContainer) {
        dispatch({
          type: _useListBox15["default"].types.setTriggerWidth,
          payload: $triggerContainer.offsetWidth
        });
      }
    };

    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch, state.refTriggerContainer]);
}

function useOnScrolled() {
  var _useListBox7 = (0, _useListBox15["default"])(),
      _useListBox8 = (0, _slicedToArray2["default"])(_useListBox7, 1),
      state = _useListBox8[0];

  _react["default"].useLayoutEffect(function () {
    if (!state.refListBox.current || state.activeOption === null) return;
    var $box = state.refListBox.current;
    var $option = state.options[state.activeOption] ? document.getElementById(state.options[state.activeOption].id) : null;

    if ($box && $option) {
      var rectBox = $box.getBoundingClientRect();
      var rectOption = $option.getBoundingClientRect(); // if options its between the box don't do anything

      if (rectOption.top >= rectBox.top && rectOption.bottom <= rectBox.bottom) {
        return;
      }

      var _getComputedStyle = getComputedStyle($option),
          marginBottom = _getComputedStyle.marginBottom,
          marginTop = _getComputedStyle.marginTop;

      var margin = (0, _parseInt["default"])(marginBottom.split("px")[0], 10) + (0, _parseInt["default"])(marginTop.split("px")[0], 10);
      var gap = rectOption.bottom - rectBox.bottom;
      var isScrollingDown = Math.sign(gap) > 0;
      var optionHeightWithMargin = rectOption.height + margin;
      var gapWithMargin = gap + margin;

      if (isScrollingDown) {
        // this means that the option is partially visible but not completely
        if (gap < rectOption.height) {
          $box.scrollTo(0, $box.scrollTop + gapWithMargin);
          return;
        }

        $box.scrollTo(0, $box.scrollTop + optionHeightWithMargin);
        return;
      }

      gap = rectBox.top - rectOption.top;
      gapWithMargin = gap + margin; // this means that the option is partially visible but not completely

      if (gap < rectOption.height) {
        $box.scrollTo(0, $box.scrollTop - gapWithMargin);
        return;
      }

      $box.scrollTo(0, $box.scrollTop - optionHeightWithMargin);
    }
  }, [state.activeOption, state.options, state.refListBox]);
}

function useIsDisabled(isDisabled) {
  var _useListBox9 = (0, _useListBox15["default"])(),
      _useListBox10 = (0, _slicedToArray2["default"])(_useListBox9, 2),
      dispatch = _useListBox10[1];

  _react["default"].useEffect(function () {
    dispatch({
      type: _useListBox15["default"].types.setIsDisabled,
      payload: isDisabled
    });
  }, [dispatch, isDisabled]);
}

function useOptionSelected() {
  var _useListBox11 = (0, _useListBox15["default"])(),
      _useListBox12 = (0, _slicedToArray2["default"])(_useListBox11, 2),
      state = _useListBox12[0],
      dispatch = _useListBox12[1];

  _react["default"].useEffect(function () {
    if (state.onChangeFn) {
      state.onChangeFn(state, dispatch);
    }
  }, [dispatch, state, state.selectedOptions]);
}

function useHasFooter(footer) {
  var _useListBox13 = (0, _useListBox15["default"])(),
      _useListBox14 = (0, _slicedToArray2["default"])(_useListBox13, 2),
      dispatch = _useListBox14[1];

  _react["default"].useEffect(function () {
    if (footer) {
      dispatch({
        type: _useListBox15["default"].types.setHasFooter,
        payload: true
      });
    }
  }, [dispatch, footer]);
}
//# sourceMappingURL=hooks.js.map

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = extractChildren;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(182));

var _isArray = _interopRequireDefault(__webpack_require__(95));

var _react = _interopRequireDefault(__webpack_require__(2));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function extractChildren(children, types) {
  var _children = [];
  var components = {};

  if ((0, _isArray["default"])(types)) {
    _react["default"].Children.toArray(children).forEach(function (child) {
      if (child.type && types.includes(child.type.displayName)) {
        if (Object.prototype.hasOwnProperty.call(components, child.type.displayName)) {
          var childs = (0, _isArray["default"])(components[child.type.displayName]) ? [child].concat((0, _toConsumableArray2["default"])(components[child.type.displayName])) : [child, components[child.type.displayName]];
          components[child.type.displayName] = childs;
        } else {
          components[child.type.displayName] = child;
        }
      } else {
        _children.push(child);
      }
    });

    return _objectSpread(_objectSpread({}, components), {}, {
      children: _children
    });
  }

  throw new Error("extractChildren types parameter must be an Array");
}
//# sourceMappingURL=extractChildren.js.map

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Divider["default"];
  }
});

var _Divider = _interopRequireDefault(__webpack_require__(1211));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Divider;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var sc = _interopRequireWildcard(__webpack_require__(1212));

var propTypes = {
  /**  isDisable is use internally as a default prop
  the prop is read by the option/helpers/optionState.js which is assigned in the store
  it helps to ignore the divider while using the keyboard.
  see: options/helpers/options.js */
  isDisabled: _propTypes["default"].bool,
  // eslint-disable-line
  children: _propTypes["default"].node
};
var defaultProps = {
  /** Disables the divider if true */
  isDisabled: true,

  /** Body content of the divider. */
  children: null
};

function Divider(props) {
  return /*#__PURE__*/_react["default"].createElement(sc.Divider, {
    "aria-hidden": "true",
    "data-pka-anchor": "list-box.divider"
  }, props.children);
}

Divider.propTypes = propTypes;
Divider.defaultProps = defaultProps;
Divider.displayName = "ListBox.Divider";
//# sourceMappingURL=Divider.js.map

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Divider = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var pseudoElement = (0, _styledComponents.css)(["background:", ";content:\"\";display:inline-block;flex-grow:1;height:1px;"], _tokens["default"].color.blackLighten60);
var textDividerStyles = (0, _styledComponents.css)(["&:after{", " margin-left:", ";}"], pseudoElement, _tokens["default"].space);

var Divider = _styledComponents["default"].li.withConfig({
  displayName: "Dividerstyles__Divider",
  componentId: "pwhnzq-0"
})(["align-items:center;color:", ";display:flex;justify-content:center;padding:", ";width:100%;", ";", ""], _tokens["default"].color.blackLighten20, _tokens["default"].spaceSm, _stylers["default"].fontSize(-1), textDividerStyles);

exports.Divider = Divider;
//# sourceMappingURL=Divider.styles.js.map

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = BoxShell;

var _react = _interopRequireDefault(__webpack_require__(2));

function BoxShell() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
}

BoxShell.displayName = "ListBox.Box";
//# sourceMappingURL=BoxShell.js.map

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Filter["default"];
  }
});

var _Filter = _interopRequireDefault(__webpack_require__(1215));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useI18n = _interopRequireDefault(__webpack_require__(729));

var _Search = _interopRequireDefault(__webpack_require__(645));

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var _helpers = __webpack_require__(1216);

var sc = _interopRequireWildcard(__webpack_require__(1217));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Filters the list */
  filter: _propTypes["default"].func,

  /** If true displays a search icon */
  hasSearchIcon: _propTypes["default"].bool,

  /** Message displayed if no results are found */
  noResultsMessage: _propTypes["default"].string,

  /** Callback to be executed when the value is changed  */
  onChangeFilter: _propTypes["default"].func,

  /** Callback to be executed when a key is pressed */
  onKeyDown: _propTypes["default"].func,

  /** Displays a placeholder */
  placeholder: _propTypes["default"].string,

  /** Render function for filter */
  renderFilter: _propTypes["default"].func,

  /** Sets a value for filter */
  value: _propTypes["default"].string
};
var defaultProps = {
  a11yText: null,
  filter: null,
  hasSearchIcon: true,
  onChangeFilter: null,
  onKeyDown: null,
  placeholder: null,
  noResultsMessage: null,
  renderFilter: null,
  value: null
};

function hasNoResults(textSearchValue, filteredOptions) {
  return textSearchValue && filteredOptions && filteredOptions.length === 0;
}

var Filter = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  var _React$useState = _react["default"].useState(props.value),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      textSearch = _React$useState2[0],
      setTextSearch = _React$useState2[1];

  var applyFilterType = _useListBox3["default"].types.applyFilter;
  var I18n = (0, _useI18n["default"])();

  var _reset = _react["default"].useCallback(function () {
    window.requestAnimationFrame(function () {
      (0, _helpers.applyFilter)(dispatch, applyFilterType)([], false);
      setTextSearch("");
    });
  }, [applyFilterType, dispatch]);

  _react["default"].useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        setTextSearch(function () {
          return "";
        });
      },
      reset: function reset() {
        _reset();
      }
    };
  });

  var handleChangeFilter = function handleChangeFilter(event) {
    var textSearchValue = event.target.value;
    if (state.isDisabled) return;

    if (props.filter) {
      setTextSearch(textSearchValue);
      var result = props.filter({
        search: textSearchValue
      });

      if (result && result.then) {
        // detecting if it's a promise
        result.then(function (response) {
          var filteredOptions = response;
          var noResultsFound = hasNoResults(textSearchValue, filteredOptions);
          (0, _helpers.applyFilter)(dispatch, applyFilterType)(filteredOptions, noResultsFound);
        });
      }

      return;
    }

    if (props.onChangeFilter) {
      props.onChangeFilter(event);
    } else {
      setTextSearch(textSearchValue);
    }

    var filteredOptions = (0, _helpers.filter)({
      props: props,
      state: state,
      textSearchValue: textSearchValue
    });
    var noResultsFound = hasNoResults(textSearchValue, filteredOptions);
    (0, _helpers.applyFilter)(dispatch, applyFilterType)(filteredOptions, noResultsFound);
  };

  var handleBlur = function handleBlur() {
    window.requestAnimationFrame(function () {
      if (state.hasFooter) {
        // if has footer the responsible of closing is the Footer no the onblur event
        return;
      }

      if (document.activeElement !== state.refListBoxContainer.current) {
        // this will reset the activeOption and close the Popover
        dispatch({
          type: _useListBox3["default"].types.setActiveOption,
          payload: {
            activeOptionIndex: null
          }
        });
      }
    });
  };

  _react["default"].useEffect(function () {
    if (!state.isOpen) {
      _reset();
    }
  }, [_reset, state.isOpen]);

  _react["default"].useEffect(function () {
    dispatch({
      type: _useListBox3["default"].types.hasFilter,
      payload: true
    });
  }, [dispatch]);

  if (state.isInline || state.isOpen) {
    var renderFilter = props.renderFilter,
        placeholder = props.placeholder,
        value = props.value,
        onChangeFilter = props.onChangeFilter,
        _filter = props.filter,
        hasSearchIcon = props.hasSearchIcon,
        noResultsMessage = props.noResultsMessage,
        moreProps = (0, _objectWithoutProperties2["default"])(props, ["renderFilter", "placeholder", "value", "onChangeFilter", "filter", "hasSearchIcon", "noResultsMessage"]);

    if (renderFilter) {
      return props.renderFilter(props);
    }

    return /*#__PURE__*/_react["default"].createElement(sc.Filter, {
      "data-pka-anchor": "list-filter"
    }, /*#__PURE__*/_react["default"].createElement(sc.FilterInput, (0, _extends2["default"])({
      a11yText: props.a11yText || I18n.t("listBox.filter.a11y_text"),
      "data-pka-anchor": "list-filter-input",
      icon: hasSearchIcon ? /*#__PURE__*/_react["default"].createElement(_Search["default"], null) : null,
      isDisabled: state.isDisabled,
      onBlur: handleBlur,
      onChange: handleChangeFilter,
      onKeyDown: props.onKeyDown,
      placeholder: placeholder || I18n.t("listBox.filter.placeholder"),
      ref: state.refFilterInput,
      value: value || textSearch || "",
      size: state.size
    }, moreProps)));
  }

  return null;
});

var _default = Filter;
exports["default"] = _default;
Filter.propTypes = propTypes;
Filter.defaultProps = defaultProps;
Filter.displayName = "ListBox.Filter";
//# sourceMappingURL=Filter.js.map

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.applyFilter = exports.filter = void 0;

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _keys = _interopRequireDefault(__webpack_require__(13));

// this might be better using _.escapeRegExp by lodash. But good enough for now
function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

var filter = function filter(_ref) {
  var state = _ref.state,
      textSearchValue = _ref.textSearchValue;
  var options = state.options;
  var keys = (0, _keys["default"])(options);

  if (keys.length) {
    var filteredOptions = keys.filter(function (key) {
      var hasLabel = typeof options[key].content === "string" || options[key].label || null;

      if (hasLabel) {
        var label = options[key].content === "string" || options[key].label;
        var filterRegExp = new RegExp(escapeRegExp(textSearchValue), "gi");
        return label.match(filterRegExp);
      }

      return false;
    });

    if (!filteredOptions.length) {
      return [];
    }

    return filteredOptions.map(function (key) {
      return (0, _parseInt["default"])(key, 10);
    });
  }

  return [];
};

exports.filter = filter;

var applyFilter = function applyFilter(dispatch, type) {
  return function (filteredOptions, noResultsFound) {
    dispatch({
      type: type,
      payload: {
        filteredOptions: filteredOptions,
        noResultsFound: noResultsFound
      }
    });
  };
};

exports.applyFilter = applyFilter;
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.FilterInput = exports.Filter = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _input = _interopRequireDefault(__webpack_require__(1218));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var Filter = _styledComponents["default"].div.withConfig({
  displayName: "Filterstyles__Filter",
  componentId: "sc-12suo2d-0"
})(["position:relative;"]);

exports.Filter = Filter;
var FilterInput = (0, _styledComponents["default"])(_input["default"]).withConfig({
  displayName: "Filterstyles__FilterInput",
  componentId: "sc-12suo2d-1"
})(["&&{background-color:white;display:inline-block;margin:", ";width:calc(100% - 16px);}"], _tokens["default"].space);
exports.FilterInput = FilterInput;
//# sourceMappingURL=Filter.styles.js.map

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Input["default"];
  }
});

var _Input = _interopRequireDefault(__webpack_require__(1219));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(38));

var constants = _interopRequireWildcard(__webpack_require__(40));

var _TimesCircle = _interopRequireDefault(__webpack_require__(509));

var _button = _interopRequireDefault(__webpack_require__(1220));

var types = _interopRequireWildcard(__webpack_require__(743));

var sc = _interopRequireWildcard(__webpack_require__(1232));

var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var inputClearHandler = function inputClearHandler(e) {
    e.target.value = "";
    props.onChange(e);
    props.onClear();
  };

  var renderClear = function renderClear() {
    var clearIcon = props.clearIcon,
        hasClearButton = props.hasClearButton,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        size = props.size,
        value = props.value;
    if (!hasClearButton || isDisabled || isReadOnly || !value) return null;
    var iconSize = size === types.LARGE ? types.MEDIUM : types.SMALL;
    return /*#__PURE__*/_react["default"].createElement(_button["default"].Icon, {
      a11yText: "Clear Input" // TODO: add L10n
      ,
      className: "form-input__clear",
      kind: types.MINOR,
      size: iconSize,
      onClick: inputClearHandler
    }, clearIcon || /*#__PURE__*/_react["default"].createElement(_TimesCircle["default"], null));
  };

  var renderIcon = function renderIcon() {
    if (!props.icon) return null;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "form-input__icon"
    }, props.icon);
  };

  var a11yText = props.a11yText,
      clearIcon = props.clearIcon,
      className = props.className,
      icon = props.icon,
      isDisabled = props.isDisabled,
      isReadOnly = props.isReadOnly,
      hasClearButton = props.hasClearButton,
      hasError = props.hasError,
      onClear = props.onClear,
      size = props.size,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "clearIcon", "className", "icon", "isDisabled", "isReadOnly", "hasClearButton", "hasError", "onClear", "size"]);

  if (moreProps.value || moreProps.value === "") {
    delete moreProps.defaultValue;
  } else {
    delete moreProps.value;
  }

  var styleProps = {
    size: size,
    hasClearButton: hasClearButton
  };
  if (a11yText) moreProps["aria-label"] = a11yText;
  var rootClasses = (0, _classnames["default"])("form-input", "form-input--".concat(size), {
    "form-input--has-icon": icon
  }, {
    "form-input--is-disabled": isDisabled
  }, {
    "form-input--is-readonly": isReadOnly
  }, {
    "form-input--has-error": hasError
  }, className);
  return /*#__PURE__*/_react["default"].createElement(sc.Input, (0, _extends2["default"])({}, styleProps, {
    className: rootClasses
  }), renderIcon(), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    "aria-invalid": hasError,
    className: "form-input__input",
    "data-pka-anchor": "input",
    disabled: isDisabled,
    readOnly: isReadOnly,
    ref: ref
  }, moreProps)), renderClear());
});

Input.types = {
  size: constants.defaultSize,
  type: types.inputValidTypes
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Sets the class for the input. */
  className: _propTypes["default"].string,

  /** Custom icon for the clear action in the input. */
  clearIcon: _propTypes["default"].node,

  /** Sets the default input value  */
  defaultValue: _propTypes["default"].string,

  /** If true displays a clear button inside the input if it contains a value.  */
  hasClearButton: _propTypes["default"].bool,

  /** If true displays a red border around input to show error.  */
  hasError: _propTypes["default"].bool,

  /** Displays an icon inside the input. */
  icon: _propTypes["default"].node,

  /** If true it makes the input disabled. */
  isDisabled: _propTypes["default"].bool,

  /** If true it makes the input read only. */
  isReadOnly: _propTypes["default"].bool,

  /** Callback to be executed when the input value is changed. Should not be used with defaultValue prop */
  onChange: _propTypes["default"].func,

  /** Callback to be executed when the input value is cleared */
  onClear: _propTypes["default"].func,

  /** Changes the size of the input. */
  size: _propTypes["default"].oneOf([Input.types.size.SMALL, Input.types.size.MEDIUM, Input.types.size.LARGE]),

  /** Allows user to specify the type of input. */
  type: _propTypes["default"].oneOf([Input.types.type.EMAIL, Input.types.type.NUMBER, Input.types.type.PASSWORD, Input.types.type.SEARCH, Input.types.type.TELEPHONE, Input.types.type.TEXT, Input.types.type.URL]),

  /** The value inside of the input */
  value: _propTypes["default"].string
};
var defaultProps = {
  a11yText: null,
  clearIcon: null,
  className: null,
  defaultValue: "",
  hasClearButton: false,
  hasError: false,
  icon: null,
  isDisabled: false,
  isReadOnly: false,
  onChange: function onChange() {},
  onClear: function onClear() {},
  size: Input.types.size.MEDIUM,
  type: Input.types.type.TEXT,
  value: null
};
Input.displayName = "Input";
Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
var _default = Input;
exports["default"] = _default;
//# sourceMappingURL=Input.js.map

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button["default"];
  }
});

var _Button = _interopRequireDefault(__webpack_require__(567));

var _Close = _interopRequireDefault(__webpack_require__(1224));

var _Icon = _interopRequireDefault(__webpack_require__(742));

var _Link = _interopRequireDefault(__webpack_require__(1229));

_Button["default"].Close = _Close["default"];
_Button["default"].Icon = _Icon["default"];
_Button["default"].Link = _Link["default"];
//# sourceMappingURL=index.js.map

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RawButton["default"];
  }
});

var _RawButton = _interopRequireDefault(__webpack_require__(1222));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var sc = _interopRequireWildcard(__webpack_require__(1223));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** If the visual focus ring should be displayed with an inset style. */
  hasInsetFocusStyle: _propTypes["default"].bool,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  isActive: null,
  isDisabled: false,
  hasInsetFocusStyle: false,
  onClick: function onClick() {},
  role: "button",
  tabIndex: null
};

var isTriggerKey = function isTriggerKey(key) {
  return [" ", "Enter"].includes(key);
};

var RawButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      onClick = props.onClick,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "isActive", "isDisabled", "onClick", "tabIndex"]);

  var rawButtonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        rawButtonRef.current.focus();
      }
    };
  });

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);
    if (!canPropagate) event.stopPropagation();
    if (!isDisabled) onClick(event);
  };

  function handleBlur(event) {
    if (moreProps.onBlur) moreProps.onBlur(event);
    setHasForcedFocus(false);
  }

  var handleKeyDown = function handleKeyDown(event) {
    // Prevent scrolling the page with a spacerbar keypress
    // Prevent submitting forms in IE/Edge with and enter keypress
    if (isTriggerKey(event.key)) event.preventDefault();
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;
    if (shouldHandle && moreProps.onKeyDown) moreProps.onKeyDown(event);
  };

  var handleKeyUp = function handleKeyUp(event) {
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;

    if (!isDisabled && shouldHandle && isTriggerKey(event.key)) {
      onClick(event);
    }

    if (shouldHandle && moreProps.onKeyUp) moreProps.onKeyUp(event);
  };

  var bestTabIndex = isDisabled && tabIndex === null ? -1 : tabIndex || 0;
  return /*#__PURE__*/_react["default"].createElement(sc.RawButton, (0, _extends2["default"])({
    "aria-pressed": isActive,
    "data-pka-anchor": "raw-button",
    tabIndex: bestTabIndex,
    "aria-label": a11yText
  }, moreProps, {
    "aria-disabled": isDisabled,
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isDisabled,
    onBlur: handleBlur,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: rawButtonRef
  }), children);
});

RawButton.displayName = "RawButton";
RawButton.propTypes = propTypes;
RawButton.defaultProps = defaultProps;
var _default = RawButton;
exports["default"] = _default;
//# sourceMappingURL=RawButton.js.map

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RawButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var focusStyles = function focusStyles(isInset) {
  return (0, _styledComponents.css)(["&:focus{", "}[data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{box-shadow:none;outline:none;}"], _stylers["default"].focusRing(isInset));
};

var disabledStyles = (0, _styledComponents.css)(["cursor:not-allowed;&:focus{box-shadow:none;}"]);

var RawButton = _styledComponents["default"].span.withConfig({
  displayName: "RawButtonstyles__RawButton",
  componentId: "sc-1jqcbbw-0"
})(function (_ref) {
  var hasInsetFocusStyle = _ref.hasInsetFocusStyle,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["cursor:pointer;display:inline-block;", ";", ";"], isActive ? _stylers["default"].focusRing(hasInsetFocusStyle) : focusStyles(hasInsetFocusStyle), isDisabled && disabledStyles);
});

exports.RawButton = RawButton;
//# sourceMappingURL=RawButton.styles.js.map

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Close["default"];
  }
});

var _Close = _interopRequireDefault(__webpack_require__(1225));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Times = _interopRequireDefault(__webpack_require__(362));

var constants = _interopRequireWildcard(__webpack_require__(40));

var types = _interopRequireWildcard(__webpack_require__(568));

var sc = _interopRequireWildcard(__webpack_require__(1226));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If the close button will be rendered on a dark background and will use inverted colours. */
  isDark: _propTypes["default"].bool
};
var defaultProps = {
  a11yText: null,
  isDark: false
};

var Close = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    a11yText: props.a11yText || "close",
    // TODO: use L10n
    isDark: props.isDark,
    kind: types.MINOR
  };
  return /*#__PURE__*/_react["default"].createElement(sc.CloseButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_Times["default"], null));
});

Close.types = {
  kind: constants.kind
};
Close.displayName = "Button.Close";
Close.propTypes = propTypes;
Close.defaultProps = defaultProps;
var _default = Close;
exports["default"] = _default;
//# sourceMappingURL=Close.js.map

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CloseButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Icon = _interopRequireDefault(__webpack_require__(742));

var darkStyles = (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;&:hover{background-color:", ";[data-pka-anchor=\"button.icon\"]{color:", ";}}&:active{background-color:", ";transition:none;[data-pka-anchor=\"button.icon\"]{color:", ";transition:none;}}[data-pka-anchor=\"button.icon\"]{color:", ";transition:color 0.2s ease-out;}"], _stylers["default"].alpha(_tokens["default"].color.white, 0.2), _tokens["default"].color.white, _stylers["default"].alpha(_tokens["default"].color.white, 0.3), _tokens["default"].color.white, _tokens["default"].color.blackLighten50);
var CloseButton = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "CloseButtonstyles__CloseButton",
  componentId: "sc-17tyw7-0"
})(function (_ref) {
  var isDark = _ref.isDark;
  return (0, _styledComponents.css)(["[data-pka-anchor=\"button.icon\"]{color:", ";}", ""], _tokens["default"].textColor.icon, isDark ? darkStyles : "");
});
exports.CloseButton = CloseButton;
//# sourceMappingURL=CloseButton.styles.js.map

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var constants = _interopRequireWildcard(__webpack_require__(40));

var sc = _interopRequireWildcard(__webpack_require__(1228));

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    children: null,
    icon: props.children,
    isFullWidth: false
  };
  return /*#__PURE__*/_react["default"].createElement(sc.IconButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }));
});

Icon.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var IconPropTypes = {
  /** Body content of the button (an icon). */
  children: _propTypes["default"].node.isRequired,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Icon.types.kind.DEFAULT, Icon.types.kind.PRIMARY, Icon.types.kind.SECONDARY, Icon.types.kind.DESTRUCTIVE, Icon.types.kind.FLAT, Icon.types.kind.MINOR, Icon.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Icon.types.size.SMALL, Icon.types.size.MEDIUM, Icon.types.size.LARGE])
};
var IconDefaultProps = {
  kind: Icon.types.kind.DEFAULT,
  size: Icon.types.size.MEDIUM
};
Icon.displayName = "Button.Icon";
Icon.propTypes = IconPropTypes;
Icon.defaultProps = IconDefaultProps;
var _default = Icon;
exports["default"] = _default;
//# sourceMappingURL=Icon.js.map

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.IconButton = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Button = _interopRequireDefault(__webpack_require__(567));

var types = _interopRequireWildcard(__webpack_require__(568));

var _iconButtonSizes;

var iconButtonSizes = (_iconButtonSizes = {}, (0, _defineProperty2["default"])(_iconButtonSizes, types.SMALL, (0, _styledComponents.css)(["font-size:14px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(3), (0, _parseInt["default"])(_tokens["default"].space, 10) * 3 - 2, _stylers["default"].spacer(3))), (0, _defineProperty2["default"])(_iconButtonSizes, types.MEDIUM, (0, _styledComponents.css)(["font-size:18px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(4), (0, _parseInt["default"])(_tokens["default"].space, 10) * 4 - 2, _stylers["default"].spacer(4))), (0, _defineProperty2["default"])(_iconButtonSizes, types.LARGE, (0, _styledComponents.css)(["font-size:22px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(5), (0, _parseInt["default"])(_tokens["default"].space, 10) * 5 - 2, _stylers["default"].spacer(5))), _iconButtonSizes);

var minorStyles = function minorStyles(_ref) {
  var isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;", ""], isDisabled ? (0, _styledComponents.css)(["&,&:hover,&:active{[data-pka-anchor=\"button.icon\"] svg{color:", ";}}"], _tokens["default"].color.blackDisabled) : (0, _styledComponents.css)(["&:hover{background-color:", ";}&:active{background-color:", ";}"], _stylers["default"].alpha(_tokens["default"].color.black, 0.1), _stylers["default"].alpha(_tokens["default"].color.black, 0.2)));
};

var IconButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "IconButtonstyles__IconButton",
  componentId: "sc-1rmwp4p-0"
})(function (_ref2) {
  var size = _ref2.size,
      kind = _ref2.kind;
  return (0, _styledComponents.css)(["", " ", " [data-pka-anchor=\"button.icon\"]{color:inherit;margin:0;}"], iconButtonSizes[size], kind === types.MINOR ? minorStyles : "");
});
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.styles.js.map

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Link["default"];
  }
});

var _Link = _interopRequireDefault(__webpack_require__(1230));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _NewTab = _interopRequireDefault(__webpack_require__(363));

var constants = _interopRequireWildcard(__webpack_require__(40));

var types = _interopRequireWildcard(__webpack_require__(568));

var sc = _interopRequireWildcard(__webpack_require__(1231));

var _Button = __webpack_require__(567);

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      children = props.children,
      href = props.href,
      isDisabled = props.isDisabled,
      shouldOpenNewTab = props.shouldOpenNewTab,
      kind = props.kind,
      icon = props.icon,
      size = props.size,
      suffixIcon = props.suffixIcon,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "href", "isDisabled", "shouldOpenNewTab", "kind", "icon", "size", "suffixIcon"]);
  var shouldOpenNewTabProps = {
    target: "_blank",
    rel: "noopener noreferrer"
  };

  function renderSuffix(_ref) {
    var kind = _ref.kind,
        isDisabled = _ref.isDisabled,
        suffixIcon = _ref.suffixIcon,
        shouldOpenNewTab = _ref.shouldOpenNewTab;

    if (kind === types.LINK && shouldOpenNewTab && suffixIcon) {
      return /*#__PURE__*/_react["default"].createElement(sc.LinkButtonIcon, {
        isDisabled: isDisabled,
        kind: types.LINK,
        isSuffixIcon: true
      }, suffixIcon);
    }

    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(sc.LinkButton, (0, _extends2["default"])({
    "aria-disabled": isDisabled,
    "aria-label": a11yText,
    href: !isDisabled ? href : null,
    isDisabled: isDisabled,
    kind: kind,
    size: size
  }, shouldOpenNewTab ? shouldOpenNewTabProps : {}, moreProps, {
    as: isDisabled ? "span" : "a",
    ref: ref
  }), icon ? /*#__PURE__*/_react["default"].createElement(_Button.ButtonIcon, {
    isDisabled: isDisabled
  }, icon) : null, children, renderSuffix(props));
});

Link.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** Url for the link. */
  href: _propTypes["default"].string.isRequired,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Link.types.kind.DEFAULT, Link.types.kind.PRIMARY, Link.types.kind.SECONDARY, Link.types.kind.DESTRUCTIVE, Link.types.kind.FLAT, Link.types.kind.MINOR, Link.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Link.types.size.SMALL, Link.types.size.MEDIUM, Link.types.size.LARGE]),

  /** Whether the link should open a new tab. */
  shouldOpenNewTab: _propTypes["default"].bool,

  /** Size of the button (font size, min-height, padding, etc). */
  suffixIcon: _propTypes["default"].node
};
var defaultProps = {
  a11yText: null,
  icon: null,
  isDisabled: false,
  kind: Link.types.kind.LINK,
  shouldOpenNewTab: false,
  size: Link.types.size.MEDIUM,
  suffixIcon: /*#__PURE__*/_react["default"].createElement(_NewTab["default"], null)
};
Link.displayName = "Button.Link";
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;
var _default = Link;
exports["default"] = _default;
//# sourceMappingURL=Link.js.map

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LinkButtonIcon = exports.LinkButton = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Button = __webpack_require__(741);

var _Button2 = __webpack_require__(567);

var LinkButton = _styledComponents["default"].a.withConfig({
  displayName: "LinkButtonstyles__LinkButton",
  componentId: "fsc7ri-0"
})(function (_ref) {
  var size = _ref.size,
      kind = _ref.kind,
      isFullWidth = _ref.isFullWidth,
      isActive = _ref.isActive,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "kind", "isFullWidth", "isActive"]);
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], _Button.commonStyles, _Button.sizeStyles[size], (0, _Button.kindStyles)(props)[kind], isFullWidth && _Button.fullWidthStyles, isActive ? _Button.activeStyles : _Button.inactiveStyles);
});

exports.LinkButton = LinkButton;
var LinkButtonIcon = (0, _styledComponents["default"])(_Button2.ButtonIcon).withConfig({
  displayName: "LinkButtonstyles__LinkButtonIcon",
  componentId: "fsc7ri-1"
})(["", " color:", ";margin-top:-", ";"], _stylers["default"].fontSize(-3), _tokens["default"].textColor.icon, _tokens["default"].spaceSm);
exports.LinkButtonIcon = LinkButtonIcon;
//# sourceMappingURL=LinkButton.styles.js.map

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Input = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var types = _interopRequireWildcard(__webpack_require__(743));

var _iconStyles;

var iconStyles = (_iconStyles = {}, (0, _defineProperty2["default"])(_iconStyles, types.SMALL, (0, _styledComponents.css)(["", " margin-left:3px;padding:0 ", ";"], _stylers["default"].fontSize(-2), _tokens["default"].spaceSm)), (0, _defineProperty2["default"])(_iconStyles, types.MEDIUM, (0, _styledComponents.css)(["", " margin-left:2px;padding:0 ", ";"], _stylers["default"].fontSize(), _tokens["default"].spaceSm)), (0, _defineProperty2["default"])(_iconStyles, types.LARGE, (0, _styledComponents.css)(["", " margin-left:", ";padding:0 ", ";"], _stylers["default"].fontSize(2), _tokens["default"].spaceSm, _tokens["default"].spaceSm)), _iconStyles);

var Input = _styledComponents["default"].div.withConfig({
  displayName: "Inputstyles__Input",
  componentId: "hb56vf-0"
})(function (_ref) {
  var hasClearButton = _ref.hasClearButton,
      size = _ref.size;
  return (0, _styledComponents.css)(["line-height:1;position:relative;input.form-input__input{", " background-color:", ";border:1px solid ", ";border-radius:", ";box-shadow:none;box-sizing:border-box;color:", ";display:block;margin:0;padding:0 0 0 ", ";padding-right:", ";transition:box-shadow 0.2s,color 0.2s;width:100%;&:focus{background-color:", ";border-color:", ";box-shadow:", ";outline:none;}&::-ms-clear{display:none;}}&.form-input--small input.form-input__input{", " height:", ";}&.form-input--medium input.form-input__input{", " height:", ";}&.form-input--large input.form-input__input{", " height:", ";}.form-input__icon,.form-input__clear{", ";color:", ";position:absolute;top:50%;transform:translateY(-50%);}.form-input__icon{", ";svg{vertical-align:middle;}}.form-input__clear{border-radius:", ";color:", ";right:", ";transition:color 0.2s ease-out;&:hover{color:", ";background-color:transparent;}&:active{color:", ";transition:none;}}&.form-input--has-icon input.form-input__input{padding-left:", ";}&.form-input--is-disabled,&[disabled]{input.form-input__input{", "}.form-input__icon{color:", ";}}&.form-input--is-readonly,&[readonly]{input.form-input__input{", "}}&.form-input--has-error input.form-input__input{", "}"], _stylers["default"].placeholders, _tokens["default"].color.white, _tokens["default"].border.color, _tokens["default"].border.radius, _tokens["default"].color.black, _tokens["default"].space, hasClearButton ? _stylers["default"].spacer(3) : _tokens["default"].space, _tokens["default"].color.white, _tokens["default"].highlight.active.noBorder.borderColor, _tokens["default"].highlight.active.noBorder.boxShadow, _stylers["default"].fontSize(-2), _stylers["default"].spacer(3), _stylers["default"].fontSize(-1), _stylers["default"].spacer(4), _stylers["default"].fontSize(), _stylers["default"].spacer(5), _stylers["default"].z(1), _tokens["default"].textColor.icon, iconStyles[size], _tokens["default"].border.radius, _tokens["default"].color.blackLighten50, _tokens["default"].spaceSm, _tokens["default"].color.blackLighten30, _tokens["default"].color.black, size === types.LARGE ? _stylers["default"].spacer(4) : _stylers["default"].spacer(3), _stylers["default"].disabledFormStyles, _tokens["default"].color.blackLighten60, _stylers["default"].readOnlyFormStyles, _stylers["default"].errorFormStyles);
});

exports.Input = Input;
//# sourceMappingURL=Input.styles.js.map

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Footer["default"];
  }
});

var _Footer = _interopRequireDefault(__webpack_require__(1234));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.FooterComponent = FooterComponent;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _button = _interopRequireDefault(__webpack_require__(643));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var _invokeOnChange = _interopRequireDefault(__webpack_require__(562));

var sc = _interopRequireWildcard(__webpack_require__(1235));

function FooterComponent(props, ref) {
  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      dispatch = _useListBox2[1];

  var labelCancel = props.labelCancel,
      labelAccept = props.labelAccept,
      labelClear = props.labelClear,
      isCancelVisible = props.isCancelVisible,
      isAcceptVisible = props.isAcceptVisible,
      isClearVisible = props.isClearVisible,
      kindAccept = props.kindAccept,
      kindCancel = props.kindCancel,
      kindClear = props.kindClear,
      renderExtraButton = props.renderExtraButton,
      size = props.size;

  var handleClickAccept = function handleClickAccept(event) {
    event.stopPropagation();
    dispatch({
      type: _useListBox3["default"].types.accept,
      payload: {
        onChangeFn: (0, _invokeOnChange["default"])(props.onClickAccept, "list-box:footer:accept")
      }
    });
  };

  var handleClickCancel = function handleClickCancel(event) {
    event.stopPropagation();
    var onChangeFn = props.onClickCancel ? (0, _invokeOnChange["default"])(props.onClickCancel, "list-box:footer:cancel") : (0, _invokeOnChange["default"])();
    dispatch({
      type: _useListBox3["default"].types.cancel,
      payload: {
        onChangeFn: onChangeFn
      }
    });
  };

  var handleClickClear = function handleClickClear(event) {
    event.stopPropagation();
    var onChangeFn = props.onClickClear ? (0, _invokeOnChange["default"])(props.onClickClear, "list-box:footer:clear") : (0, _invokeOnChange["default"])();
    dispatch({
      type: _useListBox3["default"].types.clear,
      payload: {
        isOpen: true,
        onChangeFn: onChangeFn
      }
    });
  };

  var isDisabled = props.isDisabled;
  return /*#__PURE__*/_react["default"].createElement(sc.Footer, {
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("div", null, isAcceptVisible && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    isDisabled: isDisabled,
    kind: kindAccept,
    size: size,
    onClick: handleClickAccept
  }, labelAccept), isCancelVisible && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    isDisabled: isDisabled,
    kind: kindCancel,
    size: size,
    onClick: handleClickCancel
  }, labelCancel)), /*#__PURE__*/_react["default"].createElement("div", null, isClearVisible && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    "data-pka-anchor": "footer-clear-button",
    isDisabled: isDisabled,
    kind: kindClear,
    size: size,
    onClick: handleClickClear
  }, labelClear), renderExtraButton()));
}

var Footer = /*#__PURE__*/_react["default"].forwardRef(FooterComponent);

var propTypes = {
  /** If true it makes the accept button visible */
  isAcceptVisible: _propTypes["default"].bool,

  /** If true it makes the cancel button visible */
  isCancelVisible: _propTypes["default"].bool,

  /** If true it makes the clear button visible */
  isClearVisible: _propTypes["default"].bool,

  /** If true it makes the footer disabled */
  isDisabled: _propTypes["default"].bool,

  /** Sets what kind the accept button will be  */
  kindAccept: _propTypes["default"].oneOf([_button["default"].types.kind.PRIMARY, _button["default"].types.kind.MINOR]),

  /** Sets what kind the cancel button will be  */
  kindCancel: _propTypes["default"].oneOf([_button["default"].types.kind.PRIMARY, _button["default"].types.kind.MINOR]),

  /** Sets what kind the cancel button will be  */
  kindClear: _propTypes["default"].oneOf([_button["default"].types.kind.PRIMARY, _button["default"].types.kind.MINOR]),

  /** Sets the label for the accept button */
  labelAccept: _propTypes["default"].string,

  /** Sets the label for the cancel button */
  labelCancel: _propTypes["default"].string,

  /** Sets the label for the clear button */
  labelClear: _propTypes["default"].string,

  /** Callback to be executed when the accept button is clicked or activated by keyboard. */
  onClickAccept: _propTypes["default"].func,

  /** Callback to be executed when the cancel button is clicked or activated by keyboard. */
  onClickCancel: _propTypes["default"].func,

  /** Callback to be executed when the clear button is clicked or activated by keyboard. */
  onClickClear: _propTypes["default"].func,

  /** Render an extra button beside the clear button */
  renderExtraButton: _propTypes["default"].func,

  /** Determines the size of the footer */
  size: _propTypes["default"].oneOf([_button["default"].types.size.SMALL, _button["default"].types.size.MEDIUM, _button["default"].types.size.LARGE])
};
var defaultProps = {
  isAcceptVisible: true,
  isCancelVisible: true,
  isClearVisible: true,
  isDisabled: false,
  kindAccept: _button["default"].types.kind.PRIMARY,
  kindCancel: _button["default"].types.kind.MINOR,
  kindClear: _button["default"].types.kind.MINOR,
  labelAccept: "Accept",
  labelCancel: "Cancel",
  labelClear: "Clear",
  onClickAccept: null,
  onClickCancel: null,
  onClickClear: null,
  renderExtraButton: function renderExtraButton() {},
  size: _button["default"].types.size.SMALL
};
Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps; // forwardRef component are struggling with react-docgen
// https://github.com/pedronauck/docz/issues/334 once we move to Storybook doc we might be able to
// remove this

FooterComponent.propTypes = propTypes;
FooterComponent.defaultProps = defaultProps;
Footer.displayName = "ListBox.Footer";
var _default = Footer;
exports["default"] = _default;
//# sourceMappingURL=Footer.js.map

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Footer = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyles__Footer",
  componentId: "sc-7mvb2i-0"
})(["border-top:1px solid #d7d7d7;display:flex;justify-content:flex-start;padding:8px;width:calc(100% - 16px);& > div{width:calc(50% - 8px);[role=\"button\"]{margin-right:8px;}}& > div + div{text-align:right;}"]);

exports.Footer = Footer;
//# sourceMappingURL=Footer.styles.js.map

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Option;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var _OnChangeProvider = __webpack_require__(508);

var _DOMAttributes = __webpack_require__(564);

var _options = __webpack_require__(410);

var _useIsSelectedOption = _interopRequireDefault(__webpack_require__(1237));

var sc = _interopRequireWildcard(__webpack_require__(1238));

var propTypes = {
  /** String, number or JSX content */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,

  /* Controls if the option is selected or not, never combine it with defaultIsSelected */
  isSelected: _propTypes["default"].bool,

  /** Describe if the option started as selected or not */
  defaultIsSelected: _propTypes["default"].bool,

  /** Describe if the option is enable or not */
  isDisabled: _propTypes["default"].bool,

  /** Describe if the option is hidden or not */
  isHidden: _propTypes["default"].bool,

  /** When the children are not a String, label should need to be add so the filter can work  */
  label: _propTypes["default"].string,

  /** Callback for the clicking event */
  onClick: _propTypes["default"].func,

  /** Value of your option this can be any data structure  */
  value: _propTypes["default"].any,
  // eslint-disable-line

  /** Internal prop, which shouldn't be documented */
  preventDefaultOnSelect: _propTypes["default"].bool
};
var defaultProps = {
  isDisabled: false,
  isHidden: false,
  preventDefaultOnSelect: false,
  isSelected: null,
  defaultIsSelected: null,
  label: null,
  onClick: null,
  value: null
};

function Option(props) {
  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  var onChangeContext = _react["default"].useContext(_OnChangeProvider.OnChangeContext);

  var activeOption = state.activeOption,
      listBoxHasFocus = state.listBoxHasFocus,
      isDisabledState = state.isDisabled,
      size = state.size;
  var index = props.index,
      groupId = props.groupId,
      label = props.label,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["index", "groupId", "label"]); // eslint-disable-line

  (0, _useIsSelectedOption["default"])({
    index: index,
    props: props
  });

  if (typeof state.options[index] === "undefined") {
    return null;
  }

  if (!(0, _options.isOptionVisible)(state, index)) {
    return null;
  }

  var isSelected = (0, _options.isOptionSelected)(state, index);
  var isDisabled = isDisabledState || props.isDisabled;
  var id = state.options[index].id;
  return /*#__PURE__*/_react["default"].createElement(sc.Option, (0, _extends2["default"])({}, moreProps, (0, _DOMAttributes.getA11yAttributesForOption)(isSelected), {
    hasPreventDefaultOnSelect: props.preventDefaultOnSelect,
    id: id,
    listBoxHasFocus: listBoxHasFocus,
    isActive: activeOption === index,
    isDisabled: isDisabled,
    isSelected: isSelected,
    size: size,
    key: index,
    onClick: (0, _options.handleClickOption)({
      props: props,
      state: state,
      dispatch: dispatch,
      onChangeContext: onChangeContext
    }),
    "data-pka-anchor": isSelected ? "list-option--is-selected" : "list-option",
    "data-pka-prevent-default-on-select": props.preventDefaultOnSelect
  }), typeof props.children === "function" ? props.children({
    isSelected: isSelected,
    isDisabled: isDisabled,
    id: id
  }) : props.children);
  /* eslint-enable react/prop-types */
}

Option.displayName = "ListBox.Option";
Option.propTypes = propTypes;
Option.defaultProps = defaultProps;
//# sourceMappingURL=Option.js.map

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = useIsSelectedOption;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(2));

var _useListBox3 = _interopRequireDefault(__webpack_require__(140));

var _options = __webpack_require__(410);

// prevents onChange to be fired twice when props are changed.
var noop = function noop() {};

function useIsSelectedOption(_ref) {
  var index = _ref.index,
      props = _ref.props;

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  var isSelected = props.isSelected;

  _react["default"].useEffect(function () {
    if (isSelected !== null) {
      if (state.isMulti) {
        (0, _options.selectMultipleOption)({
          activeOptionIndex: index,
          dispatch: dispatch,
          isSelected: isSelected,
          onChange: noop,
          isOpen: state.isOpen
        });
        return;
      }

      if (isSelected === true) {
        // we want to execute the method exclusively on the prop with selected === true
        (0, _options.selectSingleOption)({
          activeOptionIndex: index,
          state: state,
          dispatch: dispatch,
          isOpen: state.isOpen,
          onChange: noop
        });
      }
    }
  }, [dispatch, index, isSelected]); // eslint-disable-line

}
//# sourceMappingURL=useIsSelectedOption.js.map

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Option = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var types = _interopRequireWildcard(__webpack_require__(740));

var _fontSize;

var blueSelected = _tokens["default"].color.blueLighten50;
var activeStyles = (0, _styledComponents.css)(["border:2px solid Highlight;border-radius:3px;"]);
var disabledStyles = (0, _styledComponents.css)(["background:transparent;border:0;color:", ";"], _tokens["default"].color.blackLighten60);
var fontSize = (_fontSize = {}, (0, _defineProperty2["default"])(_fontSize, types.SMALL, (0, _styledComponents.css)(["", ""], _stylers["default"].fontSize(-2))), (0, _defineProperty2["default"])(_fontSize, types.MEDIUM, (0, _styledComponents.css)(["", ""], _stylers["default"].fontSize(-1))), (0, _defineProperty2["default"])(_fontSize, types.LARGE, (0, _styledComponents.css)(["", ""], _stylers["default"].fontSize())), _fontSize);

var Option = _styledComponents["default"].li.withConfig({
  displayName: "Optionstyles__Option",
  componentId: "nkqkwn-0"
})(function (_ref) {
  var size = _ref.size,
      isDisabled = _ref.isDisabled,
      hasPreventDefaultOnSelect = _ref.hasPreventDefaultOnSelect,
      isSelected = _ref.isSelected,
      isActive = _ref.isActive,
      listBoxHasFocus = _ref.listBoxHasFocus;
  return (0, _styledComponents.css)(["border:2px solid transparent;border-radius:3px;cursor:pointer;margin-bottom:", ";padding:", ";", " &:hover{", ";", ";background:", ";}", ";", " ", " ", " ", ""], _tokens["default"].spaceSm, _tokens["default"].spaceSm, fontSize[size], isDisabled ? "background: transparent; cursor: not-allowed;" : "", hasPreventDefaultOnSelect ? "background: transparent;" : "", isSelected ? blueSelected : _tokens["default"].color.blackLighten70, isActive && listBoxHasFocus && hasPreventDefaultOnSelect ? "border-color: ".concat(_tokens["default"].color.blackLighten60) : "", isActive && listBoxHasFocus ? activeStyles : "", hasPreventDefaultOnSelect, isSelected ? "background: ".concat(blueSelected, ";") : "", isDisabled ? disabledStyles : "");
});

exports.Option = Option;
//# sourceMappingURL=Option.styles.js.map

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RawItem["default"];
  }
});

var _RawItem = _interopRequireDefault(__webpack_require__(1240));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = RawItem;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Option = _interopRequireDefault(__webpack_require__(744));

/**

This component let the consumer to write `<ListBox.Option preventDefaultOnSelect />`
in a more semantic way:

<ListBox>
  <ListBox.Option>Option 1</ListBox.Option>
  <ListBox.RawItem> this is not interactive and can be anything </ListBox.RawItem>
</ListBox>

see: GetTypeOfChildren.js
*/
var propTypes = {
  preventDefaultOnSelect: _propTypes["default"].bool
};
var defaultProps = {
  preventDefaultOnSelect: true
};

function RawItem(props) {
  return /*#__PURE__*/_react["default"].createElement(_Option["default"], props);
}

RawItem.displayName = "ListBox.RawItem";
RawItem.propTypes = propTypes;
RawItem.defaultProps = defaultProps;
//# sourceMappingURL=RawItem.js.map

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrganizationItem__ = __webpack_require__(1242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OrganizationItem__["a"]; });


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OrganizationItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrganizationItem_scss__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrganizationItem_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OrganizationItem_scss__);



function OrganizationItem(_ref) {
  var href = _ref.href,
      title = _ref.title;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: "sriracha-org-switcher__organization-item",
    href: href,
    "data-testid": "organization-link"
  }, title);
}
OrganizationItem.propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__availableAppShape__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Section_Section__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_appData__ = __webpack_require__(747);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var propTypes = {
  apps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__availableAppShape__["a" /* default */]))
};

function Sections(_ref) {
  var apps = _ref.apps;
  var i18n = __WEBPACK_IMPORTED_MODULE_3__paprika_l10n_lib_useI18n___default()();

  function getAppGroups(availableApps, _appsData) {
    var appGroups = [];

    _appsData.forEach(function (group) {
      var appsInGroup = group.apps.map(function (app) {
        var foundApp = availableApps.find(function (availableApp) {
          return availableApp.key === app.key;
        });

        if (foundApp) {
          return _objectSpread(_objectSpread({}, app), {}, {
            link: foundApp.url,
            title: foundApp.title
          });
        }

        return null;
      }).filter(function (app) {
        return app !== null;
      });

      if (appsInGroup.length > 0) {
        appGroups.push({
          key: group.key,
          apps: appsInGroup
        });
      }
    });

    return appGroups;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    "data-testid": "sections"
  }, getAppGroups(apps, __WEBPACK_IMPORTED_MODULE_6__data_appData__["a" /* default */]).map(function (group) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Section_Section__["a" /* default */], {
      key: group.key,
      title: i18n.t("global_navigation.app_sections.".concat(group.key)),
      apps: group.apps
    });
  }));
}

Sections.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Sections);

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_collapsible__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_collapsible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__paprika_collapsible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_ArrowUp__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_ArrowUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_ArrowUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_ArrowDown__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_ArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_ArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AppRow__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appShape__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Section_scss__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Section_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Section_scss__);











function Section(_ref) {
  var apps = _ref.apps,
      title = _ref.title;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(false),
      _React$useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_React$useState, 2),
      isCollapsed = _React$useState2[0],
      setIsCollapsed = _React$useState2[1]; // TODO: get from some local storage or other method


  var i18n = __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default()();

  function toggleIsCollapsed() {
    setIsCollapsed(function (prevIsCollapsed) {
      return !prevIsCollapsed;
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_collapsible___default.a, {
    ariaText: "".concat(title, " ").concat(i18n.t('global_navigation.section')),
    className: "app-switcher-section",
    isCollapsed: isCollapsed,
    label: title,
    onClick: toggleIsCollapsed,
    iconAlign: "right",
    iconCollapse: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__acl_services_wasabicons_lib_ArrowDown___default.a, null),
    iconExpand: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__acl_services_wasabicons_lib_ArrowUp___default.a, null),
    "data-testid": "appSection"
  }, apps.map(function (app) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AppRow__["a" /* default */], {
      app: app,
      key: app.title
    }, app.title);
  }));
}

Section.propTypes = {
  apps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__appShape__["a" /* default */])).isRequired,
  title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapsible["default"];
  }
});

var _Collapsible = _interopRequireDefault(__webpack_require__(1248));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ArrowRight = _interopRequireDefault(__webpack_require__(569));

var _ArrowDown = _interopRequireDefault(__webpack_require__(1249));

var _ArrowUp = _interopRequireDefault(__webpack_require__(1250));

var _useI18n = _interopRequireDefault(__webpack_require__(174));

var _rawButton = _interopRequireDefault(__webpack_require__(554));

var sc = _interopRequireWildcard(__webpack_require__(1251));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Body content of the collapsible. */
  children: _propTypes["default"].node,

  /** Set's icon alignment left or right. */
  iconAlign: _propTypes["default"].oneOf(["left", "right"]),

  /** Sets RightArrowIcon if true. */
  iconCollapse: _propTypes["default"].node,

  /** Sets DownArrowIcon if true. */
  iconExpand: _propTypes["default"].node,

  /** State of the collapsible. */
  isCollapsed: _propTypes["default"].bool,

  /** If the collapsible is disabled. */
  isDisabled: _propTypes["default"].bool,
  hasOnlyIconToggle: _propTypes["default"].bool,

  /** Sets the label that will display in the collapsible */
  label: _propTypes["default"].node.isRequired,

  /** Callback to be executed when the button is clicked or activated by keyboard. */
  onClick: _propTypes["default"].func,

  /** aria-describedby on the trigger element. */
  triggerAriaDescribedby: _propTypes["default"].string
};
var defaultProps = {
  a11yText: null,
  children: null,
  iconAlign: "left",
  iconCollapse: /*#__PURE__*/_react["default"].createElement(_ArrowRight["default"], null),
  iconExpand: /*#__PURE__*/_react["default"].createElement(_ArrowDown["default"], null),
  isCollapsed: true,
  isDisabled: false,
  hasOnlyIconToggle: false,
  onClick: function onClick() {},
  triggerAriaDescribedby: null
};

var Collapsible = function Collapsible(props) {
  var I18n = (0, _useI18n["default"])();
  var hasWarnedForA11yText = false;
  var collapsedIcon = props.iconAlign === "right" ? [/*#__PURE__*/_react["default"].createElement(_ArrowUp["default"], null), /*#__PURE__*/_react["default"].createElement(_ArrowDown["default"], null)] : [props.iconExpand, props.iconCollapse];

  var checkPropsError = function checkPropsError() {
    if (!props.a11yText && !(I18n && I18n.t) && !hasWarnedForA11yText) {
      hasWarnedForA11yText = true;
      console.error("Error: It is necessary to provide either an a11yText prop or the i18n.t function via the L10n component for Collapsible.");
    }
  };

  var renderDefaultCollapsible = function renderDefaultCollapsible() {
    var a11yText = props.a11yText,
        label = props.label,
        isCollapsed = props.isCollapsed,
        isDisabled = props.isDisabled,
        iconAlign = props.iconAlign,
        triggerAriaDescribedby = props.triggerAriaDescribedby;
    return /*#__PURE__*/_react["default"].createElement(_rawButton["default"], {
      a11yText: a11yText || I18n.t("collapsible.ariaText"),
      "aria-expanded": !isCollapsed,
      className: "collapsible__label",
      "data-pka-anchor": "collapsible.trigger",
      isDisabled: isDisabled,
      onClick: props.onClick,
      "aria-describedby": triggerAriaDescribedby
    }, /*#__PURE__*/_react["default"].createElement("span", {
      "data-pka-anchor": "collapsible.icon",
      className: "collapsible__icon collapsible__icon--".concat(iconAlign),
      "aria-hidden": "true"
    }, collapsedIcon[+isCollapsed]), label);
  };

  var renderCollapsibleByIcon = function renderCollapsibleByIcon() {
    var a11yText = props.a11yText,
        label = props.label,
        isCollapsed = props.isCollapsed,
        isDisabled = props.isDisabled,
        iconAlign = props.iconAlign,
        triggerAriaDescribedby = props.triggerAriaDescribedby;
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-pka-anchor": "collapsible.heading"
    }, /*#__PURE__*/_react["default"].createElement(_rawButton["default"], {
      a11yText: a11yText || I18n.t("collapsible.ariaText"),
      "aria-expanded": !isCollapsed,
      className: "collapsible__label collapsible__label--is-toggle-icon-only collapsible__label--".concat(iconAlign),
      "data-pka-anchor": "collapsible.iconTrigger",
      isDisabled: isDisabled,
      onClick: props.onClick,
      "aria-describedby": triggerAriaDescribedby
    }, /*#__PURE__*/_react["default"].createElement("span", {
      "data-pka-anchor": "collapsible.icon",
      "aria-hidden": "true",
      className: "collapsible__icon"
    }, collapsedIcon[+isCollapsed])), label);
  };

  _react["default"].useEffect(function () {
    checkPropsError();
  });

  var a11yText = props.a11yText,
      children = props.children,
      iconAlign = props.iconAlign,
      iconCollapse = props.iconCollapse,
      iconExpand = props.iconExpand,
      isCollapsed = props.isCollapsed,
      isDisabled = props.isDisabled,
      hasOnlyIconToggle = props.hasOnlyIconToggle,
      onClick = props.onClick,
      label = props.label,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "iconAlign", "iconCollapse", "iconExpand", "isCollapsed", "isDisabled", "hasOnlyIconToggle", "onClick", "label"]);
  var collapsibleProps = {
    isCollapsed: isCollapsed
  };
  var hiddenStyles = {
    display: "none"
  };
  return /*#__PURE__*/_react["default"].createElement(sc.Collapsible, (0, _extends2["default"])({}, collapsibleProps, {
    role: "group"
  }, moreProps), hasOnlyIconToggle ? renderCollapsibleByIcon() : renderDefaultCollapsible(), /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible__body",
    style: isCollapsed ? hiddenStyles : null
  }, children));
};

Collapsible.displayName = "Collapsible";
Collapsible.propTypes = propTypes;
Collapsible.defaultProps = defaultProps;
var _default = Collapsible;
exports["default"] = _default;
//# sourceMappingURL=Collapsible.js.map

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "ArrowDown___StyledSvg",
  componentId: "sc-10xhb1r-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgArrowDown = function SvgArrowDown(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.514 17.293c.82.82 2.151.82 2.972 0L22.5 8.279 20.271 6.05l-8.27 8.272L3.728 6.05 1.5 8.279l9.014 9.014z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var _default = SvgArrowDown;
exports["default"] = _default;
//# sourceMappingURL=ArrowDown.js.map

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "ArrowUp___StyledSvg",
  componentId: "d6j2pb-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgArrowUp = function SvgArrowUp(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.514 6.707c.82-.82 2.151-.82 2.972 0l9.014 9.014-2.229 2.229-8.27-8.272-8.272 8.272L1.5 15.721l9.014-9.014z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgArrowUp;
exports["default"] = _default;
//# sourceMappingURL=ArrowUp.js.map

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Collapsible = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var Collapsible = _styledComponents["default"].div.withConfig({
  displayName: "Collapsiblestyles__Collapsible",
  componentId: "sc-1m0v0pb-0"
})(["&,*{box-sizing:border-box;}", " color:", ";display:block;line-height:", ";width:100%;.collapsible__label{display:inline-block;border-radius:", ";margin-left:-", ";margin-right:-", ";padding-left:", ";padding-right:", ";width:calc(100% + ", ");}.collapsible__icon--left{margin-right:", ";}.collapsible__icon--right{float:right;margin-left:", ";}.collapsible__label--is-toggle-icon-only{margin:0;width:auto;}.collapsible__label--left{margin-right:", ";}.collapsible__label--right{float:right;margin-left:", ";}.collapsible__icon svg{color:", ";vertical-align:-2px;}.collapsible__body{width:100%;}"], _stylers["default"].fontSize(), _tokens["default"].color.black, _stylers["default"].spacer(3), _tokens["default"].border.radius, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].space, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].textColor.icon);

exports.Collapsible = Collapsible;
//# sourceMappingURL=Collapsible.styles.js.map

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "ArrowUp___StyledSvg",
  componentId: "d6j2pb-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgArrowUp = function SvgArrowUp(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.514 6.707c.82-.82 2.151-.82 2.972 0l9.014 9.014-2.229 2.229-8.27-8.272-8.272 8.272L1.5 15.721l9.014-9.014z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgArrowUp;
exports["default"] = _default;
//# sourceMappingURL=ArrowUp.js.map

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "ArrowDown___StyledSvg",
  componentId: "sc-10xhb1r-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgArrowDown = function SvgArrowDown(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.514 17.293c.82.82 2.151.82 2.972 0L22.5 8.279 20.271 6.05l-8.27 8.272L3.728 6.05 1.5 8.279l9.014 9.014z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var _default = SvgArrowDown;
exports["default"] = _default;
//# sourceMappingURL=ArrowDown.js.map

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Notebook___StyledSvg",
  componentId: "sc-5rwqjp-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Notebook = function Notebook(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M395.863 30.131c24.953 0 45.246 18.805 45.246 41.975v335.8c0 23.15-20.293 41.975-45.246 41.975h-271.48c-24.953 0-45.246-18.825-45.246-41.975v-41.975H33.891v-41.975h45.246v-62.962H33.891v-41.975h45.246v-62.963H33.891v-41.975h45.246V72.106c0-23.17 20.293-41.975 45.247-41.975h271.479zm-271.48 377.775h271.502l-.022-335.8h-271.48v41.975h22.624v41.975h-22.623v62.963h22.623v41.975h-22.623v62.962h22.623v41.975h-22.623v41.975z"
  }));
};

var _default = Notebook;
exports["default"] = _default;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Target___StyledSvg",
  componentId: "b6pie0-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Target = function Target(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M213.246 285.832c-11.306 0-20.472-9.255-20.472-20.671 0-11.417 9.166-20.672 20.472-20.672 11.306 0 20.472 9.255 20.472 20.672 0 11.416-9.166 20.67-20.472 20.67zM446.911 58.448l-86.125 86.964 57.178 57.735H274.66v-144.7l57.178 57.736 86.125-86.964 28.947 29.229zM151.831 265.16c0 34.21 27.555 62.013 61.415 62.013s61.415-27.823 61.415-62.013h40.944c0 56.99-45.918 103.356-102.359 103.356-56.44 0-102.359-46.366-102.359-103.356 0-56.991 45.918-103.357 102.36-103.357v41.343c-33.861 0-61.416 27.823-61.416 62.014zm61.415 144.698c79 0 143.303-64.887 143.303-144.698h40.943c0 102.591-82.644 186.041-184.246 186.041C111.645 451.202 29 367.752 29 265.161c0-102.592 82.645-186.042 184.246-186.042v41.343c-79 0-143.302 64.907-143.302 144.699 0 79.79 64.301 144.698 143.302 144.698z"
  }));
};

var _default = Target;
exports["default"] = _default;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ClockPlus___StyledSvg",
  componentId: "sc-1xg9jya-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var ClockPlus = function ClockPlus(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M187.5 30C100.665 30 30 100.665 30 187.5S100.665 345 187.5 345 345 274.335 345 187.5 274.335 30 187.5 30zm0 280C119.95 310 65 255.05 65 187.5S119.95 65 187.5 65C255.032 65 310 119.95 310 187.5S255.032 310 187.5 310z"
  }), _react["default"].createElement("path", {
    d: "M205 100h-35v96.863l60.287 40.197 19.426-29.12L205 178.137zM397.5 362.5V310h-35v52.5H310v35h52.5V450h35v-52.5H450v-35z"
  })));
};

var _default = ClockPlus;
exports["default"] = _default;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ClipboardCheck___StyledSvg",
  componentId: "sc-118r0v8-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var ClipboardCheck = function ClipboardCheck(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M169.397 84.783C177.56 53.392 205.918 30 239.848 30c33.928 0 62.286 23.394 70.449 54.783h20.855v36.523h36.521c20.141 0 36.521 16.397 36.521 36.521v255.652c0 20.141-16.38 36.521-36.521 36.521H112.021C91.88 450 75.5 433.62 75.5 413.479V157.827c0-20.122 16.378-36.521 36.521-36.521h36.521V84.783h20.855zm198.276 328.696V157.827h-36.521v36.521h-182.61v-36.521h-36.52v255.652h255.651zm-146.087-98.864l-41.871-41.872-25.822 25.82 67.694 67.712L325.8 262.042 299.98 236.22l-78.392 78.395zm-36.52-156.788H294.63v-36.521H185.065v36.521zm86.391-73.044c-6.319-10.92-18.116-18.26-31.609-18.26-13.497 0-25.292 7.34-31.628 18.26h63.237z"
  }));
};

var _default = ClipboardCheck;
exports["default"] = _default;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ChartArrow___StyledSvg",
  componentId: "sc-3zasnh-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var ChartArrow = function ChartArrow(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M72 282.013v-63.004h42c5.565 0 10.92-2.205 14.847-6.153L156 185.723l48.153 48.134c8.211 8.212 21.483 8.212 29.694 0L261 206.724l27.153 27.133c4.095 4.116 9.471 6.154 14.847 6.154 5.376 0 10.752-2.038 14.847-6.154l90.132-90.136-.042 138.292H72zm336-210.01v12.306L303 189.314l-27.153-27.154c-8.211-8.19-21.483-8.19-29.694 0L219 189.314l-48.153-48.155c-8.211-8.19-21.483-8.19-29.694 0l-35.847 35.848H72V72.002h336zM408 30H72c-23.163 0-42 18.838-42 42.002v210.01c0 23.165 18.837 42.003 42 42.003h117.285L63.306 450h59.388L219 353.71V450h42v-96.29L357.306 450h59.388L290.715 324.015H408c23.163 0 42-18.838 42-42.002V72.003C450 48.837 431.163 30 408 30z"
  }));
};

var _default = ChartArrow;
exports["default"] = _default;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "AnalyticsLogoCircle___StyledSvg",
  componentId: "sc-1pbkn5s-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var AnalyticsLogoCircle = function AnalyticsLogoCircle(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M185.737 297.909h77.556l-22.869-21.212zM194.354 230.958l-68.939 66.951 99.1-37.121zM159.222 197.151l-33.807 70.928 53.03-51.373zM284.506 237.919l-26.515-67.283-47.728 46.07 35.464 35.465zM328.919 243.222l-17.898 6.96 19.555 47.727h33.475z"
  }), _react["default"].createElement("path", {
    d: "M240.093 30.438c-115.341 0-209.47 94.46-209.47 209.47 0 115.009 94.129 209.469 209.47 209.469 115.34 0 209.47-94.129 209.47-209.47 0-115.34-94.46-209.47-209.47-209.47zM77.688 319.12l75.9-155.445 40.766 38.779 70.597-70.597 38.778 97.112 33.476-12.263L403.16 319.12H77.687z"
  }), _react["default"].createElement("path", {
    d: "M263.294 268.08l30.161 29.829h14.252l-15.91-40.435z"
  })));
};

var _default = AnalyticsLogoCircle;
exports["default"] = _default;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Flowchart___StyledSvg",
  componentId: "sc-5odkhh-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Flowchart = function Flowchart(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M410 409h-85v-63h85v63zm-254 0H71v-63h85v63zm42-338h85v63h-85V71zm232.848 232.95h-42.304V282.8c0-34.982-28.45-63.45-63.414-63.45h-63.457v-42.3h42.304c11.676 0 21.153-9.475 21.153-21.15V50.15c0-11.675-9.477-21.15-21.153-21.15H177.065c-11.676 0-21.152 9.475-21.152 21.15V155.9c0 11.675 9.476 21.15 21.152 21.15h42.304v42.3h-63.456c-34.986 0-63.457 28.468-63.457 63.45v21.15H50.152C38.476 303.95 29 313.425 29 325.1v105.75C29 442.525 38.476 452 50.152 452h126.913c11.676 0 21.152-9.475 21.152-21.15V325.1c0-11.675-9.476-21.15-21.152-21.15H134.76V282.8c0-11.654 9.497-21.15 21.152-21.15H325.13c11.633 0 21.11 9.496 21.11 21.15v21.15h-42.263c-11.675 0-21.152 9.475-21.152 21.15v105.75c0 11.675 9.477 21.15 21.152 21.15h126.87c11.677 0 21.153-9.475 21.153-21.15V325.1c0-11.675-9.476-21.15-21.152-21.15z"
  }));
};

var _default = Flowchart;
exports["default"] = _default;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Clipboard___StyledSvg",
  componentId: "z0v8je-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Clipboard = function Clipboard(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M367.673 450H112.021C91.88 450 75.5 433.62 75.5 413.479V157.827c0-20.122 16.378-36.521 36.521-36.521h36.521V84.783h20.855C177.56 53.392 205.918 30 239.848 30c33.928 0 62.286 23.392 70.449 54.783h20.855v36.523h36.521c20.143 0 36.521 16.399 36.521 36.521v255.652c0 20.141-16.378 36.521-36.521 36.521zm-219.13-292.173H112.02v255.652h255.652V157.827h-36.521v36.521h-182.61v-36.521zM169.846 355.5h105v-35h-105v35zm0-70h140v-35h-140v35zm15.218-127.673h109.566v-36.521H185.065v36.521zm86.392-73.044c-6.319-10.92-18.116-18.26-31.609-18.26-13.497 0-25.292 7.34-31.628 18.26h63.237z"
  }));
};

var _default = Clipboard;
exports["default"] = _default;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "FileAdd___StyledSvg",
  componentId: "e8zmuy-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var FileAdd = function FileAdd(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M397.5 310.001v52.5H450V397.5h-52.5V450h-35v-52.5H310v-34.999h52.5v-52.5h35zM345 110.256V275h-34.984L310 135H240V65H64.999v315h210v35.001h-210c-19.301 0-34.999-15.697-34.999-35V65C30 45.716 45.695 30.002 64.999 30h199.745L345 110.256zM100 292.5h105v-35H100v35zm0-70h140v-35H100v35z"
  }));
};

var _default = FileAdd;
exports["default"] = _default;

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "TimeAndDate___StyledSvg",
  componentId: "bhm1dq-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var TimeAndDate = function TimeAndDate(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M64.125 337.125V166.5H371.25v-51.188c0-18.802-15.305-34.124-34.125-34.124h-17.063V30h-34.125v85.313h-17.062V81.186H149.437V30h-34.125v85.313H98.25V81.186H64.125C45.305 81.188 30 96.493 30 115.314v221.812c0 18.82 15.305 34.125 34.125 34.125H166.5v-34.125H64.125z",
    style: {
      mixBlendMode: "darken"
    }
  }), _react["default"].createElement("path", {
    d: "M331.875 450c-65.137 0-118.125-52.988-118.125-118.125S266.738 213.75 331.875 213.75 450 266.738 450 331.875 397.012 450 331.875 450zm0-202.5c-46.524 0-84.375 37.85-84.375 84.375 0 46.524 37.85 84.375 84.375 84.375 46.524 0 84.375-37.85 84.375-84.375 0-46.524-37.85-84.375-84.375-84.375z",
    style: {
      mixBlendMode: "darken"
    }
  }), _react["default"].createElement("path", {
    style: {
      mixBlendMode: "darken"
    },
    d: "M397.5 345h-78.75v-78.75h39.375v47.25H397.5z"
  })));
};

var _default = TimeAndDate;
exports["default"] = _default;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Placeholder___StyledSvg",
  componentId: "u5r6yu-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Placeholder = function Placeholder(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "#f0f",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M345.235 271.421v41.895H135.758V271.42H72.915v-20.947h41.896v-41.895h41.895v-41.895h167.581v41.895h41.895v41.895h41.896v20.947h-62.843zm62.843-62.842v-41.895h-41.896V124.79h-41.895V82.895h-41.895v41.894h-83.79V82.895h-41.896v41.894H114.81v41.895H72.915v41.895H31.02v188.526h41.895v-83.79h20.948v83.79h41.895v-41.894h209.477v41.894h41.895v-83.79h20.948v83.79h41.895V208.58h-41.895zM219.555 397.105h-83.79V439h83.79zM261.45 439h83.791v-41.895H261.45zM366.189 41h-41.896v41.895h41.896zM114.817 82.895h41.895V41h-41.895z"
  }), _react["default"].createElement("path", {
    d: "M156.712 271.421h41.895v-41.895h-41.895zM282.398 271.421h41.895v-41.895h-41.895z"
  })));
};

var _default = Placeholder;
exports["default"] = _default;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "AssetTypes___StyledSvg",
  componentId: "sc-12s6tev-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var AssetTypes = function AssetTypes(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    d: "M21 13h-2v-3a1 1 0 00-1-1h-2V6a1 1 0 00-1-1H9a1 1 0 00-1 1v3H6a1 1 0 00-1 1v3H3a1 1 0 00-1 1v4a1 1 0 001 1h18a1 1 0 001-1v-4a1 1 0 00-1-1zm-4 0h-4v-2h4v2zm-7-6h4v2h-4V7zm-3 4h4v2H7v-2zm-3 4h4v2H4v-2zm6 0h4v2h-4v-2zm10 2h-4v-2h4v2z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var _default = AssetTypes;
exports["default"] = _default;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ToolsAndTemplatesLogo___StyledSvg",
  componentId: "sc-9gv5qg-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var ToolsAndTemplatesLogo = function ToolsAndTemplatesLogo(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M392.727 145.413h-57.272v-38.191c0-21.043-17.125-38.191-38.182-38.191H182.727c-21.057 0-38.182 17.148-38.182 38.19v38.192H87.273C55.696 145.413 30 171.115 30 202.699v76.382h19.09v95.477c0 31.584 25.697 57.287 57.274 57.287h267.272c31.577 0 57.273-25.703 57.273-57.287v-95.477H450V202.7c0-31.584-25.696-57.286-57.273-57.286zm-210-38.191h114.546v38.19H182.727v-38.19zm210 267.336c0 10.56-8.572 19.096-19.09 19.096H106.363c-10.52 0-19.091-8.536-19.091-19.096v-95.477h76.363c0 21.062 17.125 38.191 38.182 38.191h76.364c21.057 0 38.182-17.129 38.182-38.19h76.363v95.476zm-190.909-95.477v-38.19h76.364l-.057 38.19h-76.307zm210-38.19h-95.454c0-21.044-17.125-38.192-38.182-38.192h-76.364c-21.057 0-38.182 17.148-38.182 38.191H68.182V202.7c0-10.522 8.572-19.096 19.09-19.096h305.455c10.52 0 19.091 8.574 19.091 19.095v38.191z"
  }));
};

var _default = ToolsAndTemplatesLogo;
exports["default"] = _default;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "HelpdocsLogo___StyledSvg",
  componentId: "sc-2k2e2z-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var HelpdocsLogo = function HelpdocsLogo(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M286.667 263.34v-70L380 146.671v70l-93.333 46.668zm-210 77.155L240 401.746l163.333-61.25V91.104L250.43 167.546a23.277 23.277 0 01-20.86 0L76.667 91.105v249.39zM240 450c-2.777 0-5.553-.49-8.19-1.47L45.143 378.529C36.043 375.099 30 366.395 30 356.665V53.328c0-8.074 4.2-15.587 11.06-19.834a23.294 23.294 0 0122.703-1.027L240 120.575l176.237-88.108a23.291 23.291 0 0122.703 1.027A23.356 23.356 0 01450 53.328v303.337c0 9.73-6.043 18.434-15.143 21.864L248.19 448.53A23.513 23.513 0 01240 450z"
  }));
};

var _default = HelpdocsLogo;
exports["default"] = _default;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "LifeBuoy___StyledSvg",
  componentId: "slj4e4-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var LifeBuoy = function LifeBuoy(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M240 30C124.211 30 30 124.237 30 240c0 115.815 94.211 210 210 210 115.815 0 210-94.185 210-210 0-115.763-94.185-210-210-210zm71.531 40.714l-20.448 48.352c-32.34-13.65-69.825-13.65-102.165 0l-20.45-48.352c45.335-19.189 97.73-19.189 143.063 0zM119.04 291.109l-48.353 20.475C61.107 288.904 56.25 264.806 56.25 240c0-24.806 4.856-48.851 14.437-71.531l48.353 20.475c-6.825 16.143-10.29 33.311-10.29 51.056 0 17.745 3.465 34.965 10.29 51.109zM240 423.75c-24.806 0-48.877-4.83-71.531-14.464l20.449-48.352c32.34 13.702 69.825 13.702 102.165 0l20.448 48.352c-22.68 9.634-46.725 14.464-71.531 14.464zm0-78.75c-57.907 0-105-47.066-105-105 0-57.881 47.093-105 105-105s105 47.119 105 105c0 57.934-47.093 105-105 105zm120.934-53.891c6.851-16.144 10.316-33.364 10.316-51.109 0-17.745-3.465-34.913-10.316-51.056l48.352-20.475c9.608 22.68 14.464 46.725 14.464 71.531 0 24.806-4.856 48.904-14.464 71.584l-48.352-20.475z"
  }));
};

var _default = LifeBuoy;
exports["default"] = _default;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Download___StyledSvg",
  componentId: "sc-9o81gv-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Download = function Download(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M449 294.2c-3.271-30.543-23.071-56.1-50.471-67.5.128-2.486.4-4.986.4-7.471 0-3.929-.129-7.729-.529-11.529-5.771-63.443-59.243-113.257-124.257-113.257-49.672 0-92.543 29.1-112.6 71.171-9.7-7.6-21.886-12.057-35.257-12.057-31.857 0-57.543 25.829-57.543 57.543v1.971a53.017 53.017 0 002.628 15.2c-22.414 13.243-38.142 36.572-41.028 63.7-.129 2.886-.257 5.9-.257 8.915 0 34.728 20.971 64.614 50.985 77.6 9.829 4.328 20.715 6.686 32.115 6.814h126.5c-3.015-.4-5.9-1.971-8.257-4.714l-73.143-87.043c-5.372-6.429-2.886-11.529 5.371-11.529H217v-81.271h47.586v81.271h53.471c8.257 0 10.743 5.243 5.372 11.529l-73.015 87.171c-2.357 2.758-5.243 4.329-8.257 4.715H362.23c1.442.128 3.014.257 4.457.257 16.128 0 31.071-4.586 43.785-12.586 23.329-14.543 38.929-40.5 38.929-70.128.129-3.015 0-5.9-.4-8.786v.014z"
  }));
};

var _default = Download;
exports["default"] = _default;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Design___StyledSvg",
  componentId: "js2vl4-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Design = function Design(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M369.974 280c-14.8 0-28.5 4.3-40.42 11.32l-37.16-37.18-28.28 28.28 37.18 37.16c-7.02 11.92-11.32 25.6-11.32 40.42 0 44.14 35.82 80 80 80 14.8 0 28.5-4.3 40.4-11.32l-54.54-54.54 28.28-28.28 54.54 54.54c7.02-11.9 11.32-25.6 11.32-40.4 0-44.2-35.82-80-80-80m-240-80c14.8 0 28.5-4.3 40.4-11.32l37.18 37.18 28.28-28.28-37.18-37.18c7.02-11.9 11.32-25.6 11.32-40.4 0-44.2-35.82-80-80-80-14.8 0-28.5 4.3-40.42 11.32l54.56 54.54-28.28 28.28-54.54-54.56c-7.02 11.92-11.32 25.6-11.32 40.42 0 44.14 35.82 80 80 80"
  }), _react["default"].createElement("path", {
    d: "M218.258 300l155.86-155.86 15.86 15.86 60-80-40-40-80 60 15.86 15.86-155.86 155.86-45.86-45.86-28.28 28.28 25.86 25.86-85.86 85.86c-7.82 7.82-7.82 20.46 0 28.28l40 40c7.8 7.82 20.46 7.82 28.28 0l85.86-85.86 25.86 25.86 28.28-28.28-45.86-45.86z"
  })));
};

var _default = Design;
exports["default"] = _default;

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_popover__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__paprika_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CurrentApp_scss__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CurrentApp_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CurrentApp_scss__);
/* eslint-disable jsx-a11y/mouse-events-have-key-events */







function CurrentApp(_ref) {
  var appUrl = _ref.appUrl,
      appId = _ref.appId,
      appModuleName = _ref.appModuleName,
      zIndex = _ref.zIndex;
  var i18n = __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n___default()();
  var appName = i18n.t("global_navigation.apps.".concat(appId), {
    defaultValue: appModuleName
  });
  var dashboardLinkTitle = i18n.t('global_navigation.apps.dashboard', {
    module: appName
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "navigation-current-app"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a, {
    isEager: true,
    isDark: true,
    zIndex: zIndex
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a.Trigger, null, function (handler) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      className: "navigation-item__trigger",
      onMouseOver: handler,
      onMouseOut: handler,
      onBlur: handler,
      "aria-label": dashboardLinkTitle,
      href: appUrl
    }, appName);
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a.Content, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a.Card, null, dashboardLinkTitle)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a.Tip, null)));
}

CurrentApp.propTypes = {
  appUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  appId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  appModuleName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};
CurrentApp.defaultProps = {
  appUrl: '/',
  appId: '',
  appModuleName: null,
  zIndex: 9999
};
CurrentApp.componentType = __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* navigationItems */].currentApp;
/* harmony default export */ __webpack_exports__["a"] = (CurrentApp);

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OverflowMenuTrigger__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LinkStyles_scss__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LinkStyles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LinkStyles_scss__);









function Helper(_ref) {
  var helpDocUrl = _ref.helpDocUrl,
      supportUrl = _ref.supportUrl,
      zIndex = _ref.zIndex;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(false),
      _React$useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var i18n = __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default()();

  function toggleIsOpen() {
    setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  }

  function handleCloseOverflowMenu() {
    setIsOpen(false);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "navigation-helper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default.a, {
    onClose: handleCloseOverflowMenu,
    zIndex: zIndex
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default.a.Trigger, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OverflowMenuTrigger__["a" /* default */], {
    ariaLabel: i18n.t('global_navigation.navigation_items.helper'),
    icon: __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* icons */].helper,
    isOpen: isOpen,
    onClick: toggleIsOpen
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default.a.LinkItem, {
    className: "navigation-overflow__link",
    isExternal: true,
    link: helpDocUrl
  }, i18n.t('global_navigation.helper.help_docs')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default.a.LinkItem, {
    className: "navigation-overflow__link",
    isExternal: true,
    link: supportUrl
  }, i18n.t('global_navigation.helper.support'))));
}

Helper.propTypes = {
  helpDocUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  supportUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  zIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
};
Helper.defaultProps = {
  zIndex: null
};
Helper.componentType = __WEBPACK_IMPORTED_MODULE_6__constants__["d" /* navigationItems */].helper;
/* harmony default export */ __webpack_exports__["a"] = (Helper);

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _v = _interopRequireDefault(__webpack_require__(124));

__webpack_require__(62);

var _popover = _interopRequireDefault(__webpack_require__(1277));

var _extractChildren2 = _interopRequireDefault(__webpack_require__(1295));

var _Content = _interopRequireDefault(__webpack_require__(1296));

var _Divider = _interopRequireDefault(__webpack_require__(1298));

var _Trigger = _interopRequireDefault(__webpack_require__(1301));

var _LinkItem = _interopRequireDefault(__webpack_require__(1317));

var _Item = _interopRequireDefault(__webpack_require__(1319));

var sc = _interopRequireWildcard(__webpack_require__(1321));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var propTypes = {
  /** Alignment of the Popover */
  align: _popover["default"].propTypes.align,

  /** Children should consist of <OverflowMenu.Item /> */
  children: _propTypes["default"].node.isRequired,

  /** If provided, will align Popover to specified edge of Trigger */
  edge: _popover["default"].propTypes.edge,

  /** Control if the overflow menu popover open. */
  isOpen: _popover["default"].propTypes.isOpen,

  /** If provided, will fire when the Popover is closed */
  onClose: _popover["default"].propTypes.onClose,

  /** The z-index for the popover / confirmation */
  zIndex: _popover["default"].propTypes.zIndex
};
var defaultProps = {
  align: _popover["default"].defaultProps.align,
  edge: _popover["default"].defaultProps.edge,
  isOpen: null,
  onClose: _popover["default"].defaultProps.onClose,
  zIndex: _popover["default"].defaultProps.zIndex
};
var popoverOffset = 4;

var OverflowMenu = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var align = props.align,
      children = props.children,
      edge = props.edge,
      controlledIsOpen = props.isOpen,
      onClose = props.onClose,
      zIndex = props.zIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["align", "children", "edge", "isOpen", "onClose", "zIndex"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      isConfirming = _React$useState4[0],
      setIsConfirming = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(0),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      currentFocusIndex = _React$useState6[0],
      setFocusIndex = _React$useState6[1];

  var triggerRef = _react["default"].useRef(null);

  var menuId = _react["default"].useRef((0, _v["default"])());

  var triggerId = _react["default"].useRef((0, _v["default"])());

  var overflowListRef = _react["default"].useRef(null);

  var renderConfirmationRef = _react["default"].useRef(null);

  function focusAndSetIndex(index) {
    if (overflowListRef && overflowListRef.current && index !== undefined) overflowListRef.current.querySelectorAll('[data-pka-anchor="overflow-menu.item"]')[index].focus();
    setFocusIndex(index);
  }

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focusAndSetIndex: focusAndSetIndex
    };
  });

  function getIsOpenValue() {
    return controlledIsOpen === null ? isOpen : controlledIsOpen;
  }

  function setIsOpenValue(value) {
    if (controlledIsOpen !== null) return;
    setIsOpen(value);
  }

  var handleCloseMenu = function handleCloseMenu(key) {
    setIsOpenValue(false);

    if (isConfirming) {
      setIsConfirming(false);
      renderConfirmationRef.current = null;
    }

    if (triggerRef.current && key === "Tab") {
      triggerRef.current.focus();
    }

    if (onClose) {
      onClose();
    }
  };

  var handleOpenMenu = function handleOpenMenu() {
    setIsOpenValue(true);

    if (document.querySelector("html").getAttribute("data-whatinput") === "keyboard") {
      setTimeout(function () {
        focusAndSetIndex(0);
      }, 250);
    }
  };

  var _extractChildren = (0, _extractChildren2["default"])(children, ["OverflowMenu.Trigger", "OverflowMenu.Content"]),
      Trigger = _extractChildren["OverflowMenu.Trigger"],
      Content = _extractChildren["OverflowMenu.Content"],
      extractedChildren = _extractChildren.children;

  var ContentProps = Content && Content.props ? Content.props : null;
  var overflowLastItemIndex = _react["default"].Children.toArray(extractedChildren.filter(function (child) {
    return child.type && (child.type.displayName === "OverflowMenu.Item" || child.type.displayName === "OverflowMenu.LinkItem");
  })).length - 1;

  var _onKeyDown = function onKeyDown(event, currentIndex) {
    if (event.key === "ArrowDown") {
      var indexToFocus = currentIndex === overflowLastItemIndex ? 0 : currentIndex + 1;
      focusAndSetIndex(indexToFocus);
    } else if (event.key === "ArrowUp") {
      var _indexToFocus = currentIndex === 0 ? overflowLastItemIndex : currentIndex - 1;

      focusAndSetIndex(_indexToFocus);
    } else if (event.key === "Home") {
      focusAndSetIndex(0);
    } else if (event.key === "End") {
      focusAndSetIndex(overflowLastItemIndex);
    } else if (event.key === "Enter" || event.key === " ") {// do nothing
    } else {
      handleCloseMenu(event.key);
    }
  };

  var handleShowConfirmation = function handleShowConfirmation(renderConfirmation) {
    renderConfirmationRef.current = renderConfirmation;
    return function () {
      setIsConfirming(function (prevIsConfirmingState) {
        return !prevIsConfirmingState;
      });
    };
  };

  var renderTrigger = function renderTrigger() {
    // wrapping the returned item in a function to avoid needing to tab twice
    // https://github.com/acl-services/paprika/issues/126
    return function () {
      return /*#__PURE__*/_react["default"].cloneElement(Trigger, {
        isOpen: getIsOpenValue(),
        onOpenMenu: handleOpenMenu,
        triggerRef: triggerRef,
        menuId: menuId.current,
        id: triggerId.current
      });
    };
  };

  var extractRenderConfirmation = function extractRenderConfirmation() {
    extractedChildren.forEach(function (child) {
      if (child.props.renderConfirmation && child.props.renderConfirmation !== renderConfirmationRef.current) {
        renderConfirmationRef.current = child.props.renderConfirmation;
      }
    });
  };

  var getClonedChild = function getClonedChild(child, childKey) {
    var additionalProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread({
      onKeyDown: function onKeyDown(e) {
        return _onKeyDown(e, currentFocusIndex);
      }
    }, childKey), additionalProps));
  };

  var renderContent = function renderContent() {
    if (isConfirming) {
      extractRenderConfirmation();
      var confirmationComponent = renderConfirmationRef.current(handleCloseMenu);
      return /*#__PURE__*/_react["default"].cloneElement(confirmationComponent, {
        align: align,
        edge: edge,
        defaultIsOpen: true,
        getPositioningElement: function getPositioningElement() {
          return document.getElementById(triggerId.current);
        },
        offset: popoverOffset,
        onClose: handleCloseMenu,
        zIndex: zIndex
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_popover["default"].Card, null, /*#__PURE__*/_react["default"].createElement(sc.Content, {
      ref: overflowListRef
    }, extractedChildren.map(function (child, index) {
      var childKey = {
        key: "OverflowMenuItem".concat(index)
      };

      if (child && child.type && child.type.displayName === "OverflowMenu.Item") {
        if (child.props.renderConfirmation) {
          return getClonedChild(child, childKey, {
            onShowConfirmation: handleShowConfirmation(child.props.renderConfirmation)
          });
        }

        return getClonedChild(child, childKey, {
          onClose: handleCloseMenu
        });
      }

      return getClonedChild(child, childKey);
    })));
  };

  return /*#__PURE__*/_react["default"].createElement(_popover["default"], (0, _extends2["default"])({
    align: align,
    offset: popoverOffset,
    isOpen: getIsOpenValue(),
    edge: edge,
    zIndex: zIndex
  }, moreProps, {
    onClose: function onClose() {
      if (!isConfirming) handleCloseMenu();
    }
  }), /*#__PURE__*/_react["default"].createElement(_popover["default"].Trigger, null, renderTrigger()), /*#__PURE__*/_react["default"].createElement(_popover["default"].Content, (0, _extends2["default"])({
    id: menuId.current,
    role: !isConfirming ? "menu" : null
  }, ContentProps), getIsOpenValue() && renderContent()));
});

OverflowMenu.displayName = "OverflowMenu";
OverflowMenu.propTypes = propTypes;
OverflowMenu.defaultProps = defaultProps;
OverflowMenu.Content = _Content["default"];
OverflowMenu.Divider = _Divider["default"];
OverflowMenu.LinkItem = _LinkItem["default"];
OverflowMenu.Item = _Item["default"];
OverflowMenu.Trigger = _Trigger["default"];
var _default = OverflowMenu;
exports["default"] = _default;
//# sourceMappingURL=OverflowMenu.js.map

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover["default"];
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(1278));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _parseInt2 = _interopRequireDefault(__webpack_require__(112));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _construct = _interopRequireDefault(__webpack_require__(216));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(217));

var _createClass2 = _interopRequireDefault(__webpack_require__(218));

var _inherits2 = _interopRequireDefault(__webpack_require__(219));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(220));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(221));

var _react = _interopRequireDefault(__webpack_require__(2));

var _memoizeOne = _interopRequireDefault(__webpack_require__(207));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = _interopRequireDefault(__webpack_require__(222));

var _v = _interopRequireDefault(__webpack_require__(124));

var constants = _interopRequireWildcard(__webpack_require__(40));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _helpers = __webpack_require__(109);

var types = _interopRequireWildcard(__webpack_require__(1279));

var _isInsideBoundaries = _interopRequireDefault(__webpack_require__(1280));

var _getPosition = __webpack_require__(1281);

var _getBoundingClientRect = _interopRequireDefault(__webpack_require__(1283));

var _PopoverContext = _interopRequireWildcard(__webpack_require__(510));

var _Content = _interopRequireDefault(__webpack_require__(1284));

var _Card = _interopRequireDefault(__webpack_require__(1289));

var _Trigger = _interopRequireDefault(__webpack_require__(1291));

var _Tip = _interopRequireDefault(__webpack_require__(1293));

var sc = _interopRequireWildcard(__webpack_require__(511));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var openDelay = 350;
var closeDelay = 150;
var throttleDelay = 20;
var focusableElementSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]'; // TODO: To handle cases where there are multiple scrolling containers, we need to implement
//       getScrollContainer as oneOfType([func, arrayOf(func)])

var Popover = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popover);
    _this = _super.call(this, props);
    _this.getContextValues = (0, _memoizeOne["default"])(function (content, maxWidth, minWidth, width, isEager, isOpen, isPortal, portalElement, refContent, refTip, shouldKeepFocus, tip, zIndex, ariaIdForContent) {
      return {
        content: _objectSpread(_objectSpread({}, content), {}, {
          maxWidth: maxWidth,
          minWidth: minWidth,
          width: width,
          zIndex: zIndex,
          ariaId: ariaIdForContent
        }),
        isEager: isEager,
        isOpen: isOpen,
        onClick: _this.handleClick,
        onClose: _this.handleClose,
        onDelayedClose: _this.handleDelayedClose,
        onDelayedOpen: _this.handleDelayedOpen,
        onOpen: _this.handleOpen,
        isPortal: isPortal,
        portalElement: portalElement,
        refContent: refContent,
        refTip: refTip,
        shouldKeepFocus: shouldKeepFocus,
        tip: tip
      };
    });

    _this.getCoordinates = function () {
      var _this$props = _this.props,
          align = _this$props.align,
          edge = _this$props.edge,
          getScrollContainer = _this$props.getScrollContainer;
      var targetRect = _this.props.getPositioningElement === null ? (0, _getBoundingClientRect["default"])(_this.$popover.current) : (0, _getBoundingClientRect["default"])(_this.props.getPositioningElement());
      var contentCoords = (0, _getPosition.getContentCoordinates)({
        rect: _this.$content ? (0, _getBoundingClientRect["default"])(_this.$content) : null,
        targetRect: targetRect,
        scrollRect: getScrollContainer !== null ? (0, _getBoundingClientRect["default"])(getScrollContainer()) : null,
        align: align,
        offset: _this.props.offset,
        edge: edge
      });
      var tipCoords = {
        x: null,
        y: null,
        rotate: null
      };

      if (_this.$tip) {
        tipCoords = (0, _getPosition.getTipCoordinates)({
          tipRect: (0, _getBoundingClientRect["default"])(_this.$tip),
          targetRect: targetRect,
          contentRect: (0, _getBoundingClientRect["default"])(_this.$content),
          contentCoords: contentCoords,
          align: align
        });
      }

      return {
        tip: tipCoords,
        content: contentCoords
      };
    };

    _this.handleReposition = (0, _lodash["default"])(function () {
      if (_this.isOpen()) {
        var scrollContainer = _this.props.getScrollContainer === null ? document.body : _this.props.getScrollContainer();

        if (!(0, _isInsideBoundaries["default"])({
          $container: scrollContainer,
          $element: _this.$popover.current,
          align: _this.props.align
        })) {
          _this.close();

          return;
        }

        _this.setVisibilityAndPosition();
      }
    }, throttleDelay);

    _this.handleKeyUp = function (event) {
      if (event.key === "Escape") {
        _this.close();

        if (_this.$trigger) _this.$trigger.focus();
      }
    };

    _this.handleKeyDown = function (event) {
      if (event.key === "Tab" && _this.isOpen() && _this.$trigger) {
        var isFocusOnFirst = _this.focusIsOnCertainElementInPopover("first") || document.activeElement === _this.$content;

        var isFocusOnLast = _this.focusIsOnCertainElementInPopover("last");

        if (event.shiftKey && isFocusOnFirst) {
          event.preventDefault();

          _this.focusableElements[_this.triggerFocusIndex].focus();
        } else if (!event.shiftKey && isFocusOnLast) {
          event.preventDefault();

          _this.focusableElements[_this.triggerFocusIndex + 1].focus();
        }
      }
    };

    _this.focusIsOnCertainElementInPopover = function (which) {
      var focusableElementsInPopover = _this.$content.querySelectorAll(focusableElementSelector);

      var index = which === "first" ? 0 : focusableElementsInPopover.length - 1;
      return document.activeElement === focusableElementsInPopover[index];
    };

    _this.elementIsDescendentOfPopover = function (elem) {
      var elementsParent = elem.parentNode;

      while (elementsParent !== null) {
        if (elementsParent.getAttribute && elementsParent.getAttribute("data-pka-anchor") === "popover.content") {
          return true;
        }

        elementsParent = elementsParent.parentNode;
      }

      return false;
    };

    _this.getPopoverTriggerFocusIndex = function () {
      _this.focusableElements.forEach(function (focusableElement, index) {
        if (focusableElement === _this.$trigger) {
          _this.triggerFocusIndex = index;
        }
      });
    };

    _this.handleTransitionEnd = function (event) {
      // NOTE: do this should make more that only focus the content div? should as well
      //       find the first focusable element like button, input, etc?
      //       can focus automatically
      if (!_this.props.shouldKeepFocus && !_this.props.isEager && _this.isOpen() && event.propertyName === "visibility") {
        _this.getPopoverTriggerFocusIndex();

        event.target.focus();
      }
    };

    _this.handleOpen = function () {
      _this.open();
    };

    _this.handleClose = function () {
      _this.close();
    };

    _this.handleDelayedOpen = function () {
      clearTimeout(_this.closeTimer);
      _this.openTimer = setTimeout(_this.handleOpen, openDelay);
    };

    _this.handleDelayedClose = function () {
      clearTimeout(_this.openTimer);
      _this.closeTimer = setTimeout(_this.handleClose, closeDelay);
    };

    _this.handleClick = function () {
      if (_this.isOpen() && !_this.props.shouldKeepFocus && !_this.props.isEager) _this.close();else _this.open();
    };

    _this.refTip = function (ref) {
      _this.$tip = ref;
    };

    _this.refContent = function (ref) {
      _this.$content = ref;
    };

    _this.handleChildChange = function () {
      setTimeout(function () {
        _this.setVisibilityAndPosition();
      });
    };

    _this.hasListeners = false;
    _this.$popover = /*#__PURE__*/_react["default"].createRef();
    _this.$trigger = null;
    _this.$tip = null; // this ref comes from a callback of the <Tip /> component

    if (props.isPortal) {
      var portalNode = document.createElement("div");
      _this.$portal = document.body.appendChild(portalNode);
    }

    _this.focusableElements = [];
    _this.triggerFocusIndex = null;
    _this.state = {
      isOpen: _this.props.defaultIsOpen || false,
      tip: {
        x: 0,
        y: 0
      },
      content: {
        x: 0,
        y: 0
      },
      width: "auto"
    }; // NOTE: should we created a link explaining more deeply this kind of errors?
    //       this type of validation should live in the constructor or somewhere else?

    if (props.isOpen !== null && props.defaultIsOpen !== null) {
      console.error("The use of defaultIsOpen prop is for uncontrolled components only and cannot be used when\n        isOpen prop is also provided.");
    }

    _this.ariaIdForContent = "popover-content-".concat((0, _v["default"])());
    return _this;
  }

  (0, _createClass2["default"])(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // about setState for Popovers and Tooltips in ComponentDidMount
      // https://reactjs.org/docs/react-component.html#componentdidmount
      if (this.isOpen()) {
        this.addListeners();
        this.setVisibilityAndPosition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        this.open();
      }

      if (this.isOpen() && !this.hasListeners) {
        this.focusableElements = document.querySelectorAll(focusableElementSelector);
        this.addListeners();
      }

      if (this.isOpen() && prevProps !== this.props) this.setVisibilityAndPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
      clearTimeout(this.openTimer);
      this.openTimer = null;
      clearTimeout(this.closeTimer);
      this.closeTimer = null;

      if (this.props.isPortal) {
        document.body.removeChild(this.$portal);
      }
    }
  }, {
    key: "getContentWidth",
    value: function getContentWidth() {
      var $shadowContent = this.$content.cloneNode(true);
      $shadowContent.style.visibility = "hidden";
      $shadowContent.style.top = 0;
      $shadowContent.style.left = 0;
      $shadowContent.style.width = "auto";
      $shadowContent.style.maxWidth = this.props.maxWidth;
      $shadowContent.style.minWidth = this.props.minWidth;
      document.body.appendChild($shadowContent);
      var contentWidth = (0, _getBoundingClientRect["default"])($shadowContent).width;
      document.body.removeChild($shadowContent);
      return contentWidth;
    }
  }, {
    key: "setVisibilityAndPosition",
    value: function setVisibilityAndPosition() {
      var _this2 = this;

      var isOpening = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.$content) {
        // dynamically setting a fixed width before positioning avoids issues at the
        // right edge of the screen
        if (isOpening && [types.TOP, types.BOTTOM].includes(this.props.align)) {
          var newWidth = this.getContentWidth();

          if (newWidth !== this.state.width) {
            this.setState({
              width: newWidth
            }, function () {
              _this2.updateVisibilityAndPositionState(isOpening);
            });
            return;
          }
        }

        this.updateVisibilityAndPositionState(isOpening);
      }
    }
  }, {
    key: "open",
    value: function open() {
      this.$trigger = document.activeElement;
      this.setVisibilityAndPosition(true);
    }
  }, {
    key: "close",
    value: function close() {
      // NOTE: Even if uncontrolled, the app may want to be notified when closed via the onClose callback
      if (this.props.onClose !== null) {
        this.props.onClose();
      }

      if (this.props.isOpen === null) {
        this.setState({
          isOpen: false
        });
        this.removeListeners();
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      this.focusableElements = document.querySelectorAll(focusableElementSelector);
      return this.props.isOpen !== null ? this.props.isOpen : this.state.isOpen;
    }
  }, {
    key: "updateVisibilityAndPositionState",
    value: function updateVisibilityAndPositionState() {
      var isOpening = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _this$getCoordinates = this.getCoordinates(),
          content = _this$getCoordinates.content,
          tip = _this$getCoordinates.tip;

      var newState = {
        content: content,
        tip: tip
      };
      if (isOpening) newState.isOpen = true;
      this.setState(newState);
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      if (this.$content) {
        document.addEventListener("keyup", this.handleKeyUp, false);
        document.addEventListener("keydown", this.handleKeyDown, false);
        document.addEventListener("resize", this.handleReposition, false);
        document.addEventListener("scroll", this.handleReposition, false);

        if (this.props.getScrollContainer !== null) {
          this.props.getScrollContainer().addEventListener("scroll", this.handleReposition, false);
        }

        this.$content.addEventListener("transitionend", this.handleTransitionEnd, false);
        this.hasListeners = true;
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (this.$content) {
        document.removeEventListener("resize", this.handleReposition);

        if (this.props.getScrollContainer === null) {
          document.removeEventListener("scroll", this.handleReposition);
        } else {
          this.props.getScrollContainer().removeEventListener("scroll", this.handleReposition);
        }

        document.removeEventListener("keyup", this.handleKeyUp);
        document.removeEventListener("keydown", this.handleKeyDown);
        this.$content.removeEventListener("transitionend", this.handleTransitionEnd);
        this.hasListeners = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          align = _this$props2.align,
          children = _this$props2.children,
          isDark = _this$props2.isDark,
          isEager = _this$props2.isEager,
          isOpen = _this$props2.isOpen,
          isPortal = _this$props2.isPortal,
          defaultIsOpen = _this$props2.defaultIsOpen,
          maxWidth = _this$props2.maxWidth,
          minWidth = _this$props2.minWidth,
          onClose = _this$props2.onClose,
          offset = _this$props2.offset,
          getPositioningElement = _this$props2.getPositioningElement,
          getScrollContainer = _this$props2.getScrollContainer,
          zIndex = _this$props2.zIndex,
          moreProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["align", "children", "isDark", "isEager", "isOpen", "isPortal", "defaultIsOpen", "maxWidth", "minWidth", "onClose", "offset", "getPositioningElement", "getScrollContainer", "zIndex"]);
      var contextValue = this.getContextValues(this.state.content, maxWidth, minWidth, this.state.width, isEager, this.isOpen(), isPortal, this.$portal, this.refContent, this.refTip, this.props.shouldKeepFocus, this.state.tip, zIndex, this.ariaIdForContent);
      return /*#__PURE__*/_react["default"].createElement(_PopoverContext.ThemeContext.Provider, {
        value: isDark
      }, /*#__PURE__*/_react["default"].createElement(_PopoverContext["default"].Provider, {
        value: contextValue
      }, /*#__PURE__*/_react["default"].createElement(sc.Popover, (0, _extends2["default"])({
        "data-pka-anchor": "popover"
      }, moreProps, {
        ref: this.$popover
      }), /*#__PURE__*/_react["default"].createElement(PopoverChildren, {
        onChildChange: this.handleChildChange
      }, this.props.children))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!prevState.isOpen && nextProps.isOpen) {
        return {
          isOpen: true
        };
      }

      return null;
    }
  }]);
  return Popover;
}(_react["default"].Component); // Todo Refactor this when we convert popover component to use hooks


function PopoverChildren(props) {
  var children = props.children,
      onChildChange = props.onChildChange;

  _react["default"].useLayoutEffect(function () {
    if (children) onChildChange();
  }, [children, onChildChange]);

  return children;
}

Popover.types = {
  align: constants.align
};
var propTypes = {
  /** Where the popover content is positioned relative to the trigger or getPositioningElement. */
  align: _propTypes["default"].oneOf([Popover.types.align.TOP, Popover.types.align.RIGHT, Popover.types.align.BOTTOM, Popover.types.align.LEFT]),

  /** Content of the popover */
  children: _propTypes["default"].node.isRequired,

  /** Displays as a "tooltip" style with white text on black background. */
  isDark: _propTypes["default"].bool,

  /** Activated by mouseOver / focus instead of onClick. */
  isEager: _propTypes["default"].bool,

  /** How "controlled" popovers are shown / hidden. */
  isOpen: _propTypes["default"].bool,

  /** This renders the popover inline in the DOM and not in a react portal. WARNING: will have side effects with paprika side panels and modals, use with caution. */
  isPortal: _propTypes["default"].bool,

  /** How "uncontrolled" popovers can be rendered open by default. */
  defaultIsOpen: _propTypes["default"].bool,

  /** Where the edge of the popover content is based on the trigger or getPositioningElement */
  edge: _propTypes["default"].oneOf([Popover.types.align.LEFT, Popover.types.align.RIGHT, null]),

  /** Maximum width of popover content. Using a number is recommended and implies px units. */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Minimumn width of popover content. Using a number is recommended and implies px units. */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Callback to fire when user closes popover. */
  onClose: _propTypes["default"].func,

  /** Distance, in px, between popover content edge and trigger / getPositioningElement. */
  offset: _propTypes["default"].number,

  /** Function that provides DOM element to use as target for positioning the popover. */
  getPositioningElement: _propTypes["default"].func,

  /** Function that provides the scrolling DOM element that contains the popover. */
  getScrollContainer: _propTypes["default"].func,

  /** If focus will stay at the trigger when showing popover. Popover can still be closed when clicking outside or pressing escape key. */
  shouldKeepFocus: _propTypes["default"].bool,

  /** Number setting the z-index for the popover content / tip. */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  align: Popover.types.align.BOTTOM,
  isDark: false,
  isEager: false,
  isOpen: null,
  isPortal: true,
  defaultIsOpen: null,
  edge: null,
  maxWidth: 320,
  minWidth: 0,
  onClose: null,
  offset: (0, _parseInt2["default"])(_tokens["default"].spaceLg, 10),
  getPositioningElement: null,
  getScrollContainer: null,
  shouldKeepFocus: false,
  zIndex: (0, _helpers.zValue)(1)
};
Popover.displayName = "Popover";
Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
Popover.Trigger = _Trigger["default"];
Popover.Content = _Content["default"];
Popover.Card = _Card["default"];
Popover.Tip = _Tip["default"];
var _default = Popover;
exports["default"] = _default;
//# sourceMappingURL=Popover.js.map

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LEFT = exports.BOTTOM = exports.RIGHT = exports.TOP = void 0;

var constants = _interopRequireWildcard(__webpack_require__(40));

var TOP = constants.align.TOP;
exports.TOP = TOP;
var RIGHT = constants.align.RIGHT;
exports.RIGHT = RIGHT;
var BOTTOM = constants.align.BOTTOM;
exports.BOTTOM = BOTTOM;
var LEFT = constants.align.LEFT;
exports.LEFT = LEFT;
//# sourceMappingURL=types.js.map

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var isInsideBoundaries = function isInsideBoundaries(_ref) {
  var $container = _ref.$container,
      $element = _ref.$element,
      align = _ref.align;

  if ($container && $element) {
    var containerRect = $container.getBoundingClientRect();
    var elementRect = $element.getBoundingClientRect();
    var alignVert = ["bottom", "top"].includes(align); // avoid some weirdness with the tip and with scrollbars
    // we might actually want the dimensions of the Tip to do this right
    // half tip + edgePadding

    var edgeBuffer = {
      vert: alignVert ? 0 : 15,
      horz: alignVert ? 15 : 0
    }; // ¿ maybe just round up to 20 ?

    var scrollbarBuffer = 17;
    var elementLimit = {
      left: alignVert ? elementRect.right - elementRect.width / 2 : elementRect.right,
      right: alignVert ? elementRect.right - elementRect.width / 2 : elementRect.left + scrollbarBuffer,
      top: alignVert ? elementRect.bottom : elementRect.bottom - elementRect.height / 2,
      bottom: alignVert ? elementRect.top + scrollbarBuffer : elementRect.bottom - elementRect.height / 2
    };
    return elementLimit.top - edgeBuffer.vert >= containerRect.top && elementLimit.bottom + edgeBuffer.vert <= containerRect.bottom && elementLimit.right + edgeBuffer.horz <= containerRect.right && elementLimit.left - edgeBuffer.horz >= containerRect.left;
  }

  return true;
};

var _default = isInsideBoundaries;
exports["default"] = _default;
//# sourceMappingURL=isInsideBoundaries.js.map

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.getTipCoordinates = exports.getContentCoordinates = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _isNan = _interopRequireDefault(__webpack_require__(181));

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _customPropTypes = __webpack_require__(1282);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var rotate = {
  top: 180,
  right: 270,
  bottom: 0,
  left: 90
};
var edgePadding = (0, _parseInt["default"])(_tokens["default"].space, 10);

var getAdjustedContentCoordinates = function getAdjustedContentCoordinates(_ref) {
  var x = _ref.x,
      y = _ref.y,
      contentRect = _ref.contentRect,
      targetRect = _ref.targetRect,
      scrollRect = _ref.scrollRect,
      align = _ref.align,
      offset = _ref.offset;
  var viewport = {
    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  };
  var boundary = {
    top: scrollRect ? scrollRect.top : 0,
    right: scrollRect ? Math.min(scrollRect.right, viewport.width) : viewport.width,
    bottom: scrollRect ? Math.min(scrollRect.bottom, viewport.height) : viewport.height,
    left: scrollRect ? scrollRect.left : 0
  };
  var alignVert = ["bottom", "top"].includes(align);
  var isOnRightSide = targetRect.x + targetRect.width / 2 > boundary.left + (boundary.right - boundary.left) / 2;
  var isOnBottomHalf = targetRect.y + targetRect.height / 2 > boundary.top + (boundary.bottom - boundary.top) / 2;
  var overflowsViewportLeft = x < boundary.left;
  var overflowsViewportRight = x + contentRect.width > boundary.right;
  var overflowsViewportTop = y < boundary.top;
  var overflowsViewportBottom = y + contentRect.height > boundary.bottom;
  var newX = (0, _isNan["default"])(x) ? 0 : x;
  var newY = (0, _isNan["default"])(y) ? 0 : y;

  if (overflowsViewportLeft && !isOnRightSide) {
    newX = alignVert ? boundary.left + edgePadding : newX = targetRect.x + targetRect.width + offset;
  }

  if (overflowsViewportRight && isOnRightSide) {
    newX = alignVert ? boundary.right - contentRect.width - edgePadding : targetRect.x - contentRect.width - offset;
  }

  if (overflowsViewportTop && !isOnBottomHalf) {
    newY = alignVert ? targetRect.y + targetRect.height + offset : boundary.top + edgePadding;
  }

  if (overflowsViewportBottom && isOnBottomHalf) {
    newY = alignVert ? y - (contentRect.height + offset * 2 + targetRect.height) : boundary.bottom - contentRect.height - edgePadding;
  }

  return {
    x: newX,
    y: newY
  };
};

var getAnchor = function getAnchor(rect, align) {
  var positions = {
    top: function top() {
      return {
        x: rect.left + rect.width / 2,
        y: rect.top
      };
    },
    right: function right() {
      return {
        x: rect.right,
        y: rect.y + rect.height / 2
      };
    },
    bottom: function bottom() {
      return {
        x: rect.left + rect.width / 2,
        y: rect.y + rect.height
      };
    },
    left: function left() {
      return {
        x: rect.left,
        y: rect.y + rect.height / 2
      };
    }
  };
  return positions[align]();
};

var getContentCoordinates = function getContentCoordinates(_ref2) {
  var _alignedPosition;

  var rect = _ref2.rect,
      targetRect = _ref2.targetRect,
      scrollRect = _ref2.scrollRect,
      align = _ref2.align,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 12 : _ref2$offset,
      edge = _ref2.edge;
  var anchor = getAnchor(targetRect, align);

  var getContentXByEdge = function getContentXByEdge() {
    if (edge === _customPropTypes.AlignTypes.LEFT) {
      return anchor.x - targetRect.width / 2;
    }

    if (edge === _customPropTypes.AlignTypes.RIGHT) {
      return anchor.x - rect.width + targetRect.width / 2;
    }

    return anchor.x - rect.width / 2;
  };

  var alignedPosition = (_alignedPosition = {}, (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.TOP, function () {
    return getAdjustedContentCoordinates({
      x: getContentXByEdge(),
      y: anchor.y - (rect.height + offset),
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.RIGHT, function () {
    return getAdjustedContentCoordinates({
      x: anchor.x + offset,
      y: anchor.y - rect.height / 2,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.BOTTOM, function () {
    return getAdjustedContentCoordinates({
      x: getContentXByEdge(),
      y: anchor.y + offset,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _customPropTypes.AlignTypes.LEFT, function () {
    return getAdjustedContentCoordinates({
      x: anchor.x - rect.width - offset,
      y: anchor.y - rect.height / 2,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), _alignedPosition);
  return alignedPosition[align]();
}; // The default value of 1.2 pixels for offset is to ensure a small overlap so that at certain browser zoom levels
// we do not see a slim piece of the underlying content (Popover.Card border)


exports.getContentCoordinates = getContentCoordinates;

var getTipCoordinates = function getTipCoordinates(_ref3) {
  var tipRect = _ref3.tipRect,
      targetRect = _ref3.targetRect,
      contentRect = _ref3.contentRect,
      contentCoords = _ref3.contentCoords,
      align = _ref3.align,
      _ref3$offset = _ref3.offset,
      offset = _ref3$offset === void 0 ? -1.2 : _ref3$offset;
  var alignedPosition = {
    top: function top() {
      return {
        x: targetRect.x + targetRect.width / 2 - tipRect.width / 2,
        y: contentCoords.y + contentRect.height + offset
      };
    },
    right: function right() {
      return {
        x: contentCoords.x - tipRect.width - offset,
        y: targetRect.y + targetRect.height / 2 - tipRect.height / 2
      };
    },
    bottom: function bottom() {
      return {
        x: targetRect.x + targetRect.width / 2 - tipRect.width / 2,
        y: contentCoords.y - tipRect.height - offset
      };
    },
    left: function left() {
      return {
        x: contentCoords.x + contentRect.width + offset,
        y: targetRect.y + targetRect.height / 2 - tipRect.height / 2
      };
    }
  };
  var tipAlign = {
    top: function top() {
      return contentCoords.y > targetRect.y ? "bottom" : align;
    },
    right: function right() {
      return contentCoords.x < targetRect.x ? "left" : align;
    },
    bottom: function bottom() {
      return contentCoords.y < targetRect.y ? "top" : align;
    },
    left: function left() {
      return contentCoords.x > targetRect.x ? "right" : align;
    }
  };
  var adjustedAlign = tipAlign[align]();
  return _objectSpread(_objectSpread({}, alignedPosition[adjustedAlign]()), {}, {
    rotate: rotate[adjustedAlign]
  });
};

exports.getTipCoordinates = getTipCoordinates;
//# sourceMappingURL=getPosition.js.map

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RefOf = exports.FocusPropTypes = exports.InputValidTypes = exports.deprecated = exports.AlignTypes = exports.ShirtSizes = void 0;

var _values = _interopRequireDefault(__webpack_require__(96));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

// NOTE: Maybe this should be provided as a consumable package?
var ShirtSizes = {
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge"
};
exports.ShirtSizes = ShirtSizes;
ShirtSizes.DEFAULT = [ShirtSizes.SMALL, ShirtSizes.MEDIUM, ShirtSizes.LARGE];
ShirtSizes.LIMITED = [ShirtSizes.SMALL, ShirtSizes.MEDIUM];
ShirtSizes.ALL = (0, _values["default"])(ShirtSizes);
var AlignTypes = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left"
};
exports.AlignTypes = AlignTypes;
AlignTypes.ALL = (0, _values["default"])(AlignTypes);

var deprecated = function deprecated(name) {
  return function (props, propName, component) {
    if (props[propName] !== undefined) {
      return new Error("Deprecated prop '".concat(propName, "' supplied to ").concat(component, ". Use '").concat(name, "' instead."));
    }

    return null;
  };
};

exports.deprecated = deprecated;
var InputValidTypes = {
  EMAIL: "email",
  NUMBER: "number",
  PASSWORD: "password",
  SEARCH: "search",
  TELEPHONE: "tel",
  TEXT: "text",
  URL: "url"
};
exports.InputValidTypes = InputValidTypes;
var FocusPropTypes = {
  // properties copy from https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/src/Lock.js#L160
  // see description for props here: https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/interfaces.d.ts#L4
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  returnFocus: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
  noFocusGuards: _propTypes["default"].bool,
  allowTextSelection: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  persistentFocus: _propTypes["default"].bool,
  group: _propTypes["default"].string,
  className: _propTypes["default"].string,
  whiteList: _propTypes["default"].func,
  shards: _propTypes["default"].arrayOf(_propTypes["default"].any),
  as: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  lockProps: _propTypes["default"].object,
  onActivation: _propTypes["default"].func,
  onDeactivation: _propTypes["default"].func,
  sideCar: _propTypes["default"].any
};
exports.FocusPropTypes = FocusPropTypes;
InputValidTypes.ALL = (0, _values["default"])(InputValidTypes);

var RefOf = function RefOf() {
  var propType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _propTypes["default"].object;
  return _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: propType
  })]);
};

exports.RefOf = RefOf;
//# sourceMappingURL=customPropTypes.js.map

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = getBoundingClientRect;

function getBoundingClientRect(el) {
  var rect = el.getBoundingClientRect();
  var x;
  var y;

  if (rect.x === undefined) {
    x = rect.left;
  } else {
    x = rect.x;
  }

  if (rect.y === undefined) {
    y = rect.top;
  } else {
    y = rect.y;
  }

  return {
    left: rect.left,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    x: x,
    y: y,
    width: rect.width,
    height: rect.height
  };
}
//# sourceMappingURL=getBoundingClientRect.js.map

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _parseInt2 = _interopRequireDefault(__webpack_require__(112));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _isElementContainsFocus = _interopRequireDefault(__webpack_require__(1285));

var _PopoverContext = _interopRequireDefault(__webpack_require__(510));

var _Popover = __webpack_require__(511);

var _Content = __webpack_require__(1288);

var propTypes = {
  children: _propTypes["default"].node,

  /** Callback to indicate the element loses focus */
  onBlur: _propTypes["default"].func
};
var defaultProps = {
  children: null,
  onBlur: function onBlur() {}
};

var Content = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onBlur = props.onBlur,
      children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["onBlur", "children"]);

  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      isEager = _React$useContext.isEager,
      isOpen = _React$useContext.isOpen,
      isPortal = _React$useContext.isPortal,
      onClose = _React$useContext.onClose,
      onDelayedClose = _React$useContext.onDelayedClose,
      onDelayedOpen = _React$useContext.onDelayedOpen,
      portalElement = _React$useContext.portalElement,
      refContent = _React$useContext.refContent; // TODO: extract this to Storybook story somehow so supporting numbers as strings is not required


  function isNumber(n) {
    return RegExp(/^[0-9]+$/).test(n);
  }

  function handleMouseEvent(event) {
    if (!isEager) return;

    if (event.type === "mouseover") {
      onDelayedOpen();
    } else if (event.type === "mouseout") {
      onDelayedClose();
    }
  }

  function handleBlur(event) {
    // onblur canceling onclick the following happens when:
    // Clicking twice the trigger button (open, close), will fire an onclick and onblur event
    // creating a race condition nullyfing the onClick and keeping the popover open
    // https://stackoverflow.com/questions/121499/when-a-blur-event-occurs-how-can-i-find-out-which-element-focus-went-to
    // the previous link answer suggested the use of the mouseDown event, thought, that will kill all accessibility of onClick,
    // as well will affect the devUX when you want to have a controlled Popover forcing the use of mouseDown event instead of onClick
    // Solution https://stackoverflow.com/a/121708/196038
    // Use timeout to delay examination of activeElement until after blur/focus
    // events have been processed.
    var currentTarget = event.currentTarget;
    setTimeout(function () {
      if (!(0, _isElementContainsFocus["default"])(currentTarget)) {
        onClose();
        onBlur();
      }
    }, (0, _parseInt2["default"])(_Popover.consts.transition, 10));
  }

  function cssValue(value) {
    return isNumber(value) ? "".concat(value, "px") : value;
  }

  var handleRef = function handleRef(_ref) {
    refContent(_ref);

    if (ref) {
      // https://github.com/reactjs/rfcs/blob/master/text/0017-new-create-ref.md#basic-example
      ref.current = _ref; // eslint-disable-line
    }
  };

  var contentStyles = {
    left: content.x,
    top: content.y,
    maxWidth: cssValue(content.maxWidth),
    minWidth: cssValue(content.minWidth)
  };

  if (content.width && content.width !== "auto") {
    contentStyles.width = content.width;
  }
  /* eslint-disable jsx-a11y/mouse-events-have-key-events */


  var ContentStyledComponent = /*#__PURE__*/_react["default"].createElement(_Content.ContentStyled, (0, _extends2["default"])({
    "aria-hidden": !isOpen,
    "data-component-name": "PopoverContent",
    "data-pka-anchor": "popover.content",
    ref: handleRef,
    id: isEager ? content.ariaId : null,
    isOpen: isOpen,
    onBlur: handleBlur,
    onMouseOut: handleMouseEvent,
    onMouseOver: handleMouseEvent,
    style: contentStyles,
    tabIndex: "-1",
    zIndex: content.zIndex
  }, moreProps), props.children);

  if (isPortal) {
    return /*#__PURE__*/_reactDom["default"].createPortal(ContentStyledComponent, portalElement);
  }

  return ContentStyledComponent;
});
/* eslint-enable jsx-a11y/mouse-events-have-key-events */


Content.displayName = "Popover.Content";
Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
var _default = Content;
exports["default"] = _default;
//# sourceMappingURL=Content.js.map

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var isElementContainsFocus = function isElementContainsFocus(element) {
  if (document.activeElement === element) return true;
  return element.contains(document.activeElement);
};

var _default = isElementContainsFocus;
exports["default"] = _default;
//# sourceMappingURL=isElementContainsFocus.js.map

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(62);

var sc = _interopRequireWildcard(__webpack_require__(1287));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** If the visual focus ring should be displayed with an inset style. */
  hasInsetFocusStyle: _propTypes["default"].bool,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  isActive: null,
  isDisabled: false,
  hasInsetFocusStyle: false,
  onClick: function onClick() {},
  role: "button",
  tabIndex: null
};

var isTriggerKey = function isTriggerKey(key) {
  return [" ", "Enter"].includes(key);
};

var RawButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      onClick = props.onClick,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "isActive", "isDisabled", "onClick", "tabIndex"]);

  var rawButtonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        rawButtonRef.current.focus();
      }
    };
  });

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);
    if (!canPropagate) event.stopPropagation();
    if (!isDisabled) onClick(event);
  };

  function handleBlur(event) {
    if (moreProps.onBlur) moreProps.onBlur(event);
    setHasForcedFocus(false);
  }

  var handleKeyDown = function handleKeyDown(event) {
    // Prevent scrolling the page with a spacerbar keypress
    // Prevent submitting forms in IE/Edge with and enter keypress
    if (isTriggerKey(event.key)) event.preventDefault();
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;
    if (shouldHandle && moreProps.onKeyDown) moreProps.onKeyDown(event);
  };

  var handleKeyUp = function handleKeyUp(event) {
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;

    if (!isDisabled && shouldHandle && isTriggerKey(event.key)) {
      onClick(event);
    }

    if (shouldHandle && moreProps.onKeyUp) moreProps.onKeyUp(event);
  };

  var bestTabIndex = isDisabled && tabIndex === null ? -1 : tabIndex || 0;
  return /*#__PURE__*/_react["default"].createElement(sc.RawButton, (0, _extends2["default"])({
    "aria-pressed": isActive,
    "data-pka-anchor": "raw-button",
    tabIndex: bestTabIndex,
    "aria-label": a11yText
  }, moreProps, {
    "aria-disabled": isDisabled,
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isDisabled,
    onBlur: handleBlur,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: rawButtonRef
  }), children);
});

RawButton.displayName = "RawButton";
RawButton.propTypes = propTypes;
RawButton.defaultProps = defaultProps;
var _default = RawButton;
exports["default"] = _default;
//# sourceMappingURL=RawButton.js.map

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RawButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var focusStyles = function focusStyles(isInset) {
  return (0, _styledComponents.css)(["&:focus{", "}[data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{box-shadow:none;outline:none;}"], _stylers["default"].focusRing(isInset));
};

var disabledStyles = (0, _styledComponents.css)(["cursor:not-allowed;&:focus{box-shadow:none;}"]);

var RawButton = _styledComponents["default"].span.withConfig({
  displayName: "RawButtonstyles__RawButton",
  componentId: "sc-1jqcbbw-0"
})(function (_ref) {
  var hasInsetFocusStyle = _ref.hasInsetFocusStyle,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["cursor:pointer;display:inline-block;", ";", ";"], isActive ? _stylers["default"].focusRing(hasInsetFocusStyle) : focusStyles(hasInsetFocusStyle), isDisabled && disabledStyles);
});

exports.RawButton = RawButton;
//# sourceMappingURL=RawButton.styles.js.map

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ContentStyled = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _Popover = __webpack_require__(511);

var ContentStyled = _styledComponents["default"].div.withConfig({
  displayName: "Contentstyles__ContentStyled",
  componentId: "sc-1abapfp-0"
})(["opacity:", ";position:fixed;transition:opacity ", " ease,visibility ", " ease;visibility:", ";z-index:", ";&:focus{outline:none;}"], function (props) {
  return props.isOpen ? 1 : 0;
}, _Popover.consts.transition, _Popover.consts.transition, function (props) {
  return props.isOpen ? "visible" : "hidden";
}, function (props) {
  return props.zIndex;
});

exports.ContentStyled = ContentStyled;
//# sourceMappingURL=Content.styles.js.map

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _PopoverContext = __webpack_require__(510);

var _Card = _interopRequireDefault(__webpack_require__(1290));

function Card(props) {
  var children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children"]);

  var isDark = _react["default"].useContext(_PopoverContext.ThemeContext);

  return /*#__PURE__*/_react["default"].createElement(_Card["default"], (0, _extends2["default"])({
    isDark: isDark,
    "data-pka-anchor": "popover.card"
  }, moreProps), children);
}

Card.displayName = "Popover.Card";
Card.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = Card;
exports["default"] = _default;
//# sourceMappingURL=Card.js.map

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var defaultStyles = "\n  background-color: ".concat(_tokens["default"].color.white, ";\n  border: 1px solid ").concat(_tokens["default"].border.color, ";\n  border-radius: ").concat(_tokens["default"].card.borderRadius, ";\n  box-shadow: ").concat(_tokens["default"].shadow, ";\n  color: ").concat(_tokens["default"].textColor["default"], ";\n  padding: ").concat(_tokens["default"].space, " ").concat(_tokens["default"].spaceLg, ";\n");
var darkStyles = "\n  background-color: ".concat(_tokens["default"].color.black, ";\n  border: 1px solid ").concat(_tokens["default"].color.black, ";\n  border-radius: ").concat(_tokens["default"].border.radius, ";\n  color: ").concat(_tokens["default"].color.white, ";\n  padding: ").concat(_tokens["default"].spaceSm, " ").concat(_tokens["default"].space, ";\n");

var CardStyled = _styledComponents["default"].div.withConfig({
  displayName: "Cardstyles__CardStyled",
  componentId: "sc-1penuek-0"
})(["", ";", ";", ";overflow:hidden;"], function (props) {
  return props.isDark ? darkStyles : defaultStyles;
}, _stylers["default"].fontSize(-1), _stylers["default"].lineHeight());

var _default = CardStyled;
exports["default"] = _default;
//# sourceMappingURL=Card.styles.js.map

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _rawButton = _interopRequireDefault(__webpack_require__(512));

var _isActiveElementPopover = __webpack_require__(1292);

var _PopoverContext = _interopRequireDefault(__webpack_require__(510));

var sc = _interopRequireWildcard(__webpack_require__(511));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var propTypes = {
  /** Descriptive a11y text for assistive technologies for the trigger. */
  a11yText: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]).isRequired
};
var defaultProps = {
  a11yText: null
};

function Trigger(props) {
  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      isEager = _React$useContext.isEager,
      isOpen = _React$useContext.isOpen,
      onClick = _React$useContext.onClick,
      onClose = _React$useContext.onClose,
      onDelayedClose = _React$useContext.onDelayedClose,
      onDelayedOpen = _React$useContext.onDelayedOpen,
      onOpen = _React$useContext.onOpen,
      shouldKeepFocus = _React$useContext.shouldKeepFocus;

  function handleTriggerEvent(event) {
    if (isEager && (event.type === "mouseover" || event.type === "focus")) {
      if (event.type === "mouseover") {
        onDelayedOpen();
      } else {
        onOpen();
      }
    } else if (isEager && event.type === "mouseout") {
      onDelayedClose();
    } else if ((shouldKeepFocus || isEager) && event.type === "blur") {
      window.requestAnimationFrame(function () {
        if (!(0, _isActiveElementPopover.isActiveElementPopover)()) onClose();
      });
    } else if (event.type === "click" || event.key === " " || event.key === "Enter") {
      onClick();
    }
  }

  var children = props.children,
      a11yText = props.a11yText,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "a11yText"]);

  if (typeof children === "function") {
    var a11yAttributes = {
      "aria-describedby": content.ariaId
    };
    return /*#__PURE__*/_react["default"].cloneElement(children(handleTriggerEvent, a11yAttributes, isOpen), _objectSpread({}, moreProps));
  }

  if (isEager) {
    return /*#__PURE__*/_react["default"].createElement(sc.Trigger, (0, _extends2["default"])({
      a11yText: a11yText,
      "data-pka-anchor": "popover.trigger",
      onMouseOver: handleTriggerEvent,
      onMouseOut: handleTriggerEvent,
      onFocus: handleTriggerEvent,
      onBlur: handleTriggerEvent,
      "aria-describedby": content.ariaId
    }, moreProps), children);
  }

  return /*#__PURE__*/_react["default"].createElement(_rawButton["default"], (0, _extends2["default"])({
    a11yText: a11yText,
    "data-pka-anchor": "popover.trigger",
    onClick: handleTriggerEvent,
    onBlur: shouldKeepFocus ? handleTriggerEvent : null
  }, moreProps), children);
}

Trigger.displayName = "Popover.Trigger";
Trigger.propTypes = propTypes;
Trigger.defaultProps = defaultProps;
var _default = Trigger;
exports["default"] = _default;
//# sourceMappingURL=Trigger.js.map

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isActiveElementPopover = void 0;

var isActiveElementPopover = function isActiveElementPopover() {
  return document.activeElement.dataset.componentName === "PopoverContent";
};

exports.isActiveElementPopover = isActiveElementPopover;
//# sourceMappingURL=isActiveElementPopover.js.map

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _PopoverContext = _interopRequireWildcard(__webpack_require__(510));

var _Tip = __webpack_require__(1294);

var propTypes = {
  /** Number setting the z-index */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  zIndex: null
};

function Tip(props) {
  var zIndex = props.zIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["zIndex"]);

  var isDark = _react["default"].useContext(_PopoverContext.ThemeContext);

  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      tip = _React$useContext.tip,
      refTip = _React$useContext.refTip,
      isOpen = _React$useContext.isOpen,
      isPortal = _React$useContext.isPortal,
      portalElement = _React$useContext.portalElement;

  var borderColor = isDark ? _tokens["default"].color.black : _tokens["default"].border.color;
  var backgroundColor = isDark ? _tokens["default"].color.black : _tokens["default"].color.white;

  var TipStyledComponent = /*#__PURE__*/_react["default"].createElement(_Tip.TipStyled, (0, _extends2["default"])({
    isOpen: isOpen,
    "data-pka-anchor": "popover.tip",
    ref: refTip,
    rotate: tip.rotate,
    style: {
      left: tip.x,
      top: tip.y
    },
    zIndex: zIndex || content.zIndex
  }, moreProps), /*#__PURE__*/_react["default"].createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "0 0 12 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "0 12 12 12 6 6",
    fill: borderColor
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "1 12 11 12 6 7",
    fill: backgroundColor
  })));

  if (isPortal) {
    return /*#__PURE__*/_reactDom["default"].createPortal(TipStyledComponent, portalElement);
  }

  return TipStyledComponent;
}

Tip.displayName = "Popover.Tip";
Tip.propTypes = propTypes;
Tip.defaultProps = defaultProps;
var _default = Tip;
exports["default"] = _default;
//# sourceMappingURL=Tip.js.map

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TipStyled = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Popover = __webpack_require__(511);

var TipStyled = _styledComponents["default"].div.withConfig({
  displayName: "Tipstyles__TipStyled",
  componentId: "sc-15lrbjo-0"
})(["display:block;height:", ";line-height:", ";opacity:", ";pointer-events:none;position:fixed;transform:rotate(", "deg);transition:opacity ", " ease,visibility ", " ease;visibility:", ";width:", ";z-index:", ";"], _stylers["default"].spacer(2), _stylers["default"].spacer(2), function (props) {
  return props.isOpen ? 1 : 0;
}, function (props) {
  return props.rotate || "0";
}, _Popover.consts.transition, _Popover.consts.transition, function (props) {
  return props.isOpen ? "visible" : "hidden";
}, _stylers["default"].spacer(2), function (props) {
  return props.zIndex;
});

exports.TipStyled = TipStyled;
//# sourceMappingURL=Tip.styles.js.map

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = extractChildren;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(182));

var _isArray = _interopRequireDefault(__webpack_require__(95));

var _react = _interopRequireDefault(__webpack_require__(2));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function extractChildren(children, types) {
  var _children = [];
  var components = {};
  var result;

  if ((0, _isArray["default"])(types)) {
    _react["default"].Children.toArray(children).some(function (child) {
      if (child.type && child.type === _react["default"].Fragment) {
        result = extractChildren(child.props.children, types);
        return true;
      }

      if (child.type && types.includes(child.type.displayName)) {
        if (Object.prototype.hasOwnProperty.call(components, child.type.displayName)) {
          var childs = (0, _isArray["default"])(components[child.type.displayName]) ? [].concat((0, _toConsumableArray2["default"])(components[child.type.displayName]), [child]) : [components[child.type.displayName], child];
          components[child.type.displayName] = childs;
        } else {
          components[child.type.displayName] = child;
        }
      } else {
        _children.push(child);
      }

      return false;
    });

    return result || _objectSpread(_objectSpread({}, components), {}, {
      children: _children
    });
  }

  throw new Error("extractChildren types parameter must be an Array");
}
//# sourceMappingURL=extractChildren.js.map

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Content["default"];
  }
});

var _Content = _interopRequireDefault(__webpack_require__(1297));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Content;

var _react = _interopRequireDefault(__webpack_require__(2));

function Content() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
}

Content.displayName = "OverflowMenu.Content";
//# sourceMappingURL=Content.js.map

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Divider["default"];
  }
});

var _Divider = _interopRequireDefault(__webpack_require__(1299));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Divider;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _Divider = _interopRequireDefault(__webpack_require__(1300));

var _StyledSpan = (0, _styledComponents["default"])("span").withConfig({
  displayName: "Divider___StyledSpan",
  componentId: "yastat-0"
})(["", ""], _Divider["default"]);

function Divider() {
  return /*#__PURE__*/_react["default"].createElement(_StyledSpan, null);
}

Divider.displayName = "OverflowMenu.Divider";
//# sourceMappingURL=Divider.js.map

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _styledComponents = __webpack_require__(4);

var _tokens = _interopRequireDefault(__webpack_require__(27));

var dividerStyles = (0, _styledComponents.css)(["border-top:1px solid ", ";display:block;margin:", " 0;"], _tokens["default"].border.color, _tokens["default"].space);
var _default = dividerStyles;
exports["default"] = _default;
//# sourceMappingURL=Divider.styles.js.map

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Trigger["default"];
  }
});

var _Trigger = _interopRequireDefault(__webpack_require__(1302));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _rawButton = _interopRequireDefault(__webpack_require__(512));

var _button = _interopRequireDefault(__webpack_require__(1303));

var types = _interopRequireWildcard(__webpack_require__(1316));

var ButtonComponentMap = {
  icon: _button["default"].Icon,
  raw: _rawButton["default"],
  simple: _button["default"]
};

function Trigger(props) {
  var children = props.children,
      isOpen = props.isOpen,
      onOpenMenu = props.onOpenMenu,
      menuRefId = props.menuRefId,
      triggerRef = props.triggerRef,
      buttonType = props.buttonType,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["children", "isOpen", "onOpenMenu", "menuRefId", "triggerRef", "buttonType"]);
  var TriggerComponent = ButtonComponentMap[buttonType];
  return /*#__PURE__*/_react["default"].createElement(TriggerComponent, (0, _extends2["default"])({
    ref: triggerRef,
    "aria-controls": menuRefId,
    "aria-expanded": isOpen,
    "aria-haspopup": "true",
    onClick: onOpenMenu,
    isSemantic: false
  }, otherProps), children);
}

Trigger.types = {
  button: types.buttonTypes
};
var propTypes = {
  children: _propTypes["default"].node,

  /** Determine the styling of the button */
  buttonType: _propTypes["default"].oneOf([Trigger.types.button.ICON, Trigger.types.button.RAW, Trigger.types.button.SIMPLE]),
  isOpen: _propTypes["default"].bool,
  menuRefId: _propTypes["default"].string,
  onOpenMenu: _propTypes["default"].func,
  triggerRef: _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Object)
  }) || null
};
var defaultProps = {
  buttonType: Trigger.types.button.SIMPLE,
  children: null,
  menuRefId: "",
  triggerRef: null,
  isOpen: false,
  onOpenMenu: function onOpenMenu() {}
};
Trigger.displayName = "OverflowMenu.Trigger";
Trigger.defaultProps = defaultProps;
Trigger.propTypes = propTypes;
var _default = Trigger;
exports["default"] = _default;
//# sourceMappingURL=Trigger.js.map

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button["default"];
  }
});

var _Button = _interopRequireDefault(__webpack_require__(570));

var _Close = _interopRequireDefault(__webpack_require__(1307));

var _Icon = _interopRequireDefault(__webpack_require__(750));

var _Link = _interopRequireDefault(__webpack_require__(1313));

_Button["default"].Close = _Close["default"];
_Button["default"].Icon = _Icon["default"];
_Button["default"].Link = _Link["default"];
//# sourceMappingURL=index.js.map

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "Refresh___StyledSvg",
  componentId: "sc-1sctrs9-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgRefresh = function SvgRefresh(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.931 6.069L15.15 8.85h6.3v-6.3l-2.035 2.035A10.425 10.425 0 0012 1.5C6.21 1.5 1.5 6.21 1.5 12h2.1c0-4.632 3.768-8.4 8.4-8.4 2.28 0 4.385.915 5.931 2.469zM6.07 17.93L8.85 15.15h-6.3v6.3l2.034-2.035A10.427 10.427 0 0012 22.5c5.79 0 10.5-4.71 10.5-10.5h-2.1c0 4.632-3.768 8.4-8.4 8.4a8.334 8.334 0 01-5.931-2.469z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgRefresh;
exports["default"] = _default;
//# sourceMappingURL=Refresh.js.map

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "CaretDown___StyledSvg",
  componentId: "dw438p-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgCaretDown = function SvgCaretDown(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.099 15.258a1.501 1.501 0 01-2.223 0c-1.41-1.554-3.83-4.22-5.256-5.789a.753.753 0 01.556-1.257h11.623a.751.751 0 01.556 1.257l-5.256 5.789z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgCaretDown;
exports["default"] = _default;
//# sourceMappingURL=CaretDown.js.map

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest

/* eslint-disable func-names */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  };
}
/* eslint-enable func-names */
//# sourceMappingURL=closest.js.map

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Close["default"];
  }
});

var _Close = _interopRequireDefault(__webpack_require__(1308));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Times = _interopRequireDefault(__webpack_require__(1309));

var constants = _interopRequireWildcard(__webpack_require__(40));

var types = _interopRequireWildcard(__webpack_require__(571));

var sc = _interopRequireWildcard(__webpack_require__(1310));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If the close button will be rendered on a dark background and will use inverted colours. */
  isDark: _propTypes["default"].bool
};
var defaultProps = {
  a11yText: null,
  isDark: false
};

var Close = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    a11yText: props.a11yText || "close",
    // TODO: use L10n
    isDark: props.isDark,
    kind: types.MINOR
  };
  return /*#__PURE__*/_react["default"].createElement(sc.CloseButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_Times["default"], null));
});

Close.types = {
  kind: constants.kind
};
Close.displayName = "Button.Close";
Close.propTypes = propTypes;
Close.defaultProps = defaultProps;
var _default = Close;
exports["default"] = _default;
//# sourceMappingURL=Close.js.map

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "Times___StyledSvg",
  componentId: "sc-1hngl9r-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var SvgTimes = function SvgTimes(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.743 9.029L20.27 1.5 22.5 3.728l-7.529 7.53a1.05 1.05 0 000 1.485l7.529 7.529-2.229 2.228-7.528-7.529a1.05 1.05 0 00-1.486 0L3.728 22.5 1.5 20.272l7.529-7.53a1.05 1.05 0 000-1.485L1.5 3.728 3.728 1.5l7.53 7.529c.41.41 1.074.41 1.485 0z",
    fillRule: "evenodd",
    fill: "currentColor"
  }));
};

var _default = SvgTimes;
exports["default"] = _default;
//# sourceMappingURL=Times.js.map

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CloseButton = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Icon = _interopRequireDefault(__webpack_require__(750));

var darkStyles = (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;&:hover{background-color:", ";[data-pka-anchor=\"button.icon\"]{color:", ";}}&:active{background-color:", ";transition:none;[data-pka-anchor=\"button.icon\"]{color:", ";transition:none;}}[data-pka-anchor=\"button.icon\"]{color:", ";transition:color 0.2s ease-out;}"], _stylers["default"].alpha(_tokens["default"].color.white, 0.2), _tokens["default"].color.white, _stylers["default"].alpha(_tokens["default"].color.white, 0.3), _tokens["default"].color.white, _tokens["default"].color.blackLighten50);
var CloseButton = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "CloseButtonstyles__CloseButton",
  componentId: "sc-17tyw7-0"
})(function (_ref) {
  var isDark = _ref.isDark;
  return (0, _styledComponents.css)(["[data-pka-anchor=\"button.icon\"]{color:", ";}", ""], _tokens["default"].textColor.icon, isDark ? darkStyles : "");
});
exports.CloseButton = CloseButton;
//# sourceMappingURL=CloseButton.styles.js.map

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var constants = _interopRequireWildcard(__webpack_require__(40));

var sc = _interopRequireWildcard(__webpack_require__(1312));

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    children: null,
    icon: props.children,
    isFullWidth: false
  };
  return /*#__PURE__*/_react["default"].createElement(sc.IconButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }));
});

Icon.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var IconPropTypes = {
  /** Body content of the button (an icon). */
  children: _propTypes["default"].node.isRequired,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Icon.types.kind.DEFAULT, Icon.types.kind.PRIMARY, Icon.types.kind.SECONDARY, Icon.types.kind.DESTRUCTIVE, Icon.types.kind.FLAT, Icon.types.kind.MINOR, Icon.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Icon.types.size.SMALL, Icon.types.size.MEDIUM, Icon.types.size.LARGE])
};
var IconDefaultProps = {
  kind: Icon.types.kind.DEFAULT,
  size: Icon.types.size.MEDIUM
};
Icon.displayName = "Button.Icon";
Icon.propTypes = IconPropTypes;
Icon.defaultProps = IconDefaultProps;
var _default = Icon;
exports["default"] = _default;
//# sourceMappingURL=Icon.js.map

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _interopRequireWildcard = __webpack_require__(5);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.IconButton = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _parseInt = _interopRequireDefault(__webpack_require__(44));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Button = _interopRequireDefault(__webpack_require__(570));

var types = _interopRequireWildcard(__webpack_require__(571));

var _iconButtonSizes;

var iconButtonSizes = (_iconButtonSizes = {}, (0, _defineProperty2["default"])(_iconButtonSizes, types.SMALL, (0, _styledComponents.css)(["font-size:14px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(3), (0, _parseInt["default"])(_tokens["default"].space, 10) * 3 - 2, _stylers["default"].spacer(3))), (0, _defineProperty2["default"])(_iconButtonSizes, types.MEDIUM, (0, _styledComponents.css)(["font-size:18px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(4), (0, _parseInt["default"])(_tokens["default"].space, 10) * 4 - 2, _stylers["default"].spacer(4))), (0, _defineProperty2["default"])(_iconButtonSizes, types.LARGE, (0, _styledComponents.css)(["font-size:22px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(5), (0, _parseInt["default"])(_tokens["default"].space, 10) * 5 - 2, _stylers["default"].spacer(5))), _iconButtonSizes);

var minorStyles = function minorStyles(_ref) {
  var isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;", ""], isDisabled ? (0, _styledComponents.css)(["&,&:hover,&:active{[data-pka-anchor=\"button.icon\"] svg{color:", ";}}"], _tokens["default"].color.blackDisabled) : (0, _styledComponents.css)(["&:hover{background-color:", ";}&:active{background-color:", ";}"], _stylers["default"].alpha(_tokens["default"].color.black, 0.1), _stylers["default"].alpha(_tokens["default"].color.black, 0.2)));
};

var IconButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "IconButtonstyles__IconButton",
  componentId: "sc-1rmwp4p-0"
})(function (_ref2) {
  var size = _ref2.size,
      kind = _ref2.kind;
  return (0, _styledComponents.css)(["", " ", " [data-pka-anchor=\"button.icon\"]{color:inherit;margin:0;}"], iconButtonSizes[size], kind === types.MINOR ? minorStyles : "");
});
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.styles.js.map

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Link["default"];
  }
});

var _Link = _interopRequireDefault(__webpack_require__(1314));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _NewTab = _interopRequireDefault(__webpack_require__(751));

var constants = _interopRequireWildcard(__webpack_require__(40));

var types = _interopRequireWildcard(__webpack_require__(571));

var sc = _interopRequireWildcard(__webpack_require__(1315));

var _Button = __webpack_require__(570);

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      children = props.children,
      href = props.href,
      isDisabled = props.isDisabled,
      shouldOpenNewTab = props.shouldOpenNewTab,
      kind = props.kind,
      icon = props.icon,
      size = props.size,
      suffixIcon = props.suffixIcon,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "href", "isDisabled", "shouldOpenNewTab", "kind", "icon", "size", "suffixIcon"]);
  var shouldOpenNewTabProps = {
    target: "_blank",
    rel: "noopener noreferrer"
  };

  function renderSuffix(_ref) {
    var kind = _ref.kind,
        isDisabled = _ref.isDisabled,
        suffixIcon = _ref.suffixIcon,
        shouldOpenNewTab = _ref.shouldOpenNewTab;

    if (kind === types.LINK && shouldOpenNewTab && suffixIcon) {
      return /*#__PURE__*/_react["default"].createElement(sc.LinkButtonIcon, {
        isDisabled: isDisabled,
        kind: types.LINK,
        isSuffixIcon: true
      }, suffixIcon);
    }

    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(sc.LinkButton, (0, _extends2["default"])({
    "aria-disabled": isDisabled,
    "aria-label": a11yText,
    href: !isDisabled ? href : null,
    isDisabled: isDisabled,
    kind: kind,
    size: size
  }, shouldOpenNewTab ? shouldOpenNewTabProps : {}, moreProps, {
    as: isDisabled ? "span" : "a",
    ref: ref
  }), icon ? /*#__PURE__*/_react["default"].createElement(_Button.ButtonIcon, {
    isDisabled: isDisabled
  }, icon) : null, children, renderSuffix(props));
});

Link.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** Url for the link. */
  href: _propTypes["default"].string.isRequired,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Link.types.kind.DEFAULT, Link.types.kind.PRIMARY, Link.types.kind.SECONDARY, Link.types.kind.DESTRUCTIVE, Link.types.kind.FLAT, Link.types.kind.MINOR, Link.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Link.types.size.SMALL, Link.types.size.MEDIUM, Link.types.size.LARGE]),

  /** Whether the link should open a new tab. */
  shouldOpenNewTab: _propTypes["default"].bool,

  /** Size of the button (font size, min-height, padding, etc). */
  suffixIcon: _propTypes["default"].node
};
var defaultProps = {
  a11yText: null,
  icon: null,
  isDisabled: false,
  kind: Link.types.kind.LINK,
  shouldOpenNewTab: false,
  size: Link.types.size.MEDIUM,
  suffixIcon: /*#__PURE__*/_react["default"].createElement(_NewTab["default"], null)
};
Link.displayName = "Button.Link";
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;
var _default = Link;
exports["default"] = _default;
//# sourceMappingURL=Link.js.map

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(5);

var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LinkButtonIcon = exports.LinkButton = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireWildcard(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var _Button = __webpack_require__(749);

var _Button2 = __webpack_require__(570);

var LinkButton = _styledComponents["default"].a.withConfig({
  displayName: "LinkButtonstyles__LinkButton",
  componentId: "fsc7ri-0"
})(function (_ref) {
  var size = _ref.size,
      kind = _ref.kind,
      isFullWidth = _ref.isFullWidth,
      isActive = _ref.isActive,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "kind", "isFullWidth", "isActive"]);
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], _Button.commonStyles, _Button.sizeStyles[size], (0, _Button.kindStyles)(props)[kind], isFullWidth && _Button.fullWidthStyles, isActive ? _Button.activeStyles : _Button.inactiveStyles);
});

exports.LinkButton = LinkButton;
var LinkButtonIcon = (0, _styledComponents["default"])(_Button2.ButtonIcon).withConfig({
  displayName: "LinkButtonstyles__LinkButtonIcon",
  componentId: "fsc7ri-1"
})(["", " color:", ";margin-top:-", ";"], _stylers["default"].fontSize(-3), _tokens["default"].textColor.icon, _tokens["default"].spaceSm);
exports.LinkButtonIcon = LinkButtonIcon;
//# sourceMappingURL=LinkButton.styles.js.map

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.buttonTypes = void 0;
var buttonTypes = {
  ICON: "icon",
  RAW: "raw",
  SIMPLE: "simple"
};
exports.buttonTypes = buttonTypes;
//# sourceMappingURL=types.js.map

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _LinkItem["default"];
  }
});

var _LinkItem = _interopRequireDefault(__webpack_require__(1318));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty2 = __webpack_require__(0);

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(0));

var _defineProperties = _interopRequireDefault(__webpack_require__(22));

var _getOwnPropertyDescriptors = _interopRequireDefault(__webpack_require__(23));

var _getOwnPropertyDescriptor = _interopRequireDefault(__webpack_require__(17));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(15));

var _keys = _interopRequireDefault(__webpack_require__(13));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _NewTab = _interopRequireDefault(__webpack_require__(751));

var _useI18n = _interopRequireDefault(__webpack_require__(174));

var _Item = _interopRequireDefault(__webpack_require__(752));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var bool = _propTypes["default"].bool,
    node = _propTypes["default"].node,
    string = _propTypes["default"].string,
    func = _propTypes["default"].func;
var propTypes = {
  /** HTML for each LinkItem */
  children: node.isRequired,

  /** The url for the href */
  link: string.isRequired,

  /** Callback to be executed when key is pressed */
  onKeyDown: func,

  /** Should the link open content in a new tab */
  isExternal: bool
};
var defaultProps = {
  isExternal: false,
  onKeyDown: function onKeyDown() {}
};

var _StyledA = (0, _styledComponents["default"])("a").withConfig({
  displayName: "LinkItem___StyledA",
  componentId: "nh5hkn-0"
})(["", ""], _Item["default"]);

var LinkItem = function LinkItem(props) {
  var children = props.children,
      onKeyDown = props.onKeyDown,
      isExternal = props.isExternal,
      link = props.link,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "onKeyDown", "isExternal", "link"]);
  var I18n = (0, _useI18n["default"])();

  var linkItemProps = _objectSpread({
    "data-pka-anchor": "overflow-menu.item",
    href: link,
    onKeyDown: onKeyDown,
    role: "menuitem"
  }, moreProps);

  var externalLinkIcon = null;

  if (isExternal) {
    linkItemProps["aria-label"] = I18n.t("overflowMenu.isExternal", {
      link: children
    });
    linkItemProps.target = "_blank";
    linkItemProps.rel = "noopener noreferrer";
    externalLinkIcon = /*#__PURE__*/_react["default"].createElement(_NewTab["default"], {
      size: "10px"
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_StyledA, linkItemProps, children, externalLinkIcon);
};

LinkItem.displayName = "OverflowMenu.LinkItem";
LinkItem.propTypes = propTypes;
LinkItem.defaultProps = defaultProps;
var _default = LinkItem;
exports["default"] = _default;
//# sourceMappingURL=LinkItem.js.map

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Item["default"];
  }
});

var _Item = _interopRequireDefault(__webpack_require__(1320));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _rawButton = _interopRequireDefault(__webpack_require__(512));

var _Item = _interopRequireDefault(__webpack_require__(752));

var bool = _propTypes["default"].bool,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes = {
  /** HTML for each item */
  children: node.isRequired,

  /** If the item is destructive. */
  isDestructive: bool,

  /** Callback to be executed when button is clicked */
  onClick: func,

  /** Callback to be executed when key is pressed */
  onKeyDown: func,

  /** Callback to be executed when overflow menu needs to be closed */
  onClose: func,

  /** Callback to be executed when delete item is clicked */
  onShowConfirmation: func,

  /** Render prop to render the replacement node */
  renderConfirmation: func
};
var defaultProps = {
  isDestructive: false,
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  onClose: function onClose() {},
  onShowConfirmation: function onShowConfirmation() {},
  renderConfirmation: null
};

var _StyledRawButton = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "Item___StyledRawButton",
  componentId: "fx5h55-0"
})(["", ""], _Item["default"]);

var Item = function Item(props) {
  var children = props.children,
      isDestructive = props.isDestructive,
      onClick = props.onClick,
      onClose = props.onClose,
      onShowConfirmation = props.onShowConfirmation,
      renderConfirmation = props.renderConfirmation,
      onKeyDown = props.onKeyDown,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "isDestructive", "onClick", "onClose", "onShowConfirmation", "renderConfirmation", "onKeyDown"]);

  var handleClickItem = function handleClickItem() {
    onClick(children);
    onClose();
  };

  var itemProps = {
    canPropagate: false,
    "data-pka-anchor": "overflow-menu.item",
    hasInsetFocusStyle: true,
    isDestructive: isDestructive,
    onClick: renderConfirmation !== null ? onShowConfirmation : handleClickItem,
    onKeyDown: onKeyDown,
    role: "menuitem",
    tabIndex: 0
  };
  return /*#__PURE__*/_react["default"].createElement(_StyledRawButton, (0, _extends2["default"])({}, itemProps, moreProps), children);
};

Item.displayName = "OverflowMenu.Item";
Item.propTypes = propTypes;
Item.defaultProps = defaultProps;
var _default = Item;
exports["default"] = _default;
//# sourceMappingURL=Item.js.map

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Content = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(4));

var _tokens = _interopRequireDefault(__webpack_require__(27));

var _stylers = _interopRequireDefault(__webpack_require__(16));

var Content = _styledComponents["default"].div.withConfig({
  displayName: "OverflowMenustyles__Content",
  componentId: "sc-5q8ct4-0"
})(["margin-left:-", ";margin-right:-", ";[role=\"menuitem\"]{", "}"], _tokens["default"].spaceLg, _tokens["default"].spaceLg, _stylers["default"].lineHeight(-1));

exports.Content = Content;
//# sourceMappingURL=OverflowMenu.styles.js.map

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_overflow_menu__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_overflow_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paprika_overflow_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__paprika_popover__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__paprika_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__paprika_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigationIcon__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HelperWithPendo_scss__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HelperWithPendo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__HelperWithPendo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LinkStyles_scss__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LinkStyles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__LinkStyles_scss__);












function HelperWithPendo(_ref) {
  var helpDocUrl = _ref.helpDocUrl,
      supportUrl = _ref.supportUrl,
      zIndex = _ref.zIndex;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(false),
      _React$useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_React$useState, 2),
      isOverflowMenuOpen = _React$useState2[0],
      setIsOverflowMenuOpen = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(false),
      _React$useState4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_React$useState3, 2),
      isTooltipOpen = _React$useState4[0],
      setIsTooltipOpen = _React$useState4[1];

  var _React$useState5 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(false),
      _React$useState6 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_React$useState5, 2),
      isKeyboardInput = _React$useState6[0],
      setIsKeyboardInput = _React$useState6[1];

  var i18n = __WEBPACK_IMPORTED_MODULE_6__paprika_l10n_lib_useI18n___default()();

  function handleCloseOverflowMenu() {
    setIsOverflowMenuOpen(false);
  }

  function isGovCloud() {
    return window.location.href.indexOf('highbond-gov') > -1;
  }

  function toggleIsOpen(event) {
    setIsKeyboardInput(!!event.key && (event.key === ' ' || event.key === 'Enter'));
    setIsOverflowMenuOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });

    if (!isOverflowMenuOpen) {
      setIsTooltipOpen(false);
    }
  }

  function handleTooltipOpen() {
    if (!isOverflowMenuOpen) {
      setIsTooltipOpen(true);
    }
  }

  function handleTooltipClose() {
    setIsTooltipOpen(false);
  }

  var isOpenValue = isOverflowMenuOpen && (isGovCloud() || isKeyboardInput);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('navigation-helper', {
      'navigation-helper--with-pendo': !isGovCloud()
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paprika_popover___default.a, {
    isEager: true,
    isDark: true,
    isOpen: isTooltipOpen,
    zIndex: zIndex
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paprika_popover___default.a.Trigger, null, function () {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
      onMouseOver: handleTooltipOpen,
      onMouseOut: handleTooltipClose,
      onFocus: handleTooltipOpen,
      onBlur: handleTooltipClose
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__paprika_overflow_menu___default.a, {
      onClose: handleCloseOverflowMenu,
      zIndex: zIndex,
      isOpen: isOpenValue
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__paprika_overflow_menu___default.a.Trigger, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('navigation-item__trigger', {
        'navigation-item__trigger--is-active': isOpenValue
      }),
      a11yText: i18n.t('global_navigation.navigation_items.helper'),
      isOpen: isOpenValue,
      onClick: toggleIsOpen,
      menuRefId: "sriracha-global-navigation-helper__overflow-content"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NavigationIcon__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* icons */].helper
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__paprika_overflow_menu___default.a.Content, {
      id: "sriracha-global-navigation-helper__overflow-content",
      className: "sriracha"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__paprika_overflow_menu___default.a.LinkItem, {
      className: "navigation-overflow__link",
      isExternal: true,
      link: helpDocUrl
    }, i18n.t('global_navigation.helper.help_docs')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__paprika_overflow_menu___default.a.LinkItem, {
      className: "navigation-overflow__link",
      isExternal: true,
      link: supportUrl
    }, i18n.t('global_navigation.helper.support'))));
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paprika_popover___default.a.Content, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paprika_popover___default.a.Card, null, i18n.t('global_navigation.navigation_items.helper'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paprika_popover___default.a.Tip, null)));
}

HelperWithPendo.propTypes = {
  helpDocUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  supportUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  zIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
};
HelperWithPendo.defaultProps = {
  zIndex: null
};
HelperWithPendo.componentType = __WEBPACK_IMPORTED_MODULE_8__constants__["d" /* navigationItems */].helperWithPendo;
/* harmony default export */ __webpack_exports__["a"] = (HelperWithPendo);

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_popover__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__paprika_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Logo_scss__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Logo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Logo_scss__);
/* eslint-disable jsx-a11y/mouse-events-have-key-events */







function Logo(_ref) {
  var launchpadUrl = _ref.launchpadUrl,
      zIndex = _ref.zIndex;
  var i18n = __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n___default()();
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "navigation-logo"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a, {
    isEager: true,
    isDark: true,
    zIndex: zIndex
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a.Trigger, null, function (handler) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      className: "navigation-item__trigger",
      onMouseOver: handler,
      onMouseOut: handler,
      onBlur: handler,
      "aria-label": i18n.t('global_navigation.navigation_items.logo'),
      href: launchpadUrl,
      target: "_top"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 639 548"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      fill: "#F0A117",
      fillRule: "evenodd",
      d: "M456.396,365.44 L638.97,0.317 L456.417,0.317 L298.212,316.7 L298.213,316.687 C292.286,328.291 281.386,331.669 273.701,331.669 C266.569,331.669 256.407,328.196 250.599,318.936 L182.553,182.876 L0,182.876 L91.292,365.44 L91.297,365.44 L0,548 L182.553,548 L249.482,414.176 L249.481,414.192 C255.407,402.585 266.307,399.21 273.992,399.21 C281.124,399.21 291.287,402.681 297.094,411.943 L365.14,548 L547.695,548 L456.401,365.44 L456.396,365.44"
    })));
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a.Content, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a.Card, null, i18n.t('global_navigation.navigation_items.logo'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_popover___default.a.Tip, null)));
}

Logo.propTypes = {
  launchpadUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};
Logo.defaultProps = {
  zIndex: 9999
};
Logo.componentType = __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* navigationItems */].logo;
/* harmony default export */ __webpack_exports__["a"] = (Logo);

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OverflowMenuTrigger__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__User_scss__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__User_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__User_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LinkStyles_scss__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LinkStyles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__LinkStyles_scss__);










function User(_ref) {
  var customerName = _ref.customerName,
      username = _ref.username,
      userProfileUrl = _ref.userProfileUrl,
      logoutUrl = _ref.logoutUrl,
      zIndex = _ref.zIndex;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(false),
      _React$useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var i18n = __WEBPACK_IMPORTED_MODULE_4__paprika_l10n_lib_useI18n___default()();
  var tooltipLabel = i18n.t('global_navigation.navigation_items.user_with_customer', {
    username: username,
    customerName: customerName
  });

  function toggleIsOpen() {
    setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  }

  function handleCloseOverflowMenu() {
    setIsOpen(false);
  }

  function handleClickLogout() {
    window.location.href = logoutUrl;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "navigation-user"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default.a, {
    onClose: handleCloseOverflowMenu,
    zIndex: zIndex
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default.a.Content, {
    id: "sriracha-global-navigation-user__overflow-content",
    className: "sriracha"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default.a.Trigger, {
    a11yText: tooltipLabel,
    menuRefId: "sriracha-global-navigation-user__overflow-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OverflowMenuTrigger__["a" /* default */], {
    ariaLabel: tooltipLabel,
    icon: __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* icons */].user,
    isOpen: isOpen,
    onClick: toggleIsOpen
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
    className: "sriracha-global-navigation__user-overflow__header"
  }, username, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", {
    "aria-hidden": true
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
    className: "customer-name"
  }, customerName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default.a.LinkItem, {
    className: "navigation-overflow__link",
    link: userProfileUrl
  }, i18n.t('global_navigation.user.my_profile')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__paprika_overflow_menu___default.a.Item, {
    className: "navigation-overflow__link",
    onClick: handleClickLogout
  }, i18n.t('global_navigation.user.log_out'))));
}

User.propTypes = {
  customerName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  username: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  userProfileUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  logoutUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  zIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
};
User.defaultProps = {
  customerName: null,
  zIndex: null
};
User.componentType = __WEBPACK_IMPORTED_MODULE_6__constants__["d" /* navigationItems */].user;
/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigationButton__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(306);






function SignIn(_ref) {
  var loginUrl = _ref.loginUrl,
      zIndex = _ref.zIndex;
  var i18n = __WEBPACK_IMPORTED_MODULE_2__paprika_l10n_lib_useI18n___default()();

  function handleClickLogin() {
    window.location.href = loginUrl;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "navigation-signin"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NavigationButton__["a" /* default */], {
    ariaLabel: i18n.t('global_navigation.navigation_items.sign_in'),
    onClick: handleClickLogin,
    zIndex: zIndex
  }, i18n.t('global_navigation.navigation_items.sign_in')));
}

SignIn.propTypes = {
  loginUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};
SignIn.defaultProps = {
  zIndex: null
};
SignIn.componentType = __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* navigationItems */].signIn;
/* harmony default export */ __webpack_exports__["a"] = (SignIn);

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__organizationShape__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__availableAppShape__ = __webpack_require__(646);



var appSwitcherPropsShape = {
  launchpadUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  productTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  organizations: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_1__organizationShape__["a" /* default */])).isRequired,
  apps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_2__availableAppShape__["a" /* default */])).isRequired,
  initialOrganizationId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  resourceLinks: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.exact({
    launchpad: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    academy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    community: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  }).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (appSwitcherPropsShape);

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appData__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resourceData__ = __webpack_require__(748);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__appData__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__resourceData__["a"]; });




/***/ })
/******/ ]);
});
//# sourceMappingURL=GlobalNavigation.js.map